//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IKlipApiProxy {
    acmIdmAuth_Login(provider: string | null, redirectUri?: string | null | undefined, signal?: AbortSignal): Promise<FileResponse>;
    acmIdmAuth_LogOut(signal?: AbortSignal): Promise<FileResponse>;
    acmIdmAuth_SignOutComplete(signal?: AbortSignal): Promise<FileResponse>;
    /**
     * Uitloggen van een gebruiker uit de Klip Web front-end zonder uit te loggen bij ACM/IDM, dit laat de gebruiker toe te wisselen van organisatie.
     */
    acmIdmAuth_SwitchIdentity(signal?: AbortSignal): Promise<void>;
    acmIdmAuth_IsAuthenticated(signal?: AbortSignal): Promise<EnvelopeOfBoolean>;
    acmIdmAuth_AcmIdmRegistrationLinks(organisationCode?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfAcmIdmRegistrationLinks>;
    acmIdmAuth_GetUserData(hardRefresh?: boolean | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfUserData>;
    acmIdmAuth_HasPendingImpersonationConsent(userId?: string | undefined, organisationId?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfUserImpersonationDto>;
    acmIdmAuth_ChangeImpersonationConsent(userId?: string | undefined, userImpersonationId?: string | undefined, consent?: boolean | undefined, signal?: AbortSignal): Promise<void>;
    /**
     * Gets all CodeLists
     */
    codeLists_GetAll(signal?: AbortSignal): Promise<EnvelopeOfCodeLists>;
    document_DownloadImklAttachment(mapRequestId: string, fileId: string, signal?: AbortSignal): Promise<EnvelopeOfStream>;
    document_DownloadMapRequestPrintPackage(printId: string, signal?: AbortSignal): Promise<EnvelopeOfStream>;
    document_DownloadImklTestFile(imklFileId: string, signal?: AbortSignal): Promise<FileResponse>;
    document_DownloadImklTestFileAttachment(fileId: string, signal?: AbortSignal): Promise<FileResponse>;
    document_DownloadKlipPackage(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfStream>;
    document_DownloadKlipPackageForUna(mapRequestId: string, zoneId: string, signal?: AbortSignal): Promise<EnvelopeOfStream>;
    document_DownloadImklFile(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfStream>;
    /**
     * Download IMKL file by map request id and zone id
     * @param mapRequestId Type Guid
     * @param zoneId Type Guid
     * @return Success
     */
    document_DownloadImklFileUna(mapRequestId: string, zoneId: string, signal?: AbortSignal): Promise<Stream>;
    document_DownloadInvoiceFile(type: string, blobName: string, format: string, external: boolean, organisationId?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfStream>;
    document_DownloadInvoiceFiles(fromDate?: string | undefined, toDate?: string | undefined, organisationId?: string | null | undefined, klipUserId?: string | null | undefined, docNr?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfStream>;
    /**
     * Generate download file for maprequests list
     * @param request Type GetMapRequestsRepliedInput
     */
    document_DownloadMapRequestsReplied(request: GetMapRequestsRepliedInput, signal?: AbortSignal): Promise<FileResponse>;
    /**
     * Download zone file by maprequestId, zoneId and Format
     * @return Success
     */
    document_DownloadMapRequestZoneFileAsUna(mapRequestId: string, zoneId: string, format: string, isArchived: boolean, coordinateSystem: CoordinateSystem, signal?: AbortSignal): Promise<EnvelopeOfStream>;
    /**
     * Download maprequest zone file by mapRequestId and Format
     * @return Success
     */
    document_DownloadMapRequestZoneFile(mapRequestId: string, format: string, isArchived: boolean, coordinateSystem: CoordinateSystem, signal?: AbortSignal): Promise<EnvelopeOfStream>;
    /**
     * Donwload maprequest archive
     */
    document_DownloadMapRequestArchive(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfString>;
    /**
     * Download maprequest archive
     */
    document_DownloadMapRequestArchiveForUna(mapRequestId: string, zoneId: string, signal?: AbortSignal): Promise<EnvelopeOfString>;
    document_DownloadZoneFile(pdaZoneId: string, format: string, coordinateSystem: CoordinateSystem, signal?: AbortSignal): Promise<Stream>;
    /**
     * Download maprequest zone file by mapRequestId and Format
     * @return Success
     */
    document_DownloadMapRequestOverlayZone(mapRequestId: string, format: string, coordinateSystem: CoordinateSystem, signal?: AbortSignal): Promise<EnvelopeOfStream>;
    /**
     * Generate download file for maprequests list
     * @param request Type GetMapRequestsRequest
     */
    document_DownloadFile(request: GetMapRequestsInput, signal?: AbortSignal): Promise<FileResponse>;
    /**
     * Generate download file for maprequests list
     * @param request Type GetUsersInput
     */
    document_ExportUsers(request: GetUsersInput, signal?: AbortSignal): Promise<FileResponse>;
    enforcer_SearchEnforcerMapRequestView(signal?: AbortSignal): Promise<EnvelopeOfSearchEnforcerMapRequestView>;
    enforcer_GetMapRequestsCount(request: GetEnforcerMapRequestsInput, signal?: AbortSignal): Promise<EnvelopeOfInteger>;
    enforcer_GetMapRequests(request: GetEnforcerMapRequestsInput, signal?: AbortSignal): Promise<EnvelopeOfICollectionOfMapRequestListItem>;
    enforcer_GetMapRequest(mapRequestId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfEnforcerMapRequest>;
    enforcer_GetArchivedMapRequest(mapRequestId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfArchivedEnforcerMapRequest>;
    /**
     * Gets all FeatureFlags
     */
    featureFlags_GetAll(signal?: AbortSignal): Promise<EnvelopeOfIListOfFeatureFlag>;
    geometries_ConvertLambert72ToLambert2008(wkt: string, signal?: AbortSignal): Promise<EnvelopeOfLambert72ToLambert2008ConversionResponse>;
    /**
     * The Version function returns the applicationInfo. The primary goal of this function serves as an action to be called by the WatchDog Logic App to prevent application warmup.
     */
    home_Version(signal?: AbortSignal): Promise<ApplicationInfo>;
    home_AppContext(signal?: AbortSignal): Promise<EnvelopeOfUserData>;
    home_DownloadArchiveViewer(version?: string | null | undefined, signal?: AbortSignal): Promise<FileResponse>;
    home_Prices(signal?: AbortSignal): Promise<PriceDto>;
    home_ViewerVersion(signal?: AbortSignal): Promise<FileResponse>;
    home_DownloadArchiveViewerVersions(signal?: AbortSignal): Promise<string[]>;
    imklTest_UploadImklFile(file?: FileParameter | null | undefined, signal?: AbortSignal): Promise<UploadImklFileResult>;
    /**
     * Get imkl test result viewModel
     * @param imklFileId imklFileId
     */
    imklTest_GetImklTestResultView(imklFileId: string, signal?: AbortSignal): Promise<EnvelopeOfImklTestResultViewModel>;
    /**
     * Get Pmkl
     * @param imklFileId imklFileId
     */
    imklTest_GetImklTestPmkl(imklFileId: string, signal?: AbortSignal): Promise<EnvelopeOfString>;
    /**
     * Get imkl test viewModel
     */
    imklTest_GetImklTestView(signal?: AbortSignal): Promise<EnvelopeOfImklTestViewModel>;
    /**
     * Get viewer viewModel
     * @param imklFileId imklFileId
     */
    imklTest_GetViewer(imklFileId: string, signal?: AbortSignal): Promise<EnvelopeOfImklTestViewerViewModel>;
    /**
     * Get full address suggestions based on a supplied address
     */
    location_GetAddressSuggestion(address: string, signal?: AbortSignal): Promise<EnvelopeOfStringOf>;
    /**
     * Get the zipcodes based on the city and street
     */
    location_GetZipCodes(street: string, city: string, signal?: AbortSignal): Promise<EnvelopeOfStringOf>;
    /**
     * Get the street number based on the city and street
     */
    location_GetStreetNumbers(street: string, city: string, signal?: AbortSignal): Promise<EnvelopeOfStringOf>;
    /**
     * Adds a log entry from the frontend to the backend logging mechanism.
     * @param logEntry Log entry.
     * @return Log entry added successfully.
     */
    log_Add(logEntry: LogEntry, signal?: AbortSignal): Promise<EnvelopeOfString>;
    /**
     * Get email example
     */
    mail_GetEmailExample(emailTemplate: string, firstname: string | null, signal?: AbortSignal): Promise<EnvelopeOfString>;
    /**
     * Get application messages
     */
    messages_GetApplicationMessages(signal?: AbortSignal): Promise<EnvelopeOfApplicationMessages>;
    /**
     * Get all active and pending maprequests for a user based on search criteria.
     * @param request Type GetMapRequestsInput
     */
    mri_GetMapRequests(request: GetMapRequestsInput, signal?: AbortSignal): Promise<EnvelopeOfGetMapRequestsView>;
    /**
     * Create a new maprequest for overlay
     */
    mri_CreateMapRequestForOverlay(input: CreateMapRequestForOverlayInput, signal?: AbortSignal): Promise<EnvelopeOfCreateMapRequestForOverlay>;
    /**
     * Get count of all maprequests for a user based on search criteria.
     * @param request Type GetMapRequestsInput
     */
    mri_GetMapRequestsCount(request: GetMapRequestsInput, signal?: AbortSignal): Promise<EnvelopeOfInteger>;
    /**
     * Get the Tags for the maprequest list
     */
    mri_GetTags(signal?: AbortSignal): Promise<EnvelopeOfListOfString>;
    /**
     * Add a Tag for a maprequest
     * @param tag (optional) 
     * @param mapRequestId (optional) 
     */
    mri_AddTag(tag?: string | null | undefined, mapRequestId?: string | undefined, signal?: AbortSignal): Promise<void>;
    /**
     * Delete a Tag of a maprequest
     * @param tag (optional) Type String
     * @param mapRequestId (optional) Type Guid
     */
    mri_DeleteTag(tag?: string | null | undefined, mapRequestId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfString>;
    /**
     * Get Pmkl status of a maprequest
     */
    mri_GetPmklAssetsStatus(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfAssetsStatusMri>;
    /**
     * Order imkl file by mapRequestId
     * @return Success
     */
    mri_OrderImklFile(orderImklMapRequestInput: OrderImklMapRequestInput, signal?: AbortSignal): Promise<EnvelopeOfString>;
    mri_GetInvoicesAndPaymentReceipts(query: InvoicesAndPaymentReceiptsQuery, signal?: AbortSignal): Promise<EnvelopeOfInvoicesAndPaymentReceiptsResponse>;
    /**
     * Get maprequest responders by maprequest id
     */
    mri_GetMapRequestResponders(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfMapRequestRespondersData>;
    /**
     * Get MapRequest Prints
     * @param mapRequestId Type Guid
     */
    mri_GetMapRequestPrints(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfIListOfMapRequestPrintView>;
    /**
     * Get MapRequest Prints
     * @param request PrintMapRequestData needed for printing
     */
    mri_PrintMapRequest(request: PrintMapRequestInput, signal?: AbortSignal): Promise<EnvelopeOfPrintMapRequestView>;
    /**
     * Get MapRequest Pmkl
     * @param mapRequestId Type Guid
     */
    mri_GetMapRequestPmkl(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfString>;
    /**
     * Get MapRequest Pmkl as stream
     * @param mapRequestId Type Guid
     */
    mri_GetMapRequestPmklStream(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfStream>;
    /**
     * Get MapRequest Wfs
     * @param mapRequestId Type Guid
     */
    mri_GetMapRequestWfs(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfString>;
    /**
     * Get MapRequest Wfs stream
     * @param mapRequestId Type Guid
     */
    mri_GetMapRequestWfsStream(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfString>;
    /**
     * Get MapRequest KmHm stream
     * @param mapRequestId Type Guid
     */
    mri_GetMapRequestKmHmStream(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfString>;
    /**
     * Create a new maprequest
     */
    mri_CreateMapRequest(input: CreateOrUpdateMapRequestInput, signal?: AbortSignal): Promise<EnvelopeOfString>;
    /**
     * Get maprequest status by maprequest id
    Remark: This api action calls the GetMapRequestById just to retrieve the status of the maprequest. A dedicated api action to get the status should be created instead.
     */
    mri_GetMapRequestStatus(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfMapRequestStatusData>;
    /**
     * Gets the ViewModel for the mri maprequests list view
     */
    mri_GetMapRequestListViewMri(signal?: AbortSignal): Promise<EnvelopeOfMapRequestListViewMri>;
    /**
     * Gets the ViewModel for the create maprequest view
        - For a new maprequest
        - For a resubmitted maprequest archive 
        - For a resubmitted maprequest non-archive
        - For a maprequest from shoppingcart in edit mode
        - For an overlay
     * @param mapRequestId (optional) 
     * @param createMapRequestType (optional) 
     */
    mri_GetCreateMapRequestView(mapRequestId?: string | null | undefined, createMapRequestType?: CreateMapRequestType | undefined, signal?: AbortSignal): Promise<EnvelopeOfCreateMapRequestView>;
    /**
     * Gets the ViewModel for the create maprequest for overlay view
     */
    mri_GetCreateMapRequestForOverlayView(signal?: AbortSignal): Promise<EnvelopeOfCreateMapRequestForOverlayView>;
    /**
     * Gets the ViewModel for the maprequest for
    view
     */
    mri_GetMapRequestForOverlayView(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfMapRequestForOverlayView>;
    /**
     * Get maprequest by id view
     */
    mri_GetMapRequestView(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfMapRequestViewMri>;
    /**
     * Get viewer viewModel
     * @param mapRequestId Type Guid
     */
    mri_GetViewer(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfMriViewerViewModel>;
    operations_SearchOperationsMapRequestView(signal?: AbortSignal): Promise<EnvelopeOfSearchOperationsMapRequestView>;
    operations_SearchOperationsMapRequestForUserView(signal?: AbortSignal): Promise<EnvelopeOfSearchOperationsMapRequestForUserView>;
    operations_SearchOperationsMapRequestForOrganisationView(organisationId?: string | undefined, mapRequestForOrganisationType?: SearchOperationsMapRequestForOrganisationType | undefined, signal?: AbortSignal): Promise<EnvelopeOfSearchOperationsMapRequestForOrganisationView>;
    operations_GetMapRequestsCount(request: GetOperationsMapRequestsInput, signal?: AbortSignal): Promise<EnvelopeOfInteger>;
    operations_GetMapRequests(request: GetOperationsMapRequestsInput, signal?: AbortSignal): Promise<EnvelopeOfICollectionOfMapRequestListItem2>;
    operations_GetMapRequest(mapRequestId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfOperationsMapRequest>;
    operations_GetArchivedMapRequest(mapRequestId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfOperationsArchivedMapRequest>;
    operations_GetUnaAuditLog(mapRequestId?: string | undefined, zoneId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfIListOfAuditLog>;
    operations_MoveMapRequests(mapRequestsToMove: MoveMapRequestsInput, signal?: AbortSignal): Promise<FileResponse>;
    operations_GetOrganisations(request: GetOrganisationsInput, signal?: AbortSignal): Promise<EnvelopeOfOrganisationsPagedResult>;
    operations_GetOrganisationDetail(organisationId: string, signal?: AbortSignal): Promise<EnvelopeOfOrganisationDetail>;
    operations_GetOrganisationInvoiceDetail(organisationId: string, signal?: AbortSignal): Promise<EnvelopeOfOrganisationInvoiceSettings>;
    operations_GetOrganisationInvoiceSettings(organisationId: string, signal?: AbortSignal): Promise<EnvelopeOfInvoiceSettingsForOrganisation>;
    operations_UpdateOrganisationInvoiceDetail(updateOrganisationInvoiceData: UpdateOperationInvoiceDataInput, signal?: AbortSignal): Promise<void>;
    operations_UpdateOrganisationPaymentSettings(input: UpdateOrganisationPaymentSettingsInput, signal?: AbortSignal): Promise<void>;
    operations_CreateOrUpdateOrganisationActor(request: UpdateOrganisationActorInput, signal?: AbortSignal): Promise<void>;
    operations_GetSubOrganisationDetail(organisationId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfSubOrganisationDetail>;
    operations_DeleteOrganisation(organisationId: string, signal?: AbortSignal): Promise<void>;
    operations_UpdateConfirmationInUnaZoneSettings(input: UpdateConfirmationInUnaZoneSettingsInput, signal?: AbortSignal): Promise<void>;
    operations_GetActorByAthumiId(athumiId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfActorDto>;
    operations_GetSubOrganisationUnaZone(organisationId?: string | undefined, zoneId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfSubOrganisationUnaZoneDetail>;
    operations_GetPdaZones(organisationId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfIListOfZoneListItem>;
    operations_GetVersions(signal?: AbortSignal): Promise<EnvelopeOfICollectionOfVersionDto>;
    operations_AddVersion(request: AddVersionRequest, signal?: AbortSignal): Promise<void>;
    operations_Prices(signal?: AbortSignal): Promise<EnvelopeOfIListOfPriceDto>;
    operations_Holidays(signal?: AbortSignal): Promise<EnvelopeOfIDictionaryOfIntegerAndListOfDateTime>;
    operations_Messages(signal?: AbortSignal): Promise<EnvelopeOfIListOfMessageDto>;
    operations_UpdateMessage(request: UpdateMessageRequest, signal?: AbortSignal): Promise<EnvelopeOfIListOfMessageDto>;
    operations_DeleteMessage(messageId?: number | undefined, signal?: AbortSignal): Promise<EnvelopeOfBoolean>;
    organisation_CreateOrganisation(organisationSettingsInput: OrganisationSettingsInput, signal?: AbortSignal): Promise<EnvelopeOfString>;
    organisation_EditOrganisation(organisationSettingsInput: OrganisationSettingsInput, signal?: AbortSignal): Promise<EnvelopeOfString>;
    organisation_EditUnaSettingsForOrganisation(organisationUnaSettingsInput: OrganisationUnaSettingsInput, signal?: AbortSignal): Promise<EnvelopeOfString>;
    organisation_LoadSettingsForOrganisation(signal?: AbortSignal): Promise<EnvelopeOfSettingsForOrganisationView>;
    organisation_LoadCreateOrganisationView(signal?: AbortSignal): Promise<EnvelopeOfCreateOrganisationView>;
    organisation_LoadEditOrganisationView(organisationId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfEditOrganisationView>;
    organisation_GetOrganisation(organisationId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfOrganisation>;
    organisation_LoadUnaZonesForOrganisation(organisationId?: string | undefined, includeArchived?: boolean | undefined, signal?: AbortSignal): Promise<EnvelopeOfICollectionOfZoneNamespace>;
    organisation_FilterOrganisationsByName(name?: string | null | undefined, onlyIncludeUnaOrganisations?: boolean | null | undefined, onlyIncludeRootOrganisations?: boolean | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfICollectionOfOrganisation>;
    organisation_GetOrganisationHierarchyFlatList(organisationId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfICollectionOfOrganisationHierarchyFlatListItem>;
    payment_GetShoppingCartStatus(signal?: AbortSignal): Promise<EnvelopeOfShoppingCartStatus>;
    payment_GetPrepaidAmount(signal?: AbortSignal): Promise<EnvelopeOfPrepaidAmount>;
    payment_DeleteShoppingCartMapRequest(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfGetCurrentShoppingCartResult>;
    payment_DeleteShoppingCart(signal?: AbortSignal): Promise<EnvelopeOfBoolean>;
    payment_DeleteShoppingCartMapRequestExtra(mapRequestExtraId: number, signal?: AbortSignal): Promise<EnvelopeOfGetCurrentShoppingCartResult>;
    payment_Checkout(checkoutInput: CheckoutInput, signal?: AbortSignal): Promise<EnvelopeOfDictionaryOfStringAndString>;
    payment_GetShoppingCartView(signal?: AbortSignal): Promise<EnvelopeOfShoppingCartViewModel>;
    payment_GetShoppingCartCheckoutView(signal?: AbortSignal): Promise<EnvelopeOfShoppingCartCheckoutViewModel>;
    payment_GetPrepaidCheckoutView(signal?: AbortSignal): Promise<EnvelopeOfPrepaidCheckoutViewModel>;
    payment_GetPrepaidView(signal?: AbortSignal): Promise<EnvelopeOfPrepaidViewModel>;
    payment_ActivePrice(signal?: AbortSignal): Promise<EnvelopeOfPriceDto>;
    paymentProcessing_CheckShoppingCartPaymentState(shoppingCartId: string, signal?: AbortSignal): Promise<EnvelopeOfShoppingCartPaymentStatusResult>;
    paymentProcessing_CheckTopUpPaymentState(returnMac?: string | null | undefined, hostedCheckoutId?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfShoppingCartPaymentStatusResult>;
    /**
     * Get All zones for a pda user
     */
    pda_GetAll(signal?: AbortSignal): Promise<EnvelopeOfIListOfZoneListItem>;
    /**
     * Get Zone by Id
     */
    pda_GetZoneById(zoneId: string, includeDownloadUrls: boolean, signal?: AbortSignal): Promise<EnvelopeOfZoneDetails>;
    pda_CreateZone(zone: NewZone, signal?: AbortSignal): Promise<EnvelopeOfString>;
    pda_UpdateZone(zone: UpdateZone, signal?: AbortSignal): Promise<EnvelopeOfString>;
    pda_DeleteZoneById(zoneId: string, signal?: AbortSignal): Promise<EnvelopeOfString>;
    pda_GetUnaZonesByZoneId(zoneId: string, organisationId?: string | undefined, parentOrganisationId?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfIListOfUnaZoneListItem>;
    pda_GetMapRequests(request: GetPdaMapRequestsInput, signal?: AbortSignal): Promise<EnvelopeOfIListOfMapRequestListItem>;
    pda_GetMapRequestsCount(request: GetPdaMapRequestsInput, signal?: AbortSignal): Promise<EnvelopeOfInteger>;
    pda_GetZoneDetailView(zoneId: string, signal?: AbortSignal): Promise<EnvelopeOfZoneDetailView>;
    pda_GetMapRequestView(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfMapRequestViewPda>;
    /**
     * Update email settings
    Remark: The new settings updates only the mail settings to the request. But the API expects all data from the old UI,
            which isn't used anymore, but still needs to be present for the update or the data is lost.
     */
    settings_UpdateEmailSettings(input: UpdateMailSettingsInput, signal?: AbortSignal): Promise<EnvelopeOfString>;
    settings_GetSettingsView(signal?: AbortSignal): Promise<EnvelopeOfSettingsView>;
    settings_GetInvoiceSettings(signal?: AbortSignal): Promise<EnvelopeOfInvoiceSettingsView>;
    settings_GetOrganisationInvoiceSettings(signal?: AbortSignal): Promise<EnvelopeOfOrganisationInvoiceSettingsView>;
    settings_UpdateOrganisationSettings(organisationInvoiceSetting: OrganisationInvoiceSetting, signal?: AbortSignal): Promise<void>;
    settings_CreateOrganisationInvoiceGroup(organisationInvoiceGroup: OrganisationInvoiceGroup, signal?: AbortSignal): Promise<EnvelopeOfOrganisationInvoiceGroup>;
    settings_UpdateOrganisationInvoiceGroup(organisationInvoiceGroup: OrganisationInvoiceGroup, signal?: AbortSignal): Promise<EnvelopeOfOrganisationInvoiceGroup>;
    settings_DeleteOrganisationInvoiceGroup(organisationInvoiceGroupId?: string | undefined, signal?: AbortSignal): Promise<void>;
    una_ReplyWithImkl(mapRequestId: string, zoneId: string, file?: FileParameter | null | undefined, signal?: AbortSignal): Promise<string>;
    /**
     * Una response Not Involved
     */
    una_NotInvolved(requestNotInvolvedInput: MapRequestNotInvolvedInput, signal?: AbortSignal): Promise<string>;
    /**
     * Get Imkl File Upload Status
     * @return Data Valid when response is ImklDataValidReportResponse, Data Invalid when response is ImklDataInvalidReportResponse
     */
    una_GetImklFileUploadStatus(mapRequestId: string, zoneId: string, signal?: AbortSignal): Promise<EnvelopeOfImklDataValidationReport>;
    una_GetPmklAssetsStatus(mapRequestId: string, zoneId: string, signal?: AbortSignal): Promise<EnvelopeOfPmklMapAssetsStatusUna>;
    /**
     * Get maprequests to confirm for a user based on search criteria.
     * @param request Type GetMapRequestsToConfirmInput
     */
    una_GetMapRequestsToConfirm(request: GetMapRequestsToConfirmInput, signal?: AbortSignal): Promise<EnvelopeOfMapRequestsToConfirmList>;
    /**
     * Confirm maprequests.
     * @param request Type ConfirmMapRequestReceivedRequest
     */
    una_ConfirmMapRequests(request: ConfirmMapRequestsInput[], signal?: AbortSignal): Promise<EnvelopeOfString>;
    /**
     * Get maprequests to reply for a user based on search criteria.
     * @param request Type GetMapRequestsToReplyInput
     */
    una_GetMapRequestsToReply(request: GetMapRequestsToReplyInput, signal?: AbortSignal): Promise<EnvelopeOfMapRequestsToReplyList>;
    /**
     * Get maprequests replied for a user based on search criteria.
     * @param request Type GetMapRequestsRepliedInput
     */
    una_GetMapRequestsReplied(request: GetMapRequestsRepliedInput, signal?: AbortSignal): Promise<EnvelopeOfMapRequestsRepliedList>;
    /**
     * Get count of all toconfirm maprequests for a user based on search criteria.
     * @param request Type GetMapRequestsToConfirmInput
     */
    una_GetMapRequestsToConfirmCount(request: GetMapRequestsToConfirmInput, signal?: AbortSignal): Promise<EnvelopeOfInteger>;
    /**
     * Get count of all toreply maprequests for a user based on search criteria.
     * @param request Type GetMapRequestsToReplyInput
     */
    una_GetMapRequestsToReplyCount(request: GetMapRequestsToReplyInput, signal?: AbortSignal): Promise<EnvelopeOfInteger>;
    /**
     * Get count of all replied maprequests for a user based on search criteria.
     * @param request Type GetMapRequestsToReplyInput
     */
    una_GetMapRequestsRepliedCount(request: GetMapRequestsRepliedInput, signal?: AbortSignal): Promise<EnvelopeOfInteger>;
    una_GetAllMapRequestCount(request: GetAllMapRequestCountInput, signal?: AbortSignal): Promise<EnvelopeOfMapRequestCount>;
    /**
     * Get MapRequest Pmkl
     * @param mapRequestId Type Guid
     * @param zoneId Type Guid
     */
    una_GetMapRequestPmkl(mapRequestId: string, zoneId: string, signal?: AbortSignal): Promise<EnvelopeOfString>;
    /**
     * Get MapRequest Pmkl as stream
     * @param mapRequestId Type Guid
     * @param zoneId Type Guid
     */
    una_GetMapRequestPmklStream(mapRequestId: string, zoneId: string, signal?: AbortSignal): Promise<EnvelopeOfStream>;
    /**
     * Get MapRequest Wfs
     * @param mapRequestId Type Guid
     */
    una_GetMapRequestWfs(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfString>;
    /**
     * Get MapRequest Wfs stream
     * @param mapRequestId Type Guid
     */
    una_GetMapRequestWfsStream(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfString>;
    /**
     * Get MapRequest KmHm stream
     * @param mapRequestId Type Guid
     */
    una_GetMapRequestKmHmStream(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfString>;
    una_GetZoneNamespace(zoneId: string, signal?: AbortSignal): Promise<EnvelopeOfString>;
    /**
     * Gets the ViewModel for the una maprequests list view
     */
    una_GetMapRequestsListView(signal?: AbortSignal): Promise<EnvelopeOfMapRequestListViewUna>;
    una_GetMapRequestViewUna(mapRequestId: string, zoneId: string, isArchived: boolean, signal?: AbortSignal): Promise<EnvelopeOfMapRequestViewUna>;
    una_GetViewer(mapRequestId: string, zoneId: string, signal?: AbortSignal): Promise<EnvelopeOfUnaViewerViewModel>;
    una_PrintMapRequest(request: PrintMapRequestInput, signal?: AbortSignal): Promise<EnvelopeOfPrintMapRequestView>;
    una_GetMapRequestPrints(mapRequestId: string, zoneId: string, signal?: AbortSignal): Promise<EnvelopeOfIListOfMapRequestPrintView>;
    unaSettings_GetUnaZoneCreateView(signal?: AbortSignal): Promise<EnvelopeOfUnaZoneCreateView>;
    unaSettings_GetUnaZoneEditView(zoneId?: string | undefined, organisationId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfUnaZoneEditView>;
    unaSettings_CreateKlipZone(request: CreateKlipZoneInput, signal?: AbortSignal): Promise<EnvelopeOfKlipZoneCreated>;
    unaSettings_UpdateKlipZone(request: UpdateKlipZoneInput, signal?: AbortSignal): Promise<EnvelopeOfString>;
    unaSettings_DeleteKlipZoneById(id: string, signal?: AbortSignal): Promise<EnvelopeOfString>;
    /**
     * Download zone file by BlobName and Format
     * @return Success
     */
    unaSettings_DownloadZoneFile(utilityNetworkAuthorityZoneGeometryId: string, format: string, coordinateSystem: CoordinateSystem, signal?: AbortSignal): Promise<EnvelopeOfStream>;
    unaSettings_ZoneNameExist(name: string, zoneId?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfBoolean>;
    unaSettings_DisplayNameExists(name?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfBoolean>;
    unaSettings_NamespaceExists(name: string, id?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfBoolean>;
    unaSettings_CreateKlimZone(input: CreateKlimZoneInput, signal?: AbortSignal): Promise<EnvelopeOfKlimZoneCreated>;
    unaSettings_UpdateKlimZone(input: UpdateKlimZoneInput, signal?: AbortSignal): Promise<EnvelopeOfString>;
    unaSettings_GetUnaManagerEmailAddresses(query: GetUnaManagerEmailAddressesQuery, signal?: AbortSignal): Promise<EnvelopeOfIListOfString>;
    unaSettings_MoveZone(input: MoveZoneInput, signal?: AbortSignal): Promise<void>;
    unaSettings_MoveZoneOngoing(input: MoveZoneInput, signal?: AbortSignal): Promise<EnvelopeOfBoolean>;
    validation_IsGeometryWithinBufferedFlanders(input: IsGeometryWithinBufferedFlandersInput, signal?: AbortSignal): Promise<EnvelopeOfBoolean>;
    validation_IsGeometryIntersectingFlanders(input: IsGeometryIntersectingFlandersInput, signal?: AbortSignal): Promise<EnvelopeOfBoolean>;
    events_GetEvents(request: GetEventsRequest, signal?: AbortSignal): Promise<EnvelopeOfIEnumerableOfEventDto>;
    events_ReplayEvents(request: ReplayEventsRequest, signal?: AbortSignal): Promise<EnvelopeOfBoolean>;
    invoice_StartInvoiceRound(request: StartInvoicingRoundRequest, signal?: AbortSignal): Promise<EnvelopeOfStartInvoiceRoundResponse>;
    invoice_CurrentInvoiceRound(signal?: AbortSignal): Promise<EnvelopeOfCurrentInvoiceRound>;
    invoice_MapRequestsNotRegisteredInFinancialTransaction(endDate?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfIListOfMapRequestWithFinancialAnomalies>;
    performance_PerformanceData(signal?: AbortSignal): Promise<EnvelopeOfPerformanceData>;
    performance_PerformanceDataDetail(serviceName: string, signal?: AbortSignal): Promise<EnvelopeOfPerformanceDataDetail>;
    performance_PollPerformanceDataDetail(serviceName: string, signal?: AbortSignal): Promise<EnvelopeOfPollPerformanceDataDetail>;
    performance_Requeue(request: DeadLetterRequest, signal?: AbortSignal): Promise<EnvelopeOfString>;
    performance_Delete(request: DeadLetterRequest, signal?: AbortSignal): Promise<EnvelopeOfString>;
    processes_ProcessCounter(processCounter?: ProcessCounter | undefined, signal?: AbortSignal): Promise<EnvelopeOfInteger>;
    processes_FailedPmklPackages(signal?: AbortSignal): Promise<EnvelopeOfIListOfFailedPmklPackage>;
    processes_DeleteFailedPmklPackages(mapRequestId?: string | undefined, zoneId?: string | undefined, blobName?: string | null | undefined, signal?: AbortSignal): Promise<void>;
    processes_AdditionalProcesses(signal?: AbortSignal): Promise<EnvelopeOfAdditionalProcesses>;
    processes_HangingImklValidations(signal?: AbortSignal): Promise<EnvelopeOfIListOfHangingImklValidation>;
    processes_DeleteHangingImklValidation(mapRequestId?: string | undefined, zoneId?: string | undefined, blobName?: string | null | undefined, signal?: AbortSignal): Promise<void>;
    processes_FailedAndMissingKlimResponses(signal?: AbortSignal): Promise<EnvelopeOfFailedAndMissingKlimResponse>;
    processes_HandleFailedKlimResponse(mapRequestId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfBoolean>;
    processes_PendingRequests(signal?: AbortSignal): Promise<EnvelopeOfIEnumerableOfPendingRequest>;
    processes_DeletePendingRequest(id?: string | null | undefined, messageType?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfBoolean>;
    processes_PendingPmkl2Assets(signal?: AbortSignal): Promise<EnvelopeOfIEnumerableOfPendingPmkl2Asset>;
    processes_DeletePendingPmkl2Assets(mapRequestId?: string | undefined, type?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfBoolean>;
    processes_UnprocessedPaidShoppingCarts(signal?: AbortSignal): Promise<EnvelopeOfIEnumerableOfUnprocessedPaidShoppingCartMapRequest>;
    processes_ProcessUnprocessedPaidShoppingCarts(shoppingCartId?: string | undefined, mapRequestId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfBoolean>;
    processes_HangingMapRequests(signal?: AbortSignal): Promise<EnvelopeOfIEnumerableOfHangingMapRequest>;
    processes_OverdueMapRequests(signal?: AbortSignal): Promise<EnvelopeOfIEnumerableOfOverdueMapRequest>;
    processes_MapRequestRespondersInIncorrectStatus(signal?: AbortSignal): Promise<EnvelopeOfIEnumerableOfMapRequestRespondersInIncorrectStatus>;
    processes_MapRequestWithFinancialAnomalies(signal?: AbortSignal): Promise<EnvelopeOfMapRequestsWithFinancialAnomaly>;
    saga_GetSaga(id: string, sagaType: SagaType, signal?: AbortSignal): Promise<EnvelopeOfSagaDto>;
    saga_ResetSaga(id: string, sagaType: SagaType, signal?: AbortSignal): Promise<EnvelopeOfBoolean>;
    users_GetUsersCount(request: GetUsersInput, signal?: AbortSignal): Promise<EnvelopeOfInteger>;
    users_GetUsers(request: GetUsersInput, signal?: AbortSignal): Promise<EnvelopeOfICollectionOfUserListItem>;
    users_GetUserDetail(userId?: string | undefined, organisationId?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfUserDetail>;
    users_AskImpersonationConsent(consentRequest: AskImpersonationConsentRequest, signal?: AbortSignal): Promise<void>;
    users_ImpersonationForUser(userId?: string | undefined, organisationId?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfImpersonationSessionForUser>;
    users_StartImpersonationForUser(userId?: string | undefined, userImpersonationId?: string | undefined, impersonatorUserId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfUserImpersonationDto>;
    users_StopImpersonationForUser(userId?: string | undefined, userImpersonationId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfUnit>;
}

export class KlipApiProxy implements IKlipApiProxy {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:44330";

    }

    acmIdmAuth_Login(provider: string | null, redirectUri?: string | null | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/auth/login/{provider}?";
        if (provider === undefined || provider === null)
            throw new globalThis.Error("The parameter 'provider' must be defined.");
        url_ = url_.replace("{provider}", encodeURIComponent("" + provider));
        if (redirectUri !== undefined && redirectUri !== null)
            url_ += "redirectUri=" + encodeURIComponent("" + redirectUri) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcmIdmAuth_Login(_response);
        });
    }

    protected processAcmIdmAuth_Login(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    acmIdmAuth_LogOut(signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/auth/LogOut";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcmIdmAuth_LogOut(_response);
        });
    }

    protected processAcmIdmAuth_LogOut(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    acmIdmAuth_SignOutComplete(signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/auth/logout/callback";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcmIdmAuth_SignOutComplete(_response);
        });
    }

    protected processAcmIdmAuth_SignOutComplete(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Uitloggen van een gebruiker uit de Klip Web front-end zonder uit te loggen bij ACM/IDM, dit laat de gebruiker toe te wisselen van organisatie.
     */
    acmIdmAuth_SwitchIdentity(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/auth/switch";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcmIdmAuth_SwitchIdentity(_response);
        });
    }

    protected processAcmIdmAuth_SwitchIdentity(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 302) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    acmIdmAuth_IsAuthenticated(signal?: AbortSignal): Promise<EnvelopeOfBoolean> {
        let url_ = this.baseUrl + "/auth/isAuthenticated";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcmIdmAuth_IsAuthenticated(_response);
        });
    }

    protected processAcmIdmAuth_IsAuthenticated(response: AxiosResponse): Promise<EnvelopeOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfBoolean.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfBoolean>(null as any);
    }

    acmIdmAuth_AcmIdmRegistrationLinks(organisationCode?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfAcmIdmRegistrationLinks> {
        let url_ = this.baseUrl + "/auth/AcmIdmRegistrationLinks?";
        if (organisationCode !== undefined && organisationCode !== null)
            url_ += "organisationCode=" + encodeURIComponent("" + organisationCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcmIdmAuth_AcmIdmRegistrationLinks(_response);
        });
    }

    protected processAcmIdmAuth_AcmIdmRegistrationLinks(response: AxiosResponse): Promise<EnvelopeOfAcmIdmRegistrationLinks> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfAcmIdmRegistrationLinks.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfAcmIdmRegistrationLinks>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfAcmIdmRegistrationLinks>(null as any);
    }

    acmIdmAuth_GetUserData(hardRefresh?: boolean | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfUserData> {
        let url_ = this.baseUrl + "/auth/userData?";
        if (hardRefresh !== undefined && hardRefresh !== null)
            url_ += "hardRefresh=" + encodeURIComponent("" + hardRefresh) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcmIdmAuth_GetUserData(_response);
        });
    }

    protected processAcmIdmAuth_GetUserData(response: AxiosResponse): Promise<EnvelopeOfUserData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfUserData.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfUserData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfUserData>(null as any);
    }

    acmIdmAuth_HasPendingImpersonationConsent(userId?: string | undefined, organisationId?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfUserImpersonationDto> {
        let url_ = this.baseUrl + "/auth/HasPendingImpersonationConsent?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (organisationId !== undefined && organisationId !== null)
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcmIdmAuth_HasPendingImpersonationConsent(_response);
        });
    }

    protected processAcmIdmAuth_HasPendingImpersonationConsent(response: AxiosResponse): Promise<EnvelopeOfUserImpersonationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfUserImpersonationDto.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfUserImpersonationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfUserImpersonationDto>(null as any);
    }

    acmIdmAuth_ChangeImpersonationConsent(userId?: string | undefined, userImpersonationId?: string | undefined, consent?: boolean | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/auth/ChangeImpersonationConsent?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (userImpersonationId === null)
            throw new globalThis.Error("The parameter 'userImpersonationId' cannot be null.");
        else if (userImpersonationId !== undefined)
            url_ += "userImpersonationId=" + encodeURIComponent("" + userImpersonationId) + "&";
        if (consent === null)
            throw new globalThis.Error("The parameter 'consent' cannot be null.");
        else if (consent !== undefined)
            url_ += "consent=" + encodeURIComponent("" + consent) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcmIdmAuth_ChangeImpersonationConsent(_response);
        });
    }

    protected processAcmIdmAuth_ChangeImpersonationConsent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets all CodeLists
     */
    codeLists_GetAll(signal?: AbortSignal): Promise<EnvelopeOfCodeLists> {
        let url_ = this.baseUrl + "/bff/CodeLists";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCodeLists_GetAll(_response);
        });
    }

    protected processCodeLists_GetAll(response: AxiosResponse): Promise<EnvelopeOfCodeLists> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfCodeLists.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfCodeLists>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfCodeLists>(null as any);
    }

    document_DownloadImklAttachment(mapRequestId: string, fileId: string, signal?: AbortSignal): Promise<EnvelopeOfStream> {
        let url_ = this.baseUrl + "/bff/Document/imklattachment/{mapRequestId}/{fileId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocument_DownloadImklAttachment(_response);
        });
    }

    protected processDocument_DownloadImklAttachment(response: AxiosResponse): Promise<EnvelopeOfStream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfStream.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfStream>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfStream>(null as any);
    }

    document_DownloadMapRequestPrintPackage(printId: string, signal?: AbortSignal): Promise<EnvelopeOfStream> {
        let url_ = this.baseUrl + "/bff/Document/Print/{printId}";
        if (printId === undefined || printId === null)
            throw new globalThis.Error("The parameter 'printId' must be defined.");
        url_ = url_.replace("{printId}", encodeURIComponent("" + printId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocument_DownloadMapRequestPrintPackage(_response);
        });
    }

    protected processDocument_DownloadMapRequestPrintPackage(response: AxiosResponse): Promise<EnvelopeOfStream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfStream.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfStream>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfStream>(null as any);
    }

    document_DownloadImklTestFile(imklFileId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/bff/Document/downloadimkltestfile/{imklFileId}";
        if (imklFileId === undefined || imklFileId === null)
            throw new globalThis.Error("The parameter 'imklFileId' must be defined.");
        url_ = url_.replace("{imklFileId}", encodeURIComponent("" + imklFileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocument_DownloadImklTestFile(_response);
        });
    }

    protected processDocument_DownloadImklTestFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    document_DownloadImklTestFileAttachment(fileId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/bff/Document/imklattachment/test/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocument_DownloadImklTestFileAttachment(_response);
        });
    }

    protected processDocument_DownloadImklTestFileAttachment(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    document_DownloadKlipPackage(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfStream> {
        let url_ = this.baseUrl + "/bff/Document/downloadpmklfile/{mapRequestId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocument_DownloadKlipPackage(_response);
        });
    }

    protected processDocument_DownloadKlipPackage(response: AxiosResponse): Promise<EnvelopeOfStream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            let result202: any = null;
            let resultData202  = _responseText;
            result202 = EnvelopeOfStream.fromJS(resultData202);
            return Promise.resolve<EnvelopeOfStream>(result202);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfStream>(null as any);
    }

    document_DownloadKlipPackageForUna(mapRequestId: string, zoneId: string, signal?: AbortSignal): Promise<EnvelopeOfStream> {
        let url_ = this.baseUrl + "/bff/Document/downloadpmklfile/{mapRequestId}/{zoneId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        if (zoneId === undefined || zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' must be defined.");
        url_ = url_.replace("{zoneId}", encodeURIComponent("" + zoneId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocument_DownloadKlipPackageForUna(_response);
        });
    }

    protected processDocument_DownloadKlipPackageForUna(response: AxiosResponse): Promise<EnvelopeOfStream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            let result202: any = null;
            let resultData202  = _responseText;
            result202 = EnvelopeOfStream.fromJS(resultData202);
            return Promise.resolve<EnvelopeOfStream>(result202);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfStream>(null as any);
    }

    document_DownloadImklFile(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfStream> {
        let url_ = this.baseUrl + "/bff/Document/downloadimklfile/{mapRequestId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocument_DownloadImklFile(_response);
        });
    }

    protected processDocument_DownloadImklFile(response: AxiosResponse): Promise<EnvelopeOfStream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfStream.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfStream>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 405) {
            const _responseText = response.data;
            let result405: any = null;
            let resultData405  = _responseText;
            result405 = EnvelopeOfString.fromJS(resultData405);
            return throwException("A server side error occurred.", status, _responseText, _headers, result405);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfStream>(null as any);
    }

    /**
     * Download IMKL file by map request id and zone id
     * @param mapRequestId Type Guid
     * @param zoneId Type Guid
     * @return Success
     */
    document_DownloadImklFileUna(mapRequestId: string, zoneId: string, signal?: AbortSignal): Promise<Stream> {
        let url_ = this.baseUrl + "/bff/Document/downloadimklfile/{mapRequestId}/una/{zoneId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        if (zoneId === undefined || zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' must be defined.");
        url_ = url_.replace("{zoneId}", encodeURIComponent("" + zoneId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocument_DownloadImklFileUna(_response);
        });
    }

    protected processDocument_DownloadImklFileUna(response: AxiosResponse): Promise<Stream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Stream.fromJS(resultData200);
            return Promise.resolve<Stream>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : null as any;
    
            return throwException("File not found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Stream>(null as any);
    }

    document_DownloadInvoiceFile(type: string, blobName: string, format: string, external: boolean, organisationId?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfStream> {
        let url_ = this.baseUrl + "/bff/Document/downloadinvoicefile/{type}/{blobName}/{format}/{external}?";
        if (type === undefined || type === null)
            throw new globalThis.Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        if (blobName === undefined || blobName === null)
            throw new globalThis.Error("The parameter 'blobName' must be defined.");
        url_ = url_.replace("{blobName}", encodeURIComponent("" + blobName));
        if (format === undefined || format === null)
            throw new globalThis.Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (external === undefined || external === null)
            throw new globalThis.Error("The parameter 'external' must be defined.");
        url_ = url_.replace("{external}", encodeURIComponent("" + external));
        if (organisationId !== undefined && organisationId !== null)
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocument_DownloadInvoiceFile(_response);
        });
    }

    protected processDocument_DownloadInvoiceFile(response: AxiosResponse): Promise<EnvelopeOfStream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfStream.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfStream>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfStream>(null as any);
    }

    document_DownloadInvoiceFiles(fromDate?: string | undefined, toDate?: string | undefined, organisationId?: string | null | undefined, klipUserId?: string | null | undefined, docNr?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfStream> {
        let url_ = this.baseUrl + "/bff/Document/downloadinvoicesfile?";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (organisationId !== undefined && organisationId !== null)
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        if (klipUserId !== undefined && klipUserId !== null)
            url_ += "klipUserId=" + encodeURIComponent("" + klipUserId) + "&";
        if (docNr !== undefined && docNr !== null)
            url_ += "docNr=" + encodeURIComponent("" + docNr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocument_DownloadInvoiceFiles(_response);
        });
    }

    protected processDocument_DownloadInvoiceFiles(response: AxiosResponse): Promise<EnvelopeOfStream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfStream.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfStream>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfStream>(null as any);
    }

    /**
     * Generate download file for maprequests list
     * @param request Type GetMapRequestsRepliedInput
     */
    document_DownloadMapRequestsReplied(request: GetMapRequestsRepliedInput, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/bff/Document/maprequests/downloadmaprequestsreplied";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocument_DownloadMapRequestsReplied(_response);
        });
    }

    protected processDocument_DownloadMapRequestsReplied(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Download zone file by maprequestId, zoneId and Format
     * @return Success
     */
    document_DownloadMapRequestZoneFileAsUna(mapRequestId: string, zoneId: string, format: string, isArchived: boolean, coordinateSystem: CoordinateSystem, signal?: AbortSignal): Promise<EnvelopeOfStream> {
        let url_ = this.baseUrl + "/bff/Document/maprequestzonefile/download/{mapRequestId}/{zoneId}/{format}/{isArchived}/{coordinateSystem}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        if (zoneId === undefined || zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' must be defined.");
        url_ = url_.replace("{zoneId}", encodeURIComponent("" + zoneId));
        if (format === undefined || format === null)
            throw new globalThis.Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (isArchived === undefined || isArchived === null)
            throw new globalThis.Error("The parameter 'isArchived' must be defined.");
        url_ = url_.replace("{isArchived}", encodeURIComponent("" + isArchived));
        if (coordinateSystem === undefined || coordinateSystem === null)
            throw new globalThis.Error("The parameter 'coordinateSystem' must be defined.");
        url_ = url_.replace("{coordinateSystem}", encodeURIComponent("" + coordinateSystem));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocument_DownloadMapRequestZoneFileAsUna(_response);
        });
    }

    protected processDocument_DownloadMapRequestZoneFileAsUna(response: AxiosResponse): Promise<EnvelopeOfStream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfStream.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfStream>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("File not found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfStream>(null as any);
    }

    /**
     * Download maprequest zone file by mapRequestId and Format
     * @return Success
     */
    document_DownloadMapRequestZoneFile(mapRequestId: string, format: string, isArchived: boolean, coordinateSystem: CoordinateSystem, signal?: AbortSignal): Promise<EnvelopeOfStream> {
        let url_ = this.baseUrl + "/bff/Document/maprequestzonefile/download/{mapRequestId}/{format}/{isArchived}/{coordinateSystem}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        if (format === undefined || format === null)
            throw new globalThis.Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (isArchived === undefined || isArchived === null)
            throw new globalThis.Error("The parameter 'isArchived' must be defined.");
        url_ = url_.replace("{isArchived}", encodeURIComponent("" + isArchived));
        if (coordinateSystem === undefined || coordinateSystem === null)
            throw new globalThis.Error("The parameter 'coordinateSystem' must be defined.");
        url_ = url_.replace("{coordinateSystem}", encodeURIComponent("" + coordinateSystem));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocument_DownloadMapRequestZoneFile(_response);
        });
    }

    protected processDocument_DownloadMapRequestZoneFile(response: AxiosResponse): Promise<EnvelopeOfStream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfStream.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfStream>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("File not found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfStream>(null as any);
    }

    /**
     * Donwload maprequest archive
     */
    document_DownloadMapRequestArchive(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Document/maprequest/downloadarchive/{mapRequestId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocument_DownloadMapRequestArchive(_response);
        });
    }

    protected processDocument_DownloadMapRequestArchive(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    /**
     * Download maprequest archive
     */
    document_DownloadMapRequestArchiveForUna(mapRequestId: string, zoneId: string, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Document/maprequest/downloadarchive/{mapRequestId}/{zoneId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        if (zoneId === undefined || zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' must be defined.");
        url_ = url_.replace("{zoneId}", encodeURIComponent("" + zoneId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocument_DownloadMapRequestArchiveForUna(_response);
        });
    }

    protected processDocument_DownloadMapRequestArchiveForUna(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    document_DownloadZoneFile(pdaZoneId: string, format: string, coordinateSystem: CoordinateSystem, signal?: AbortSignal): Promise<Stream> {
        let url_ = this.baseUrl + "/bff/Document/DownloadZoneFile/{pdaZoneId}/{format}/{coordinateSystem}";
        if (pdaZoneId === undefined || pdaZoneId === null)
            throw new globalThis.Error("The parameter 'pdaZoneId' must be defined.");
        url_ = url_.replace("{pdaZoneId}", encodeURIComponent("" + pdaZoneId));
        if (format === undefined || format === null)
            throw new globalThis.Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (coordinateSystem === undefined || coordinateSystem === null)
            throw new globalThis.Error("The parameter 'coordinateSystem' must be defined.");
        url_ = url_.replace("{coordinateSystem}", encodeURIComponent("" + coordinateSystem));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocument_DownloadZoneFile(_response);
        });
    }

    protected processDocument_DownloadZoneFile(response: AxiosResponse): Promise<Stream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Stream.fromJS(resultData200);
            return Promise.resolve<Stream>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Stream>(null as any);
    }

    /**
     * Download maprequest zone file by mapRequestId and Format
     * @return Success
     */
    document_DownloadMapRequestOverlayZone(mapRequestId: string, format: string, coordinateSystem: CoordinateSystem, signal?: AbortSignal): Promise<EnvelopeOfStream> {
        let url_ = this.baseUrl + "/bff/Document/maprequestoverlayzonefile/download/{mapRequestId}/{format}/{coordinateSystem}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        if (format === undefined || format === null)
            throw new globalThis.Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (coordinateSystem === undefined || coordinateSystem === null)
            throw new globalThis.Error("The parameter 'coordinateSystem' must be defined.");
        url_ = url_.replace("{coordinateSystem}", encodeURIComponent("" + coordinateSystem));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocument_DownloadMapRequestOverlayZone(_response);
        });
    }

    protected processDocument_DownloadMapRequestOverlayZone(response: AxiosResponse): Promise<EnvelopeOfStream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfStream.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfStream>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("File not found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfStream>(null as any);
    }

    /**
     * Generate download file for maprequests list
     * @param request Type GetMapRequestsRequest
     */
    document_DownloadFile(request: GetMapRequestsInput, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/bff/Document/maprequests/DownloadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocument_DownloadFile(_response);
        });
    }

    protected processDocument_DownloadFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Generate download file for maprequests list
     * @param request Type GetUsersInput
     */
    document_ExportUsers(request: GetUsersInput, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/bff/Document/users/ExportUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDocument_ExportUsers(_response);
        });
    }

    protected processDocument_ExportUsers(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    enforcer_SearchEnforcerMapRequestView(signal?: AbortSignal): Promise<EnvelopeOfSearchEnforcerMapRequestView> {
        let url_ = this.baseUrl + "/bff/Enforcer/SearchEnforcerMapRequestView";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnforcer_SearchEnforcerMapRequestView(_response);
        });
    }

    protected processEnforcer_SearchEnforcerMapRequestView(response: AxiosResponse): Promise<EnvelopeOfSearchEnforcerMapRequestView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfSearchEnforcerMapRequestView.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfSearchEnforcerMapRequestView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfSearchEnforcerMapRequestView>(null as any);
    }

    enforcer_GetMapRequestsCount(request: GetEnforcerMapRequestsInput, signal?: AbortSignal): Promise<EnvelopeOfInteger> {
        let url_ = this.baseUrl + "/bff/Enforcer/GetMapRequestsCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnforcer_GetMapRequestsCount(_response);
        });
    }

    protected processEnforcer_GetMapRequestsCount(response: AxiosResponse): Promise<EnvelopeOfInteger> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfInteger.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfInteger>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfInteger>(null as any);
    }

    enforcer_GetMapRequests(request: GetEnforcerMapRequestsInput, signal?: AbortSignal): Promise<EnvelopeOfICollectionOfMapRequestListItem> {
        let url_ = this.baseUrl + "/bff/Enforcer/GetMapRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnforcer_GetMapRequests(_response);
        });
    }

    protected processEnforcer_GetMapRequests(response: AxiosResponse): Promise<EnvelopeOfICollectionOfMapRequestListItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfICollectionOfMapRequestListItem.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfICollectionOfMapRequestListItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfICollectionOfMapRequestListItem>(null as any);
    }

    enforcer_GetMapRequest(mapRequestId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfEnforcerMapRequest> {
        let url_ = this.baseUrl + "/bff/Enforcer/GetMapRequest?";
        if (mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' cannot be null.");
        else if (mapRequestId !== undefined)
            url_ += "mapRequestId=" + encodeURIComponent("" + mapRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnforcer_GetMapRequest(_response);
        });
    }

    protected processEnforcer_GetMapRequest(response: AxiosResponse): Promise<EnvelopeOfEnforcerMapRequest> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfEnforcerMapRequest.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfEnforcerMapRequest>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfEnforcerMapRequest>(null as any);
    }

    enforcer_GetArchivedMapRequest(mapRequestId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfArchivedEnforcerMapRequest> {
        let url_ = this.baseUrl + "/bff/Enforcer/GetArchivedMapRequest?";
        if (mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' cannot be null.");
        else if (mapRequestId !== undefined)
            url_ += "mapRequestId=" + encodeURIComponent("" + mapRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnforcer_GetArchivedMapRequest(_response);
        });
    }

    protected processEnforcer_GetArchivedMapRequest(response: AxiosResponse): Promise<EnvelopeOfArchivedEnforcerMapRequest> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfArchivedEnforcerMapRequest.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfArchivedEnforcerMapRequest>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfArchivedEnforcerMapRequest>(null as any);
    }

    /**
     * Gets all FeatureFlags
     */
    featureFlags_GetAll(signal?: AbortSignal): Promise<EnvelopeOfIListOfFeatureFlag> {
        let url_ = this.baseUrl + "/bff/FeatureFlags";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFeatureFlags_GetAll(_response);
        });
    }

    protected processFeatureFlags_GetAll(response: AxiosResponse): Promise<EnvelopeOfIListOfFeatureFlag> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfIListOfFeatureFlag.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfIListOfFeatureFlag>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfIListOfFeatureFlag>(null as any);
    }

    geometries_ConvertLambert72ToLambert2008(wkt: string, signal?: AbortSignal): Promise<EnvelopeOfLambert72ToLambert2008ConversionResponse> {
        let url_ = this.baseUrl + "/bff/Geometries/ConvertLambert72ToLambert2008";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(wkt);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGeometries_ConvertLambert72ToLambert2008(_response);
        });
    }

    protected processGeometries_ConvertLambert72ToLambert2008(response: AxiosResponse): Promise<EnvelopeOfLambert72ToLambert2008ConversionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfLambert72ToLambert2008ConversionResponse.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfLambert72ToLambert2008ConversionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfLambert72ToLambert2008ConversionResponse>(null as any);
    }

    /**
     * The Version function returns the applicationInfo. The primary goal of this function serves as an action to be called by the WatchDog Logic App to prevent application warmup.
     */
    home_Version(signal?: AbortSignal): Promise<ApplicationInfo> {
        let url_ = this.baseUrl + "/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHome_Version(_response);
        });
    }

    protected processHome_Version(response: AxiosResponse): Promise<ApplicationInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApplicationInfo.fromJS(resultData200);
            return Promise.resolve<ApplicationInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationInfo>(null as any);
    }

    home_AppContext(signal?: AbortSignal): Promise<EnvelopeOfUserData> {
        let url_ = this.baseUrl + "/AppContext";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHome_AppContext(_response);
        });
    }

    protected processHome_AppContext(response: AxiosResponse): Promise<EnvelopeOfUserData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfUserData.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfUserData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfUserData>(null as any);
    }

    home_DownloadArchiveViewer(version?: string | null | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/downloadviewer?";
        if (version !== undefined && version !== null)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHome_DownloadArchiveViewer(_response);
        });
    }

    protected processHome_DownloadArchiveViewer(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    home_Prices(signal?: AbortSignal): Promise<PriceDto> {
        let url_ = this.baseUrl + "/prices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHome_Prices(_response);
        });
    }

    protected processHome_Prices(response: AxiosResponse): Promise<PriceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PriceDto.fromJS(resultData200);
            return Promise.resolve<PriceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PriceDto>(null as any);
    }

    home_ViewerVersion(signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/version/viewer";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHome_ViewerVersion(_response);
        });
    }

    protected processHome_ViewerVersion(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    home_DownloadArchiveViewerVersions(signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/availableviewerversions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHome_DownloadArchiveViewerVersions(_response);
        });
    }

    protected processHome_DownloadArchiveViewerVersions(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    imklTest_UploadImklFile(file?: FileParameter | null | undefined, signal?: AbortSignal): Promise<UploadImklFileResult> {
        let url_ = this.baseUrl + "/bff/ImklTest/uploadimklfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImklTest_UploadImklFile(_response);
        });
    }

    protected processImklTest_UploadImklFile(response: AxiosResponse): Promise<UploadImklFileResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UploadImklFileResult.fromJS(resultData200);
            return Promise.resolve<UploadImklFileResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadImklFileResult>(null as any);
    }

    /**
     * Get imkl test result viewModel
     * @param imklFileId imklFileId
     */
    imklTest_GetImklTestResultView(imklFileId: string, signal?: AbortSignal): Promise<EnvelopeOfImklTestResultViewModel> {
        let url_ = this.baseUrl + "/bff/ImklTest/getimkltestresultview/{imklFileId}";
        if (imklFileId === undefined || imklFileId === null)
            throw new globalThis.Error("The parameter 'imklFileId' must be defined.");
        url_ = url_.replace("{imklFileId}", encodeURIComponent("" + imklFileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImklTest_GetImklTestResultView(_response);
        });
    }

    protected processImklTest_GetImklTestResultView(response: AxiosResponse): Promise<EnvelopeOfImklTestResultViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfImklTestResultViewModel.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfImklTestResultViewModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfImklTestResultViewModel>(null as any);
    }

    /**
     * Get Pmkl
     * @param imklFileId imklFileId
     */
    imklTest_GetImklTestPmkl(imklFileId: string, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/ImklTest/getimkltestpmkl/{imklFileId}";
        if (imklFileId === undefined || imklFileId === null)
            throw new globalThis.Error("The parameter 'imklFileId' must be defined.");
        url_ = url_.replace("{imklFileId}", encodeURIComponent("" + imklFileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImklTest_GetImklTestPmkl(_response);
        });
    }

    protected processImklTest_GetImklTestPmkl(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    /**
     * Get imkl test viewModel
     */
    imklTest_GetImklTestView(signal?: AbortSignal): Promise<EnvelopeOfImklTestViewModel> {
        let url_ = this.baseUrl + "/bff/ImklTest/getimkltestview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImklTest_GetImklTestView(_response);
        });
    }

    protected processImklTest_GetImklTestView(response: AxiosResponse): Promise<EnvelopeOfImklTestViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfImklTestViewModel.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfImklTestViewModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfImklTestViewModel>(null as any);
    }

    /**
     * Get viewer viewModel
     * @param imklFileId imklFileId
     */
    imklTest_GetViewer(imklFileId: string, signal?: AbortSignal): Promise<EnvelopeOfImklTestViewerViewModel> {
        let url_ = this.baseUrl + "/bff/ImklTest/viewer/{imklFileId}";
        if (imklFileId === undefined || imklFileId === null)
            throw new globalThis.Error("The parameter 'imklFileId' must be defined.");
        url_ = url_.replace("{imklFileId}", encodeURIComponent("" + imklFileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImklTest_GetViewer(_response);
        });
    }

    protected processImklTest_GetViewer(response: AxiosResponse): Promise<EnvelopeOfImklTestViewerViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfImklTestViewerViewModel.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfImklTestViewerViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfImklTestViewerViewModel>(null as any);
    }

    /**
     * Get full address suggestions based on a supplied address
     */
    location_GetAddressSuggestion(address: string, signal?: AbortSignal): Promise<EnvelopeOfStringOf> {
        let url_ = this.baseUrl + "/bff/Location/addresssuggestion/{address}";
        if (address === undefined || address === null)
            throw new globalThis.Error("The parameter 'address' must be defined.");
        url_ = url_.replace("{address}", encodeURIComponent("" + address));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocation_GetAddressSuggestion(_response);
        });
    }

    protected processLocation_GetAddressSuggestion(response: AxiosResponse): Promise<EnvelopeOfStringOf> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfStringOf.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfStringOf>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfStringOf>(null as any);
    }

    /**
     * Get the zipcodes based on the city and street
     */
    location_GetZipCodes(street: string, city: string, signal?: AbortSignal): Promise<EnvelopeOfStringOf> {
        let url_ = this.baseUrl + "/bff/Location/zipcodes/{city}/{street}";
        if (street === undefined || street === null)
            throw new globalThis.Error("The parameter 'street' must be defined.");
        url_ = url_.replace("{street}", encodeURIComponent("" + street));
        if (city === undefined || city === null)
            throw new globalThis.Error("The parameter 'city' must be defined.");
        url_ = url_.replace("{city}", encodeURIComponent("" + city));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocation_GetZipCodes(_response);
        });
    }

    protected processLocation_GetZipCodes(response: AxiosResponse): Promise<EnvelopeOfStringOf> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfStringOf.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfStringOf>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfStringOf>(null as any);
    }

    /**
     * Get the street number based on the city and street
     */
    location_GetStreetNumbers(street: string, city: string, signal?: AbortSignal): Promise<EnvelopeOfStringOf> {
        let url_ = this.baseUrl + "/bff/Location/streetnumbers/{city}/{street}";
        if (street === undefined || street === null)
            throw new globalThis.Error("The parameter 'street' must be defined.");
        url_ = url_.replace("{street}", encodeURIComponent("" + street));
        if (city === undefined || city === null)
            throw new globalThis.Error("The parameter 'city' must be defined.");
        url_ = url_.replace("{city}", encodeURIComponent("" + city));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocation_GetStreetNumbers(_response);
        });
    }

    protected processLocation_GetStreetNumbers(response: AxiosResponse): Promise<EnvelopeOfStringOf> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfStringOf.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfStringOf>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfStringOf>(null as any);
    }

    /**
     * Adds a log entry from the frontend to the backend logging mechanism.
     * @param logEntry Log entry.
     * @return Log entry added successfully.
     */
    log_Add(logEntry: LogEntry, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Log/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(logEntry);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLog_Add(_response);
        });
    }

    protected processLog_Add(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    /**
     * Get email example
     */
    mail_GetEmailExample(emailTemplate: string, firstname: string | null, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Mail/emails/{emailTemplate}/{firstname}";
        if (emailTemplate === undefined || emailTemplate === null)
            throw new globalThis.Error("The parameter 'emailTemplate' must be defined.");
        url_ = url_.replace("{emailTemplate}", encodeURIComponent("" + emailTemplate));
        if (firstname === undefined || firstname === null)
            throw new globalThis.Error("The parameter 'firstname' must be defined.");
        url_ = url_.replace("{firstname}", encodeURIComponent("" + firstname));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMail_GetEmailExample(_response);
        });
    }

    protected processMail_GetEmailExample(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    /**
     * Get application messages
     */
    messages_GetApplicationMessages(signal?: AbortSignal): Promise<EnvelopeOfApplicationMessages> {
        let url_ = this.baseUrl + "/bff/Messages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMessages_GetApplicationMessages(_response);
        });
    }

    protected processMessages_GetApplicationMessages(response: AxiosResponse): Promise<EnvelopeOfApplicationMessages> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfApplicationMessages.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfApplicationMessages>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfApplicationMessages>(null as any);
    }

    /**
     * Get all active and pending maprequests for a user based on search criteria.
     * @param request Type GetMapRequestsInput
     */
    mri_GetMapRequests(request: GetMapRequestsInput, signal?: AbortSignal): Promise<EnvelopeOfGetMapRequestsView> {
        let url_ = this.baseUrl + "/bff/Mri/maprequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMri_GetMapRequests(_response);
        });
    }

    protected processMri_GetMapRequests(response: AxiosResponse): Promise<EnvelopeOfGetMapRequestsView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfGetMapRequestsView.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfGetMapRequestsView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfGetMapRequestsView>(null as any);
    }

    /**
     * Create a new maprequest for overlay
     */
    mri_CreateMapRequestForOverlay(input: CreateMapRequestForOverlayInput, signal?: AbortSignal): Promise<EnvelopeOfCreateMapRequestForOverlay> {
        let url_ = this.baseUrl + "/bff/Mri/maprequests/overlay/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMri_CreateMapRequestForOverlay(_response);
        });
    }

    protected processMri_CreateMapRequestForOverlay(response: AxiosResponse): Promise<EnvelopeOfCreateMapRequestForOverlay> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfCreateMapRequestForOverlay.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfCreateMapRequestForOverlay>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfCreateMapRequestForOverlay>(null as any);
    }

    /**
     * Get count of all maprequests for a user based on search criteria.
     * @param request Type GetMapRequestsInput
     */
    mri_GetMapRequestsCount(request: GetMapRequestsInput, signal?: AbortSignal): Promise<EnvelopeOfInteger> {
        let url_ = this.baseUrl + "/bff/Mri/maprequests/count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMri_GetMapRequestsCount(_response);
        });
    }

    protected processMri_GetMapRequestsCount(response: AxiosResponse): Promise<EnvelopeOfInteger> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfInteger.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfInteger>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfInteger>(null as any);
    }

    /**
     * Get the Tags for the maprequest list
     */
    mri_GetTags(signal?: AbortSignal): Promise<EnvelopeOfListOfString> {
        let url_ = this.baseUrl + "/bff/Mri/maprequests/tags";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMri_GetTags(_response);
        });
    }

    protected processMri_GetTags(response: AxiosResponse): Promise<EnvelopeOfListOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfListOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfListOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfListOfString>(null as any);
    }

    /**
     * Add a Tag for a maprequest
     * @param tag (optional) 
     * @param mapRequestId (optional) 
     */
    mri_AddTag(tag?: string | null | undefined, mapRequestId?: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/bff/Mri/maprequests/addtag?";
        if (tag !== undefined && tag !== null)
            url_ += "tag=" + encodeURIComponent("" + tag) + "&";
        if (mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' cannot be null.");
        else if (mapRequestId !== undefined)
            url_ += "mapRequestId=" + encodeURIComponent("" + mapRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMri_AddTag(_response);
        });
    }

    protected processMri_AddTag(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete a Tag of a maprequest
     * @param tag (optional) Type String
     * @param mapRequestId (optional) Type Guid
     */
    mri_DeleteTag(tag?: string | null | undefined, mapRequestId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Mri/maprequests/deletetag?";
        if (tag !== undefined && tag !== null)
            url_ += "tag=" + encodeURIComponent("" + tag) + "&";
        if (mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' cannot be null.");
        else if (mapRequestId !== undefined)
            url_ += "mapRequestId=" + encodeURIComponent("" + mapRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMri_DeleteTag(_response);
        });
    }

    protected processMri_DeleteTag(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    /**
     * Get Pmkl status of a maprequest
     */
    mri_GetPmklAssetsStatus(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfAssetsStatusMri> {
        let url_ = this.baseUrl + "/bff/Mri/maprequests/{mapRequestId}/pmklassets/status";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMri_GetPmklAssetsStatus(_response);
        });
    }

    protected processMri_GetPmklAssetsStatus(response: AxiosResponse): Promise<EnvelopeOfAssetsStatusMri> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfAssetsStatusMri.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfAssetsStatusMri>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfAssetsStatusMri>(null as any);
    }

    /**
     * Order imkl file by mapRequestId
     * @return Success
     */
    mri_OrderImklFile(orderImklMapRequestInput: OrderImklMapRequestInput, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Mri/maprequest/orderimklfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderImklMapRequestInput);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMri_OrderImklFile(_response);
        });
    }

    protected processMri_OrderImklFile(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = EnvelopeOfFailureResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 405) {
            const _responseText = response.data;
            let result405: any = null;
            let resultData405  = _responseText;
            result405 = EnvelopeOfFailureResult.fromJS(resultData405);
            return throwException("Method not allowed: In case of citizen, in case the Imkl has already been ordered for MapRequest", status, _responseText, _headers, result405);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    mri_GetInvoicesAndPaymentReceipts(query: InvoicesAndPaymentReceiptsQuery, signal?: AbortSignal): Promise<EnvelopeOfInvoicesAndPaymentReceiptsResponse> {
        let url_ = this.baseUrl + "/bff/Mri/GetInvoicesAndPaymentReceipts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMri_GetInvoicesAndPaymentReceipts(_response);
        });
    }

    protected processMri_GetInvoicesAndPaymentReceipts(response: AxiosResponse): Promise<EnvelopeOfInvoicesAndPaymentReceiptsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfInvoicesAndPaymentReceiptsResponse.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfInvoicesAndPaymentReceiptsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfInvoicesAndPaymentReceiptsResponse>(null as any);
    }

    /**
     * Get maprequest responders by maprequest id
     */
    mri_GetMapRequestResponders(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfMapRequestRespondersData> {
        let url_ = this.baseUrl + "/bff/Mri/maprequest/responders/{mapRequestId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMri_GetMapRequestResponders(_response);
        });
    }

    protected processMri_GetMapRequestResponders(response: AxiosResponse): Promise<EnvelopeOfMapRequestRespondersData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfMapRequestRespondersData.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfMapRequestRespondersData>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfMapRequestRespondersData>(null as any);
    }

    /**
     * Get MapRequest Prints
     * @param mapRequestId Type Guid
     */
    mri_GetMapRequestPrints(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfIListOfMapRequestPrintView> {
        let url_ = this.baseUrl + "/bff/Mri/maprequest/getprints/{mapRequestId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMri_GetMapRequestPrints(_response);
        });
    }

    protected processMri_GetMapRequestPrints(response: AxiosResponse): Promise<EnvelopeOfIListOfMapRequestPrintView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfIListOfMapRequestPrintView.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfIListOfMapRequestPrintView>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfIListOfMapRequestPrintView>(null as any);
    }

    /**
     * Get MapRequest Prints
     * @param request PrintMapRequestData needed for printing
     */
    mri_PrintMapRequest(request: PrintMapRequestInput, signal?: AbortSignal): Promise<EnvelopeOfPrintMapRequestView> {
        let url_ = this.baseUrl + "/bff/Mri/maprequest/print";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMri_PrintMapRequest(_response);
        });
    }

    protected processMri_PrintMapRequest(response: AxiosResponse): Promise<EnvelopeOfPrintMapRequestView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfPrintMapRequestView.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfPrintMapRequestView>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfPrintMapRequestView>(null as any);
    }

    /**
     * Get MapRequest Pmkl
     * @param mapRequestId Type Guid
     */
    mri_GetMapRequestPmkl(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Mri/maprequest/getpmkl/{mapRequestId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMri_GetMapRequestPmkl(_response);
        });
    }

    protected processMri_GetMapRequestPmkl(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    /**
     * Get MapRequest Pmkl as stream
     * @param mapRequestId Type Guid
     */
    mri_GetMapRequestPmklStream(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfStream> {
        let url_ = this.baseUrl + "/bff/Mri/maprequest/getpmklstream/{mapRequestId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMri_GetMapRequestPmklStream(_response);
        });
    }

    protected processMri_GetMapRequestPmklStream(response: AxiosResponse): Promise<EnvelopeOfStream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfStream.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfStream>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfStream>(null as any);
    }

    /**
     * Get MapRequest Wfs
     * @param mapRequestId Type Guid
     */
    mri_GetMapRequestWfs(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Mri/maprequest/getwfs/{mapRequestId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMri_GetMapRequestWfs(_response);
        });
    }

    protected processMri_GetMapRequestWfs(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    /**
     * Get MapRequest Wfs stream
     * @param mapRequestId Type Guid
     */
    mri_GetMapRequestWfsStream(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Mri/maprequest/getwfsstream/{mapRequestId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMri_GetMapRequestWfsStream(_response);
        });
    }

    protected processMri_GetMapRequestWfsStream(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    /**
     * Get MapRequest KmHm stream
     * @param mapRequestId Type Guid
     */
    mri_GetMapRequestKmHmStream(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Mri/maprequest/getkmhmstream/{mapRequestId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMri_GetMapRequestKmHmStream(_response);
        });
    }

    protected processMri_GetMapRequestKmHmStream(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    /**
     * Create a new maprequest
     */
    mri_CreateMapRequest(input: CreateOrUpdateMapRequestInput, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Mri/maprequests/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMri_CreateMapRequest(_response);
        });
    }

    protected processMri_CreateMapRequest(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = EnvelopeOfStringOf.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfStringOf.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 405) {
            const _responseText = response.data;
            let result405: any = null;
            let resultData405  = _responseText;
            result405 = EnvelopeOfStringOf.fromJS(resultData405);
            return throwException("A server side error occurred.", status, _responseText, _headers, result405);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    /**
     * Get maprequest status by maprequest id
    Remark: This api action calls the GetMapRequestById just to retrieve the status of the maprequest. A dedicated api action to get the status should be created instead.
     */
    mri_GetMapRequestStatus(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfMapRequestStatusData> {
        let url_ = this.baseUrl + "/bff/Mri/maprequest/status/{mapRequestId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMri_GetMapRequestStatus(_response);
        });
    }

    protected processMri_GetMapRequestStatus(response: AxiosResponse): Promise<EnvelopeOfMapRequestStatusData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfMapRequestStatusData.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfMapRequestStatusData>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfMapRequestStatusData>(null as any);
    }

    /**
     * Gets the ViewModel for the mri maprequests list view
     */
    mri_GetMapRequestListViewMri(signal?: AbortSignal): Promise<EnvelopeOfMapRequestListViewMri> {
        let url_ = this.baseUrl + "/bff/Mri/maprequestlistview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMri_GetMapRequestListViewMri(_response);
        });
    }

    protected processMri_GetMapRequestListViewMri(response: AxiosResponse): Promise<EnvelopeOfMapRequestListViewMri> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfMapRequestListViewMri.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfMapRequestListViewMri>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfMapRequestListViewMri>(null as any);
    }

    /**
     * Gets the ViewModel for the create maprequest view
        - For a new maprequest
        - For a resubmitted maprequest archive 
        - For a resubmitted maprequest non-archive
        - For a maprequest from shoppingcart in edit mode
        - For an overlay
     * @param mapRequestId (optional) 
     * @param createMapRequestType (optional) 
     */
    mri_GetCreateMapRequestView(mapRequestId?: string | null | undefined, createMapRequestType?: CreateMapRequestType | undefined, signal?: AbortSignal): Promise<EnvelopeOfCreateMapRequestView> {
        let url_ = this.baseUrl + "/bff/Mri/createmaprequestview?";
        if (mapRequestId !== undefined && mapRequestId !== null)
            url_ += "MapRequestId=" + encodeURIComponent("" + mapRequestId) + "&";
        if (createMapRequestType === null)
            throw new globalThis.Error("The parameter 'createMapRequestType' cannot be null.");
        else if (createMapRequestType !== undefined)
            url_ += "CreateMapRequestType=" + encodeURIComponent("" + createMapRequestType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMri_GetCreateMapRequestView(_response);
        });
    }

    protected processMri_GetCreateMapRequestView(response: AxiosResponse): Promise<EnvelopeOfCreateMapRequestView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfCreateMapRequestView.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfCreateMapRequestView>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfCreateMapRequestView>(null as any);
    }

    /**
     * Gets the ViewModel for the create maprequest for overlay view
     */
    mri_GetCreateMapRequestForOverlayView(signal?: AbortSignal): Promise<EnvelopeOfCreateMapRequestForOverlayView> {
        let url_ = this.baseUrl + "/bff/Mri/createmaprequestforoverlayview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMri_GetCreateMapRequestForOverlayView(_response);
        });
    }

    protected processMri_GetCreateMapRequestForOverlayView(response: AxiosResponse): Promise<EnvelopeOfCreateMapRequestForOverlayView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfCreateMapRequestForOverlayView.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfCreateMapRequestForOverlayView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfCreateMapRequestForOverlayView>(null as any);
    }

    /**
     * Gets the ViewModel for the maprequest for
    view
     */
    mri_GetMapRequestForOverlayView(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfMapRequestForOverlayView> {
        let url_ = this.baseUrl + "/bff/Mri/maprequestforoverlayview/{MapRequestId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{MapRequestId}", encodeURIComponent("" + mapRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMri_GetMapRequestForOverlayView(_response);
        });
    }

    protected processMri_GetMapRequestForOverlayView(response: AxiosResponse): Promise<EnvelopeOfMapRequestForOverlayView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfMapRequestForOverlayView.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfMapRequestForOverlayView>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfMapRequestForOverlayView>(null as any);
    }

    /**
     * Get maprequest by id view
     */
    mri_GetMapRequestView(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfMapRequestViewMri> {
        let url_ = this.baseUrl + "/bff/Mri/maprequestview/{mapRequestId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMri_GetMapRequestView(_response);
        });
    }

    protected processMri_GetMapRequestView(response: AxiosResponse): Promise<EnvelopeOfMapRequestViewMri> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfMapRequestViewMri.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfMapRequestViewMri>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfMapRequestViewMri>(null as any);
    }

    /**
     * Get viewer viewModel
     * @param mapRequestId Type Guid
     */
    mri_GetViewer(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfMriViewerViewModel> {
        let url_ = this.baseUrl + "/bff/Mri/viewer/{mapRequestId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMri_GetViewer(_response);
        });
    }

    protected processMri_GetViewer(response: AxiosResponse): Promise<EnvelopeOfMriViewerViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfMriViewerViewModel.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfMriViewerViewModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfMriViewerViewModel>(null as any);
    }

    operations_SearchOperationsMapRequestView(signal?: AbortSignal): Promise<EnvelopeOfSearchOperationsMapRequestView> {
        let url_ = this.baseUrl + "/bff/Operations/SearchOperationsMapRequestView";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_SearchOperationsMapRequestView(_response);
        });
    }

    protected processOperations_SearchOperationsMapRequestView(response: AxiosResponse): Promise<EnvelopeOfSearchOperationsMapRequestView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfSearchOperationsMapRequestView.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfSearchOperationsMapRequestView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfSearchOperationsMapRequestView>(null as any);
    }

    operations_SearchOperationsMapRequestForUserView(signal?: AbortSignal): Promise<EnvelopeOfSearchOperationsMapRequestForUserView> {
        let url_ = this.baseUrl + "/bff/Operations/SearchOperationsMapRequestForUserView";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_SearchOperationsMapRequestForUserView(_response);
        });
    }

    protected processOperations_SearchOperationsMapRequestForUserView(response: AxiosResponse): Promise<EnvelopeOfSearchOperationsMapRequestForUserView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfSearchOperationsMapRequestForUserView.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfSearchOperationsMapRequestForUserView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfSearchOperationsMapRequestForUserView>(null as any);
    }

    operations_SearchOperationsMapRequestForOrganisationView(organisationId?: string | undefined, mapRequestForOrganisationType?: SearchOperationsMapRequestForOrganisationType | undefined, signal?: AbortSignal): Promise<EnvelopeOfSearchOperationsMapRequestForOrganisationView> {
        let url_ = this.baseUrl + "/bff/Operations/SearchOperationsMapRequestForOrganisationView?";
        if (organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' cannot be null.");
        else if (organisationId !== undefined)
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        if (mapRequestForOrganisationType === null)
            throw new globalThis.Error("The parameter 'mapRequestForOrganisationType' cannot be null.");
        else if (mapRequestForOrganisationType !== undefined)
            url_ += "mapRequestForOrganisationType=" + encodeURIComponent("" + mapRequestForOrganisationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_SearchOperationsMapRequestForOrganisationView(_response);
        });
    }

    protected processOperations_SearchOperationsMapRequestForOrganisationView(response: AxiosResponse): Promise<EnvelopeOfSearchOperationsMapRequestForOrganisationView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfSearchOperationsMapRequestForOrganisationView.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfSearchOperationsMapRequestForOrganisationView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfSearchOperationsMapRequestForOrganisationView>(null as any);
    }

    operations_GetMapRequestsCount(request: GetOperationsMapRequestsInput, signal?: AbortSignal): Promise<EnvelopeOfInteger> {
        let url_ = this.baseUrl + "/bff/Operations/GetMapRequestsCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_GetMapRequestsCount(_response);
        });
    }

    protected processOperations_GetMapRequestsCount(response: AxiosResponse): Promise<EnvelopeOfInteger> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfInteger.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfInteger>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfInteger>(null as any);
    }

    operations_GetMapRequests(request: GetOperationsMapRequestsInput, signal?: AbortSignal): Promise<EnvelopeOfICollectionOfMapRequestListItem2> {
        let url_ = this.baseUrl + "/bff/Operations/GetMapRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_GetMapRequests(_response);
        });
    }

    protected processOperations_GetMapRequests(response: AxiosResponse): Promise<EnvelopeOfICollectionOfMapRequestListItem2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfICollectionOfMapRequestListItem2.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfICollectionOfMapRequestListItem2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfICollectionOfMapRequestListItem2>(null as any);
    }

    operations_GetMapRequest(mapRequestId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfOperationsMapRequest> {
        let url_ = this.baseUrl + "/bff/Operations/GetMapRequest?";
        if (mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' cannot be null.");
        else if (mapRequestId !== undefined)
            url_ += "mapRequestId=" + encodeURIComponent("" + mapRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_GetMapRequest(_response);
        });
    }

    protected processOperations_GetMapRequest(response: AxiosResponse): Promise<EnvelopeOfOperationsMapRequest> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfOperationsMapRequest.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfOperationsMapRequest>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfOperationsMapRequest>(null as any);
    }

    operations_GetArchivedMapRequest(mapRequestId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfOperationsArchivedMapRequest> {
        let url_ = this.baseUrl + "/bff/Operations/GetArchivedMapRequest?";
        if (mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' cannot be null.");
        else if (mapRequestId !== undefined)
            url_ += "mapRequestId=" + encodeURIComponent("" + mapRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_GetArchivedMapRequest(_response);
        });
    }

    protected processOperations_GetArchivedMapRequest(response: AxiosResponse): Promise<EnvelopeOfOperationsArchivedMapRequest> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfOperationsArchivedMapRequest.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfOperationsArchivedMapRequest>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfOperationsArchivedMapRequest>(null as any);
    }

    operations_GetUnaAuditLog(mapRequestId?: string | undefined, zoneId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfIListOfAuditLog> {
        let url_ = this.baseUrl + "/bff/Operations/GetUnaAuditLog?";
        if (mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' cannot be null.");
        else if (mapRequestId !== undefined)
            url_ += "mapRequestId=" + encodeURIComponent("" + mapRequestId) + "&";
        if (zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_GetUnaAuditLog(_response);
        });
    }

    protected processOperations_GetUnaAuditLog(response: AxiosResponse): Promise<EnvelopeOfIListOfAuditLog> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfIListOfAuditLog.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfIListOfAuditLog>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfIListOfAuditLog>(null as any);
    }

    operations_MoveMapRequests(mapRequestsToMove: MoveMapRequestsInput, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/bff/Operations/MoveMapRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mapRequestsToMove);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_MoveMapRequests(_response);
        });
    }

    protected processOperations_MoveMapRequests(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    operations_GetOrganisations(request: GetOrganisationsInput, signal?: AbortSignal): Promise<EnvelopeOfOrganisationsPagedResult> {
        let url_ = this.baseUrl + "/bff/Operations/GetOrganisations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_GetOrganisations(_response);
        });
    }

    protected processOperations_GetOrganisations(response: AxiosResponse): Promise<EnvelopeOfOrganisationsPagedResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfOrganisationsPagedResult.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfOrganisationsPagedResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfOrganisationsPagedResult>(null as any);
    }

    operations_GetOrganisationDetail(organisationId: string, signal?: AbortSignal): Promise<EnvelopeOfOrganisationDetail> {
        let url_ = this.baseUrl + "/bff/Operations/GetOrganisationDetail/{organisationId}";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_GetOrganisationDetail(_response);
        });
    }

    protected processOperations_GetOrganisationDetail(response: AxiosResponse): Promise<EnvelopeOfOrganisationDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfOrganisationDetail.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfOrganisationDetail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfOrganisationDetail>(null as any);
    }

    operations_GetOrganisationInvoiceDetail(organisationId: string, signal?: AbortSignal): Promise<EnvelopeOfOrganisationInvoiceSettings> {
        let url_ = this.baseUrl + "/bff/Operations/GetOrganisationInvoiceDetail/{organisationId}";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_GetOrganisationInvoiceDetail(_response);
        });
    }

    protected processOperations_GetOrganisationInvoiceDetail(response: AxiosResponse): Promise<EnvelopeOfOrganisationInvoiceSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfOrganisationInvoiceSettings.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfOrganisationInvoiceSettings>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfOrganisationInvoiceSettings>(null as any);
    }

    operations_GetOrganisationInvoiceSettings(organisationId: string, signal?: AbortSignal): Promise<EnvelopeOfInvoiceSettingsForOrganisation> {
        let url_ = this.baseUrl + "/bff/Operations/GetOrganisationInvoiceSettings/{organisationId}";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_GetOrganisationInvoiceSettings(_response);
        });
    }

    protected processOperations_GetOrganisationInvoiceSettings(response: AxiosResponse): Promise<EnvelopeOfInvoiceSettingsForOrganisation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfInvoiceSettingsForOrganisation.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfInvoiceSettingsForOrganisation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfInvoiceSettingsForOrganisation>(null as any);
    }

    operations_UpdateOrganisationInvoiceDetail(updateOrganisationInvoiceData: UpdateOperationInvoiceDataInput, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/bff/Operations/UpdateOrganisationInvoiceDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateOrganisationInvoiceData);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_UpdateOrganisationInvoiceDetail(_response);
        });
    }

    protected processOperations_UpdateOrganisationInvoiceDetail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    operations_UpdateOrganisationPaymentSettings(input: UpdateOrganisationPaymentSettingsInput, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/bff/Operations/UpdateOrganisationPaymentSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_UpdateOrganisationPaymentSettings(_response);
        });
    }

    protected processOperations_UpdateOrganisationPaymentSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    operations_CreateOrUpdateOrganisationActor(request: UpdateOrganisationActorInput, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/bff/Operations/CreateOrUpdateOrganisationActor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_CreateOrUpdateOrganisationActor(_response);
        });
    }

    protected processOperations_CreateOrUpdateOrganisationActor(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    operations_GetSubOrganisationDetail(organisationId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfSubOrganisationDetail> {
        let url_ = this.baseUrl + "/bff/Operations/GetSubOrganisationDetail?";
        if (organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' cannot be null.");
        else if (organisationId !== undefined)
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_GetSubOrganisationDetail(_response);
        });
    }

    protected processOperations_GetSubOrganisationDetail(response: AxiosResponse): Promise<EnvelopeOfSubOrganisationDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfSubOrganisationDetail.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfSubOrganisationDetail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfSubOrganisationDetail>(null as any);
    }

    operations_DeleteOrganisation(organisationId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/bff/Operations/DeleteOrganisation/{organisationId}";
        if (organisationId === undefined || organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' must be defined.");
        url_ = url_.replace("{organisationId}", encodeURIComponent("" + organisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_DeleteOrganisation(_response);
        });
    }

    protected processOperations_DeleteOrganisation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    operations_UpdateConfirmationInUnaZoneSettings(input: UpdateConfirmationInUnaZoneSettingsInput, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/bff/Operations/UpdateConfirmationInUnaZoneSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_UpdateConfirmationInUnaZoneSettings(_response);
        });
    }

    protected processOperations_UpdateConfirmationInUnaZoneSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    operations_GetActorByAthumiId(athumiId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfActorDto> {
        let url_ = this.baseUrl + "/bff/Operations/GetActorByAthumiId?";
        if (athumiId === null)
            throw new globalThis.Error("The parameter 'athumiId' cannot be null.");
        else if (athumiId !== undefined)
            url_ += "athumiId=" + encodeURIComponent("" + athumiId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_GetActorByAthumiId(_response);
        });
    }

    protected processOperations_GetActorByAthumiId(response: AxiosResponse): Promise<EnvelopeOfActorDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfActorDto.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfActorDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfActorDto>(null as any);
    }

    operations_GetSubOrganisationUnaZone(organisationId?: string | undefined, zoneId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfSubOrganisationUnaZoneDetail> {
        let url_ = this.baseUrl + "/bff/Operations/GetSubOrganisationUnaZone?";
        if (organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' cannot be null.");
        else if (organisationId !== undefined)
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        if (zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_GetSubOrganisationUnaZone(_response);
        });
    }

    protected processOperations_GetSubOrganisationUnaZone(response: AxiosResponse): Promise<EnvelopeOfSubOrganisationUnaZoneDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfSubOrganisationUnaZoneDetail.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfSubOrganisationUnaZoneDetail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfSubOrganisationUnaZoneDetail>(null as any);
    }

    operations_GetPdaZones(organisationId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfIListOfZoneListItem> {
        let url_ = this.baseUrl + "/bff/Operations/zones?";
        if (organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' cannot be null.");
        else if (organisationId !== undefined)
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_GetPdaZones(_response);
        });
    }

    protected processOperations_GetPdaZones(response: AxiosResponse): Promise<EnvelopeOfIListOfZoneListItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfIListOfZoneListItem.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfIListOfZoneListItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfIListOfZoneListItem>(null as any);
    }

    operations_GetVersions(signal?: AbortSignal): Promise<EnvelopeOfICollectionOfVersionDto> {
        let url_ = this.baseUrl + "/bff/Operations/GetVersions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_GetVersions(_response);
        });
    }

    protected processOperations_GetVersions(response: AxiosResponse): Promise<EnvelopeOfICollectionOfVersionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfICollectionOfVersionDto.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfICollectionOfVersionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfICollectionOfVersionDto>(null as any);
    }

    operations_AddVersion(request: AddVersionRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/bff/Operations/AddVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_AddVersion(_response);
        });
    }

    protected processOperations_AddVersion(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    operations_Prices(signal?: AbortSignal): Promise<EnvelopeOfIListOfPriceDto> {
        let url_ = this.baseUrl + "/bff/Operations/Prices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_Prices(_response);
        });
    }

    protected processOperations_Prices(response: AxiosResponse): Promise<EnvelopeOfIListOfPriceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfIListOfPriceDto.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfIListOfPriceDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfIListOfPriceDto>(null as any);
    }

    operations_Holidays(signal?: AbortSignal): Promise<EnvelopeOfIDictionaryOfIntegerAndListOfDateTime> {
        let url_ = this.baseUrl + "/bff/Operations/Holidays";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_Holidays(_response);
        });
    }

    protected processOperations_Holidays(response: AxiosResponse): Promise<EnvelopeOfIDictionaryOfIntegerAndListOfDateTime> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfIDictionaryOfIntegerAndListOfDateTime.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfIDictionaryOfIntegerAndListOfDateTime>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfIDictionaryOfIntegerAndListOfDateTime>(null as any);
    }

    operations_Messages(signal?: AbortSignal): Promise<EnvelopeOfIListOfMessageDto> {
        let url_ = this.baseUrl + "/bff/Operations/Messages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_Messages(_response);
        });
    }

    protected processOperations_Messages(response: AxiosResponse): Promise<EnvelopeOfIListOfMessageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfIListOfMessageDto.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfIListOfMessageDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfIListOfMessageDto>(null as any);
    }

    operations_UpdateMessage(request: UpdateMessageRequest, signal?: AbortSignal): Promise<EnvelopeOfIListOfMessageDto> {
        let url_ = this.baseUrl + "/bff/Operations/Messages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_UpdateMessage(_response);
        });
    }

    protected processOperations_UpdateMessage(response: AxiosResponse): Promise<EnvelopeOfIListOfMessageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfIListOfMessageDto.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfIListOfMessageDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfIListOfMessageDto>(null as any);
    }

    operations_DeleteMessage(messageId?: number | undefined, signal?: AbortSignal): Promise<EnvelopeOfBoolean> {
        let url_ = this.baseUrl + "/bff/Operations/Messages?";
        if (messageId === null)
            throw new globalThis.Error("The parameter 'messageId' cannot be null.");
        else if (messageId !== undefined)
            url_ += "messageId=" + encodeURIComponent("" + messageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOperations_DeleteMessage(_response);
        });
    }

    protected processOperations_DeleteMessage(response: AxiosResponse): Promise<EnvelopeOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfBoolean.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfBoolean>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfBoolean>(null as any);
    }

    organisation_CreateOrganisation(organisationSettingsInput: OrganisationSettingsInput, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Organisation/CreateOrganisation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organisationSettingsInput);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganisation_CreateOrganisation(_response);
        });
    }

    protected processOrganisation_CreateOrganisation(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    organisation_EditOrganisation(organisationSettingsInput: OrganisationSettingsInput, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Organisation/EditOrganisation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organisationSettingsInput);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganisation_EditOrganisation(_response);
        });
    }

    protected processOrganisation_EditOrganisation(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    organisation_EditUnaSettingsForOrganisation(organisationUnaSettingsInput: OrganisationUnaSettingsInput, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Organisation/EditUnaSettingsForOrganisation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organisationUnaSettingsInput);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganisation_EditUnaSettingsForOrganisation(_response);
        });
    }

    protected processOrganisation_EditUnaSettingsForOrganisation(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    organisation_LoadSettingsForOrganisation(signal?: AbortSignal): Promise<EnvelopeOfSettingsForOrganisationView> {
        let url_ = this.baseUrl + "/bff/Organisation/LoadSettingsForOrganisation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganisation_LoadSettingsForOrganisation(_response);
        });
    }

    protected processOrganisation_LoadSettingsForOrganisation(response: AxiosResponse): Promise<EnvelopeOfSettingsForOrganisationView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfSettingsForOrganisationView.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfSettingsForOrganisationView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfSettingsForOrganisationView>(null as any);
    }

    organisation_LoadCreateOrganisationView(signal?: AbortSignal): Promise<EnvelopeOfCreateOrganisationView> {
        let url_ = this.baseUrl + "/bff/Organisation/LoadCreateOrganisationView";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganisation_LoadCreateOrganisationView(_response);
        });
    }

    protected processOrganisation_LoadCreateOrganisationView(response: AxiosResponse): Promise<EnvelopeOfCreateOrganisationView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfCreateOrganisationView.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfCreateOrganisationView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfCreateOrganisationView>(null as any);
    }

    organisation_LoadEditOrganisationView(organisationId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfEditOrganisationView> {
        let url_ = this.baseUrl + "/bff/Organisation/LoadEditOrganisationView?";
        if (organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' cannot be null.");
        else if (organisationId !== undefined)
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganisation_LoadEditOrganisationView(_response);
        });
    }

    protected processOrganisation_LoadEditOrganisationView(response: AxiosResponse): Promise<EnvelopeOfEditOrganisationView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfEditOrganisationView.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfEditOrganisationView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfEditOrganisationView>(null as any);
    }

    organisation_GetOrganisation(organisationId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfOrganisation> {
        let url_ = this.baseUrl + "/bff/Organisation/GetOrganisation?";
        if (organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' cannot be null.");
        else if (organisationId !== undefined)
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganisation_GetOrganisation(_response);
        });
    }

    protected processOrganisation_GetOrganisation(response: AxiosResponse): Promise<EnvelopeOfOrganisation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfOrganisation.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfOrganisation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfOrganisation>(null as any);
    }

    organisation_LoadUnaZonesForOrganisation(organisationId?: string | undefined, includeArchived?: boolean | undefined, signal?: AbortSignal): Promise<EnvelopeOfICollectionOfZoneNamespace> {
        let url_ = this.baseUrl + "/bff/Organisation/LoadUnaZonesForOrganisation?";
        if (organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' cannot be null.");
        else if (organisationId !== undefined)
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        if (includeArchived === null)
            throw new globalThis.Error("The parameter 'includeArchived' cannot be null.");
        else if (includeArchived !== undefined)
            url_ += "includeArchived=" + encodeURIComponent("" + includeArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganisation_LoadUnaZonesForOrganisation(_response);
        });
    }

    protected processOrganisation_LoadUnaZonesForOrganisation(response: AxiosResponse): Promise<EnvelopeOfICollectionOfZoneNamespace> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfICollectionOfZoneNamespace.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfICollectionOfZoneNamespace>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfICollectionOfZoneNamespace>(null as any);
    }

    organisation_FilterOrganisationsByName(name?: string | null | undefined, onlyIncludeUnaOrganisations?: boolean | null | undefined, onlyIncludeRootOrganisations?: boolean | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfICollectionOfOrganisation> {
        let url_ = this.baseUrl + "/bff/Organisation/FilterOrganisationsByName?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (onlyIncludeUnaOrganisations !== undefined && onlyIncludeUnaOrganisations !== null)
            url_ += "onlyIncludeUnaOrganisations=" + encodeURIComponent("" + onlyIncludeUnaOrganisations) + "&";
        if (onlyIncludeRootOrganisations !== undefined && onlyIncludeRootOrganisations !== null)
            url_ += "onlyIncludeRootOrganisations=" + encodeURIComponent("" + onlyIncludeRootOrganisations) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganisation_FilterOrganisationsByName(_response);
        });
    }

    protected processOrganisation_FilterOrganisationsByName(response: AxiosResponse): Promise<EnvelopeOfICollectionOfOrganisation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfICollectionOfOrganisation.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfICollectionOfOrganisation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfICollectionOfOrganisation>(null as any);
    }

    organisation_GetOrganisationHierarchyFlatList(organisationId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfICollectionOfOrganisationHierarchyFlatListItem> {
        let url_ = this.baseUrl + "/bff/Organisation/GetOrganisationHierarchyFlatList?";
        if (organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' cannot be null.");
        else if (organisationId !== undefined)
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganisation_GetOrganisationHierarchyFlatList(_response);
        });
    }

    protected processOrganisation_GetOrganisationHierarchyFlatList(response: AxiosResponse): Promise<EnvelopeOfICollectionOfOrganisationHierarchyFlatListItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfICollectionOfOrganisationHierarchyFlatListItem.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfICollectionOfOrganisationHierarchyFlatListItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfICollectionOfOrganisationHierarchyFlatListItem>(null as any);
    }

    payment_GetShoppingCartStatus(signal?: AbortSignal): Promise<EnvelopeOfShoppingCartStatus> {
        let url_ = this.baseUrl + "/bff/Payment/getshoppingcartstatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPayment_GetShoppingCartStatus(_response);
        });
    }

    protected processPayment_GetShoppingCartStatus(response: AxiosResponse): Promise<EnvelopeOfShoppingCartStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfShoppingCartStatus.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfShoppingCartStatus>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = FailureResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = FailureResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = FailureResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 405) {
            const _responseText = response.data;
            let result405: any = null;
            let resultData405  = _responseText;
            result405 = FailureResult.fromJS(resultData405);
            return throwException("A server side error occurred.", status, _responseText, _headers, result405);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfShoppingCartStatus>(null as any);
    }

    payment_GetPrepaidAmount(signal?: AbortSignal): Promise<EnvelopeOfPrepaidAmount> {
        let url_ = this.baseUrl + "/bff/Payment/getprepaidamount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPayment_GetPrepaidAmount(_response);
        });
    }

    protected processPayment_GetPrepaidAmount(response: AxiosResponse): Promise<EnvelopeOfPrepaidAmount> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfPrepaidAmount.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfPrepaidAmount>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = FailureResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = FailureResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = FailureResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 405) {
            const _responseText = response.data;
            let result405: any = null;
            let resultData405  = _responseText;
            result405 = FailureResult.fromJS(resultData405);
            return throwException("A server side error occurred.", status, _responseText, _headers, result405);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfPrepaidAmount>(null as any);
    }

    payment_DeleteShoppingCartMapRequest(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfGetCurrentShoppingCartResult> {
        let url_ = this.baseUrl + "/bff/Payment/deleteshoppingcartmaprequest/{mapRequestId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPayment_DeleteShoppingCartMapRequest(_response);
        });
    }

    protected processPayment_DeleteShoppingCartMapRequest(response: AxiosResponse): Promise<EnvelopeOfGetCurrentShoppingCartResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfGetCurrentShoppingCartResult.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfGetCurrentShoppingCartResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = FailureResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = FailureResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = FailureResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 405) {
            const _responseText = response.data;
            let result405: any = null;
            let resultData405  = _responseText;
            result405 = FailureResult.fromJS(resultData405);
            return throwException("A server side error occurred.", status, _responseText, _headers, result405);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfGetCurrentShoppingCartResult>(null as any);
    }

    payment_DeleteShoppingCart(signal?: AbortSignal): Promise<EnvelopeOfBoolean> {
        let url_ = this.baseUrl + "/bff/Payment/deleteshoppingcart";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPayment_DeleteShoppingCart(_response);
        });
    }

    protected processPayment_DeleteShoppingCart(response: AxiosResponse): Promise<EnvelopeOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfBoolean.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfBoolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = FailureResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = FailureResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = FailureResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 405) {
            const _responseText = response.data;
            let result405: any = null;
            let resultData405  = _responseText;
            result405 = FailureResult.fromJS(resultData405);
            return throwException("A server side error occurred.", status, _responseText, _headers, result405);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfBoolean>(null as any);
    }

    payment_DeleteShoppingCartMapRequestExtra(mapRequestExtraId: number, signal?: AbortSignal): Promise<EnvelopeOfGetCurrentShoppingCartResult> {
        let url_ = this.baseUrl + "/bff/Payment/deleteshoppingcartmaprequestextra/{mapRequestExtraId}";
        if (mapRequestExtraId === undefined || mapRequestExtraId === null)
            throw new globalThis.Error("The parameter 'mapRequestExtraId' must be defined.");
        url_ = url_.replace("{mapRequestExtraId}", encodeURIComponent("" + mapRequestExtraId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPayment_DeleteShoppingCartMapRequestExtra(_response);
        });
    }

    protected processPayment_DeleteShoppingCartMapRequestExtra(response: AxiosResponse): Promise<EnvelopeOfGetCurrentShoppingCartResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfGetCurrentShoppingCartResult.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfGetCurrentShoppingCartResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = FailureResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = FailureResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = FailureResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 405) {
            const _responseText = response.data;
            let result405: any = null;
            let resultData405  = _responseText;
            result405 = FailureResult.fromJS(resultData405);
            return throwException("A server side error occurred.", status, _responseText, _headers, result405);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfGetCurrentShoppingCartResult>(null as any);
    }

    payment_Checkout(checkoutInput: CheckoutInput, signal?: AbortSignal): Promise<EnvelopeOfDictionaryOfStringAndString> {
        let url_ = this.baseUrl + "/bff/Payment/checkout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(checkoutInput);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPayment_Checkout(_response);
        });
    }

    protected processPayment_Checkout(response: AxiosResponse): Promise<EnvelopeOfDictionaryOfStringAndString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfDictionaryOfStringAndString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfDictionaryOfStringAndString>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = FailureResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = FailureResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = FailureResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 405) {
            const _responseText = response.data;
            let result405: any = null;
            let resultData405  = _responseText;
            result405 = EnvelopeOfString.fromJS(resultData405);
            return throwException("A server side error occurred.", status, _responseText, _headers, result405);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfDictionaryOfStringAndString>(null as any);
    }

    payment_GetShoppingCartView(signal?: AbortSignal): Promise<EnvelopeOfShoppingCartViewModel> {
        let url_ = this.baseUrl + "/bff/Payment/getshoppingcartview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPayment_GetShoppingCartView(_response);
        });
    }

    protected processPayment_GetShoppingCartView(response: AxiosResponse): Promise<EnvelopeOfShoppingCartViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfShoppingCartViewModel.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfShoppingCartViewModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = FailureResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = FailureResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = FailureResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 405) {
            const _responseText = response.data;
            let result405: any = null;
            let resultData405  = _responseText;
            result405 = EnvelopeOfString.fromJS(resultData405);
            return throwException("A server side error occurred.", status, _responseText, _headers, result405);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfShoppingCartViewModel>(null as any);
    }

    payment_GetShoppingCartCheckoutView(signal?: AbortSignal): Promise<EnvelopeOfShoppingCartCheckoutViewModel> {
        let url_ = this.baseUrl + "/bff/Payment/getshoppingcartcheckoutview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPayment_GetShoppingCartCheckoutView(_response);
        });
    }

    protected processPayment_GetShoppingCartCheckoutView(response: AxiosResponse): Promise<EnvelopeOfShoppingCartCheckoutViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfShoppingCartCheckoutViewModel.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfShoppingCartCheckoutViewModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = FailureResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = FailureResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = FailureResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 405) {
            const _responseText = response.data;
            let result405: any = null;
            let resultData405  = _responseText;
            result405 = EnvelopeOfString.fromJS(resultData405);
            return throwException("A server side error occurred.", status, _responseText, _headers, result405);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfShoppingCartCheckoutViewModel>(null as any);
    }

    payment_GetPrepaidCheckoutView(signal?: AbortSignal): Promise<EnvelopeOfPrepaidCheckoutViewModel> {
        let url_ = this.baseUrl + "/bff/Payment/getprepaidcheckoutview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPayment_GetPrepaidCheckoutView(_response);
        });
    }

    protected processPayment_GetPrepaidCheckoutView(response: AxiosResponse): Promise<EnvelopeOfPrepaidCheckoutViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfPrepaidCheckoutViewModel.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfPrepaidCheckoutViewModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = FailureResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = FailureResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = FailureResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 405) {
            const _responseText = response.data;
            let result405: any = null;
            let resultData405  = _responseText;
            result405 = EnvelopeOfString.fromJS(resultData405);
            return throwException("A server side error occurred.", status, _responseText, _headers, result405);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfPrepaidCheckoutViewModel>(null as any);
    }

    payment_GetPrepaidView(signal?: AbortSignal): Promise<EnvelopeOfPrepaidViewModel> {
        let url_ = this.baseUrl + "/bff/Payment/getprepaidview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPayment_GetPrepaidView(_response);
        });
    }

    protected processPayment_GetPrepaidView(response: AxiosResponse): Promise<EnvelopeOfPrepaidViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfPrepaidViewModel.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfPrepaidViewModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = FailureResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = FailureResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = FailureResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 405) {
            const _responseText = response.data;
            let result405: any = null;
            let resultData405  = _responseText;
            result405 = FailureResult.fromJS(resultData405);
            return throwException("A server side error occurred.", status, _responseText, _headers, result405);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfPrepaidViewModel>(null as any);
    }

    payment_ActivePrice(signal?: AbortSignal): Promise<EnvelopeOfPriceDto> {
        let url_ = this.baseUrl + "/bff/Payment/ActivePrice";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPayment_ActivePrice(_response);
        });
    }

    protected processPayment_ActivePrice(response: AxiosResponse): Promise<EnvelopeOfPriceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfPriceDto.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfPriceDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = FailureResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = FailureResult.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = FailureResult.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 405) {
            const _responseText = response.data;
            let result405: any = null;
            let resultData405  = _responseText;
            result405 = FailureResult.fromJS(resultData405);
            return throwException("A server side error occurred.", status, _responseText, _headers, result405);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfPriceDto>(null as any);
    }

    paymentProcessing_CheckShoppingCartPaymentState(shoppingCartId: string, signal?: AbortSignal): Promise<EnvelopeOfShoppingCartPaymentStatusResult> {
        let url_ = this.baseUrl + "/bff/PaymentProcessing/CheckShoppingCartPaymentState/{shoppingCartId}";
        if (shoppingCartId === undefined || shoppingCartId === null)
            throw new globalThis.Error("The parameter 'shoppingCartId' must be defined.");
        url_ = url_.replace("{shoppingCartId}", encodeURIComponent("" + shoppingCartId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaymentProcessing_CheckShoppingCartPaymentState(_response);
        });
    }

    protected processPaymentProcessing_CheckShoppingCartPaymentState(response: AxiosResponse): Promise<EnvelopeOfShoppingCartPaymentStatusResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfShoppingCartPaymentStatusResult.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfShoppingCartPaymentStatusResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfShoppingCartPaymentStatusResult>(null as any);
    }

    paymentProcessing_CheckTopUpPaymentState(returnMac?: string | null | undefined, hostedCheckoutId?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfShoppingCartPaymentStatusResult> {
        let url_ = this.baseUrl + "/bff/PaymentProcessing/CheckTopUpPaymentState?";
        if (returnMac !== undefined && returnMac !== null)
            url_ += "returnMac=" + encodeURIComponent("" + returnMac) + "&";
        if (hostedCheckoutId !== undefined && hostedCheckoutId !== null)
            url_ += "hostedCheckoutId=" + encodeURIComponent("" + hostedCheckoutId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaymentProcessing_CheckTopUpPaymentState(_response);
        });
    }

    protected processPaymentProcessing_CheckTopUpPaymentState(response: AxiosResponse): Promise<EnvelopeOfShoppingCartPaymentStatusResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfShoppingCartPaymentStatusResult.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfShoppingCartPaymentStatusResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfShoppingCartPaymentStatusResult>(null as any);
    }

    /**
     * Get All zones for a pda user
     */
    pda_GetAll(signal?: AbortSignal): Promise<EnvelopeOfIListOfZoneListItem> {
        let url_ = this.baseUrl + "/bff/Pda/zones";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPda_GetAll(_response);
        });
    }

    protected processPda_GetAll(response: AxiosResponse): Promise<EnvelopeOfIListOfZoneListItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfIListOfZoneListItem.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfIListOfZoneListItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfIListOfZoneListItem>(null as any);
    }

    /**
     * Get Zone by Id
     */
    pda_GetZoneById(zoneId: string, includeDownloadUrls: boolean, signal?: AbortSignal): Promise<EnvelopeOfZoneDetails> {
        let url_ = this.baseUrl + "/bff/Pda/zone/{zoneId}/{includeDownloadUrls}";
        if (zoneId === undefined || zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' must be defined.");
        url_ = url_.replace("{zoneId}", encodeURIComponent("" + zoneId));
        if (includeDownloadUrls === undefined || includeDownloadUrls === null)
            throw new globalThis.Error("The parameter 'includeDownloadUrls' must be defined.");
        url_ = url_.replace("{includeDownloadUrls}", encodeURIComponent("" + includeDownloadUrls));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPda_GetZoneById(_response);
        });
    }

    protected processPda_GetZoneById(response: AxiosResponse): Promise<EnvelopeOfZoneDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfZoneDetails.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfZoneDetails>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfZoneDetails>(null as any);
    }

    pda_CreateZone(zone: NewZone, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Pda/zone/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(zone);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPda_CreateZone(_response);
        });
    }

    protected processPda_CreateZone(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    pda_UpdateZone(zone: UpdateZone, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Pda/zone/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(zone);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPda_UpdateZone(_response);
        });
    }

    protected processPda_UpdateZone(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    pda_DeleteZoneById(zoneId: string, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Pda/zone/delete/{zoneId}";
        if (zoneId === undefined || zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' must be defined.");
        url_ = url_.replace("{zoneId}", encodeURIComponent("" + zoneId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPda_DeleteZoneById(_response);
        });
    }

    protected processPda_DeleteZoneById(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    pda_GetUnaZonesByZoneId(zoneId: string, organisationId?: string | undefined, parentOrganisationId?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfIListOfUnaZoneListItem> {
        let url_ = this.baseUrl + "/bff/Pda/zone/unazones/{zoneId}?";
        if (zoneId === undefined || zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' must be defined.");
        url_ = url_.replace("{zoneId}", encodeURIComponent("" + zoneId));
        if (organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' cannot be null.");
        else if (organisationId !== undefined)
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        if (parentOrganisationId !== undefined && parentOrganisationId !== null)
            url_ += "parentOrganisationId=" + encodeURIComponent("" + parentOrganisationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPda_GetUnaZonesByZoneId(_response);
        });
    }

    protected processPda_GetUnaZonesByZoneId(response: AxiosResponse): Promise<EnvelopeOfIListOfUnaZoneListItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfIListOfUnaZoneListItem.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfIListOfUnaZoneListItem>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfIListOfUnaZoneListItem>(null as any);
    }

    pda_GetMapRequests(request: GetPdaMapRequestsInput, signal?: AbortSignal): Promise<EnvelopeOfIListOfMapRequestListItem> {
        let url_ = this.baseUrl + "/bff/Pda/maprequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPda_GetMapRequests(_response);
        });
    }

    protected processPda_GetMapRequests(response: AxiosResponse): Promise<EnvelopeOfIListOfMapRequestListItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfIListOfMapRequestListItem.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfIListOfMapRequestListItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfIListOfMapRequestListItem>(null as any);
    }

    pda_GetMapRequestsCount(request: GetPdaMapRequestsInput, signal?: AbortSignal): Promise<EnvelopeOfInteger> {
        let url_ = this.baseUrl + "/bff/Pda/maprequests/count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPda_GetMapRequestsCount(_response);
        });
    }

    protected processPda_GetMapRequestsCount(response: AxiosResponse): Promise<EnvelopeOfInteger> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfInteger.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfInteger>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfInteger>(null as any);
    }

    pda_GetZoneDetailView(zoneId: string, signal?: AbortSignal): Promise<EnvelopeOfZoneDetailView> {
        let url_ = this.baseUrl + "/bff/Pda/zone/detailview/{zoneId}";
        if (zoneId === undefined || zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' must be defined.");
        url_ = url_.replace("{zoneId}", encodeURIComponent("" + zoneId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPda_GetZoneDetailView(_response);
        });
    }

    protected processPda_GetZoneDetailView(response: AxiosResponse): Promise<EnvelopeOfZoneDetailView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfZoneDetailView.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfZoneDetailView>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfZoneDetailView>(null as any);
    }

    pda_GetMapRequestView(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfMapRequestViewPda> {
        let url_ = this.baseUrl + "/bff/Pda/maprequest/detailview/{mapRequestId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPda_GetMapRequestView(_response);
        });
    }

    protected processPda_GetMapRequestView(response: AxiosResponse): Promise<EnvelopeOfMapRequestViewPda> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfMapRequestViewPda.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfMapRequestViewPda>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfMapRequestViewPda>(null as any);
    }

    /**
     * Update email settings
    Remark: The new settings updates only the mail settings to the request. But the API expects all data from the old UI,
            which isn't used anymore, but still needs to be present for the update or the data is lost.
     */
    settings_UpdateEmailSettings(input: UpdateMailSettingsInput, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Settings/email/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettings_UpdateEmailSettings(_response);
        });
    }

    protected processSettings_UpdateEmailSettings(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = EnvelopeOfString.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    settings_GetSettingsView(signal?: AbortSignal): Promise<EnvelopeOfSettingsView> {
        let url_ = this.baseUrl + "/bff/Settings/settingsview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettings_GetSettingsView(_response);
        });
    }

    protected processSettings_GetSettingsView(response: AxiosResponse): Promise<EnvelopeOfSettingsView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfSettingsView.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfSettingsView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfSettingsView>(null as any);
    }

    settings_GetInvoiceSettings(signal?: AbortSignal): Promise<EnvelopeOfInvoiceSettingsView> {
        let url_ = this.baseUrl + "/bff/Settings/invoicesettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettings_GetInvoiceSettings(_response);
        });
    }

    protected processSettings_GetInvoiceSettings(response: AxiosResponse): Promise<EnvelopeOfInvoiceSettingsView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfInvoiceSettingsView.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfInvoiceSettingsView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfInvoiceSettingsView>(null as any);
    }

    settings_GetOrganisationInvoiceSettings(signal?: AbortSignal): Promise<EnvelopeOfOrganisationInvoiceSettingsView> {
        let url_ = this.baseUrl + "/bff/Settings/organisationinvoicesettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettings_GetOrganisationInvoiceSettings(_response);
        });
    }

    protected processSettings_GetOrganisationInvoiceSettings(response: AxiosResponse): Promise<EnvelopeOfOrganisationInvoiceSettingsView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfOrganisationInvoiceSettingsView.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfOrganisationInvoiceSettingsView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfOrganisationInvoiceSettingsView>(null as any);
    }

    settings_UpdateOrganisationSettings(organisationInvoiceSetting: OrganisationInvoiceSetting, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/bff/Settings/organisationinvoicesettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organisationInvoiceSetting);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettings_UpdateOrganisationSettings(_response);
        });
    }

    protected processSettings_UpdateOrganisationSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    settings_CreateOrganisationInvoiceGroup(organisationInvoiceGroup: OrganisationInvoiceGroup, signal?: AbortSignal): Promise<EnvelopeOfOrganisationInvoiceGroup> {
        let url_ = this.baseUrl + "/bff/Settings/organisationinvoicegroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organisationInvoiceGroup);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettings_CreateOrganisationInvoiceGroup(_response);
        });
    }

    protected processSettings_CreateOrganisationInvoiceGroup(response: AxiosResponse): Promise<EnvelopeOfOrganisationInvoiceGroup> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfOrganisationInvoiceGroup.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfOrganisationInvoiceGroup>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfOrganisationInvoiceGroup>(null as any);
    }

    settings_UpdateOrganisationInvoiceGroup(organisationInvoiceGroup: OrganisationInvoiceGroup, signal?: AbortSignal): Promise<EnvelopeOfOrganisationInvoiceGroup> {
        let url_ = this.baseUrl + "/bff/Settings/organisationinvoicegroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organisationInvoiceGroup);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettings_UpdateOrganisationInvoiceGroup(_response);
        });
    }

    protected processSettings_UpdateOrganisationInvoiceGroup(response: AxiosResponse): Promise<EnvelopeOfOrganisationInvoiceGroup> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfOrganisationInvoiceGroup.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfOrganisationInvoiceGroup>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfOrganisationInvoiceGroup>(null as any);
    }

    settings_DeleteOrganisationInvoiceGroup(organisationInvoiceGroupId?: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/bff/Settings/organisationinvoicegroup?";
        if (organisationInvoiceGroupId === null)
            throw new globalThis.Error("The parameter 'organisationInvoiceGroupId' cannot be null.");
        else if (organisationInvoiceGroupId !== undefined)
            url_ += "organisationInvoiceGroupId=" + encodeURIComponent("" + organisationInvoiceGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettings_DeleteOrganisationInvoiceGroup(_response);
        });
    }

    protected processSettings_DeleteOrganisationInvoiceGroup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    una_ReplyWithImkl(mapRequestId: string, zoneId: string, file?: FileParameter | null | undefined, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/bff/Una/maprequests/imkl/upload/{mapRequestId}/{zoneId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        if (zoneId === undefined || zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' must be defined.");
        url_ = url_.replace("{zoneId}", encodeURIComponent("" + zoneId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUna_ReplyWithImkl(_response);
        });
    }

    protected processUna_ReplyWithImkl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Una response Not Involved
     */
    una_NotInvolved(requestNotInvolvedInput: MapRequestNotInvolvedInput, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/bff/Una/maprequests/notinvolved";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestNotInvolvedInput);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUna_NotInvolved(_response);
        });
    }

    protected processUna_NotInvolved(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status === 202) {
            const _responseText = response.data;
            let result202: any = null;
            let resultData202  = _responseText;
                result202 = resultData202 !== undefined ? resultData202 : null as any;
    
            return Promise.resolve<string>(result202);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 405) {
            const _responseText = response.data;
            let result405: any = null;
            let resultData405  = _responseText;
                result405 = resultData405 !== undefined ? resultData405 : null as any;
    
            return throwException("Imkl already uploaded. Zone doesn\'t answer with Imkl. MapRequest state != Confirmed || state == Closed || state == ImklUploaded", status, _responseText, _headers, result405);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get Imkl File Upload Status
     * @return Data Valid when response is ImklDataValidReportResponse, Data Invalid when response is ImklDataInvalidReportResponse
     */
    una_GetImklFileUploadStatus(mapRequestId: string, zoneId: string, signal?: AbortSignal): Promise<EnvelopeOfImklDataValidationReport> {
        let url_ = this.baseUrl + "/bff/Una/imkl/fileuploadstatus/{mapRequestId}/{zoneId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        if (zoneId === undefined || zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' must be defined.");
        url_ = url_.replace("{zoneId}", encodeURIComponent("" + zoneId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUna_GetImklFileUploadStatus(_response);
        });
    }

    protected processUna_GetImklFileUploadStatus(response: AxiosResponse): Promise<EnvelopeOfImklDataValidationReport> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfImklDataValidationReport.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfImklDataValidationReport>(result200);

        } else if (status === 202) {
            const _responseText = response.data;
            let result202: any = null;
            let resultData202  = _responseText;
            result202 = EnvelopeOfString.fromJS(resultData202);
            return throwException("Data Uploaded", status, _responseText, _headers, result202);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("Data not yet Uploaded", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfImklDataValidationReport>(null as any);
    }

    una_GetPmklAssetsStatus(mapRequestId: string, zoneId: string, signal?: AbortSignal): Promise<EnvelopeOfPmklMapAssetsStatusUna> {
        let url_ = this.baseUrl + "/bff/Una/maprequests/{mapRequestId}/{zoneId}/pmklassets/status";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        if (zoneId === undefined || zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' must be defined.");
        url_ = url_.replace("{zoneId}", encodeURIComponent("" + zoneId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUna_GetPmklAssetsStatus(_response);
        });
    }

    protected processUna_GetPmklAssetsStatus(response: AxiosResponse): Promise<EnvelopeOfPmklMapAssetsStatusUna> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfPmklMapAssetsStatusUna.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfPmklMapAssetsStatusUna>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfPmklMapAssetsStatusUna.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfPmklMapAssetsStatusUna>(null as any);
    }

    /**
     * Get maprequests to confirm for a user based on search criteria.
     * @param request Type GetMapRequestsToConfirmInput
     */
    una_GetMapRequestsToConfirm(request: GetMapRequestsToConfirmInput, signal?: AbortSignal): Promise<EnvelopeOfMapRequestsToConfirmList> {
        let url_ = this.baseUrl + "/bff/Una/maprequests/toconfirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUna_GetMapRequestsToConfirm(_response);
        });
    }

    protected processUna_GetMapRequestsToConfirm(response: AxiosResponse): Promise<EnvelopeOfMapRequestsToConfirmList> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfMapRequestsToConfirmList.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfMapRequestsToConfirmList>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfMapRequestsToConfirmList>(null as any);
    }

    /**
     * Confirm maprequests.
     * @param request Type ConfirmMapRequestReceivedRequest
     */
    una_ConfirmMapRequests(request: ConfirmMapRequestsInput[], signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Una/maprequests/confirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUna_ConfirmMapRequests(_response);
        });
    }

    protected processUna_ConfirmMapRequests(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = EnvelopeOfString.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("Not authorized to confirm map request", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    /**
     * Get maprequests to reply for a user based on search criteria.
     * @param request Type GetMapRequestsToReplyInput
     */
    una_GetMapRequestsToReply(request: GetMapRequestsToReplyInput, signal?: AbortSignal): Promise<EnvelopeOfMapRequestsToReplyList> {
        let url_ = this.baseUrl + "/bff/Una/maprequests/toreply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUna_GetMapRequestsToReply(_response);
        });
    }

    protected processUna_GetMapRequestsToReply(response: AxiosResponse): Promise<EnvelopeOfMapRequestsToReplyList> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfMapRequestsToReplyList.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfMapRequestsToReplyList>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfMapRequestsToReplyList>(null as any);
    }

    /**
     * Get maprequests replied for a user based on search criteria.
     * @param request Type GetMapRequestsRepliedInput
     */
    una_GetMapRequestsReplied(request: GetMapRequestsRepliedInput, signal?: AbortSignal): Promise<EnvelopeOfMapRequestsRepliedList> {
        let url_ = this.baseUrl + "/bff/Una/maprequests/replied";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUna_GetMapRequestsReplied(_response);
        });
    }

    protected processUna_GetMapRequestsReplied(response: AxiosResponse): Promise<EnvelopeOfMapRequestsRepliedList> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfMapRequestsRepliedList.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfMapRequestsRepliedList>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfMapRequestsRepliedList>(null as any);
    }

    /**
     * Get count of all toconfirm maprequests for a user based on search criteria.
     * @param request Type GetMapRequestsToConfirmInput
     */
    una_GetMapRequestsToConfirmCount(request: GetMapRequestsToConfirmInput, signal?: AbortSignal): Promise<EnvelopeOfInteger> {
        let url_ = this.baseUrl + "/bff/Una/maprequests/toconfirm/count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUna_GetMapRequestsToConfirmCount(_response);
        });
    }

    protected processUna_GetMapRequestsToConfirmCount(response: AxiosResponse): Promise<EnvelopeOfInteger> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfInteger.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfInteger>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfInteger>(null as any);
    }

    /**
     * Get count of all toreply maprequests for a user based on search criteria.
     * @param request Type GetMapRequestsToReplyInput
     */
    una_GetMapRequestsToReplyCount(request: GetMapRequestsToReplyInput, signal?: AbortSignal): Promise<EnvelopeOfInteger> {
        let url_ = this.baseUrl + "/bff/Una/maprequests/toreply/count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUna_GetMapRequestsToReplyCount(_response);
        });
    }

    protected processUna_GetMapRequestsToReplyCount(response: AxiosResponse): Promise<EnvelopeOfInteger> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfInteger.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfInteger>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfInteger>(null as any);
    }

    /**
     * Get count of all replied maprequests for a user based on search criteria.
     * @param request Type GetMapRequestsToReplyInput
     */
    una_GetMapRequestsRepliedCount(request: GetMapRequestsRepliedInput, signal?: AbortSignal): Promise<EnvelopeOfInteger> {
        let url_ = this.baseUrl + "/bff/Una/maprequests/replied/count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUna_GetMapRequestsRepliedCount(_response);
        });
    }

    protected processUna_GetMapRequestsRepliedCount(response: AxiosResponse): Promise<EnvelopeOfInteger> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfInteger.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfInteger>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfInteger>(null as any);
    }

    una_GetAllMapRequestCount(request: GetAllMapRequestCountInput, signal?: AbortSignal): Promise<EnvelopeOfMapRequestCount> {
        let url_ = this.baseUrl + "/bff/Una/maprequests/count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUna_GetAllMapRequestCount(_response);
        });
    }

    protected processUna_GetAllMapRequestCount(response: AxiosResponse): Promise<EnvelopeOfMapRequestCount> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfMapRequestCount.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfMapRequestCount>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfMapRequestCount>(null as any);
    }

    /**
     * Get MapRequest Pmkl
     * @param mapRequestId Type Guid
     * @param zoneId Type Guid
     */
    una_GetMapRequestPmkl(mapRequestId: string, zoneId: string, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Una/maprequest/getpmkl/{mapRequestId}/{zoneId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        if (zoneId === undefined || zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' must be defined.");
        url_ = url_.replace("{zoneId}", encodeURIComponent("" + zoneId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUna_GetMapRequestPmkl(_response);
        });
    }

    protected processUna_GetMapRequestPmkl(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    /**
     * Get MapRequest Pmkl as stream
     * @param mapRequestId Type Guid
     * @param zoneId Type Guid
     */
    una_GetMapRequestPmklStream(mapRequestId: string, zoneId: string, signal?: AbortSignal): Promise<EnvelopeOfStream> {
        let url_ = this.baseUrl + "/bff/Una/maprequest/getpmklstream/{mapRequestId}/{zoneId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        if (zoneId === undefined || zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' must be defined.");
        url_ = url_.replace("{zoneId}", encodeURIComponent("" + zoneId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUna_GetMapRequestPmklStream(_response);
        });
    }

    protected processUna_GetMapRequestPmklStream(response: AxiosResponse): Promise<EnvelopeOfStream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfStream.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfStream>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfStream>(null as any);
    }

    /**
     * Get MapRequest Wfs
     * @param mapRequestId Type Guid
     */
    una_GetMapRequestWfs(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Una/maprequest/getwfs/{mapRequestId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUna_GetMapRequestWfs(_response);
        });
    }

    protected processUna_GetMapRequestWfs(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    /**
     * Get MapRequest Wfs stream
     * @param mapRequestId Type Guid
     */
    una_GetMapRequestWfsStream(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Una/maprequest/getwfsstream/{mapRequestId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUna_GetMapRequestWfsStream(_response);
        });
    }

    protected processUna_GetMapRequestWfsStream(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    /**
     * Get MapRequest KmHm stream
     * @param mapRequestId Type Guid
     */
    una_GetMapRequestKmHmStream(mapRequestId: string, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Una/maprequest/getkmhmstream/{mapRequestId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUna_GetMapRequestKmHmStream(_response);
        });
    }

    protected processUna_GetMapRequestKmHmStream(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    una_GetZoneNamespace(zoneId: string, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Una/zone/namespace/{zoneId}";
        if (zoneId === undefined || zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' must be defined.");
        url_ = url_.replace("{zoneId}", encodeURIComponent("" + zoneId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUna_GetZoneNamespace(_response);
        });
    }

    protected processUna_GetZoneNamespace(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    /**
     * Gets the ViewModel for the una maprequests list view
     */
    una_GetMapRequestsListView(signal?: AbortSignal): Promise<EnvelopeOfMapRequestListViewUna> {
        let url_ = this.baseUrl + "/bff/Una/maprequests/maprequestlistview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUna_GetMapRequestsListView(_response);
        });
    }

    protected processUna_GetMapRequestsListView(response: AxiosResponse): Promise<EnvelopeOfMapRequestListViewUna> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfMapRequestListViewUna.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfMapRequestListViewUna>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfMapRequestListViewUna>(null as any);
    }

    una_GetMapRequestViewUna(mapRequestId: string, zoneId: string, isArchived: boolean, signal?: AbortSignal): Promise<EnvelopeOfMapRequestViewUna> {
        let url_ = this.baseUrl + "/bff/Una/maprequests/{mapRequestId}/{zoneId}/{isArchived}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        if (zoneId === undefined || zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' must be defined.");
        url_ = url_.replace("{zoneId}", encodeURIComponent("" + zoneId));
        if (isArchived === undefined || isArchived === null)
            throw new globalThis.Error("The parameter 'isArchived' must be defined.");
        url_ = url_.replace("{isArchived}", encodeURIComponent("" + isArchived));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUna_GetMapRequestViewUna(_response);
        });
    }

    protected processUna_GetMapRequestViewUna(response: AxiosResponse): Promise<EnvelopeOfMapRequestViewUna> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfMapRequestViewUna.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfMapRequestViewUna>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfMapRequestViewUna>(null as any);
    }

    una_GetViewer(mapRequestId: string, zoneId: string, signal?: AbortSignal): Promise<EnvelopeOfUnaViewerViewModel> {
        let url_ = this.baseUrl + "/bff/Una/viewer/{mapRequestId}/{zoneId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        if (zoneId === undefined || zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' must be defined.");
        url_ = url_.replace("{zoneId}", encodeURIComponent("" + zoneId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUna_GetViewer(_response);
        });
    }

    protected processUna_GetViewer(response: AxiosResponse): Promise<EnvelopeOfUnaViewerViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfUnaViewerViewModel.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfUnaViewerViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfUnaViewerViewModel>(null as any);
    }

    una_PrintMapRequest(request: PrintMapRequestInput, signal?: AbortSignal): Promise<EnvelopeOfPrintMapRequestView> {
        let url_ = this.baseUrl + "/bff/Una/maprequest/print";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUna_PrintMapRequest(_response);
        });
    }

    protected processUna_PrintMapRequest(response: AxiosResponse): Promise<EnvelopeOfPrintMapRequestView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfPrintMapRequestView.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfPrintMapRequestView>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfPrintMapRequestView>(null as any);
    }

    una_GetMapRequestPrints(mapRequestId: string, zoneId: string, signal?: AbortSignal): Promise<EnvelopeOfIListOfMapRequestPrintView> {
        let url_ = this.baseUrl + "/bff/Una/maprequest/prints/{mapRequestId}/{zoneId}";
        if (mapRequestId === undefined || mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' must be defined.");
        url_ = url_.replace("{mapRequestId}", encodeURIComponent("" + mapRequestId));
        if (zoneId === undefined || zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' must be defined.");
        url_ = url_.replace("{zoneId}", encodeURIComponent("" + zoneId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUna_GetMapRequestPrints(_response);
        });
    }

    protected processUna_GetMapRequestPrints(response: AxiosResponse): Promise<EnvelopeOfIListOfMapRequestPrintView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfIListOfMapRequestPrintView.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfIListOfMapRequestPrintView>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfIListOfMapRequestPrintView>(null as any);
    }

    unaSettings_GetUnaZoneCreateView(signal?: AbortSignal): Promise<EnvelopeOfUnaZoneCreateView> {
        let url_ = this.baseUrl + "/bff/UnaSettings/GetUnaZoneCreateView";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnaSettings_GetUnaZoneCreateView(_response);
        });
    }

    protected processUnaSettings_GetUnaZoneCreateView(response: AxiosResponse): Promise<EnvelopeOfUnaZoneCreateView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfUnaZoneCreateView.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfUnaZoneCreateView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfUnaZoneCreateView>(null as any);
    }

    unaSettings_GetUnaZoneEditView(zoneId?: string | undefined, organisationId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfUnaZoneEditView> {
        let url_ = this.baseUrl + "/bff/UnaSettings/GetUnaZoneEditView?";
        if (zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        if (organisationId === null)
            throw new globalThis.Error("The parameter 'organisationId' cannot be null.");
        else if (organisationId !== undefined)
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnaSettings_GetUnaZoneEditView(_response);
        });
    }

    protected processUnaSettings_GetUnaZoneEditView(response: AxiosResponse): Promise<EnvelopeOfUnaZoneEditView> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfUnaZoneEditView.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfUnaZoneEditView>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfUnaZoneEditView>(null as any);
    }

    unaSettings_CreateKlipZone(request: CreateKlipZoneInput, signal?: AbortSignal): Promise<EnvelopeOfKlipZoneCreated> {
        let url_ = this.baseUrl + "/bff/UnaSettings/CreateKlipZone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnaSettings_CreateKlipZone(_response);
        });
    }

    protected processUnaSettings_CreateKlipZone(response: AxiosResponse): Promise<EnvelopeOfKlipZoneCreated> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfKlipZoneCreated.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfKlipZoneCreated>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfKlipZoneCreated>(null as any);
    }

    unaSettings_UpdateKlipZone(request: UpdateKlipZoneInput, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/UnaSettings/UpdateKlipZone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnaSettings_UpdateKlipZone(_response);
        });
    }

    protected processUnaSettings_UpdateKlipZone(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    unaSettings_DeleteKlipZoneById(id: string, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/UnaSettings/deleteklipzonebyid/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnaSettings_DeleteKlipZoneById(_response);
        });
    }

    protected processUnaSettings_DeleteKlipZoneById(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    /**
     * Download zone file by BlobName and Format
     * @return Success
     */
    unaSettings_DownloadZoneFile(utilityNetworkAuthorityZoneGeometryId: string, format: string, coordinateSystem: CoordinateSystem, signal?: AbortSignal): Promise<EnvelopeOfStream> {
        let url_ = this.baseUrl + "/bff/UnaSettings/DownloadZoneFile/{utilityNetworkAuthorityZoneGeometryId}/{format}/{coordinateSystem}";
        if (utilityNetworkAuthorityZoneGeometryId === undefined || utilityNetworkAuthorityZoneGeometryId === null)
            throw new globalThis.Error("The parameter 'utilityNetworkAuthorityZoneGeometryId' must be defined.");
        url_ = url_.replace("{utilityNetworkAuthorityZoneGeometryId}", encodeURIComponent("" + utilityNetworkAuthorityZoneGeometryId));
        if (format === undefined || format === null)
            throw new globalThis.Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (coordinateSystem === undefined || coordinateSystem === null)
            throw new globalThis.Error("The parameter 'coordinateSystem' must be defined.");
        url_ = url_.replace("{coordinateSystem}", encodeURIComponent("" + coordinateSystem));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnaSettings_DownloadZoneFile(_response);
        });
    }

    protected processUnaSettings_DownloadZoneFile(response: AxiosResponse): Promise<EnvelopeOfStream> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfStream.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfStream>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("File not found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfStream>(null as any);
    }

    unaSettings_ZoneNameExist(name: string, zoneId?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfBoolean> {
        let url_ = this.baseUrl + "/bff/UnaSettings/ZoneNameExist/{name}?";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (zoneId !== undefined && zoneId !== null)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnaSettings_ZoneNameExist(_response);
        });
    }

    protected processUnaSettings_ZoneNameExist(response: AxiosResponse): Promise<EnvelopeOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfBoolean.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfBoolean>(null as any);
    }

    unaSettings_DisplayNameExists(name?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfBoolean> {
        let url_ = this.baseUrl + "/bff/UnaSettings/DisplayNameExists?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnaSettings_DisplayNameExists(_response);
        });
    }

    protected processUnaSettings_DisplayNameExists(response: AxiosResponse): Promise<EnvelopeOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfBoolean.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfBoolean>(null as any);
    }

    unaSettings_NamespaceExists(name: string, id?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfBoolean> {
        let url_ = this.baseUrl + "/bff/UnaSettings/NamespaceExists/{name}?";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnaSettings_NamespaceExists(_response);
        });
    }

    protected processUnaSettings_NamespaceExists(response: AxiosResponse): Promise<EnvelopeOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfBoolean.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfBoolean>(null as any);
    }

    unaSettings_CreateKlimZone(input: CreateKlimZoneInput, signal?: AbortSignal): Promise<EnvelopeOfKlimZoneCreated> {
        let url_ = this.baseUrl + "/bff/UnaSettings/CreateKlimZone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnaSettings_CreateKlimZone(_response);
        });
    }

    protected processUnaSettings_CreateKlimZone(response: AxiosResponse): Promise<EnvelopeOfKlimZoneCreated> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfKlimZoneCreated.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfKlimZoneCreated>(result200);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = EnvelopeOfString.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfKlimZoneCreated>(null as any);
    }

    unaSettings_UpdateKlimZone(input: UpdateKlimZoneInput, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/UnaSettings/UpdateKlimZone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnaSettings_UpdateKlimZone(_response);
        });
    }

    protected processUnaSettings_UpdateKlimZone(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = EnvelopeOfString.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = EnvelopeOfString.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    unaSettings_GetUnaManagerEmailAddresses(query: GetUnaManagerEmailAddressesQuery, signal?: AbortSignal): Promise<EnvelopeOfIListOfString> {
        let url_ = this.baseUrl + "/bff/UnaSettings/GetUnaManagerEmailAddresses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnaSettings_GetUnaManagerEmailAddresses(_response);
        });
    }

    protected processUnaSettings_GetUnaManagerEmailAddresses(response: AxiosResponse): Promise<EnvelopeOfIListOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfIListOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfIListOfString>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = EnvelopeOfIListOfString.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfIListOfString>(null as any);
    }

    unaSettings_MoveZone(input: MoveZoneInput, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/bff/UnaSettings/MoveZone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnaSettings_MoveZone(_response);
        });
    }

    protected processUnaSettings_MoveZone(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    unaSettings_MoveZoneOngoing(input: MoveZoneInput, signal?: AbortSignal): Promise<EnvelopeOfBoolean> {
        let url_ = this.baseUrl + "/bff/UnaSettings/MoveZoneOngoing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnaSettings_MoveZoneOngoing(_response);
        });
    }

    protected processUnaSettings_MoveZoneOngoing(response: AxiosResponse): Promise<EnvelopeOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfBoolean.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfBoolean>(null as any);
    }

    validation_IsGeometryWithinBufferedFlanders(input: IsGeometryWithinBufferedFlandersInput, signal?: AbortSignal): Promise<EnvelopeOfBoolean> {
        let url_ = this.baseUrl + "/bff/Validation/IsGeometryWithinBufferedFlanders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidation_IsGeometryWithinBufferedFlanders(_response);
        });
    }

    protected processValidation_IsGeometryWithinBufferedFlanders(response: AxiosResponse): Promise<EnvelopeOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfBoolean.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfBoolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = EnvelopeOfString.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfBoolean>(null as any);
    }

    validation_IsGeometryIntersectingFlanders(input: IsGeometryIntersectingFlandersInput, signal?: AbortSignal): Promise<EnvelopeOfBoolean> {
        let url_ = this.baseUrl + "/bff/Validation/IsGeometryIntersectingFlanders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidation_IsGeometryIntersectingFlanders(_response);
        });
    }

    protected processValidation_IsGeometryIntersectingFlanders(response: AxiosResponse): Promise<EnvelopeOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfBoolean.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfBoolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = EnvelopeOfString.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfBoolean>(null as any);
    }

    events_GetEvents(request: GetEventsRequest, signal?: AbortSignal): Promise<EnvelopeOfIEnumerableOfEventDto> {
        let url_ = this.baseUrl + "/bff/Events/GetEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEvents_GetEvents(_response);
        });
    }

    protected processEvents_GetEvents(response: AxiosResponse): Promise<EnvelopeOfIEnumerableOfEventDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfIEnumerableOfEventDto.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfIEnumerableOfEventDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfIEnumerableOfEventDto>(null as any);
    }

    events_ReplayEvents(request: ReplayEventsRequest, signal?: AbortSignal): Promise<EnvelopeOfBoolean> {
        let url_ = this.baseUrl + "/bff/Events/ReplayEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEvents_ReplayEvents(_response);
        });
    }

    protected processEvents_ReplayEvents(response: AxiosResponse): Promise<EnvelopeOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfBoolean.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfBoolean>(null as any);
    }

    invoice_StartInvoiceRound(request: StartInvoicingRoundRequest, signal?: AbortSignal): Promise<EnvelopeOfStartInvoiceRoundResponse> {
        let url_ = this.baseUrl + "/bff/Invoice/StartInvoiceRound";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoice_StartInvoiceRound(_response);
        });
    }

    protected processInvoice_StartInvoiceRound(response: AxiosResponse): Promise<EnvelopeOfStartInvoiceRoundResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfStartInvoiceRoundResponse.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfStartInvoiceRoundResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfStartInvoiceRoundResponse>(null as any);
    }

    invoice_CurrentInvoiceRound(signal?: AbortSignal): Promise<EnvelopeOfCurrentInvoiceRound> {
        let url_ = this.baseUrl + "/bff/Invoice/CurrentInvoiceRound";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoice_CurrentInvoiceRound(_response);
        });
    }

    protected processInvoice_CurrentInvoiceRound(response: AxiosResponse): Promise<EnvelopeOfCurrentInvoiceRound> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfCurrentInvoiceRound.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfCurrentInvoiceRound>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfCurrentInvoiceRound>(null as any);
    }

    invoice_MapRequestsNotRegisteredInFinancialTransaction(endDate?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfIListOfMapRequestWithFinancialAnomalies> {
        let url_ = this.baseUrl + "/bff/Invoice/MapRequestsNotRegisteredInFinancialTransaction?";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvoice_MapRequestsNotRegisteredInFinancialTransaction(_response);
        });
    }

    protected processInvoice_MapRequestsNotRegisteredInFinancialTransaction(response: AxiosResponse): Promise<EnvelopeOfIListOfMapRequestWithFinancialAnomalies> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfIListOfMapRequestWithFinancialAnomalies.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfIListOfMapRequestWithFinancialAnomalies>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfIListOfMapRequestWithFinancialAnomalies>(null as any);
    }

    performance_PerformanceData(signal?: AbortSignal): Promise<EnvelopeOfPerformanceData> {
        let url_ = this.baseUrl + "/bff/Performance/PerformanceData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPerformance_PerformanceData(_response);
        });
    }

    protected processPerformance_PerformanceData(response: AxiosResponse): Promise<EnvelopeOfPerformanceData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfPerformanceData.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfPerformanceData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfPerformanceData>(null as any);
    }

    performance_PerformanceDataDetail(serviceName: string, signal?: AbortSignal): Promise<EnvelopeOfPerformanceDataDetail> {
        let url_ = this.baseUrl + "/bff/Performance/PerformanceDataDetail/{serviceName}";
        if (serviceName === undefined || serviceName === null)
            throw new globalThis.Error("The parameter 'serviceName' must be defined.");
        url_ = url_.replace("{serviceName}", encodeURIComponent("" + serviceName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPerformance_PerformanceDataDetail(_response);
        });
    }

    protected processPerformance_PerformanceDataDetail(response: AxiosResponse): Promise<EnvelopeOfPerformanceDataDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfPerformanceDataDetail.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfPerformanceDataDetail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfPerformanceDataDetail>(null as any);
    }

    performance_PollPerformanceDataDetail(serviceName: string, signal?: AbortSignal): Promise<EnvelopeOfPollPerformanceDataDetail> {
        let url_ = this.baseUrl + "/bff/Performance/PollPerformanceDataDetail/{serviceName}";
        if (serviceName === undefined || serviceName === null)
            throw new globalThis.Error("The parameter 'serviceName' must be defined.");
        url_ = url_.replace("{serviceName}", encodeURIComponent("" + serviceName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPerformance_PollPerformanceDataDetail(_response);
        });
    }

    protected processPerformance_PollPerformanceDataDetail(response: AxiosResponse): Promise<EnvelopeOfPollPerformanceDataDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfPollPerformanceDataDetail.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfPollPerformanceDataDetail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfPollPerformanceDataDetail>(null as any);
    }

    performance_Requeue(request: DeadLetterRequest, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Performance/Requeue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPerformance_Requeue(_response);
        });
    }

    protected processPerformance_Requeue(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    performance_Delete(request: DeadLetterRequest, signal?: AbortSignal): Promise<EnvelopeOfString> {
        let url_ = this.baseUrl + "/bff/Performance/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPerformance_Delete(_response);
        });
    }

    protected processPerformance_Delete(response: AxiosResponse): Promise<EnvelopeOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfString.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfString>(null as any);
    }

    processes_ProcessCounter(processCounter?: ProcessCounter | undefined, signal?: AbortSignal): Promise<EnvelopeOfInteger> {
        let url_ = this.baseUrl + "/bff/Processes/ProcessCounter?";
        if (processCounter === null)
            throw new globalThis.Error("The parameter 'processCounter' cannot be null.");
        else if (processCounter !== undefined)
            url_ += "processCounter=" + encodeURIComponent("" + processCounter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcesses_ProcessCounter(_response);
        });
    }

    protected processProcesses_ProcessCounter(response: AxiosResponse): Promise<EnvelopeOfInteger> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfInteger.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfInteger>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfInteger>(null as any);
    }

    processes_FailedPmklPackages(signal?: AbortSignal): Promise<EnvelopeOfIListOfFailedPmklPackage> {
        let url_ = this.baseUrl + "/bff/Processes/FailedPmklPackages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcesses_FailedPmklPackages(_response);
        });
    }

    protected processProcesses_FailedPmklPackages(response: AxiosResponse): Promise<EnvelopeOfIListOfFailedPmklPackage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfIListOfFailedPmklPackage.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfIListOfFailedPmklPackage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfIListOfFailedPmklPackage>(null as any);
    }

    processes_DeleteFailedPmklPackages(mapRequestId?: string | undefined, zoneId?: string | undefined, blobName?: string | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/bff/Processes/FailedPmklPackages?";
        if (mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' cannot be null.");
        else if (mapRequestId !== undefined)
            url_ += "mapRequestId=" + encodeURIComponent("" + mapRequestId) + "&";
        if (zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        if (blobName !== undefined && blobName !== null)
            url_ += "blobName=" + encodeURIComponent("" + blobName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcesses_DeleteFailedPmklPackages(_response);
        });
    }

    protected processProcesses_DeleteFailedPmklPackages(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    processes_AdditionalProcesses(signal?: AbortSignal): Promise<EnvelopeOfAdditionalProcesses> {
        let url_ = this.baseUrl + "/bff/Processes/AdditionalProcesses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcesses_AdditionalProcesses(_response);
        });
    }

    protected processProcesses_AdditionalProcesses(response: AxiosResponse): Promise<EnvelopeOfAdditionalProcesses> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfAdditionalProcesses.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfAdditionalProcesses>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfAdditionalProcesses>(null as any);
    }

    processes_HangingImklValidations(signal?: AbortSignal): Promise<EnvelopeOfIListOfHangingImklValidation> {
        let url_ = this.baseUrl + "/bff/Processes/HangingImklValidations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcesses_HangingImklValidations(_response);
        });
    }

    protected processProcesses_HangingImklValidations(response: AxiosResponse): Promise<EnvelopeOfIListOfHangingImklValidation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfIListOfHangingImklValidation.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfIListOfHangingImklValidation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfIListOfHangingImklValidation>(null as any);
    }

    processes_DeleteHangingImklValidation(mapRequestId?: string | undefined, zoneId?: string | undefined, blobName?: string | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/bff/Processes/HangingImklValidations?";
        if (mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' cannot be null.");
        else if (mapRequestId !== undefined)
            url_ += "mapRequestId=" + encodeURIComponent("" + mapRequestId) + "&";
        if (zoneId === null)
            throw new globalThis.Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        if (blobName !== undefined && blobName !== null)
            url_ += "blobName=" + encodeURIComponent("" + blobName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcesses_DeleteHangingImklValidation(_response);
        });
    }

    protected processProcesses_DeleteHangingImklValidation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    processes_FailedAndMissingKlimResponses(signal?: AbortSignal): Promise<EnvelopeOfFailedAndMissingKlimResponse> {
        let url_ = this.baseUrl + "/bff/Processes/FailedAndMissingKlimResponses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcesses_FailedAndMissingKlimResponses(_response);
        });
    }

    protected processProcesses_FailedAndMissingKlimResponses(response: AxiosResponse): Promise<EnvelopeOfFailedAndMissingKlimResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfFailedAndMissingKlimResponse.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfFailedAndMissingKlimResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfFailedAndMissingKlimResponse>(null as any);
    }

    processes_HandleFailedKlimResponse(mapRequestId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfBoolean> {
        let url_ = this.baseUrl + "/bff/Processes/FailedKlimResponse?";
        if (mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' cannot be null.");
        else if (mapRequestId !== undefined)
            url_ += "mapRequestId=" + encodeURIComponent("" + mapRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcesses_HandleFailedKlimResponse(_response);
        });
    }

    protected processProcesses_HandleFailedKlimResponse(response: AxiosResponse): Promise<EnvelopeOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfBoolean.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfBoolean>(null as any);
    }

    processes_PendingRequests(signal?: AbortSignal): Promise<EnvelopeOfIEnumerableOfPendingRequest> {
        let url_ = this.baseUrl + "/bff/Processes/PendingRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcesses_PendingRequests(_response);
        });
    }

    protected processProcesses_PendingRequests(response: AxiosResponse): Promise<EnvelopeOfIEnumerableOfPendingRequest> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfIEnumerableOfPendingRequest.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfIEnumerableOfPendingRequest>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfIEnumerableOfPendingRequest>(null as any);
    }

    processes_DeletePendingRequest(id?: string | null | undefined, messageType?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfBoolean> {
        let url_ = this.baseUrl + "/bff/Processes/PendingRequests?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (messageType !== undefined && messageType !== null)
            url_ += "messageType=" + encodeURIComponent("" + messageType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcesses_DeletePendingRequest(_response);
        });
    }

    protected processProcesses_DeletePendingRequest(response: AxiosResponse): Promise<EnvelopeOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfBoolean.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfBoolean>(null as any);
    }

    processes_PendingPmkl2Assets(signal?: AbortSignal): Promise<EnvelopeOfIEnumerableOfPendingPmkl2Asset> {
        let url_ = this.baseUrl + "/bff/Processes/PendingPmkl2Asset";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcesses_PendingPmkl2Assets(_response);
        });
    }

    protected processProcesses_PendingPmkl2Assets(response: AxiosResponse): Promise<EnvelopeOfIEnumerableOfPendingPmkl2Asset> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfIEnumerableOfPendingPmkl2Asset.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfIEnumerableOfPendingPmkl2Asset>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfIEnumerableOfPendingPmkl2Asset>(null as any);
    }

    processes_DeletePendingPmkl2Assets(mapRequestId?: string | undefined, type?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfBoolean> {
        let url_ = this.baseUrl + "/bff/Processes/PendingPmkl2Asset?";
        if (mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' cannot be null.");
        else if (mapRequestId !== undefined)
            url_ += "mapRequestId=" + encodeURIComponent("" + mapRequestId) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcesses_DeletePendingPmkl2Assets(_response);
        });
    }

    protected processProcesses_DeletePendingPmkl2Assets(response: AxiosResponse): Promise<EnvelopeOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfBoolean.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfBoolean>(null as any);
    }

    processes_UnprocessedPaidShoppingCarts(signal?: AbortSignal): Promise<EnvelopeOfIEnumerableOfUnprocessedPaidShoppingCartMapRequest> {
        let url_ = this.baseUrl + "/bff/Processes/UnprocessedPaidShoppingCarts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcesses_UnprocessedPaidShoppingCarts(_response);
        });
    }

    protected processProcesses_UnprocessedPaidShoppingCarts(response: AxiosResponse): Promise<EnvelopeOfIEnumerableOfUnprocessedPaidShoppingCartMapRequest> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfIEnumerableOfUnprocessedPaidShoppingCartMapRequest.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfIEnumerableOfUnprocessedPaidShoppingCartMapRequest>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfIEnumerableOfUnprocessedPaidShoppingCartMapRequest>(null as any);
    }

    processes_ProcessUnprocessedPaidShoppingCarts(shoppingCartId?: string | undefined, mapRequestId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfBoolean> {
        let url_ = this.baseUrl + "/bff/Processes/ProcessUnprocessedPaidShoppingCarts?";
        if (shoppingCartId === null)
            throw new globalThis.Error("The parameter 'shoppingCartId' cannot be null.");
        else if (shoppingCartId !== undefined)
            url_ += "shoppingCartId=" + encodeURIComponent("" + shoppingCartId) + "&";
        if (mapRequestId === null)
            throw new globalThis.Error("The parameter 'mapRequestId' cannot be null.");
        else if (mapRequestId !== undefined)
            url_ += "mapRequestId=" + encodeURIComponent("" + mapRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcesses_ProcessUnprocessedPaidShoppingCarts(_response);
        });
    }

    protected processProcesses_ProcessUnprocessedPaidShoppingCarts(response: AxiosResponse): Promise<EnvelopeOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfBoolean.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfBoolean>(null as any);
    }

    processes_HangingMapRequests(signal?: AbortSignal): Promise<EnvelopeOfIEnumerableOfHangingMapRequest> {
        let url_ = this.baseUrl + "/bff/Processes/HangingMapRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcesses_HangingMapRequests(_response);
        });
    }

    protected processProcesses_HangingMapRequests(response: AxiosResponse): Promise<EnvelopeOfIEnumerableOfHangingMapRequest> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfIEnumerableOfHangingMapRequest.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfIEnumerableOfHangingMapRequest>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfIEnumerableOfHangingMapRequest>(null as any);
    }

    processes_OverdueMapRequests(signal?: AbortSignal): Promise<EnvelopeOfIEnumerableOfOverdueMapRequest> {
        let url_ = this.baseUrl + "/bff/Processes/OverdueMapRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcesses_OverdueMapRequests(_response);
        });
    }

    protected processProcesses_OverdueMapRequests(response: AxiosResponse): Promise<EnvelopeOfIEnumerableOfOverdueMapRequest> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfIEnumerableOfOverdueMapRequest.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfIEnumerableOfOverdueMapRequest>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfIEnumerableOfOverdueMapRequest>(null as any);
    }

    processes_MapRequestRespondersInIncorrectStatus(signal?: AbortSignal): Promise<EnvelopeOfIEnumerableOfMapRequestRespondersInIncorrectStatus> {
        let url_ = this.baseUrl + "/bff/Processes/MapRequestRespondersInIncorrectStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcesses_MapRequestRespondersInIncorrectStatus(_response);
        });
    }

    protected processProcesses_MapRequestRespondersInIncorrectStatus(response: AxiosResponse): Promise<EnvelopeOfIEnumerableOfMapRequestRespondersInIncorrectStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfIEnumerableOfMapRequestRespondersInIncorrectStatus.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfIEnumerableOfMapRequestRespondersInIncorrectStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfIEnumerableOfMapRequestRespondersInIncorrectStatus>(null as any);
    }

    processes_MapRequestWithFinancialAnomalies(signal?: AbortSignal): Promise<EnvelopeOfMapRequestsWithFinancialAnomaly> {
        let url_ = this.baseUrl + "/bff/Processes/MapRequestWithFinancialAnomalies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcesses_MapRequestWithFinancialAnomalies(_response);
        });
    }

    protected processProcesses_MapRequestWithFinancialAnomalies(response: AxiosResponse): Promise<EnvelopeOfMapRequestsWithFinancialAnomaly> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfMapRequestsWithFinancialAnomaly.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfMapRequestsWithFinancialAnomaly>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfMapRequestsWithFinancialAnomaly>(null as any);
    }

    saga_GetSaga(id: string, sagaType: SagaType, signal?: AbortSignal): Promise<EnvelopeOfSagaDto> {
        let url_ = this.baseUrl + "/bff/Saga/{SagaType}/{Id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        if (sagaType === undefined || sagaType === null)
            throw new globalThis.Error("The parameter 'sagaType' must be defined.");
        url_ = url_.replace("{SagaType}", encodeURIComponent("" + sagaType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaga_GetSaga(_response);
        });
    }

    protected processSaga_GetSaga(response: AxiosResponse): Promise<EnvelopeOfSagaDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfSagaDto.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfSagaDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfSagaDto>(null as any);
    }

    saga_ResetSaga(id: string, sagaType: SagaType, signal?: AbortSignal): Promise<EnvelopeOfBoolean> {
        let url_ = this.baseUrl + "/bff/Saga/{SagaType}/{Id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        if (sagaType === undefined || sagaType === null)
            throw new globalThis.Error("The parameter 'sagaType' must be defined.");
        url_ = url_.replace("{SagaType}", encodeURIComponent("" + sagaType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaga_ResetSaga(_response);
        });
    }

    protected processSaga_ResetSaga(response: AxiosResponse): Promise<EnvelopeOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfBoolean.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfBoolean>(null as any);
    }

    users_GetUsersCount(request: GetUsersInput, signal?: AbortSignal): Promise<EnvelopeOfInteger> {
        let url_ = this.baseUrl + "/bff/Users/GetUsersCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsers_GetUsersCount(_response);
        });
    }

    protected processUsers_GetUsersCount(response: AxiosResponse): Promise<EnvelopeOfInteger> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfInteger.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfInteger>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfInteger>(null as any);
    }

    users_GetUsers(request: GetUsersInput, signal?: AbortSignal): Promise<EnvelopeOfICollectionOfUserListItem> {
        let url_ = this.baseUrl + "/bff/Users/GetUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsers_GetUsers(_response);
        });
    }

    protected processUsers_GetUsers(response: AxiosResponse): Promise<EnvelopeOfICollectionOfUserListItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfICollectionOfUserListItem.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfICollectionOfUserListItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfICollectionOfUserListItem>(null as any);
    }

    users_GetUserDetail(userId?: string | undefined, organisationId?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfUserDetail> {
        let url_ = this.baseUrl + "/bff/Users/GetUserDetail?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (organisationId !== undefined && organisationId !== null)
            url_ += "OrganisationId=" + encodeURIComponent("" + organisationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsers_GetUserDetail(_response);
        });
    }

    protected processUsers_GetUserDetail(response: AxiosResponse): Promise<EnvelopeOfUserDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfUserDetail.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfUserDetail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfUserDetail>(null as any);
    }

    users_AskImpersonationConsent(consentRequest: AskImpersonationConsentRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/bff/Users/AskImpersonationConsent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consentRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsers_AskImpersonationConsent(_response);
        });
    }

    protected processUsers_AskImpersonationConsent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    users_ImpersonationForUser(userId?: string | undefined, organisationId?: string | null | undefined, signal?: AbortSignal): Promise<EnvelopeOfImpersonationSessionForUser> {
        let url_ = this.baseUrl + "/bff/Users/ImpersonationForUser?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (organisationId !== undefined && organisationId !== null)
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsers_ImpersonationForUser(_response);
        });
    }

    protected processUsers_ImpersonationForUser(response: AxiosResponse): Promise<EnvelopeOfImpersonationSessionForUser> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfImpersonationSessionForUser.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfImpersonationSessionForUser>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfImpersonationSessionForUser>(null as any);
    }

    users_StartImpersonationForUser(userId?: string | undefined, userImpersonationId?: string | undefined, impersonatorUserId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfUserImpersonationDto> {
        let url_ = this.baseUrl + "/bff/Users/ImpersonationForUser?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (userImpersonationId === null)
            throw new globalThis.Error("The parameter 'userImpersonationId' cannot be null.");
        else if (userImpersonationId !== undefined)
            url_ += "userImpersonationId=" + encodeURIComponent("" + userImpersonationId) + "&";
        if (impersonatorUserId === null)
            throw new globalThis.Error("The parameter 'impersonatorUserId' cannot be null.");
        else if (impersonatorUserId !== undefined)
            url_ += "impersonatorUserId=" + encodeURIComponent("" + impersonatorUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsers_StartImpersonationForUser(_response);
        });
    }

    protected processUsers_StartImpersonationForUser(response: AxiosResponse): Promise<EnvelopeOfUserImpersonationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfUserImpersonationDto.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfUserImpersonationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfUserImpersonationDto>(null as any);
    }

    users_StopImpersonationForUser(userId?: string | undefined, userImpersonationId?: string | undefined, signal?: AbortSignal): Promise<EnvelopeOfUnit> {
        let url_ = this.baseUrl + "/bff/Users/StopImpersonationForUser?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (userImpersonationId === null)
            throw new globalThis.Error("The parameter 'userImpersonationId' cannot be null.");
        else if (userImpersonationId !== undefined)
            url_ += "userImpersonationId=" + encodeURIComponent("" + userImpersonationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsers_StopImpersonationForUser(_response);
        });
    }

    protected processUsers_StopImpersonationForUser(response: AxiosResponse): Promise<EnvelopeOfUnit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnvelopeOfUnit.fromJS(resultData200);
            return Promise.resolve<EnvelopeOfUnit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvelopeOfUnit>(null as any);
    }
}

export class EnvelopeOfBoolean implements IEnvelopeOfBoolean {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: boolean;

    constructor(data?: IEnvelopeOfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): EnvelopeOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result;
        return data;
    }
}

export interface IEnvelopeOfBoolean {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: boolean;
}

export class EnvelopeOfAcmIdmRegistrationLinks implements IEnvelopeOfAcmIdmRegistrationLinks {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: AcmIdmRegistrationLinks | undefined;

    constructor(data?: IEnvelopeOfAcmIdmRegistrationLinks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? AcmIdmRegistrationLinks.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfAcmIdmRegistrationLinks {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfAcmIdmRegistrationLinks();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfAcmIdmRegistrationLinks {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: AcmIdmRegistrationLinks | undefined;
}

export class AcmIdmRegistrationLinks implements IAcmIdmRegistrationLinks {
    klipRaadplagerUrl?: string | undefined;
    klipPlanaanvraagUrl?: string | undefined;
    klipOdbUrl?: string | undefined;
    klipKlbRaadplegerUrl?: string | undefined;
    klipKlbOperatorUrl?: string | undefined;
    klipKlbBeheerderUrl?: string | undefined;

    constructor(data?: IAcmIdmRegistrationLinks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.klipRaadplagerUrl = _data["klipRaadplagerUrl"];
            this.klipPlanaanvraagUrl = _data["klipPlanaanvraagUrl"];
            this.klipOdbUrl = _data["klipOdbUrl"];
            this.klipKlbRaadplegerUrl = _data["klipKlbRaadplegerUrl"];
            this.klipKlbOperatorUrl = _data["klipKlbOperatorUrl"];
            this.klipKlbBeheerderUrl = _data["klipKlbBeheerderUrl"];
        }
    }

    static fromJS(data: any): AcmIdmRegistrationLinks {
        data = typeof data === 'object' ? data : {};
        let result = new AcmIdmRegistrationLinks();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["klipRaadplagerUrl"] = this.klipRaadplagerUrl;
        data["klipPlanaanvraagUrl"] = this.klipPlanaanvraagUrl;
        data["klipOdbUrl"] = this.klipOdbUrl;
        data["klipKlbRaadplegerUrl"] = this.klipKlbRaadplegerUrl;
        data["klipKlbOperatorUrl"] = this.klipKlbOperatorUrl;
        data["klipKlbBeheerderUrl"] = this.klipKlbBeheerderUrl;
        return data;
    }
}

export interface IAcmIdmRegistrationLinks {
    klipRaadplagerUrl?: string | undefined;
    klipPlanaanvraagUrl?: string | undefined;
    klipOdbUrl?: string | undefined;
    klipKlbRaadplegerUrl?: string | undefined;
    klipKlbOperatorUrl?: string | undefined;
    klipKlbBeheerderUrl?: string | undefined;
}

export class EnvelopeOfUserData implements IEnvelopeOfUserData {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: UserData | undefined;

    constructor(data?: IEnvelopeOfUserData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? UserData.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfUserData {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfUserData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfUserData {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: UserData | undefined;
}

export class UserData implements IUserData {
    subOrganisations?: SubOrganisation[] | undefined;
    klipUserId?: string | undefined;
    klipImpersonatorUserId?: string | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    mobilePhone?: string | undefined;
    email?: string | undefined;
    displayName?: string | undefined;
    roles?: string[] | undefined;
    claimsRoles?: string[] | undefined;
    scopes?: string[] | undefined;
    roleError?: boolean;
    validationError?: string | undefined;
    klipOrganisationApiId?: string | undefined;
    klipOrganisationApiParentId?: string | undefined;
    organisation?: string | undefined;
    organisationOvoCode?: string | undefined;
    organisationCode?: string | undefined;
    organisationKboNumber?: string | undefined;
    organisationVatNumber?: string | undefined;
    isCitizen?: boolean;
    isServiceAccount?: boolean;
    isForeignOrganisation?: boolean;
    isContactPunt?: boolean;
    isAdmin?: boolean;
    isImpersonating?: boolean;
    isEnforcer?: boolean;
    isEnforcerFirstLogin?: boolean;
    isUnaFirstLogin?: boolean;
    isMriFirstLogin?: boolean;
    paymentType?: PaymentTypes;
    isAnonymous?: boolean;
    isShoppingCartVisible?: boolean;
    applyVat?: boolean;
    vatPercentage?: number;
    sessionTimeout?: string;

    constructor(data?: IUserData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["subOrganisations"])) {
                this.subOrganisations = [] as any;
                for (let item of _data["subOrganisations"])
                    this.subOrganisations!.push(SubOrganisation.fromJS(item));
            }
            this.klipUserId = _data["klipUserId"];
            this.klipImpersonatorUserId = _data["klipImpersonatorUserId"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phone = _data["phone"];
            this.mobilePhone = _data["mobilePhone"];
            this.email = _data["email"];
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["claimsRoles"])) {
                this.claimsRoles = [] as any;
                for (let item of _data["claimsRoles"])
                    this.claimsRoles!.push(item);
            }
            if (Array.isArray(_data["scopes"])) {
                this.scopes = [] as any;
                for (let item of _data["scopes"])
                    this.scopes!.push(item);
            }
            this.roleError = _data["roleError"];
            this.validationError = _data["validationError"];
            this.klipOrganisationApiId = _data["klipOrganisationApiId"];
            this.klipOrganisationApiParentId = _data["klipOrganisationApiParentId"];
            this.organisation = _data["organisation"];
            this.organisationOvoCode = _data["organisationOvoCode"];
            this.organisationCode = _data["organisationCode"];
            this.organisationKboNumber = _data["organisationKboNumber"];
            this.organisationVatNumber = _data["organisationVatNumber"];
            this.isCitizen = _data["isCitizen"];
            this.isServiceAccount = _data["isServiceAccount"];
            this.isForeignOrganisation = _data["isForeignOrganisation"];
            this.isContactPunt = _data["isContactPunt"];
            this.isAdmin = _data["isAdmin"];
            this.isImpersonating = _data["isImpersonating"];
            this.isEnforcer = _data["isEnforcer"];
            this.isEnforcerFirstLogin = _data["isEnforcerFirstLogin"];
            this.isUnaFirstLogin = _data["isUnaFirstLogin"];
            this.isMriFirstLogin = _data["isMriFirstLogin"];
            this.paymentType = _data["paymentType"];
            this.isAnonymous = _data["isAnonymous"];
            this.isShoppingCartVisible = _data["isShoppingCartVisible"];
            this.applyVat = _data["applyVat"];
            this.vatPercentage = _data["vatPercentage"];
            this.sessionTimeout = _data["sessionTimeout"];
        }
    }

    static fromJS(data: any): UserData {
        data = typeof data === 'object' ? data : {};
        let result = new UserData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.subOrganisations)) {
            data["subOrganisations"] = [];
            for (let item of this.subOrganisations)
                data["subOrganisations"].push(item ? item.toJSON() : undefined as any);
        }
        data["klipUserId"] = this.klipUserId;
        data["klipImpersonatorUserId"] = this.klipImpersonatorUserId;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["mobilePhone"] = this.mobilePhone;
        data["email"] = this.email;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.claimsRoles)) {
            data["claimsRoles"] = [];
            for (let item of this.claimsRoles)
                data["claimsRoles"].push(item);
        }
        if (Array.isArray(this.scopes)) {
            data["scopes"] = [];
            for (let item of this.scopes)
                data["scopes"].push(item);
        }
        data["roleError"] = this.roleError;
        data["validationError"] = this.validationError;
        data["klipOrganisationApiId"] = this.klipOrganisationApiId;
        data["klipOrganisationApiParentId"] = this.klipOrganisationApiParentId;
        data["organisation"] = this.organisation;
        data["organisationOvoCode"] = this.organisationOvoCode;
        data["organisationCode"] = this.organisationCode;
        data["organisationKboNumber"] = this.organisationKboNumber;
        data["organisationVatNumber"] = this.organisationVatNumber;
        data["isCitizen"] = this.isCitizen;
        data["isServiceAccount"] = this.isServiceAccount;
        data["isForeignOrganisation"] = this.isForeignOrganisation;
        data["isContactPunt"] = this.isContactPunt;
        data["isAdmin"] = this.isAdmin;
        data["isImpersonating"] = this.isImpersonating;
        data["isEnforcer"] = this.isEnforcer;
        data["isEnforcerFirstLogin"] = this.isEnforcerFirstLogin;
        data["isUnaFirstLogin"] = this.isUnaFirstLogin;
        data["isMriFirstLogin"] = this.isMriFirstLogin;
        data["paymentType"] = this.paymentType;
        data["isAnonymous"] = this.isAnonymous;
        data["isShoppingCartVisible"] = this.isShoppingCartVisible;
        data["applyVat"] = this.applyVat;
        data["vatPercentage"] = this.vatPercentage;
        data["sessionTimeout"] = this.sessionTimeout;
        return data;
    }
}

export interface IUserData {
    subOrganisations?: SubOrganisation[] | undefined;
    klipUserId?: string | undefined;
    klipImpersonatorUserId?: string | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    mobilePhone?: string | undefined;
    email?: string | undefined;
    displayName?: string | undefined;
    roles?: string[] | undefined;
    claimsRoles?: string[] | undefined;
    scopes?: string[] | undefined;
    roleError?: boolean;
    validationError?: string | undefined;
    klipOrganisationApiId?: string | undefined;
    klipOrganisationApiParentId?: string | undefined;
    organisation?: string | undefined;
    organisationOvoCode?: string | undefined;
    organisationCode?: string | undefined;
    organisationKboNumber?: string | undefined;
    organisationVatNumber?: string | undefined;
    isCitizen?: boolean;
    isServiceAccount?: boolean;
    isForeignOrganisation?: boolean;
    isContactPunt?: boolean;
    isAdmin?: boolean;
    isImpersonating?: boolean;
    isEnforcer?: boolean;
    isEnforcerFirstLogin?: boolean;
    isUnaFirstLogin?: boolean;
    isMriFirstLogin?: boolean;
    paymentType?: PaymentTypes;
    isAnonymous?: boolean;
    isShoppingCartVisible?: boolean;
    applyVat?: boolean;
    vatPercentage?: number;
    sessionTimeout?: string;
}

export class SubOrganisation implements ISubOrganisation {
    id?: string;
    parentId?: string;
    name?: string | undefined;
    displayName?: string | undefined;
    isUna?: boolean;
    depth?: number;

    constructor(data?: ISubOrganisation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isUna = _data["isUna"];
            this.depth = _data["depth"];
        }
    }

    static fromJS(data: any): SubOrganisation {
        data = typeof data === 'object' ? data : {};
        let result = new SubOrganisation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isUna"] = this.isUna;
        data["depth"] = this.depth;
        return data;
    }
}

export interface ISubOrganisation {
    id?: string;
    parentId?: string;
    name?: string | undefined;
    displayName?: string | undefined;
    isUna?: boolean;
    depth?: number;
}

export enum PaymentTypes {
    None = 0,
    Invoice = 1,
    Online = 2,
}

export class EnvelopeOfUserImpersonationDto implements IEnvelopeOfUserImpersonationDto {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: UserImpersonationDto | undefined;

    constructor(data?: IEnvelopeOfUserImpersonationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? UserImpersonationDto.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfUserImpersonationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfUserImpersonationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfUserImpersonationDto {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: UserImpersonationDto | undefined;
}

export class UserImpersonationDto implements IUserImpersonationDto {
    id?: string;
    crmCaseNumber?: string | undefined;
    impersonatorName?: string | undefined;
    closedAt?: string | undefined;
    revokedAt?: string | undefined;
    consentAt?: string | undefined;
    startedAt?: string | undefined;
    askedForConsentAt?: string | undefined;
    impersonationStatus?: ImpersonationStatus;
    login?: UserImpersonationLoginDto | undefined;
    audit?: UserImpersonationAuditLogDto[] | undefined;

    constructor(data?: IUserImpersonationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.crmCaseNumber = _data["crmCaseNumber"];
            this.impersonatorName = _data["impersonatorName"];
            this.closedAt = _data["closedAt"];
            this.revokedAt = _data["revokedAt"];
            this.consentAt = _data["consentAt"];
            this.startedAt = _data["startedAt"];
            this.askedForConsentAt = _data["askedForConsentAt"];
            this.impersonationStatus = _data["impersonationStatus"];
            this.login = _data["login"] ? UserImpersonationLoginDto.fromJS(_data["login"]) : undefined as any;
            if (Array.isArray(_data["audit"])) {
                this.audit = [] as any;
                for (let item of _data["audit"])
                    this.audit!.push(UserImpersonationAuditLogDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserImpersonationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserImpersonationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["crmCaseNumber"] = this.crmCaseNumber;
        data["impersonatorName"] = this.impersonatorName;
        data["closedAt"] = this.closedAt;
        data["revokedAt"] = this.revokedAt;
        data["consentAt"] = this.consentAt;
        data["startedAt"] = this.startedAt;
        data["askedForConsentAt"] = this.askedForConsentAt;
        data["impersonationStatus"] = this.impersonationStatus;
        data["login"] = this.login ? this.login.toJSON() : undefined as any;
        if (Array.isArray(this.audit)) {
            data["audit"] = [];
            for (let item of this.audit)
                data["audit"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserImpersonationDto {
    id?: string;
    crmCaseNumber?: string | undefined;
    impersonatorName?: string | undefined;
    closedAt?: string | undefined;
    revokedAt?: string | undefined;
    consentAt?: string | undefined;
    startedAt?: string | undefined;
    askedForConsentAt?: string | undefined;
    impersonationStatus?: ImpersonationStatus;
    login?: UserImpersonationLoginDto | undefined;
    audit?: UserImpersonationAuditLogDto[] | undefined;
}

export enum ImpersonationStatus {
    Pending = 0,
    Consent = 1,
    Revoked = 2,
    Started = 3,
    Stopped = 4,
}

export class UserImpersonationLoginDto implements IUserImpersonationLoginDto {
    userName?: string | undefined;
    password?: string | undefined;

    constructor(data?: IUserImpersonationLoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): UserImpersonationLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserImpersonationLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface IUserImpersonationLoginDto {
    userName?: string | undefined;
    password?: string | undefined;
}

export class UserImpersonationAuditLogDto implements IUserImpersonationAuditLogDto {
    eventType?: string | undefined;
    eventDescription?: string | undefined;
    eventDate?: string;

    constructor(data?: IUserImpersonationAuditLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventType = _data["eventType"];
            this.eventDescription = _data["eventDescription"];
            this.eventDate = _data["eventDate"];
        }
    }

    static fromJS(data: any): UserImpersonationAuditLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserImpersonationAuditLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventType"] = this.eventType;
        data["eventDescription"] = this.eventDescription;
        data["eventDate"] = this.eventDate;
        return data;
    }
}

export interface IUserImpersonationAuditLogDto {
    eventType?: string | undefined;
    eventDescription?: string | undefined;
    eventDate?: string;
}

export class EnvelopeOfCodeLists implements IEnvelopeOfCodeLists {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: CodeLists | undefined;

    constructor(data?: IEnvelopeOfCodeLists) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? CodeLists.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfCodeLists {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfCodeLists();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfCodeLists {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: CodeLists | undefined;
}

export class CodeLists implements ICodeLists {
    countryCodes?: { [key: string]: string; } | undefined;
    excavationMethods?: { [key: string]: string; } | undefined;
    excavationTypes?: { [key: string]: string; } | undefined;
    holidays?: string[] | undefined;
    mapRequestRoles?: { [key: string]: string; } | undefined;
    mapRequestStatuses?: { [key: string]: string; } | undefined;
    mapRequestTypes?: { [key: string]: string; } | undefined;
    unaStatuses?: { [key: string]: string; } | undefined;
    unaTypes?: { [key: string]: string; } | undefined;
    geometryConversionErrors?: { [key: string]: string; } | undefined;
    imklStatuses?: { [key: string]: string; } | undefined;
    imklValidationMessages?: { [key: string]: string; } | undefined;
    imklValidationStepStatuses?: { [key: string]: string; } | undefined;
    imklValidationStepTypes?: { [key: string]: string; } | undefined;
    orderDirections?: string[] | undefined;
    userRoleCodes?: { [key: string]: string; } | undefined;
    mapRequestPrices?: MapRequestPrices | undefined;
    applicationInfo?: ApplicationInfo | undefined;

    constructor(data?: ICodeLists) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["countryCodes"]) {
                this.countryCodes = {} as any;
                for (let key in _data["countryCodes"]) {
                    if (_data["countryCodes"].hasOwnProperty(key))
                        (this.countryCodes as any)![key] = _data["countryCodes"][key];
                }
            }
            if (_data["excavationMethods"]) {
                this.excavationMethods = {} as any;
                for (let key in _data["excavationMethods"]) {
                    if (_data["excavationMethods"].hasOwnProperty(key))
                        (this.excavationMethods as any)![key] = _data["excavationMethods"][key];
                }
            }
            if (_data["excavationTypes"]) {
                this.excavationTypes = {} as any;
                for (let key in _data["excavationTypes"]) {
                    if (_data["excavationTypes"].hasOwnProperty(key))
                        (this.excavationTypes as any)![key] = _data["excavationTypes"][key];
                }
            }
            if (Array.isArray(_data["holidays"])) {
                this.holidays = [] as any;
                for (let item of _data["holidays"])
                    this.holidays!.push(item);
            }
            if (_data["mapRequestRoles"]) {
                this.mapRequestRoles = {} as any;
                for (let key in _data["mapRequestRoles"]) {
                    if (_data["mapRequestRoles"].hasOwnProperty(key))
                        (this.mapRequestRoles as any)![key] = _data["mapRequestRoles"][key];
                }
            }
            if (_data["mapRequestStatuses"]) {
                this.mapRequestStatuses = {} as any;
                for (let key in _data["mapRequestStatuses"]) {
                    if (_data["mapRequestStatuses"].hasOwnProperty(key))
                        (this.mapRequestStatuses as any)![key] = _data["mapRequestStatuses"][key];
                }
            }
            if (_data["mapRequestTypes"]) {
                this.mapRequestTypes = {} as any;
                for (let key in _data["mapRequestTypes"]) {
                    if (_data["mapRequestTypes"].hasOwnProperty(key))
                        (this.mapRequestTypes as any)![key] = _data["mapRequestTypes"][key];
                }
            }
            if (_data["unaStatuses"]) {
                this.unaStatuses = {} as any;
                for (let key in _data["unaStatuses"]) {
                    if (_data["unaStatuses"].hasOwnProperty(key))
                        (this.unaStatuses as any)![key] = _data["unaStatuses"][key];
                }
            }
            if (_data["unaTypes"]) {
                this.unaTypes = {} as any;
                for (let key in _data["unaTypes"]) {
                    if (_data["unaTypes"].hasOwnProperty(key))
                        (this.unaTypes as any)![key] = _data["unaTypes"][key];
                }
            }
            if (_data["geometryConversionErrors"]) {
                this.geometryConversionErrors = {} as any;
                for (let key in _data["geometryConversionErrors"]) {
                    if (_data["geometryConversionErrors"].hasOwnProperty(key))
                        (this.geometryConversionErrors as any)![key] = _data["geometryConversionErrors"][key];
                }
            }
            if (_data["imklStatuses"]) {
                this.imklStatuses = {} as any;
                for (let key in _data["imklStatuses"]) {
                    if (_data["imklStatuses"].hasOwnProperty(key))
                        (this.imklStatuses as any)![key] = _data["imklStatuses"][key];
                }
            }
            if (_data["imklValidationMessages"]) {
                this.imklValidationMessages = {} as any;
                for (let key in _data["imklValidationMessages"]) {
                    if (_data["imklValidationMessages"].hasOwnProperty(key))
                        (this.imklValidationMessages as any)![key] = _data["imklValidationMessages"][key];
                }
            }
            if (_data["imklValidationStepStatuses"]) {
                this.imklValidationStepStatuses = {} as any;
                for (let key in _data["imklValidationStepStatuses"]) {
                    if (_data["imklValidationStepStatuses"].hasOwnProperty(key))
                        (this.imklValidationStepStatuses as any)![key] = _data["imklValidationStepStatuses"][key];
                }
            }
            if (_data["imklValidationStepTypes"]) {
                this.imklValidationStepTypes = {} as any;
                for (let key in _data["imklValidationStepTypes"]) {
                    if (_data["imklValidationStepTypes"].hasOwnProperty(key))
                        (this.imklValidationStepTypes as any)![key] = _data["imklValidationStepTypes"][key];
                }
            }
            if (Array.isArray(_data["orderDirections"])) {
                this.orderDirections = [] as any;
                for (let item of _data["orderDirections"])
                    this.orderDirections!.push(item);
            }
            if (_data["userRoleCodes"]) {
                this.userRoleCodes = {} as any;
                for (let key in _data["userRoleCodes"]) {
                    if (_data["userRoleCodes"].hasOwnProperty(key))
                        (this.userRoleCodes as any)![key] = _data["userRoleCodes"][key];
                }
            }
            this.mapRequestPrices = _data["mapRequestPrices"] ? MapRequestPrices.fromJS(_data["mapRequestPrices"]) : undefined as any;
            this.applicationInfo = _data["applicationInfo"] ? ApplicationInfo.fromJS(_data["applicationInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): CodeLists {
        data = typeof data === 'object' ? data : {};
        let result = new CodeLists();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.countryCodes) {
            data["countryCodes"] = {};
            for (let key in this.countryCodes) {
                if (this.countryCodes.hasOwnProperty(key))
                    (data["countryCodes"] as any)[key] = (this.countryCodes as any)[key];
            }
        }
        if (this.excavationMethods) {
            data["excavationMethods"] = {};
            for (let key in this.excavationMethods) {
                if (this.excavationMethods.hasOwnProperty(key))
                    (data["excavationMethods"] as any)[key] = (this.excavationMethods as any)[key];
            }
        }
        if (this.excavationTypes) {
            data["excavationTypes"] = {};
            for (let key in this.excavationTypes) {
                if (this.excavationTypes.hasOwnProperty(key))
                    (data["excavationTypes"] as any)[key] = (this.excavationTypes as any)[key];
            }
        }
        if (Array.isArray(this.holidays)) {
            data["holidays"] = [];
            for (let item of this.holidays)
                data["holidays"].push(item);
        }
        if (this.mapRequestRoles) {
            data["mapRequestRoles"] = {};
            for (let key in this.mapRequestRoles) {
                if (this.mapRequestRoles.hasOwnProperty(key))
                    (data["mapRequestRoles"] as any)[key] = (this.mapRequestRoles as any)[key];
            }
        }
        if (this.mapRequestStatuses) {
            data["mapRequestStatuses"] = {};
            for (let key in this.mapRequestStatuses) {
                if (this.mapRequestStatuses.hasOwnProperty(key))
                    (data["mapRequestStatuses"] as any)[key] = (this.mapRequestStatuses as any)[key];
            }
        }
        if (this.mapRequestTypes) {
            data["mapRequestTypes"] = {};
            for (let key in this.mapRequestTypes) {
                if (this.mapRequestTypes.hasOwnProperty(key))
                    (data["mapRequestTypes"] as any)[key] = (this.mapRequestTypes as any)[key];
            }
        }
        if (this.unaStatuses) {
            data["unaStatuses"] = {};
            for (let key in this.unaStatuses) {
                if (this.unaStatuses.hasOwnProperty(key))
                    (data["unaStatuses"] as any)[key] = (this.unaStatuses as any)[key];
            }
        }
        if (this.unaTypes) {
            data["unaTypes"] = {};
            for (let key in this.unaTypes) {
                if (this.unaTypes.hasOwnProperty(key))
                    (data["unaTypes"] as any)[key] = (this.unaTypes as any)[key];
            }
        }
        if (this.geometryConversionErrors) {
            data["geometryConversionErrors"] = {};
            for (let key in this.geometryConversionErrors) {
                if (this.geometryConversionErrors.hasOwnProperty(key))
                    (data["geometryConversionErrors"] as any)[key] = (this.geometryConversionErrors as any)[key];
            }
        }
        if (this.imklStatuses) {
            data["imklStatuses"] = {};
            for (let key in this.imklStatuses) {
                if (this.imklStatuses.hasOwnProperty(key))
                    (data["imklStatuses"] as any)[key] = (this.imklStatuses as any)[key];
            }
        }
        if (this.imklValidationMessages) {
            data["imklValidationMessages"] = {};
            for (let key in this.imklValidationMessages) {
                if (this.imklValidationMessages.hasOwnProperty(key))
                    (data["imklValidationMessages"] as any)[key] = (this.imklValidationMessages as any)[key];
            }
        }
        if (this.imklValidationStepStatuses) {
            data["imklValidationStepStatuses"] = {};
            for (let key in this.imklValidationStepStatuses) {
                if (this.imklValidationStepStatuses.hasOwnProperty(key))
                    (data["imklValidationStepStatuses"] as any)[key] = (this.imklValidationStepStatuses as any)[key];
            }
        }
        if (this.imklValidationStepTypes) {
            data["imklValidationStepTypes"] = {};
            for (let key in this.imklValidationStepTypes) {
                if (this.imklValidationStepTypes.hasOwnProperty(key))
                    (data["imklValidationStepTypes"] as any)[key] = (this.imklValidationStepTypes as any)[key];
            }
        }
        if (Array.isArray(this.orderDirections)) {
            data["orderDirections"] = [];
            for (let item of this.orderDirections)
                data["orderDirections"].push(item);
        }
        if (this.userRoleCodes) {
            data["userRoleCodes"] = {};
            for (let key in this.userRoleCodes) {
                if (this.userRoleCodes.hasOwnProperty(key))
                    (data["userRoleCodes"] as any)[key] = (this.userRoleCodes as any)[key];
            }
        }
        data["mapRequestPrices"] = this.mapRequestPrices ? this.mapRequestPrices.toJSON() : undefined as any;
        data["applicationInfo"] = this.applicationInfo ? this.applicationInfo.toJSON() : undefined as any;
        return data;
    }
}

export interface ICodeLists {
    countryCodes?: { [key: string]: string; } | undefined;
    excavationMethods?: { [key: string]: string; } | undefined;
    excavationTypes?: { [key: string]: string; } | undefined;
    holidays?: string[] | undefined;
    mapRequestRoles?: { [key: string]: string; } | undefined;
    mapRequestStatuses?: { [key: string]: string; } | undefined;
    mapRequestTypes?: { [key: string]: string; } | undefined;
    unaStatuses?: { [key: string]: string; } | undefined;
    unaTypes?: { [key: string]: string; } | undefined;
    geometryConversionErrors?: { [key: string]: string; } | undefined;
    imklStatuses?: { [key: string]: string; } | undefined;
    imklValidationMessages?: { [key: string]: string; } | undefined;
    imklValidationStepStatuses?: { [key: string]: string; } | undefined;
    imklValidationStepTypes?: { [key: string]: string; } | undefined;
    orderDirections?: string[] | undefined;
    userRoleCodes?: { [key: string]: string; } | undefined;
    mapRequestPrices?: MapRequestPrices | undefined;
    applicationInfo?: ApplicationInfo | undefined;
}

export class MapRequestPrices implements IMapRequestPrices {
    mapRequestSmall?: number;
    mapRequestLarge?: number;
    imklPrice?: number;
    areaThreshold?: number;

    constructor(data?: IMapRequestPrices) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestSmall = _data["mapRequestSmall"];
            this.mapRequestLarge = _data["mapRequestLarge"];
            this.imklPrice = _data["imklPrice"];
            this.areaThreshold = _data["areaThreshold"];
        }
    }

    static fromJS(data: any): MapRequestPrices {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestPrices();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestSmall"] = this.mapRequestSmall;
        data["mapRequestLarge"] = this.mapRequestLarge;
        data["imklPrice"] = this.imklPrice;
        data["areaThreshold"] = this.areaThreshold;
        return data;
    }
}

export interface IMapRequestPrices {
    mapRequestSmall?: number;
    mapRequestLarge?: number;
    imklPrice?: number;
    areaThreshold?: number;
}

export class ApplicationInfo implements IApplicationInfo {
    buildNumber?: string | undefined;
    environment?: string | undefined;

    constructor(data?: IApplicationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildNumber = _data["buildNumber"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): ApplicationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildNumber"] = this.buildNumber;
        data["environment"] = this.environment;
        return data;
    }
}

export interface IApplicationInfo {
    buildNumber?: string | undefined;
    environment?: string | undefined;
}

export class EnvelopeOfStream implements IEnvelopeOfStream {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: Stream | undefined;

    constructor(data?: IEnvelopeOfStream) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? Stream.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfStream {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfStream();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfStream {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: Stream | undefined;
}

export abstract class Stream implements IStream {
    canRead?: boolean;
    canWrite?: boolean;
    canSeek?: boolean;
    canTimeout?: boolean;
    length?: number;
    position?: number;
    readTimeout?: number;
    writeTimeout?: number;

    constructor(data?: IStream) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canRead = _data["canRead"];
            this.canWrite = _data["canWrite"];
            this.canSeek = _data["canSeek"];
            this.canTimeout = _data["canTimeout"];
            this.length = _data["length"];
            this.position = _data["position"];
            this.readTimeout = _data["readTimeout"];
            this.writeTimeout = _data["writeTimeout"];
        }
    }

    static fromJS(data: any): Stream {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Stream' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canRead"] = this.canRead;
        data["canWrite"] = this.canWrite;
        data["canSeek"] = this.canSeek;
        data["canTimeout"] = this.canTimeout;
        data["length"] = this.length;
        data["position"] = this.position;
        data["readTimeout"] = this.readTimeout;
        data["writeTimeout"] = this.writeTimeout;
        return data;
    }
}

export interface IStream {
    canRead?: boolean;
    canWrite?: boolean;
    canSeek?: boolean;
    canTimeout?: boolean;
    length?: number;
    position?: number;
    readTimeout?: number;
    writeTimeout?: number;
}

export class EnvelopeOfString implements IEnvelopeOfString {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: string | undefined;

    constructor(data?: IEnvelopeOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): EnvelopeOfString {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result;
        return data;
    }
}

export interface IEnvelopeOfString {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class GetMapRequestsRepliedInput implements IGetMapRequestsRepliedInput {
    orderField?: MapRequestsRepliedOrderField;
    orderDirection?: OrderDirection;
    offset?: number;
    limit?: number;
    searchOption?: SearchOption;
    organisationId?: string | undefined;
    utilityNetworkAuthorityZoneId?: string | undefined;
    searchField?: SearchField;
    query?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    isArchived?: boolean;
    zoneGeometry?: string | undefined;
    zoneWkt?: string | undefined;
    isMapRequestId?: boolean;
    isMapRequestInitiator?: boolean;
    isReference?: boolean;

    constructor(data?: IGetMapRequestsRepliedInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderField = _data["orderField"];
            this.orderDirection = _data["orderDirection"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
            this.searchOption = _data["searchOption"];
            this.organisationId = _data["organisationId"];
            this.utilityNetworkAuthorityZoneId = _data["utilityNetworkAuthorityZoneId"];
            this.searchField = _data["searchField"];
            this.query = _data["query"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.isArchived = _data["isArchived"];
            this.zoneGeometry = _data["zoneGeometry"];
            this.zoneWkt = _data["zoneWkt"];
            this.isMapRequestId = _data["isMapRequestId"];
            this.isMapRequestInitiator = _data["isMapRequestInitiator"];
            this.isReference = _data["isReference"];
        }
    }

    static fromJS(data: any): GetMapRequestsRepliedInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMapRequestsRepliedInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderField"] = this.orderField;
        data["orderDirection"] = this.orderDirection;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        data["searchOption"] = this.searchOption;
        data["organisationId"] = this.organisationId;
        data["utilityNetworkAuthorityZoneId"] = this.utilityNetworkAuthorityZoneId;
        data["searchField"] = this.searchField;
        data["query"] = this.query;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["isArchived"] = this.isArchived;
        data["zoneGeometry"] = this.zoneGeometry;
        data["zoneWkt"] = this.zoneWkt;
        data["isMapRequestId"] = this.isMapRequestId;
        data["isMapRequestInitiator"] = this.isMapRequestInitiator;
        data["isReference"] = this.isReference;
        return data;
    }
}

export interface IGetMapRequestsRepliedInput {
    orderField?: MapRequestsRepliedOrderField;
    orderDirection?: OrderDirection;
    offset?: number;
    limit?: number;
    searchOption?: SearchOption;
    organisationId?: string | undefined;
    utilityNetworkAuthorityZoneId?: string | undefined;
    searchField?: SearchField;
    query?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    isArchived?: boolean;
    zoneGeometry?: string | undefined;
    zoneWkt?: string | undefined;
    isMapRequestId?: boolean;
    isMapRequestInitiator?: boolean;
    isReference?: boolean;
}

export enum MapRequestsToReplyOrderField {
    DateReceived = 1,
    Reference = 2,
    ZoneName = 3,
    StartDate = 4,
    MapRequestType = 5,
    Organisation = 6,
}

export enum MapRequestsToConfirmOrderField {
    DateReceived = 1,
    Reference = 2,
    ZoneName = 3,
    Organisation = 4,
}

export enum OrderDirection {
    None = 0,
    Asc = 1,
    Desc = 2,
}

export enum SearchOption {
    None = 0,
    All = 1,
    Organisation = 2,
    My = 3,
    SubOrganisation = 4,
}

export enum SearchField {
    None = 0,
    KlipReference = 1,
    MyReference = 2,
    Requestor = 3,
    Organisation = 4,
}

export enum MapRequestsRepliedOrderField {
    DateReceived = 1,
    Reference = 2,
    ZoneName = 3,
    StartDate = 4,
    Organisation = 5,
    Requestor = 6,
}

export enum CoordinateSystem {
    None = 0,
    Lambert2008 = 3812,
    Lambert72 = 31370,
}

export class GetMapRequestsInput implements IGetMapRequestsInput {
    query?: string | undefined;
    searchField?: SearchField;
    searchOption?: SearchOption;
    organisationId?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    orderField?: OrderField;
    orderDirection?: OrderDirection;
    tags?: string[] | undefined;
    isArchived?: boolean;
    zoneGeometry?: string | undefined;
    zoneWkt?: string | undefined;
    offset?: number | undefined;
    limit?: number | undefined;

    constructor(data?: IGetMapRequestsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"];
            this.searchField = _data["searchField"];
            this.searchOption = _data["searchOption"];
            this.organisationId = _data["organisationId"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.orderField = _data["orderField"];
            this.orderDirection = _data["orderDirection"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.isArchived = _data["isArchived"];
            this.zoneGeometry = _data["zoneGeometry"];
            this.zoneWkt = _data["zoneWkt"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): GetMapRequestsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMapRequestsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        data["searchField"] = this.searchField;
        data["searchOption"] = this.searchOption;
        data["organisationId"] = this.organisationId;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["orderField"] = this.orderField;
        data["orderDirection"] = this.orderDirection;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["isArchived"] = this.isArchived;
        data["zoneGeometry"] = this.zoneGeometry;
        data["zoneWkt"] = this.zoneWkt;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IGetMapRequestsInput {
    query?: string | undefined;
    searchField?: SearchField;
    searchOption?: SearchOption;
    organisationId?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    orderField?: OrderField;
    orderDirection?: OrderDirection;
    tags?: string[] | undefined;
    isArchived?: boolean;
    zoneGeometry?: string | undefined;
    zoneWkt?: string | undefined;
    offset?: number | undefined;
    limit?: number | undefined;
}

export enum OrderField {
    DateReceived = 1,
    Reference = 2,
    StartDate = 3,
    Status = 4,
}

export class GetUsersInput implements IGetUsersInput {
    firstName?: string | undefined;
    lastName?: string | undefined;
    organisationId?: string | undefined;
    types?: string[] | undefined;
    inActiveUsers?: boolean;
    orderField?: string | undefined;
    orderDirection?: OrderDirection;
    offset?: number | undefined;
    limit?: number | undefined;

    constructor(data?: IGetUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.organisationId = _data["organisationId"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            this.inActiveUsers = _data["inActiveUsers"];
            this.orderField = _data["orderField"];
            this.orderDirection = _data["orderDirection"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): GetUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["organisationId"] = this.organisationId;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        data["inActiveUsers"] = this.inActiveUsers;
        data["orderField"] = this.orderField;
        data["orderDirection"] = this.orderDirection;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IGetUsersInput {
    firstName?: string | undefined;
    lastName?: string | undefined;
    organisationId?: string | undefined;
    types?: string[] | undefined;
    inActiveUsers?: boolean;
    orderField?: string | undefined;
    orderDirection?: OrderDirection;
    offset?: number | undefined;
    limit?: number | undefined;
}

export class EnvelopeOfSearchEnforcerMapRequestView implements IEnvelopeOfSearchEnforcerMapRequestView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: SearchEnforcerMapRequestView | undefined;

    constructor(data?: IEnvelopeOfSearchEnforcerMapRequestView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? SearchEnforcerMapRequestView.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfSearchEnforcerMapRequestView {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfSearchEnforcerMapRequestView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfSearchEnforcerMapRequestView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: SearchEnforcerMapRequestView | undefined;
}

export class SearchEnforcerMapRequestView implements ISearchEnforcerMapRequestView {
    mapRequestColumns?: Column[] | undefined;
    defaultSearchFilter?: GetEnforcerMapRequestsInput | undefined;
    searchFields?: CodeListValueOrder[] | undefined;
    searchOptions?: CodeListValueOrder[] | undefined;

    constructor(data?: ISearchEnforcerMapRequestView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mapRequestColumns"])) {
                this.mapRequestColumns = [] as any;
                for (let item of _data["mapRequestColumns"])
                    this.mapRequestColumns!.push(Column.fromJS(item));
            }
            this.defaultSearchFilter = _data["defaultSearchFilter"] ? GetEnforcerMapRequestsInput.fromJS(_data["defaultSearchFilter"]) : undefined as any;
            if (Array.isArray(_data["searchFields"])) {
                this.searchFields = [] as any;
                for (let item of _data["searchFields"])
                    this.searchFields!.push(CodeListValueOrder.fromJS(item));
            }
            if (Array.isArray(_data["searchOptions"])) {
                this.searchOptions = [] as any;
                for (let item of _data["searchOptions"])
                    this.searchOptions!.push(CodeListValueOrder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchEnforcerMapRequestView {
        data = typeof data === 'object' ? data : {};
        let result = new SearchEnforcerMapRequestView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mapRequestColumns)) {
            data["mapRequestColumns"] = [];
            for (let item of this.mapRequestColumns)
                data["mapRequestColumns"].push(item ? item.toJSON() : undefined as any);
        }
        data["defaultSearchFilter"] = this.defaultSearchFilter ? this.defaultSearchFilter.toJSON() : undefined as any;
        if (Array.isArray(this.searchFields)) {
            data["searchFields"] = [];
            for (let item of this.searchFields)
                data["searchFields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchOptions)) {
            data["searchOptions"] = [];
            for (let item of this.searchOptions)
                data["searchOptions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISearchEnforcerMapRequestView {
    mapRequestColumns?: Column[] | undefined;
    defaultSearchFilter?: GetEnforcerMapRequestsInput | undefined;
    searchFields?: CodeListValueOrder[] | undefined;
    searchOptions?: CodeListValueOrder[] | undefined;
}

export class Column implements IColumn {
    key?: string | undefined;
    label?: string | undefined;
    type?: string | undefined;
    sortable?: boolean;
    direction?: OrderDirection;
    order?: number;
    width?: number;
    widthUnit?: string | undefined;
    isVisible?: boolean;

    constructor(data?: IColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            this.type = _data["type"];
            this.sortable = _data["sortable"];
            this.direction = _data["direction"];
            this.order = _data["order"];
            this.width = _data["width"];
            this.widthUnit = _data["widthUnit"];
            this.isVisible = _data["isVisible"];
        }
    }

    static fromJS(data: any): Column {
        data = typeof data === 'object' ? data : {};
        let result = new Column();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        data["type"] = this.type;
        data["sortable"] = this.sortable;
        data["direction"] = this.direction;
        data["order"] = this.order;
        data["width"] = this.width;
        data["widthUnit"] = this.widthUnit;
        data["isVisible"] = this.isVisible;
        return data;
    }
}

export interface IColumn {
    key?: string | undefined;
    label?: string | undefined;
    type?: string | undefined;
    sortable?: boolean;
    direction?: OrderDirection;
    order?: number;
    width?: number;
    widthUnit?: string | undefined;
    isVisible?: boolean;
}

export class GetEnforcerMapRequestsInput implements IGetEnforcerMapRequestsInput {
    query?: string | undefined;
    mapRequestStatus?: string | undefined;
    searchField?: SearchField;
    startDate?: string | undefined;
    endDate?: string | undefined;
    checkWorkingPeriod?: boolean;
    orderBy?: string | undefined;
    zoneGeometry?: string | undefined;
    orderDirection?: OrderDirection;
    isArchived?: boolean;
    offset?: number | undefined;
    limit?: number | undefined;

    constructor(data?: IGetEnforcerMapRequestsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"];
            this.mapRequestStatus = _data["mapRequestStatus"];
            this.searchField = _data["searchField"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.checkWorkingPeriod = _data["checkWorkingPeriod"];
            this.orderBy = _data["orderBy"];
            this.zoneGeometry = _data["zoneGeometry"];
            this.orderDirection = _data["orderDirection"];
            this.isArchived = _data["isArchived"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): GetEnforcerMapRequestsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEnforcerMapRequestsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        data["mapRequestStatus"] = this.mapRequestStatus;
        data["searchField"] = this.searchField;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["checkWorkingPeriod"] = this.checkWorkingPeriod;
        data["orderBy"] = this.orderBy;
        data["zoneGeometry"] = this.zoneGeometry;
        data["orderDirection"] = this.orderDirection;
        data["isArchived"] = this.isArchived;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IGetEnforcerMapRequestsInput {
    query?: string | undefined;
    mapRequestStatus?: string | undefined;
    searchField?: SearchField;
    startDate?: string | undefined;
    endDate?: string | undefined;
    checkWorkingPeriod?: boolean;
    orderBy?: string | undefined;
    zoneGeometry?: string | undefined;
    orderDirection?: OrderDirection;
    isArchived?: boolean;
    offset?: number | undefined;
    limit?: number | undefined;
}

export class CodeListValueOrder implements ICodeListValueOrder {
    key?: string | undefined;
    label?: string | undefined;
    value?: any | undefined;
    isDefaultValue?: boolean;
    order?: number;

    constructor(data?: ICodeListValueOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.label = _data["label"];
            this.value = _data["value"];
            this.isDefaultValue = _data["isDefaultValue"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): CodeListValueOrder {
        data = typeof data === 'object' ? data : {};
        let result = new CodeListValueOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["label"] = this.label;
        data["value"] = this.value;
        data["isDefaultValue"] = this.isDefaultValue;
        data["order"] = this.order;
        return data;
    }
}

export interface ICodeListValueOrder {
    key?: string | undefined;
    label?: string | undefined;
    value?: any | undefined;
    isDefaultValue?: boolean;
    order?: number;
}

export class EnvelopeOfInteger implements IEnvelopeOfInteger {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: number;

    constructor(data?: IEnvelopeOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): EnvelopeOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result;
        return data;
    }
}

export interface IEnvelopeOfInteger {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: number;
}

export class EnvelopeOfICollectionOfMapRequestListItem implements IEnvelopeOfICollectionOfMapRequestListItem {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestListItem[] | undefined;

    constructor(data?: IEnvelopeOfICollectionOfMapRequestListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(MapRequestListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvelopeOfICollectionOfMapRequestListItem {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfICollectionOfMapRequestListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnvelopeOfICollectionOfMapRequestListItem {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestListItem[] | undefined;
}

export class MapRequestListItem implements IMapRequestListItem {
    id?: string;
    reference?: string | undefined;
    requester?: string | undefined;
    organisation?: string | undefined;
    dateReceived?: string;
    status?: string | undefined;
    mapRequestType?: string | undefined;

    constructor(data?: IMapRequestListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reference = _data["reference"];
            this.requester = _data["requester"];
            this.organisation = _data["organisation"];
            this.dateReceived = _data["dateReceived"];
            this.status = _data["status"];
            this.mapRequestType = _data["mapRequestType"];
        }
    }

    static fromJS(data: any): MapRequestListItem {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reference"] = this.reference;
        data["requester"] = this.requester;
        data["organisation"] = this.organisation;
        data["dateReceived"] = this.dateReceived;
        data["status"] = this.status;
        data["mapRequestType"] = this.mapRequestType;
        return data;
    }
}

export interface IMapRequestListItem {
    id?: string;
    reference?: string | undefined;
    requester?: string | undefined;
    organisation?: string | undefined;
    dateReceived?: string;
    status?: string | undefined;
    mapRequestType?: string | undefined;
}

export class EnvelopeOfEnforcerMapRequest implements IEnvelopeOfEnforcerMapRequest {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: EnforcerMapRequest | undefined;

    constructor(data?: IEnvelopeOfEnforcerMapRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? EnforcerMapRequest.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfEnforcerMapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfEnforcerMapRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfEnforcerMapRequest {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: EnforcerMapRequest | undefined;
}

export class EnforcerMapRequest implements IEnforcerMapRequest {
    mapRequestId?: string;
    mapRequestInitiatorCompany?: string | undefined;
    mapRequestInitiatorFirstName?: string | undefined;
    mapRequestInitiatorLastName?: string | undefined;
    mapRequestInitiatorTelephone?: string | undefined;
    mapRequestInitiatorEmail?: string | undefined;
    mapRequestInitiatorAddressAdditionalLine?: string | undefined;
    mapRequestInitiatorAddressStreet?: string | undefined;
    mapRequestInitiatorAddressStreetNumber?: string | undefined;
    mapRequestInitiatorAddressBox?: string | undefined;
    mapRequestInitiatorAddressCity?: string | undefined;
    mapRequestInitiatorAddressZip?: string | undefined;
    mapRequestInitiatorAddressCountryCode?: string | undefined;
    reference?: string | undefined;
    mapRequestType?: string | undefined;
    excavationType?: string | undefined;
    excavationMethod?: string | undefined;
    excavationLocation?: string | undefined;
    excavationDescription?: string | undefined;
    respondersStatusMessage?: string | undefined;
    startDate?: string;
    endDate?: string;
    deleteDate?: string | undefined;
    excavationDepth?: number | undefined;
    dateReceived?: string;
    status?: MapRequestDetailStatus;
    mapRequestInitiatorRole?: string | undefined;
    archiveDate?: string | undefined;
    responders?: MapRequestResponderData[] | undefined;
    klimData?: MapRequestKlimData | undefined;
    assetsStatusData?: AssetsStatusMri | undefined;
    plans?: Plans | undefined;
    zoneGeometry?: any | undefined;
    mapRequestZoneDownloadUrls?: DownloadUrl[] | undefined;
    mapRequestInitiator?: MapRequestInitiatorContactData | undefined;
    auditLogs?: AuditLog[] | undefined;
    responderAuditLogs?: ResponderAuditLog[] | undefined;

    constructor(data?: IEnforcerMapRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestId = _data["mapRequestId"];
            this.mapRequestInitiatorCompany = _data["mapRequestInitiatorCompany"];
            this.mapRequestInitiatorFirstName = _data["mapRequestInitiatorFirstName"];
            this.mapRequestInitiatorLastName = _data["mapRequestInitiatorLastName"];
            this.mapRequestInitiatorTelephone = _data["mapRequestInitiatorTelephone"];
            this.mapRequestInitiatorEmail = _data["mapRequestInitiatorEmail"];
            this.mapRequestInitiatorAddressAdditionalLine = _data["mapRequestInitiatorAddressAdditionalLine"];
            this.mapRequestInitiatorAddressStreet = _data["mapRequestInitiatorAddressStreet"];
            this.mapRequestInitiatorAddressStreetNumber = _data["mapRequestInitiatorAddressStreetNumber"];
            this.mapRequestInitiatorAddressBox = _data["mapRequestInitiatorAddressBox"];
            this.mapRequestInitiatorAddressCity = _data["mapRequestInitiatorAddressCity"];
            this.mapRequestInitiatorAddressZip = _data["mapRequestInitiatorAddressZip"];
            this.mapRequestInitiatorAddressCountryCode = _data["mapRequestInitiatorAddressCountryCode"];
            this.reference = _data["reference"];
            this.mapRequestType = _data["mapRequestType"];
            this.excavationType = _data["excavationType"];
            this.excavationMethod = _data["excavationMethod"];
            this.excavationLocation = _data["excavationLocation"];
            this.excavationDescription = _data["excavationDescription"];
            this.respondersStatusMessage = _data["respondersStatusMessage"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.deleteDate = _data["deleteDate"];
            this.excavationDepth = _data["excavationDepth"];
            this.dateReceived = _data["dateReceived"];
            this.status = _data["status"];
            this.mapRequestInitiatorRole = _data["mapRequestInitiatorRole"];
            this.archiveDate = _data["archiveDate"];
            if (Array.isArray(_data["responders"])) {
                this.responders = [] as any;
                for (let item of _data["responders"])
                    this.responders!.push(MapRequestResponderData.fromJS(item));
            }
            this.klimData = _data["klimData"] ? MapRequestKlimData.fromJS(_data["klimData"]) : undefined as any;
            this.assetsStatusData = _data["assetsStatusData"] ? AssetsStatusMri.fromJS(_data["assetsStatusData"]) : undefined as any;
            this.plans = _data["plans"] ? Plans.fromJS(_data["plans"]) : undefined as any;
            this.zoneGeometry = _data["zoneGeometry"];
            if (Array.isArray(_data["mapRequestZoneDownloadUrls"])) {
                this.mapRequestZoneDownloadUrls = [] as any;
                for (let item of _data["mapRequestZoneDownloadUrls"])
                    this.mapRequestZoneDownloadUrls!.push(DownloadUrl.fromJS(item));
            }
            this.mapRequestInitiator = _data["mapRequestInitiator"] ? MapRequestInitiatorContactData.fromJS(_data["mapRequestInitiator"]) : undefined as any;
            if (Array.isArray(_data["auditLogs"])) {
                this.auditLogs = [] as any;
                for (let item of _data["auditLogs"])
                    this.auditLogs!.push(AuditLog.fromJS(item));
            }
            if (Array.isArray(_data["responderAuditLogs"])) {
                this.responderAuditLogs = [] as any;
                for (let item of _data["responderAuditLogs"])
                    this.responderAuditLogs!.push(ResponderAuditLog.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnforcerMapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnforcerMapRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestId"] = this.mapRequestId;
        data["mapRequestInitiatorCompany"] = this.mapRequestInitiatorCompany;
        data["mapRequestInitiatorFirstName"] = this.mapRequestInitiatorFirstName;
        data["mapRequestInitiatorLastName"] = this.mapRequestInitiatorLastName;
        data["mapRequestInitiatorTelephone"] = this.mapRequestInitiatorTelephone;
        data["mapRequestInitiatorEmail"] = this.mapRequestInitiatorEmail;
        data["mapRequestInitiatorAddressAdditionalLine"] = this.mapRequestInitiatorAddressAdditionalLine;
        data["mapRequestInitiatorAddressStreet"] = this.mapRequestInitiatorAddressStreet;
        data["mapRequestInitiatorAddressStreetNumber"] = this.mapRequestInitiatorAddressStreetNumber;
        data["mapRequestInitiatorAddressBox"] = this.mapRequestInitiatorAddressBox;
        data["mapRequestInitiatorAddressCity"] = this.mapRequestInitiatorAddressCity;
        data["mapRequestInitiatorAddressZip"] = this.mapRequestInitiatorAddressZip;
        data["mapRequestInitiatorAddressCountryCode"] = this.mapRequestInitiatorAddressCountryCode;
        data["reference"] = this.reference;
        data["mapRequestType"] = this.mapRequestType;
        data["excavationType"] = this.excavationType;
        data["excavationMethod"] = this.excavationMethod;
        data["excavationLocation"] = this.excavationLocation;
        data["excavationDescription"] = this.excavationDescription;
        data["respondersStatusMessage"] = this.respondersStatusMessage;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["deleteDate"] = this.deleteDate;
        data["excavationDepth"] = this.excavationDepth;
        data["dateReceived"] = this.dateReceived;
        data["status"] = this.status;
        data["mapRequestInitiatorRole"] = this.mapRequestInitiatorRole;
        data["archiveDate"] = this.archiveDate;
        if (Array.isArray(this.responders)) {
            data["responders"] = [];
            for (let item of this.responders)
                data["responders"].push(item ? item.toJSON() : undefined as any);
        }
        data["klimData"] = this.klimData ? this.klimData.toJSON() : undefined as any;
        data["assetsStatusData"] = this.assetsStatusData ? this.assetsStatusData.toJSON() : undefined as any;
        data["plans"] = this.plans ? this.plans.toJSON() : undefined as any;
        data["zoneGeometry"] = this.zoneGeometry;
        if (Array.isArray(this.mapRequestZoneDownloadUrls)) {
            data["mapRequestZoneDownloadUrls"] = [];
            for (let item of this.mapRequestZoneDownloadUrls)
                data["mapRequestZoneDownloadUrls"].push(item ? item.toJSON() : undefined as any);
        }
        data["mapRequestInitiator"] = this.mapRequestInitiator ? this.mapRequestInitiator.toJSON() : undefined as any;
        if (Array.isArray(this.auditLogs)) {
            data["auditLogs"] = [];
            for (let item of this.auditLogs)
                data["auditLogs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.responderAuditLogs)) {
            data["responderAuditLogs"] = [];
            for (let item of this.responderAuditLogs)
                data["responderAuditLogs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnforcerMapRequest {
    mapRequestId?: string;
    mapRequestInitiatorCompany?: string | undefined;
    mapRequestInitiatorFirstName?: string | undefined;
    mapRequestInitiatorLastName?: string | undefined;
    mapRequestInitiatorTelephone?: string | undefined;
    mapRequestInitiatorEmail?: string | undefined;
    mapRequestInitiatorAddressAdditionalLine?: string | undefined;
    mapRequestInitiatorAddressStreet?: string | undefined;
    mapRequestInitiatorAddressStreetNumber?: string | undefined;
    mapRequestInitiatorAddressBox?: string | undefined;
    mapRequestInitiatorAddressCity?: string | undefined;
    mapRequestInitiatorAddressZip?: string | undefined;
    mapRequestInitiatorAddressCountryCode?: string | undefined;
    reference?: string | undefined;
    mapRequestType?: string | undefined;
    excavationType?: string | undefined;
    excavationMethod?: string | undefined;
    excavationLocation?: string | undefined;
    excavationDescription?: string | undefined;
    respondersStatusMessage?: string | undefined;
    startDate?: string;
    endDate?: string;
    deleteDate?: string | undefined;
    excavationDepth?: number | undefined;
    dateReceived?: string;
    status?: MapRequestDetailStatus;
    mapRequestInitiatorRole?: string | undefined;
    archiveDate?: string | undefined;
    responders?: MapRequestResponderData[] | undefined;
    klimData?: MapRequestKlimData | undefined;
    assetsStatusData?: AssetsStatusMri | undefined;
    plans?: Plans | undefined;
    zoneGeometry?: any | undefined;
    mapRequestZoneDownloadUrls?: DownloadUrl[] | undefined;
    mapRequestInitiator?: MapRequestInitiatorContactData | undefined;
    auditLogs?: AuditLog[] | undefined;
    responderAuditLogs?: ResponderAuditLog[] | undefined;
}

export enum MapRequestDetailStatus {
    Created = 1,
    InProgress = 2,
    Active = 3,
    ActiveIncomplete = 4,
    Incomplete = 5,
    Archived = 6,
}

export class MapRequestResponderData implements IMapRequestResponderData {
    name?: string | undefined;
    zoneName?: string | undefined;
    extraInformation?: string | undefined;
    contactName?: string | undefined;
    contactTelephone?: string | undefined;
    contactEmail?: string | undefined;
    alarmCentralTelephone?: string | undefined;
    isKlimZone?: boolean;
    status?: MapRequestResponderStatus;
    statusMessage?: string | undefined;

    constructor(data?: IMapRequestResponderData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.zoneName = _data["zoneName"];
            this.extraInformation = _data["extraInformation"];
            this.contactName = _data["contactName"];
            this.contactTelephone = _data["contactTelephone"];
            this.contactEmail = _data["contactEmail"];
            this.alarmCentralTelephone = _data["alarmCentralTelephone"];
            this.isKlimZone = _data["isKlimZone"];
            this.status = _data["status"];
            this.statusMessage = _data["statusMessage"];
        }
    }

    static fromJS(data: any): MapRequestResponderData {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestResponderData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["zoneName"] = this.zoneName;
        data["extraInformation"] = this.extraInformation;
        data["contactName"] = this.contactName;
        data["contactTelephone"] = this.contactTelephone;
        data["contactEmail"] = this.contactEmail;
        data["alarmCentralTelephone"] = this.alarmCentralTelephone;
        data["isKlimZone"] = this.isKlimZone;
        data["status"] = this.status;
        data["statusMessage"] = this.statusMessage;
        return data;
    }
}

export interface IMapRequestResponderData {
    name?: string | undefined;
    zoneName?: string | undefined;
    extraInformation?: string | undefined;
    contactName?: string | undefined;
    contactTelephone?: string | undefined;
    contactEmail?: string | undefined;
    alarmCentralTelephone?: string | undefined;
    isKlimZone?: boolean;
    status?: MapRequestResponderStatus;
    statusMessage?: string | undefined;
}

export enum MapRequestResponderStatus {
    Assigned = 1,
    Confirmed = 2,
    Responded = 3,
    NotInvolved = 4,
    NotAnswered = 5,
    ShouldRespondToMri = 6,
}

export class MapRequestKlimData implements IMapRequestKlimData {
    isResponseReceived?: boolean;
    hasKlimError?: boolean;
    mapRequestKlimResponders?: MapRequestKlimResponderData[] | undefined;

    constructor(data?: IMapRequestKlimData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isResponseReceived = _data["isResponseReceived"];
            this.hasKlimError = _data["hasKlimError"];
            if (Array.isArray(_data["mapRequestKlimResponders"])) {
                this.mapRequestKlimResponders = [] as any;
                for (let item of _data["mapRequestKlimResponders"])
                    this.mapRequestKlimResponders!.push(MapRequestKlimResponderData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MapRequestKlimData {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestKlimData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isResponseReceived"] = this.isResponseReceived;
        data["hasKlimError"] = this.hasKlimError;
        if (Array.isArray(this.mapRequestKlimResponders)) {
            data["mapRequestKlimResponders"] = [];
            for (let item of this.mapRequestKlimResponders)
                data["mapRequestKlimResponders"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMapRequestKlimData {
    isResponseReceived?: boolean;
    hasKlimError?: boolean;
    mapRequestKlimResponders?: MapRequestKlimResponderData[] | undefined;
}

export class MapRequestKlimResponderData implements IMapRequestKlimResponderData {
    name?: string | undefined;
    zoneName?: string | undefined;
    extraInformation?: string | undefined;
    contactName?: string | undefined;
    contactTelephone?: string | undefined;
    contactEmail?: string | undefined;
    alarmCentralTelephone?: string | undefined;
    isKlimZone?: boolean;

    constructor(data?: IMapRequestKlimResponderData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.zoneName = _data["zoneName"];
            this.extraInformation = _data["extraInformation"];
            this.contactName = _data["contactName"];
            this.contactTelephone = _data["contactTelephone"];
            this.contactEmail = _data["contactEmail"];
            this.alarmCentralTelephone = _data["alarmCentralTelephone"];
            this.isKlimZone = _data["isKlimZone"];
        }
    }

    static fromJS(data: any): MapRequestKlimResponderData {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestKlimResponderData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["zoneName"] = this.zoneName;
        data["extraInformation"] = this.extraInformation;
        data["contactName"] = this.contactName;
        data["contactTelephone"] = this.contactTelephone;
        data["contactEmail"] = this.contactEmail;
        data["alarmCentralTelephone"] = this.alarmCentralTelephone;
        data["isKlimZone"] = this.isKlimZone;
        return data;
    }
}

export interface IMapRequestKlimResponderData {
    name?: string | undefined;
    zoneName?: string | undefined;
    extraInformation?: string | undefined;
    contactName?: string | undefined;
    contactTelephone?: string | undefined;
    contactEmail?: string | undefined;
    alarmCentralTelephone?: string | undefined;
    isKlimZone?: boolean;
}

export class AssetsStatusMri implements IAssetsStatusMri {
    pmklPackageStatus?: MapRequestPmklMapAssetsStatus;
    mapAssetsStatus?: MapRequestPmklMapAssetsStatus;
    pmklPackageSizeInBytes?: number;
    imklOrderStatus?: MapRequestImklDataOrderStatus;

    constructor(data?: IAssetsStatusMri) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pmklPackageStatus = _data["pmklPackageStatus"];
            this.mapAssetsStatus = _data["mapAssetsStatus"];
            this.pmklPackageSizeInBytes = _data["pmklPackageSizeInBytes"];
            this.imklOrderStatus = _data["imklOrderStatus"];
        }
    }

    static fromJS(data: any): AssetsStatusMri {
        data = typeof data === 'object' ? data : {};
        let result = new AssetsStatusMri();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pmklPackageStatus"] = this.pmklPackageStatus;
        data["mapAssetsStatus"] = this.mapAssetsStatus;
        data["pmklPackageSizeInBytes"] = this.pmklPackageSizeInBytes;
        data["imklOrderStatus"] = this.imklOrderStatus;
        return data;
    }
}

export interface IAssetsStatusMri {
    pmklPackageStatus?: MapRequestPmklMapAssetsStatus;
    mapAssetsStatus?: MapRequestPmklMapAssetsStatus;
    pmklPackageSizeInBytes?: number;
    imklOrderStatus?: MapRequestImklDataOrderStatus;
}

export enum MapRequestPmklMapAssetsStatus {
    IsPending = 1,
    Done = 2,
    NoPermission = 3,
    Outdated = 4,
    Error = 5,
}

export enum MapRequestImklDataOrderStatus {
    NotOrdered = 1,
    Pending = 2,
    Ordered = 3,
}

export class Plans implements IPlans {
    downloadPmklFileUrl?: string | undefined;
    downloadImklFileUrl?: string | undefined;
    openMapRequestUrl?: string | undefined;

    constructor(data?: IPlans) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.downloadPmklFileUrl = _data["downloadPmklFileUrl"];
            this.downloadImklFileUrl = _data["downloadImklFileUrl"];
            this.openMapRequestUrl = _data["openMapRequestUrl"];
        }
    }

    static fromJS(data: any): Plans {
        data = typeof data === 'object' ? data : {};
        let result = new Plans();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["downloadPmklFileUrl"] = this.downloadPmklFileUrl;
        data["downloadImklFileUrl"] = this.downloadImklFileUrl;
        data["openMapRequestUrl"] = this.openMapRequestUrl;
        return data;
    }
}

export interface IPlans {
    downloadPmklFileUrl?: string | undefined;
    downloadImklFileUrl?: string | undefined;
    openMapRequestUrl?: string | undefined;
}

export class DownloadUrl implements IDownloadUrl {
    coordinateSystem?: CoordinateSystem;
    fileFormat?: string | undefined;
    url?: string | undefined;

    constructor(data?: IDownloadUrl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coordinateSystem = _data["coordinateSystem"];
            this.fileFormat = _data["fileFormat"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): DownloadUrl {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadUrl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coordinateSystem"] = this.coordinateSystem;
        data["fileFormat"] = this.fileFormat;
        data["url"] = this.url;
        return data;
    }
}

export interface IDownloadUrl {
    coordinateSystem?: CoordinateSystem;
    fileFormat?: string | undefined;
    url?: string | undefined;
}

export class MapRequestInitiatorContactData implements IMapRequestInitiatorContactData {
    klipOrganisationId?: string;
    company?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    klipUserId?: string;
    role?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    address?: Address | undefined;

    constructor(data?: IMapRequestInitiatorContactData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.klipOrganisationId = _data["klipOrganisationId"];
            this.company = _data["company"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.klipUserId = _data["klipUserId"];
            this.role = _data["role"];
            this.telephone = _data["telephone"];
            this.email = _data["email"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : undefined as any;
        }
    }

    static fromJS(data: any): MapRequestInitiatorContactData {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestInitiatorContactData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["klipOrganisationId"] = this.klipOrganisationId;
        data["company"] = this.company;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["klipUserId"] = this.klipUserId;
        data["role"] = this.role;
        data["telephone"] = this.telephone;
        data["email"] = this.email;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        return data;
    }
}

export interface IMapRequestInitiatorContactData {
    klipOrganisationId?: string;
    company?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    klipUserId?: string;
    role?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    address?: Address | undefined;
}

export class Address implements IAddress {
    additionalLine?: string | undefined;
    street?: string | undefined;
    streetNumber?: string | undefined;
    box?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    countryCode?: string | undefined;
    country?: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additionalLine = _data["additionalLine"];
            this.street = _data["street"];
            this.streetNumber = _data["streetNumber"];
            this.box = _data["box"];
            this.city = _data["city"];
            this.zip = _data["zip"];
            this.countryCode = _data["countryCode"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalLine"] = this.additionalLine;
        data["street"] = this.street;
        data["streetNumber"] = this.streetNumber;
        data["box"] = this.box;
        data["city"] = this.city;
        data["zip"] = this.zip;
        data["countryCode"] = this.countryCode;
        data["country"] = this.country;
        return data;
    }
}

export interface IAddress {
    additionalLine?: string | undefined;
    street?: string | undefined;
    streetNumber?: string | undefined;
    box?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    countryCode?: string | undefined;
    country?: string | undefined;
}

export class AuditLog implements IAuditLog {
    description?: string | undefined;
    timestamp?: string;
    eventType?: string | undefined;

    constructor(data?: IAuditLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.timestamp = _data["timestamp"];
            this.eventType = _data["eventType"];
        }
    }

    static fromJS(data: any): AuditLog {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["timestamp"] = this.timestamp;
        data["eventType"] = this.eventType;
        return data;
    }
}

export interface IAuditLog {
    description?: string | undefined;
    timestamp?: string;
    eventType?: string | undefined;
}

export class ResponderAuditLog implements IResponderAuditLog {
    utilityNetworkAuthorityDisplayName?: string | undefined;
    utilityNetworkAuthorityZoneName?: string | undefined;
    utilityNetworkAuthorityZoneId?: string;
    addedResponse?: ResponderResponseAuditLog | undefined;
    confirmedResponse?: ResponderResponseAuditLog | undefined;
    respondedResponse?: ResponderResponseAuditLog | undefined;
    imklVersion?: string | undefined;
    isKlim?: boolean;
    removed?: boolean;
    isServiceAccount?: boolean;

    constructor(data?: IResponderAuditLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.utilityNetworkAuthorityDisplayName = _data["utilityNetworkAuthorityDisplayName"];
            this.utilityNetworkAuthorityZoneName = _data["utilityNetworkAuthorityZoneName"];
            this.utilityNetworkAuthorityZoneId = _data["utilityNetworkAuthorityZoneId"];
            this.addedResponse = _data["addedResponse"] ? ResponderResponseAuditLog.fromJS(_data["addedResponse"]) : undefined as any;
            this.confirmedResponse = _data["confirmedResponse"] ? ResponderResponseAuditLog.fromJS(_data["confirmedResponse"]) : undefined as any;
            this.respondedResponse = _data["respondedResponse"] ? ResponderResponseAuditLog.fromJS(_data["respondedResponse"]) : undefined as any;
            this.imklVersion = _data["imklVersion"];
            this.isKlim = _data["isKlim"];
            this.removed = _data["removed"];
            this.isServiceAccount = _data["isServiceAccount"];
        }
    }

    static fromJS(data: any): ResponderAuditLog {
        data = typeof data === 'object' ? data : {};
        let result = new ResponderAuditLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utilityNetworkAuthorityDisplayName"] = this.utilityNetworkAuthorityDisplayName;
        data["utilityNetworkAuthorityZoneName"] = this.utilityNetworkAuthorityZoneName;
        data["utilityNetworkAuthorityZoneId"] = this.utilityNetworkAuthorityZoneId;
        data["addedResponse"] = this.addedResponse ? this.addedResponse.toJSON() : undefined as any;
        data["confirmedResponse"] = this.confirmedResponse ? this.confirmedResponse.toJSON() : undefined as any;
        data["respondedResponse"] = this.respondedResponse ? this.respondedResponse.toJSON() : undefined as any;
        data["imklVersion"] = this.imklVersion;
        data["isKlim"] = this.isKlim;
        data["removed"] = this.removed;
        data["isServiceAccount"] = this.isServiceAccount;
        return data;
    }
}

export interface IResponderAuditLog {
    utilityNetworkAuthorityDisplayName?: string | undefined;
    utilityNetworkAuthorityZoneName?: string | undefined;
    utilityNetworkAuthorityZoneId?: string;
    addedResponse?: ResponderResponseAuditLog | undefined;
    confirmedResponse?: ResponderResponseAuditLog | undefined;
    respondedResponse?: ResponderResponseAuditLog | undefined;
    imklVersion?: string | undefined;
    isKlim?: boolean;
    removed?: boolean;
    isServiceAccount?: boolean;
}

export class ResponderResponseAuditLog implements IResponderResponseAuditLog {
    respondedAt?: string | undefined;
    respondedBy?: string | undefined;
    respondedByKlipContactId?: string | undefined;
    reminderSent?: string | undefined;
    isServiceAccount?: boolean;

    constructor(data?: IResponderResponseAuditLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.respondedAt = _data["respondedAt"];
            this.respondedBy = _data["respondedBy"];
            this.respondedByKlipContactId = _data["respondedByKlipContactId"];
            this.reminderSent = _data["reminderSent"];
            this.isServiceAccount = _data["isServiceAccount"];
        }
    }

    static fromJS(data: any): ResponderResponseAuditLog {
        data = typeof data === 'object' ? data : {};
        let result = new ResponderResponseAuditLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["respondedAt"] = this.respondedAt;
        data["respondedBy"] = this.respondedBy;
        data["respondedByKlipContactId"] = this.respondedByKlipContactId;
        data["reminderSent"] = this.reminderSent;
        data["isServiceAccount"] = this.isServiceAccount;
        return data;
    }
}

export interface IResponderResponseAuditLog {
    respondedAt?: string | undefined;
    respondedBy?: string | undefined;
    respondedByKlipContactId?: string | undefined;
    reminderSent?: string | undefined;
    isServiceAccount?: boolean;
}

export class EnvelopeOfArchivedEnforcerMapRequest implements IEnvelopeOfArchivedEnforcerMapRequest {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ArchivedEnforcerMapRequest | undefined;

    constructor(data?: IEnvelopeOfArchivedEnforcerMapRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? ArchivedEnforcerMapRequest.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfArchivedEnforcerMapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfArchivedEnforcerMapRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfArchivedEnforcerMapRequest {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ArchivedEnforcerMapRequest | undefined;
}

export class ArchivedEnforcerMapRequest implements IArchivedEnforcerMapRequest {
    mapRequestId?: string;
    mapRequestInitiatorCompany?: string | undefined;
    mapRequestInitiatorFirstName?: string | undefined;
    mapRequestInitiatorLastName?: string | undefined;
    mapRequestInitiatorTelephone?: string | undefined;
    mapRequestInitiatorEmail?: string | undefined;
    mapRequestInitiatorAddressAdditionalLine?: string | undefined;
    mapRequestInitiatorAddressStreet?: string | undefined;
    mapRequestInitiatorAddressStreetNumber?: string | undefined;
    mapRequestInitiatorAddressBox?: string | undefined;
    mapRequestInitiatorAddressCity?: string | undefined;
    mapRequestInitiatorAddressZip?: string | undefined;
    mapRequestInitiatorAddressCountryCode?: string | undefined;
    reference?: string | undefined;
    mapRequestType?: string | undefined;
    excavationType?: string | undefined;
    excavationMethod?: string | undefined;
    excavationLocation?: string | undefined;
    excavationDescription?: string | undefined;
    respondersStatusMessage?: string | undefined;
    startDate?: string;
    endDate?: string;
    deleteDate?: string | undefined;
    excavationDepth?: number | undefined;
    dateReceived?: string;
    status?: MapRequestDetailStatus;
    mapRequestInitiatorRole?: string | undefined;
    archiveDate?: string | undefined;
    responders?: MapRequestResponderData[] | undefined;
    klimData?: MapRequestKlimData | undefined;
    assetsStatusData?: AssetsStatusMri | undefined;
    plans?: Plans | undefined;
    zoneGeometry?: any | undefined;
    mapRequestZoneDownloadUrls?: DownloadUrl[] | undefined;
    mapRequestInitiator?: MapRequestInitiatorContactData | undefined;
    auditLogs?: AuditLog[] | undefined;
    responderAuditLogs?: ResponderAuditLog[] | undefined;
    downloadArchiveUrl?: string | undefined;

    constructor(data?: IArchivedEnforcerMapRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestId = _data["mapRequestId"];
            this.mapRequestInitiatorCompany = _data["mapRequestInitiatorCompany"];
            this.mapRequestInitiatorFirstName = _data["mapRequestInitiatorFirstName"];
            this.mapRequestInitiatorLastName = _data["mapRequestInitiatorLastName"];
            this.mapRequestInitiatorTelephone = _data["mapRequestInitiatorTelephone"];
            this.mapRequestInitiatorEmail = _data["mapRequestInitiatorEmail"];
            this.mapRequestInitiatorAddressAdditionalLine = _data["mapRequestInitiatorAddressAdditionalLine"];
            this.mapRequestInitiatorAddressStreet = _data["mapRequestInitiatorAddressStreet"];
            this.mapRequestInitiatorAddressStreetNumber = _data["mapRequestInitiatorAddressStreetNumber"];
            this.mapRequestInitiatorAddressBox = _data["mapRequestInitiatorAddressBox"];
            this.mapRequestInitiatorAddressCity = _data["mapRequestInitiatorAddressCity"];
            this.mapRequestInitiatorAddressZip = _data["mapRequestInitiatorAddressZip"];
            this.mapRequestInitiatorAddressCountryCode = _data["mapRequestInitiatorAddressCountryCode"];
            this.reference = _data["reference"];
            this.mapRequestType = _data["mapRequestType"];
            this.excavationType = _data["excavationType"];
            this.excavationMethod = _data["excavationMethod"];
            this.excavationLocation = _data["excavationLocation"];
            this.excavationDescription = _data["excavationDescription"];
            this.respondersStatusMessage = _data["respondersStatusMessage"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.deleteDate = _data["deleteDate"];
            this.excavationDepth = _data["excavationDepth"];
            this.dateReceived = _data["dateReceived"];
            this.status = _data["status"];
            this.mapRequestInitiatorRole = _data["mapRequestInitiatorRole"];
            this.archiveDate = _data["archiveDate"];
            if (Array.isArray(_data["responders"])) {
                this.responders = [] as any;
                for (let item of _data["responders"])
                    this.responders!.push(MapRequestResponderData.fromJS(item));
            }
            this.klimData = _data["klimData"] ? MapRequestKlimData.fromJS(_data["klimData"]) : undefined as any;
            this.assetsStatusData = _data["assetsStatusData"] ? AssetsStatusMri.fromJS(_data["assetsStatusData"]) : undefined as any;
            this.plans = _data["plans"] ? Plans.fromJS(_data["plans"]) : undefined as any;
            this.zoneGeometry = _data["zoneGeometry"];
            if (Array.isArray(_data["mapRequestZoneDownloadUrls"])) {
                this.mapRequestZoneDownloadUrls = [] as any;
                for (let item of _data["mapRequestZoneDownloadUrls"])
                    this.mapRequestZoneDownloadUrls!.push(DownloadUrl.fromJS(item));
            }
            this.mapRequestInitiator = _data["mapRequestInitiator"] ? MapRequestInitiatorContactData.fromJS(_data["mapRequestInitiator"]) : undefined as any;
            if (Array.isArray(_data["auditLogs"])) {
                this.auditLogs = [] as any;
                for (let item of _data["auditLogs"])
                    this.auditLogs!.push(AuditLog.fromJS(item));
            }
            if (Array.isArray(_data["responderAuditLogs"])) {
                this.responderAuditLogs = [] as any;
                for (let item of _data["responderAuditLogs"])
                    this.responderAuditLogs!.push(ResponderAuditLog.fromJS(item));
            }
            this.downloadArchiveUrl = _data["downloadArchiveUrl"];
        }
    }

    static fromJS(data: any): ArchivedEnforcerMapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivedEnforcerMapRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestId"] = this.mapRequestId;
        data["mapRequestInitiatorCompany"] = this.mapRequestInitiatorCompany;
        data["mapRequestInitiatorFirstName"] = this.mapRequestInitiatorFirstName;
        data["mapRequestInitiatorLastName"] = this.mapRequestInitiatorLastName;
        data["mapRequestInitiatorTelephone"] = this.mapRequestInitiatorTelephone;
        data["mapRequestInitiatorEmail"] = this.mapRequestInitiatorEmail;
        data["mapRequestInitiatorAddressAdditionalLine"] = this.mapRequestInitiatorAddressAdditionalLine;
        data["mapRequestInitiatorAddressStreet"] = this.mapRequestInitiatorAddressStreet;
        data["mapRequestInitiatorAddressStreetNumber"] = this.mapRequestInitiatorAddressStreetNumber;
        data["mapRequestInitiatorAddressBox"] = this.mapRequestInitiatorAddressBox;
        data["mapRequestInitiatorAddressCity"] = this.mapRequestInitiatorAddressCity;
        data["mapRequestInitiatorAddressZip"] = this.mapRequestInitiatorAddressZip;
        data["mapRequestInitiatorAddressCountryCode"] = this.mapRequestInitiatorAddressCountryCode;
        data["reference"] = this.reference;
        data["mapRequestType"] = this.mapRequestType;
        data["excavationType"] = this.excavationType;
        data["excavationMethod"] = this.excavationMethod;
        data["excavationLocation"] = this.excavationLocation;
        data["excavationDescription"] = this.excavationDescription;
        data["respondersStatusMessage"] = this.respondersStatusMessage;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["deleteDate"] = this.deleteDate;
        data["excavationDepth"] = this.excavationDepth;
        data["dateReceived"] = this.dateReceived;
        data["status"] = this.status;
        data["mapRequestInitiatorRole"] = this.mapRequestInitiatorRole;
        data["archiveDate"] = this.archiveDate;
        if (Array.isArray(this.responders)) {
            data["responders"] = [];
            for (let item of this.responders)
                data["responders"].push(item ? item.toJSON() : undefined as any);
        }
        data["klimData"] = this.klimData ? this.klimData.toJSON() : undefined as any;
        data["assetsStatusData"] = this.assetsStatusData ? this.assetsStatusData.toJSON() : undefined as any;
        data["plans"] = this.plans ? this.plans.toJSON() : undefined as any;
        data["zoneGeometry"] = this.zoneGeometry;
        if (Array.isArray(this.mapRequestZoneDownloadUrls)) {
            data["mapRequestZoneDownloadUrls"] = [];
            for (let item of this.mapRequestZoneDownloadUrls)
                data["mapRequestZoneDownloadUrls"].push(item ? item.toJSON() : undefined as any);
        }
        data["mapRequestInitiator"] = this.mapRequestInitiator ? this.mapRequestInitiator.toJSON() : undefined as any;
        if (Array.isArray(this.auditLogs)) {
            data["auditLogs"] = [];
            for (let item of this.auditLogs)
                data["auditLogs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.responderAuditLogs)) {
            data["responderAuditLogs"] = [];
            for (let item of this.responderAuditLogs)
                data["responderAuditLogs"].push(item ? item.toJSON() : undefined as any);
        }
        data["downloadArchiveUrl"] = this.downloadArchiveUrl;
        return data;
    }
}

export interface IArchivedEnforcerMapRequest {
    mapRequestId?: string;
    mapRequestInitiatorCompany?: string | undefined;
    mapRequestInitiatorFirstName?: string | undefined;
    mapRequestInitiatorLastName?: string | undefined;
    mapRequestInitiatorTelephone?: string | undefined;
    mapRequestInitiatorEmail?: string | undefined;
    mapRequestInitiatorAddressAdditionalLine?: string | undefined;
    mapRequestInitiatorAddressStreet?: string | undefined;
    mapRequestInitiatorAddressStreetNumber?: string | undefined;
    mapRequestInitiatorAddressBox?: string | undefined;
    mapRequestInitiatorAddressCity?: string | undefined;
    mapRequestInitiatorAddressZip?: string | undefined;
    mapRequestInitiatorAddressCountryCode?: string | undefined;
    reference?: string | undefined;
    mapRequestType?: string | undefined;
    excavationType?: string | undefined;
    excavationMethod?: string | undefined;
    excavationLocation?: string | undefined;
    excavationDescription?: string | undefined;
    respondersStatusMessage?: string | undefined;
    startDate?: string;
    endDate?: string;
    deleteDate?: string | undefined;
    excavationDepth?: number | undefined;
    dateReceived?: string;
    status?: MapRequestDetailStatus;
    mapRequestInitiatorRole?: string | undefined;
    archiveDate?: string | undefined;
    responders?: MapRequestResponderData[] | undefined;
    klimData?: MapRequestKlimData | undefined;
    assetsStatusData?: AssetsStatusMri | undefined;
    plans?: Plans | undefined;
    zoneGeometry?: any | undefined;
    mapRequestZoneDownloadUrls?: DownloadUrl[] | undefined;
    mapRequestInitiator?: MapRequestInitiatorContactData | undefined;
    auditLogs?: AuditLog[] | undefined;
    responderAuditLogs?: ResponderAuditLog[] | undefined;
    downloadArchiveUrl?: string | undefined;
}

export class EnvelopeOfIListOfFeatureFlag implements IEnvelopeOfIListOfFeatureFlag {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: FeatureFlag[] | undefined;

    constructor(data?: IEnvelopeOfIListOfFeatureFlag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(FeatureFlag.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvelopeOfIListOfFeatureFlag {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfIListOfFeatureFlag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnvelopeOfIListOfFeatureFlag {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: FeatureFlag[] | undefined;
}

export class FeatureFlag implements IFeatureFlag {
    name?: string | undefined;
    description?: string | undefined;
    valueCurrentEnvironment?: boolean;
    valueTest?: string | undefined;
    valueBeta?: string | undefined;
    valueProd?: string | undefined;
    currentEnvironmentProperty?: string | undefined;

    constructor(data?: IFeatureFlag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.valueCurrentEnvironment = _data["valueCurrentEnvironment"];
            this.valueTest = _data["valueTest"];
            this.valueBeta = _data["valueBeta"];
            this.valueProd = _data["valueProd"];
            this.currentEnvironmentProperty = _data["currentEnvironmentProperty"];
        }
    }

    static fromJS(data: any): FeatureFlag {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureFlag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["valueCurrentEnvironment"] = this.valueCurrentEnvironment;
        data["valueTest"] = this.valueTest;
        data["valueBeta"] = this.valueBeta;
        data["valueProd"] = this.valueProd;
        data["currentEnvironmentProperty"] = this.currentEnvironmentProperty;
        return data;
    }
}

export interface IFeatureFlag {
    name?: string | undefined;
    description?: string | undefined;
    valueCurrentEnvironment?: boolean;
    valueTest?: string | undefined;
    valueBeta?: string | undefined;
    valueProd?: string | undefined;
    currentEnvironmentProperty?: string | undefined;
}

export class EnvelopeOfLambert72ToLambert2008ConversionResponse implements IEnvelopeOfLambert72ToLambert2008ConversionResponse {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: Lambert72ToLambert2008ConversionResponse | undefined;

    constructor(data?: IEnvelopeOfLambert72ToLambert2008ConversionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? Lambert72ToLambert2008ConversionResponse.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfLambert72ToLambert2008ConversionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfLambert72ToLambert2008ConversionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfLambert72ToLambert2008ConversionResponse {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: Lambert72ToLambert2008ConversionResponse | undefined;
}

export class Lambert72ToLambert2008ConversionResponse implements ILambert72ToLambert2008ConversionResponse {
    wkt?: string | undefined;
    conversionSuccess?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: ILambert72ToLambert2008ConversionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wkt = _data["wkt"];
            this.conversionSuccess = _data["conversionSuccess"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): Lambert72ToLambert2008ConversionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new Lambert72ToLambert2008ConversionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wkt"] = this.wkt;
        data["conversionSuccess"] = this.conversionSuccess;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface ILambert72ToLambert2008ConversionResponse {
    wkt?: string | undefined;
    conversionSuccess?: boolean;
    errorMessage?: string | undefined;
}

export class PriceDto implements IPriceDto {
    id?: number;
    smallAreaProductCode?: string | undefined;
    smallAreaPrice?: number;
    largeAreaProductCode?: string | undefined;
    largeAreaPrice?: number;
    imklProductCode?: string | undefined;
    imklPrice?: number;
    areaThreshold?: number;
    activationDate!: string;

    constructor(data?: IPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.smallAreaProductCode = _data["smallAreaProductCode"];
            this.smallAreaPrice = _data["smallAreaPrice"];
            this.largeAreaProductCode = _data["largeAreaProductCode"];
            this.largeAreaPrice = _data["largeAreaPrice"];
            this.imklProductCode = _data["imklProductCode"];
            this.imklPrice = _data["imklPrice"];
            this.areaThreshold = _data["areaThreshold"];
            this.activationDate = _data["activationDate"];
        }
    }

    static fromJS(data: any): PriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["smallAreaProductCode"] = this.smallAreaProductCode;
        data["smallAreaPrice"] = this.smallAreaPrice;
        data["largeAreaProductCode"] = this.largeAreaProductCode;
        data["largeAreaPrice"] = this.largeAreaPrice;
        data["imklProductCode"] = this.imklProductCode;
        data["imklPrice"] = this.imklPrice;
        data["areaThreshold"] = this.areaThreshold;
        data["activationDate"] = this.activationDate;
        return data;
    }
}

export interface IPriceDto {
    id?: number;
    smallAreaProductCode?: string | undefined;
    smallAreaPrice?: number;
    largeAreaProductCode?: string | undefined;
    largeAreaPrice?: number;
    imklProductCode?: string | undefined;
    imklPrice?: number;
    areaThreshold?: number;
    activationDate: string;
}

export class UploadImklFileResult implements IUploadImklFileResult {
    imklFileId?: string | undefined;
    imklTestViewUrl?: string | undefined;

    constructor(data?: IUploadImklFileResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imklFileId = _data["imklFileId"];
            this.imklTestViewUrl = _data["imklTestViewUrl"];
        }
    }

    static fromJS(data: any): UploadImklFileResult {
        data = typeof data === 'object' ? data : {};
        let result = new UploadImklFileResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imklFileId"] = this.imklFileId;
        data["imklTestViewUrl"] = this.imklTestViewUrl;
        return data;
    }
}

export interface IUploadImklFileResult {
    imklFileId?: string | undefined;
    imklTestViewUrl?: string | undefined;
}

export class EnvelopeOfImklTestResultViewModel implements IEnvelopeOfImklTestResultViewModel {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ImklTestResultViewModel | undefined;

    constructor(data?: IEnvelopeOfImklTestResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? ImklTestResultViewModel.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfImklTestResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfImklTestResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfImklTestResultViewModel {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ImklTestResultViewModel | undefined;
}

export class ImklTestResultViewModel implements IImklTestResultViewModel {
    imklTestViewUrl?: string | undefined;
    imklTestMapViewUrl?: string | undefined;
    downloadImklTestFileUrl?: string | undefined;
    isProcessing?: boolean;
    isLatestImklVersion?: boolean;
    pmklConversionError?: boolean;
    imklValidationResult?: ImklValidationResult | undefined;

    constructor(data?: IImklTestResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imklTestViewUrl = _data["imklTestViewUrl"];
            this.imklTestMapViewUrl = _data["imklTestMapViewUrl"];
            this.downloadImklTestFileUrl = _data["downloadImklTestFileUrl"];
            this.isProcessing = _data["isProcessing"];
            this.isLatestImklVersion = _data["isLatestImklVersion"];
            this.pmklConversionError = _data["pmklConversionError"];
            this.imklValidationResult = _data["imklValidationResult"] ? ImklValidationResult.fromJS(_data["imklValidationResult"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImklTestResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImklTestResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imklTestViewUrl"] = this.imklTestViewUrl;
        data["imklTestMapViewUrl"] = this.imklTestMapViewUrl;
        data["downloadImklTestFileUrl"] = this.downloadImklTestFileUrl;
        data["isProcessing"] = this.isProcessing;
        data["isLatestImklVersion"] = this.isLatestImklVersion;
        data["pmklConversionError"] = this.pmklConversionError;
        data["imklValidationResult"] = this.imklValidationResult ? this.imklValidationResult.toJSON() : undefined as any;
        return data;
    }
}

export interface IImklTestResultViewModel {
    imklTestViewUrl?: string | undefined;
    imklTestMapViewUrl?: string | undefined;
    downloadImklTestFileUrl?: string | undefined;
    isProcessing?: boolean;
    isLatestImklVersion?: boolean;
    pmklConversionError?: boolean;
    imklValidationResult?: ImklValidationResult | undefined;
}

export class ImklValidationResult implements IImklValidationResult {
    isValidResult?: boolean;
    validationSteps?: ValidationStep[] | undefined;
    signatureValue?: string | undefined;
    dateReceived?: string;
    dateValid?: string;
    fileName?: string | undefined;
    userName?: string | undefined;

    constructor(data?: IImklValidationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValidResult = _data["isValidResult"];
            if (Array.isArray(_data["validationSteps"])) {
                this.validationSteps = [] as any;
                for (let item of _data["validationSteps"])
                    this.validationSteps!.push(ValidationStep.fromJS(item));
            }
            this.signatureValue = _data["signatureValue"];
            this.dateReceived = _data["dateReceived"];
            this.dateValid = _data["dateValid"];
            this.fileName = _data["fileName"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): ImklValidationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ImklValidationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValidResult"] = this.isValidResult;
        if (Array.isArray(this.validationSteps)) {
            data["validationSteps"] = [];
            for (let item of this.validationSteps)
                data["validationSteps"].push(item ? item.toJSON() : undefined as any);
        }
        data["signatureValue"] = this.signatureValue;
        data["dateReceived"] = this.dateReceived;
        data["dateValid"] = this.dateValid;
        data["fileName"] = this.fileName;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IImklValidationResult {
    isValidResult?: boolean;
    validationSteps?: ValidationStep[] | undefined;
    signatureValue?: string | undefined;
    dateReceived?: string;
    dateValid?: string;
    fileName?: string | undefined;
    userName?: string | undefined;
}

export class ValidationStep implements IValidationStep {
    validationStepElementType?: ValidationStepElementType;
    status?: string | undefined;
    order?: number;
    type?: string | undefined;
    validationMessages?: ValidationMessage[] | undefined;

    constructor(data?: IValidationStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validationStepElementType = _data["validationStepElementType"];
            this.status = _data["status"];
            this.order = _data["order"];
            this.type = _data["type"];
            if (Array.isArray(_data["validationMessages"])) {
                this.validationMessages = [] as any;
                for (let item of _data["validationMessages"])
                    this.validationMessages!.push(ValidationMessage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationStep {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validationStepElementType"] = this.validationStepElementType;
        data["status"] = this.status;
        data["order"] = this.order;
        data["type"] = this.type;
        if (Array.isArray(this.validationMessages)) {
            data["validationMessages"] = [];
            for (let item of this.validationMessages)
                data["validationMessages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IValidationStep {
    validationStepElementType?: ValidationStepElementType;
    status?: string | undefined;
    order?: number;
    type?: string | undefined;
    validationMessages?: ValidationMessage[] | undefined;
}

export enum ValidationStepElementType {
    Info = 1,
    Result = 2,
}

export class ValidationMessage implements IValidationMessage {
    level?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    element?: string | undefined;
    fileName?: string | undefined;
    messageCount?: string | undefined;

    constructor(data?: IValidationMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.level = _data["level"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.element = _data["element"];
            this.fileName = _data["fileName"];
            this.messageCount = _data["messageCount"];
        }
    }

    static fromJS(data: any): ValidationMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["code"] = this.code;
        data["description"] = this.description;
        data["element"] = this.element;
        data["fileName"] = this.fileName;
        data["messageCount"] = this.messageCount;
        return data;
    }
}

export interface IValidationMessage {
    level?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    element?: string | undefined;
    fileName?: string | undefined;
    messageCount?: string | undefined;
}

export class EnvelopeOfImklTestViewModel implements IEnvelopeOfImklTestViewModel {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ImklTestViewModel | undefined;

    constructor(data?: IEnvelopeOfImklTestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? ImklTestViewModel.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfImklTestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfImklTestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfImklTestViewModel {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ImklTestViewModel | undefined;
}

export class ImklTestViewModel implements IImklTestViewModel {
    imklUploadUrl?: string | undefined;

    constructor(data?: IImklTestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imklUploadUrl = _data["imklUploadUrl"];
        }
    }

    static fromJS(data: any): ImklTestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImklTestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imklUploadUrl"] = this.imklUploadUrl;
        return data;
    }
}

export interface IImklTestViewModel {
    imklUploadUrl?: string | undefined;
}

export class EnvelopeOfImklTestViewerViewModel implements IEnvelopeOfImklTestViewerViewModel {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ImklTestViewerViewModel | undefined;

    constructor(data?: IEnvelopeOfImklTestViewerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? ImklTestViewerViewModel.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfImklTestViewerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfImklTestViewerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfImklTestViewerViewModel {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ImklTestViewerViewModel | undefined;
}

export class ImklTestViewerViewModel implements IImklTestViewerViewModel {
    mapRequestReference?: string | undefined;
    getPmklUrl?: string | undefined;
    downloadImklTestAttachmentUrl?: string | undefined;

    constructor(data?: IImklTestViewerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestReference = _data["mapRequestReference"];
            this.getPmklUrl = _data["getPmklUrl"];
            this.downloadImklTestAttachmentUrl = _data["downloadImklTestAttachmentUrl"];
        }
    }

    static fromJS(data: any): ImklTestViewerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImklTestViewerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestReference"] = this.mapRequestReference;
        data["getPmklUrl"] = this.getPmklUrl;
        data["downloadImklTestAttachmentUrl"] = this.downloadImklTestAttachmentUrl;
        return data;
    }
}

export interface IImklTestViewerViewModel {
    mapRequestReference?: string | undefined;
    getPmklUrl?: string | undefined;
    downloadImklTestAttachmentUrl?: string | undefined;
}

export class EnvelopeOfStringOf implements IEnvelopeOfStringOf {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: string[] | undefined;

    constructor(data?: IEnvelopeOfStringOf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(item);
            }
        }
    }

    static fromJS(data: any): EnvelopeOfStringOf {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfStringOf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item);
        }
        return data;
    }
}

export interface IEnvelopeOfStringOf {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: string[] | undefined;
}

export class LogEntry implements ILogEntry {
    logEventLevel?: LogEventLevel;
    logImpact?: LogImpact;
    fileName?: string | undefined;
    functionName?: string | undefined;
    id?: string | undefined;
    context?: string | undefined;
    detailContext?: string | undefined;
    error?: LogEntryError | undefined;

    constructor(data?: ILogEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logEventLevel = _data["logEventLevel"];
            this.logImpact = _data["logImpact"];
            this.fileName = _data["fileName"];
            this.functionName = _data["functionName"];
            this.id = _data["id"];
            this.context = _data["context"];
            this.detailContext = _data["detailContext"];
            this.error = _data["error"] ? LogEntryError.fromJS(_data["error"]) : undefined as any;
        }
    }

    static fromJS(data: any): LogEntry {
        data = typeof data === 'object' ? data : {};
        let result = new LogEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logEventLevel"] = this.logEventLevel;
        data["logImpact"] = this.logImpact;
        data["fileName"] = this.fileName;
        data["functionName"] = this.functionName;
        data["id"] = this.id;
        data["context"] = this.context;
        data["detailContext"] = this.detailContext;
        data["error"] = this.error ? this.error.toJSON() : undefined as any;
        return data;
    }
}

export interface ILogEntry {
    logEventLevel?: LogEventLevel;
    logImpact?: LogImpact;
    fileName?: string | undefined;
    functionName?: string | undefined;
    id?: string | undefined;
    context?: string | undefined;
    detailContext?: string | undefined;
    error?: LogEntryError | undefined;
}

/** Specifies the meaning and relative importance of a log event. */
export enum LogEventLevel {
    Verbose = 0,
    Debug = 1,
    Information = 2,
    Warning = 3,
    Error = 4,
    Fatal = 5,
}

export enum LogImpact {
    Low = 0,
    Medium = 1,
    High = 2,
}

export class LogEntryError implements ILogEntryError {
    message?: string | undefined;
    baseUrl?: string | undefined;
    method?: string | undefined;
    url?: string | undefined;
    code?: string | undefined;
    status?: number;

    constructor(data?: ILogEntryError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.baseUrl = _data["baseUrl"];
            this.method = _data["method"];
            this.url = _data["url"];
            this.code = _data["code"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): LogEntryError {
        data = typeof data === 'object' ? data : {};
        let result = new LogEntryError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["baseUrl"] = this.baseUrl;
        data["method"] = this.method;
        data["url"] = this.url;
        data["code"] = this.code;
        data["status"] = this.status;
        return data;
    }
}

export interface ILogEntryError {
    message?: string | undefined;
    baseUrl?: string | undefined;
    method?: string | undefined;
    url?: string | undefined;
    code?: string | undefined;
    status?: number;
}

export class EnvelopeOfApplicationMessages implements IEnvelopeOfApplicationMessages {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ApplicationMessages | undefined;

    constructor(data?: IEnvelopeOfApplicationMessages) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? ApplicationMessages.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfApplicationMessages {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfApplicationMessages();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfApplicationMessages {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ApplicationMessages | undefined;
}

export class ApplicationMessages implements IApplicationMessages {
    whatsNew?: AlertNotification | undefined;
    messages?: AlertNotification[] | undefined;

    constructor(data?: IApplicationMessages) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.whatsNew = _data["whatsNew"] ? AlertNotification.fromJS(_data["whatsNew"]) : undefined as any;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(AlertNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApplicationMessages {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationMessages();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["whatsNew"] = this.whatsNew ? this.whatsNew.toJSON() : undefined as any;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IApplicationMessages {
    whatsNew?: AlertNotification | undefined;
    messages?: AlertNotification[] | undefined;
}

export class AlertNotification implements IAlertNotification {
    id?: string | undefined;
    icon?: string | undefined;
    title?: string | undefined;
    message?: string | undefined;
    isClosable?: boolean;
    type?: string | undefined;

    constructor(data?: IAlertNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.icon = _data["icon"];
            this.title = _data["title"];
            this.message = _data["message"];
            this.isClosable = _data["isClosable"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): AlertNotification {
        data = typeof data === 'object' ? data : {};
        let result = new AlertNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["icon"] = this.icon;
        data["title"] = this.title;
        data["message"] = this.message;
        data["isClosable"] = this.isClosable;
        data["type"] = this.type;
        return data;
    }
}

export interface IAlertNotification {
    id?: string | undefined;
    icon?: string | undefined;
    title?: string | undefined;
    message?: string | undefined;
    isClosable?: boolean;
    type?: string | undefined;
}

export class EnvelopeOfGetMapRequestsView implements IEnvelopeOfGetMapRequestsView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: GetMapRequestsView | undefined;

    constructor(data?: IEnvelopeOfGetMapRequestsView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? GetMapRequestsView.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfGetMapRequestsView {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfGetMapRequestsView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfGetMapRequestsView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: GetMapRequestsView | undefined;
}

export class GetMapRequestsView implements IGetMapRequestsView {
    mapRequests?: MapRequestListItem2[] | undefined;
    pendingMapRequestsCount?: number;
    hasArchivedMapRequests?: boolean;

    constructor(data?: IGetMapRequestsView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mapRequests"])) {
                this.mapRequests = [] as any;
                for (let item of _data["mapRequests"])
                    this.mapRequests!.push(MapRequestListItem2.fromJS(item));
            }
            this.pendingMapRequestsCount = _data["pendingMapRequestsCount"];
            this.hasArchivedMapRequests = _data["hasArchivedMapRequests"];
        }
    }

    static fromJS(data: any): GetMapRequestsView {
        data = typeof data === 'object' ? data : {};
        let result = new GetMapRequestsView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mapRequests)) {
            data["mapRequests"] = [];
            for (let item of this.mapRequests)
                data["mapRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["pendingMapRequestsCount"] = this.pendingMapRequestsCount;
        data["hasArchivedMapRequests"] = this.hasArchivedMapRequests;
        return data;
    }
}

export interface IGetMapRequestsView {
    mapRequests?: MapRequestListItem2[] | undefined;
    pendingMapRequestsCount?: number;
    hasArchivedMapRequests?: boolean;
}

export class MapRequestListItem2 implements IMapRequestListItem2 {
    id?: string;
    reference?: string | undefined;
    dateReceived?: string;
    startDate?: string;
    status?: string | undefined;

    constructor(data?: IMapRequestListItem2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reference = _data["reference"];
            this.dateReceived = _data["dateReceived"];
            this.startDate = _data["startDate"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): MapRequestListItem2 {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestListItem2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reference"] = this.reference;
        data["dateReceived"] = this.dateReceived;
        data["startDate"] = this.startDate;
        data["status"] = this.status;
        return data;
    }
}

export interface IMapRequestListItem2 {
    id?: string;
    reference?: string | undefined;
    dateReceived?: string;
    startDate?: string;
    status?: string | undefined;
}

export class EnvelopeOfCreateMapRequestForOverlay implements IEnvelopeOfCreateMapRequestForOverlay {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: CreateMapRequestForOverlay | undefined;

    constructor(data?: IEnvelopeOfCreateMapRequestForOverlay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? CreateMapRequestForOverlay.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfCreateMapRequestForOverlay {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfCreateMapRequestForOverlay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfCreateMapRequestForOverlay {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: CreateMapRequestForOverlay | undefined;
}

export class CreateMapRequestForOverlay implements ICreateMapRequestForOverlay {
    id?: string;

    constructor(data?: ICreateMapRequestForOverlay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateMapRequestForOverlay {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMapRequestForOverlay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateMapRequestForOverlay {
    id?: string;
}

export class CreateMapRequestForOverlayInput implements ICreateMapRequestForOverlayInput {
    id?: string | undefined;
    email?: string | undefined;
    reference?: string | undefined;
    excavationDescription?: string | undefined;
    excavationLocation?: string | undefined;
    mapRequestZoneWkt?: MapRequestZonesWkt | undefined;

    constructor(data?: ICreateMapRequestForOverlayInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.reference = _data["reference"];
            this.excavationDescription = _data["excavationDescription"];
            this.excavationLocation = _data["excavationLocation"];
            this.mapRequestZoneWkt = _data["mapRequestZoneWkt"] ? MapRequestZonesWkt.fromJS(_data["mapRequestZoneWkt"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateMapRequestForOverlayInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMapRequestForOverlayInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["reference"] = this.reference;
        data["excavationDescription"] = this.excavationDescription;
        data["excavationLocation"] = this.excavationLocation;
        data["mapRequestZoneWkt"] = this.mapRequestZoneWkt ? this.mapRequestZoneWkt.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateMapRequestForOverlayInput {
    id?: string | undefined;
    email?: string | undefined;
    reference?: string | undefined;
    excavationDescription?: string | undefined;
    excavationLocation?: string | undefined;
    mapRequestZoneWkt?: MapRequestZonesWkt | undefined;
}

export class MapRequestZonesWkt implements IMapRequestZonesWkt {
    name?: string | undefined;
    wkt?: string | undefined;

    constructor(data?: IMapRequestZonesWkt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.wkt = _data["wkt"];
        }
    }

    static fromJS(data: any): MapRequestZonesWkt {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestZonesWkt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["wkt"] = this.wkt;
        return data;
    }
}

export interface IMapRequestZonesWkt {
    name?: string | undefined;
    wkt?: string | undefined;
}

export class EnvelopeOfListOfString implements IEnvelopeOfListOfString {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: string[] | undefined;

    constructor(data?: IEnvelopeOfListOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(item);
            }
        }
    }

    static fromJS(data: any): EnvelopeOfListOfString {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfListOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item);
        }
        return data;
    }
}

export interface IEnvelopeOfListOfString {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: string[] | undefined;
}

export class EnvelopeOfAssetsStatusMri implements IEnvelopeOfAssetsStatusMri {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: AssetsStatusMri | undefined;

    constructor(data?: IEnvelopeOfAssetsStatusMri) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? AssetsStatusMri.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfAssetsStatusMri {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfAssetsStatusMri();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfAssetsStatusMri {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: AssetsStatusMri | undefined;
}

export class EnvelopeOfFailureResult implements IEnvelopeOfFailureResult {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: FailureResult | undefined;

    constructor(data?: IEnvelopeOfFailureResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? FailureResult.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfFailureResult {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfFailureResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfFailureResult {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: FailureResult | undefined;
}

export class FailureResult implements IFailureResult {
    errors?: ErrorMessage[];

    constructor(data?: IFailureResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorMessage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FailureResult {
        data = typeof data === 'object' ? data : {};
        let result = new FailureResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFailureResult {
    errors?: ErrorMessage[];
}

export class ErrorMessage implements IErrorMessage {
    message?: string | undefined;
    propertyName?: string | undefined;
    attemptedValue?: any | undefined;
    errorCode?: string | undefined;

    constructor(data?: IErrorMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.propertyName = _data["propertyName"];
            this.attemptedValue = _data["attemptedValue"];
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): ErrorMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["propertyName"] = this.propertyName;
        data["attemptedValue"] = this.attemptedValue;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IErrorMessage {
    message?: string | undefined;
    propertyName?: string | undefined;
    attemptedValue?: any | undefined;
    errorCode?: string | undefined;
}

export class OrderImklMapRequestInput implements IOrderImklMapRequestInput {
    mapRequestId?: string;

    constructor(data?: IOrderImklMapRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestId = _data["mapRequestId"];
        }
    }

    static fromJS(data: any): OrderImklMapRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new OrderImklMapRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestId"] = this.mapRequestId;
        return data;
    }
}

export interface IOrderImklMapRequestInput {
    mapRequestId?: string;
}

export class EnvelopeOfInvoicesAndPaymentReceiptsResponse implements IEnvelopeOfInvoicesAndPaymentReceiptsResponse {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: InvoicesAndPaymentReceiptsResponse | undefined;

    constructor(data?: IEnvelopeOfInvoicesAndPaymentReceiptsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? InvoicesAndPaymentReceiptsResponse.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfInvoicesAndPaymentReceiptsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfInvoicesAndPaymentReceiptsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfInvoicesAndPaymentReceiptsResponse {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: InvoicesAndPaymentReceiptsResponse | undefined;
}

export class InvoicesAndPaymentReceiptsResponse implements IInvoicesAndPaymentReceiptsResponse {
    unavailable?: boolean;
    invoices?: InvoiceListItem[] | undefined;
    downloadUrl?: string | undefined;

    constructor(data?: IInvoicesAndPaymentReceiptsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unavailable = _data["unavailable"];
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(InvoiceListItem.fromJS(item));
            }
            this.downloadUrl = _data["downloadUrl"];
        }
    }

    static fromJS(data: any): InvoicesAndPaymentReceiptsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicesAndPaymentReceiptsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unavailable"] = this.unavailable;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item ? item.toJSON() : undefined as any);
        }
        data["downloadUrl"] = this.downloadUrl;
        return data;
    }
}

export interface IInvoicesAndPaymentReceiptsResponse {
    unavailable?: boolean;
    invoices?: InvoiceListItem[] | undefined;
    downloadUrl?: string | undefined;
}

export class InvoiceListItem implements IInvoiceListItem {
    submitTimestamp?: string;
    totalPrice?: number;
    totalPriceFormatted?: string | undefined;
    klipContactId?: string;
    documentReference?: string | undefined;
    paymentType?: string | undefined;
    isTopUpCredit?: boolean;
    invoicePdfUrl?: string | undefined;
    attachmentCsvUrl?: string | undefined;
    type?: number;
    customerReference?: string | undefined;
    organisationName?: string | undefined;

    constructor(data?: IInvoiceListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submitTimestamp = _data["submitTimestamp"];
            this.totalPrice = _data["totalPrice"];
            this.totalPriceFormatted = _data["totalPriceFormatted"];
            this.klipContactId = _data["klipContactId"];
            this.documentReference = _data["documentReference"];
            this.paymentType = _data["paymentType"];
            this.isTopUpCredit = _data["isTopUpCredit"];
            this.invoicePdfUrl = _data["invoicePdfUrl"];
            this.attachmentCsvUrl = _data["attachmentCsvUrl"];
            this.type = _data["type"];
            this.customerReference = _data["customerReference"];
            this.organisationName = _data["organisationName"];
        }
    }

    static fromJS(data: any): InvoiceListItem {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submitTimestamp"] = this.submitTimestamp;
        data["totalPrice"] = this.totalPrice;
        data["totalPriceFormatted"] = this.totalPriceFormatted;
        data["klipContactId"] = this.klipContactId;
        data["documentReference"] = this.documentReference;
        data["paymentType"] = this.paymentType;
        data["isTopUpCredit"] = this.isTopUpCredit;
        data["invoicePdfUrl"] = this.invoicePdfUrl;
        data["attachmentCsvUrl"] = this.attachmentCsvUrl;
        data["type"] = this.type;
        data["customerReference"] = this.customerReference;
        data["organisationName"] = this.organisationName;
        return data;
    }
}

export interface IInvoiceListItem {
    submitTimestamp?: string;
    totalPrice?: number;
    totalPriceFormatted?: string | undefined;
    klipContactId?: string;
    documentReference?: string | undefined;
    paymentType?: string | undefined;
    isTopUpCredit?: boolean;
    invoicePdfUrl?: string | undefined;
    attachmentCsvUrl?: string | undefined;
    type?: number;
    customerReference?: string | undefined;
    organisationName?: string | undefined;
}

export class InvoicesAndPaymentReceiptsQuery implements IInvoicesAndPaymentReceiptsQuery {
    organisationId?: string | undefined;
    fromDate?: string;
    toDate?: string;
    klipUserId?: string | undefined;
    docNr?: string | undefined;

    constructor(data?: IInvoicesAndPaymentReceiptsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationId = _data["organisationId"];
            this.fromDate = _data["fromDate"];
            this.toDate = _data["toDate"];
            this.klipUserId = _data["klipUserId"];
            this.docNr = _data["docNr"];
        }
    }

    static fromJS(data: any): InvoicesAndPaymentReceiptsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicesAndPaymentReceiptsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationId"] = this.organisationId;
        data["fromDate"] = this.fromDate;
        data["toDate"] = this.toDate;
        data["klipUserId"] = this.klipUserId;
        data["docNr"] = this.docNr;
        return data;
    }
}

export interface IInvoicesAndPaymentReceiptsQuery {
    organisationId?: string | undefined;
    fromDate?: string;
    toDate?: string;
    klipUserId?: string | undefined;
    docNr?: string | undefined;
}

export class EnvelopeOfMapRequestRespondersData implements IEnvelopeOfMapRequestRespondersData {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestRespondersData | undefined;

    constructor(data?: IEnvelopeOfMapRequestRespondersData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? MapRequestRespondersData.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfMapRequestRespondersData {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfMapRequestRespondersData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfMapRequestRespondersData {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestRespondersData | undefined;
}

export class MapRequestRespondersData implements IMapRequestRespondersData {
    responders?: MapRequestResponderData[] | undefined;
    klimData?: MapRequestKlimData | undefined;

    constructor(data?: IMapRequestRespondersData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responders"])) {
                this.responders = [] as any;
                for (let item of _data["responders"])
                    this.responders!.push(MapRequestResponderData.fromJS(item));
            }
            this.klimData = _data["klimData"] ? MapRequestKlimData.fromJS(_data["klimData"]) : undefined as any;
        }
    }

    static fromJS(data: any): MapRequestRespondersData {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestRespondersData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responders)) {
            data["responders"] = [];
            for (let item of this.responders)
                data["responders"].push(item ? item.toJSON() : undefined as any);
        }
        data["klimData"] = this.klimData ? this.klimData.toJSON() : undefined as any;
        return data;
    }
}

export interface IMapRequestRespondersData {
    responders?: MapRequestResponderData[] | undefined;
    klimData?: MapRequestKlimData | undefined;
}

export class EnvelopeOfIListOfMapRequestPrintView implements IEnvelopeOfIListOfMapRequestPrintView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestPrintView[] | undefined;

    constructor(data?: IEnvelopeOfIListOfMapRequestPrintView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(MapRequestPrintView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvelopeOfIListOfMapRequestPrintView {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfIListOfMapRequestPrintView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnvelopeOfIListOfMapRequestPrintView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestPrintView[] | undefined;
}

export class MapRequestPrintView implements IMapRequestPrintView {
    timestamp?: string;
    printId?: string;
    mapRequestId?: string;
    zoomLevel?: number;
    downloadMapRequestPrintPackageUrl?: string | undefined;
    extraPlans?: boolean;
    resolution?: number;
    paperSize?: string | undefined;
    content?: number;
    fileSize?: number;
    isProcessed?: boolean;
    retentionPeriodInDays?: number;

    constructor(data?: IMapRequestPrintView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"];
            this.printId = _data["printId"];
            this.mapRequestId = _data["mapRequestId"];
            this.zoomLevel = _data["zoomLevel"];
            this.downloadMapRequestPrintPackageUrl = _data["downloadMapRequestPrintPackageUrl"];
            this.extraPlans = _data["extraPlans"];
            this.resolution = _data["resolution"];
            this.paperSize = _data["paperSize"];
            this.content = _data["content"];
            this.fileSize = _data["fileSize"];
            this.isProcessed = _data["isProcessed"];
            this.retentionPeriodInDays = _data["retentionPeriodInDays"];
        }
    }

    static fromJS(data: any): MapRequestPrintView {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestPrintView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp;
        data["printId"] = this.printId;
        data["mapRequestId"] = this.mapRequestId;
        data["zoomLevel"] = this.zoomLevel;
        data["downloadMapRequestPrintPackageUrl"] = this.downloadMapRequestPrintPackageUrl;
        data["extraPlans"] = this.extraPlans;
        data["resolution"] = this.resolution;
        data["paperSize"] = this.paperSize;
        data["content"] = this.content;
        data["fileSize"] = this.fileSize;
        data["isProcessed"] = this.isProcessed;
        data["retentionPeriodInDays"] = this.retentionPeriodInDays;
        return data;
    }
}

export interface IMapRequestPrintView {
    timestamp?: string;
    printId?: string;
    mapRequestId?: string;
    zoomLevel?: number;
    downloadMapRequestPrintPackageUrl?: string | undefined;
    extraPlans?: boolean;
    resolution?: number;
    paperSize?: string | undefined;
    content?: number;
    fileSize?: number;
    isProcessed?: boolean;
    retentionPeriodInDays?: number;
}

export class EnvelopeOfPrintMapRequestView implements IEnvelopeOfPrintMapRequestView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: PrintMapRequestView | undefined;

    constructor(data?: IEnvelopeOfPrintMapRequestView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? PrintMapRequestView.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfPrintMapRequestView {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfPrintMapRequestView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfPrintMapRequestView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: PrintMapRequestView | undefined;
}

export class PrintMapRequestView implements IPrintMapRequestView {
    id?: string;
    dateRequested?: string;

    constructor(data?: IPrintMapRequestView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateRequested = _data["dateRequested"];
        }
    }

    static fromJS(data: any): PrintMapRequestView {
        data = typeof data === 'object' ? data : {};
        let result = new PrintMapRequestView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateRequested"] = this.dateRequested;
        return data;
    }
}

export interface IPrintMapRequestView {
    id?: string;
    dateRequested?: string;
}

export class PrintMapRequestInput implements IPrintMapRequestInput {
    id?: string;
    zoneId?: string | undefined;
    zoomLevel?: number;
    resolution?: number;
    map?: MapSettingsInput | undefined;
    viewport?: ViewportSettingsInput | undefined;
    extraPlans?: boolean;
    paperSize?: string | undefined;
    content?: number;
    showBeschermdGebied?: boolean | undefined;
    showKmHm?: boolean | undefined;

    constructor(data?: IPrintMapRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.zoneId = _data["zoneId"];
            this.zoomLevel = _data["zoomLevel"];
            this.resolution = _data["resolution"];
            this.map = _data["map"] ? MapSettingsInput.fromJS(_data["map"]) : undefined as any;
            this.viewport = _data["viewport"] ? ViewportSettingsInput.fromJS(_data["viewport"]) : undefined as any;
            this.extraPlans = _data["extraPlans"];
            this.paperSize = _data["paperSize"];
            this.content = _data["content"];
            this.showBeschermdGebied = _data["showBeschermdGebied"];
            this.showKmHm = _data["showKmHm"];
        }
    }

    static fromJS(data: any): PrintMapRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new PrintMapRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["zoneId"] = this.zoneId;
        data["zoomLevel"] = this.zoomLevel;
        data["resolution"] = this.resolution;
        data["map"] = this.map ? this.map.toJSON() : undefined as any;
        data["viewport"] = this.viewport ? this.viewport.toJSON() : undefined as any;
        data["extraPlans"] = this.extraPlans;
        data["paperSize"] = this.paperSize;
        data["content"] = this.content;
        data["showBeschermdGebied"] = this.showBeschermdGebied;
        data["showKmHm"] = this.showKmHm;
        return data;
    }
}

export interface IPrintMapRequestInput {
    id?: string;
    zoneId?: string | undefined;
    zoomLevel?: number;
    resolution?: number;
    map?: MapSettingsInput | undefined;
    viewport?: ViewportSettingsInput | undefined;
    extraPlans?: boolean;
    paperSize?: string | undefined;
    content?: number;
    showBeschermdGebied?: boolean | undefined;
    showKmHm?: boolean | undefined;
}

export class MapSettingsInput implements IMapSettingsInput {
    height?: number;
    width?: number;

    constructor(data?: IMapSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.height = _data["height"];
            this.width = _data["width"];
        }
    }

    static fromJS(data: any): MapSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new MapSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["height"] = this.height;
        data["width"] = this.width;
        return data;
    }
}

export interface IMapSettingsInput {
    height?: number;
    width?: number;
}

export class ViewportSettingsInput implements IViewportSettingsInput {
    bottom?: number;
    left?: number;
    right?: number;
    top?: number;

    constructor(data?: IViewportSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bottom = _data["bottom"];
            this.left = _data["left"];
            this.right = _data["right"];
            this.top = _data["top"];
        }
    }

    static fromJS(data: any): ViewportSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new ViewportSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bottom"] = this.bottom;
        data["left"] = this.left;
        data["right"] = this.right;
        data["top"] = this.top;
        return data;
    }
}

export interface IViewportSettingsInput {
    bottom?: number;
    left?: number;
    right?: number;
    top?: number;
}

export class CreateOrUpdateMapRequestInput implements ICreateOrUpdateMapRequestInput {
    mapRequestId?: string | undefined;
    shoppingCartId?: string | undefined;
    includeImkl?: boolean | undefined;
    localId?: string | undefined;
    organisationId?: string | undefined;
    reference?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    role?: string | undefined;
    address?: AddressInput | undefined;
    mapRequestType?: string | undefined;
    excavationType?: string | undefined;
    excavationDescription?: string | undefined;
    excavationLocation?: string | undefined;
    excavationMethod?: string | undefined;
    excavationDepth?: number | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    mapRequestZone?: any | undefined;
    mapRequestZonesWkt?: MapRequestZonesWkt[] | undefined;
    tags?: string[] | undefined;
    createMapRequestType?: CreateMapRequestType;

    constructor(data?: ICreateOrUpdateMapRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestId = _data["mapRequestId"];
            this.shoppingCartId = _data["shoppingCartId"];
            this.includeImkl = _data["includeImkl"];
            this.localId = _data["localId"];
            this.organisationId = _data["organisationId"];
            this.reference = _data["reference"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.telephone = _data["telephone"];
            this.email = _data["email"];
            this.role = _data["role"];
            this.address = _data["address"] ? AddressInput.fromJS(_data["address"]) : undefined as any;
            this.mapRequestType = _data["mapRequestType"];
            this.excavationType = _data["excavationType"];
            this.excavationDescription = _data["excavationDescription"];
            this.excavationLocation = _data["excavationLocation"];
            this.excavationMethod = _data["excavationMethod"];
            this.excavationDepth = _data["excavationDepth"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.mapRequestZone = _data["mapRequestZone"];
            if (Array.isArray(_data["mapRequestZonesWkt"])) {
                this.mapRequestZonesWkt = [] as any;
                for (let item of _data["mapRequestZonesWkt"])
                    this.mapRequestZonesWkt!.push(MapRequestZonesWkt.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.createMapRequestType = _data["createMapRequestType"];
        }
    }

    static fromJS(data: any): CreateOrUpdateMapRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMapRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestId"] = this.mapRequestId;
        data["shoppingCartId"] = this.shoppingCartId;
        data["includeImkl"] = this.includeImkl;
        data["localId"] = this.localId;
        data["organisationId"] = this.organisationId;
        data["reference"] = this.reference;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["telephone"] = this.telephone;
        data["email"] = this.email;
        data["role"] = this.role;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["mapRequestType"] = this.mapRequestType;
        data["excavationType"] = this.excavationType;
        data["excavationDescription"] = this.excavationDescription;
        data["excavationLocation"] = this.excavationLocation;
        data["excavationMethod"] = this.excavationMethod;
        data["excavationDepth"] = this.excavationDepth;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["mapRequestZone"] = this.mapRequestZone;
        if (Array.isArray(this.mapRequestZonesWkt)) {
            data["mapRequestZonesWkt"] = [];
            for (let item of this.mapRequestZonesWkt)
                data["mapRequestZonesWkt"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["createMapRequestType"] = this.createMapRequestType;
        return data;
    }
}

export interface ICreateOrUpdateMapRequestInput {
    mapRequestId?: string | undefined;
    shoppingCartId?: string | undefined;
    includeImkl?: boolean | undefined;
    localId?: string | undefined;
    organisationId?: string | undefined;
    reference?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    role?: string | undefined;
    address?: AddressInput | undefined;
    mapRequestType?: string | undefined;
    excavationType?: string | undefined;
    excavationDescription?: string | undefined;
    excavationLocation?: string | undefined;
    excavationMethod?: string | undefined;
    excavationDepth?: number | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    mapRequestZone?: any | undefined;
    mapRequestZonesWkt?: MapRequestZonesWkt[] | undefined;
    tags?: string[] | undefined;
    createMapRequestType?: CreateMapRequestType;
}

export class AddressInput implements IAddressInput {
    additionalLine?: string | undefined;
    street?: string | undefined;
    streetNumber?: string | undefined;
    box?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    countryCode?: string | undefined;

    constructor(data?: IAddressInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additionalLine = _data["additionalLine"];
            this.street = _data["street"];
            this.streetNumber = _data["streetNumber"];
            this.box = _data["box"];
            this.city = _data["city"];
            this.zip = _data["zip"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): AddressInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddressInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalLine"] = this.additionalLine;
        data["street"] = this.street;
        data["streetNumber"] = this.streetNumber;
        data["box"] = this.box;
        data["city"] = this.city;
        data["zip"] = this.zip;
        data["countryCode"] = this.countryCode;
        return data;
    }
}

export interface IAddressInput {
    additionalLine?: string | undefined;
    street?: string | undefined;
    streetNumber?: string | undefined;
    box?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    countryCode?: string | undefined;
}

export enum CreateMapRequestType {
    Create = 0,
    Resubmit = 1,
    ResubmitArchive = 2,
    EditShoppingCart = 3,
    SubmitOverlay = 4,
}

export class EnvelopeOfMapRequestStatusData implements IEnvelopeOfMapRequestStatusData {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestStatusData | undefined;

    constructor(data?: IEnvelopeOfMapRequestStatusData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? MapRequestStatusData.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfMapRequestStatusData {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfMapRequestStatusData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfMapRequestStatusData {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestStatusData | undefined;
}

export class MapRequestStatusData implements IMapRequestStatusData {
    status?: MapRequestDetailStatus;
    respondersStatusMessage?: string | undefined;

    constructor(data?: IMapRequestStatusData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.respondersStatusMessage = _data["respondersStatusMessage"];
        }
    }

    static fromJS(data: any): MapRequestStatusData {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestStatusData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["respondersStatusMessage"] = this.respondersStatusMessage;
        return data;
    }
}

export interface IMapRequestStatusData {
    status?: MapRequestDetailStatus;
    respondersStatusMessage?: string | undefined;
}

export class EnvelopeOfMapRequestListViewMri implements IEnvelopeOfMapRequestListViewMri {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestListViewMri | undefined;

    constructor(data?: IEnvelopeOfMapRequestListViewMri) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? MapRequestListViewMri.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfMapRequestListViewMri {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfMapRequestListViewMri();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfMapRequestListViewMri {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestListViewMri | undefined;
}

export class MapRequestListViewMri implements IMapRequestListViewMri {
    mapRequestColumns?: Column[] | undefined;
    getMapRequestsInput?: GetMapRequestsInput | undefined;
    searchFields?: CodeListValueOrder[] | undefined;
    searchOptions?: CodeListValueOrder[] | undefined;
    groupedSearchOptions?: GroupedCodeListValueOrder[] | undefined;
    tags?: string[] | undefined;

    constructor(data?: IMapRequestListViewMri) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mapRequestColumns"])) {
                this.mapRequestColumns = [] as any;
                for (let item of _data["mapRequestColumns"])
                    this.mapRequestColumns!.push(Column.fromJS(item));
            }
            this.getMapRequestsInput = _data["getMapRequestsInput"] ? GetMapRequestsInput.fromJS(_data["getMapRequestsInput"]) : undefined as any;
            if (Array.isArray(_data["searchFields"])) {
                this.searchFields = [] as any;
                for (let item of _data["searchFields"])
                    this.searchFields!.push(CodeListValueOrder.fromJS(item));
            }
            if (Array.isArray(_data["searchOptions"])) {
                this.searchOptions = [] as any;
                for (let item of _data["searchOptions"])
                    this.searchOptions!.push(CodeListValueOrder.fromJS(item));
            }
            if (Array.isArray(_data["groupedSearchOptions"])) {
                this.groupedSearchOptions = [] as any;
                for (let item of _data["groupedSearchOptions"])
                    this.groupedSearchOptions!.push(GroupedCodeListValueOrder.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): MapRequestListViewMri {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestListViewMri();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mapRequestColumns)) {
            data["mapRequestColumns"] = [];
            for (let item of this.mapRequestColumns)
                data["mapRequestColumns"].push(item ? item.toJSON() : undefined as any);
        }
        data["getMapRequestsInput"] = this.getMapRequestsInput ? this.getMapRequestsInput.toJSON() : undefined as any;
        if (Array.isArray(this.searchFields)) {
            data["searchFields"] = [];
            for (let item of this.searchFields)
                data["searchFields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchOptions)) {
            data["searchOptions"] = [];
            for (let item of this.searchOptions)
                data["searchOptions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.groupedSearchOptions)) {
            data["groupedSearchOptions"] = [];
            for (let item of this.groupedSearchOptions)
                data["groupedSearchOptions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface IMapRequestListViewMri {
    mapRequestColumns?: Column[] | undefined;
    getMapRequestsInput?: GetMapRequestsInput | undefined;
    searchFields?: CodeListValueOrder[] | undefined;
    searchOptions?: CodeListValueOrder[] | undefined;
    groupedSearchOptions?: GroupedCodeListValueOrder[] | undefined;
    tags?: string[] | undefined;
}

export class GroupedCodeListValueOrder implements IGroupedCodeListValueOrder {
    groupName?: string | undefined;
    codeListValues?: CodeListValueOrder[] | undefined;

    constructor(data?: IGroupedCodeListValueOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["codeListValues"])) {
                this.codeListValues = [] as any;
                for (let item of _data["codeListValues"])
                    this.codeListValues!.push(CodeListValueOrder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupedCodeListValueOrder {
        data = typeof data === 'object' ? data : {};
        let result = new GroupedCodeListValueOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        if (Array.isArray(this.codeListValues)) {
            data["codeListValues"] = [];
            for (let item of this.codeListValues)
                data["codeListValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGroupedCodeListValueOrder {
    groupName?: string | undefined;
    codeListValues?: CodeListValueOrder[] | undefined;
}

export class EnvelopeOfCreateMapRequestView implements IEnvelopeOfCreateMapRequestView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: CreateMapRequestView | undefined;

    constructor(data?: IEnvelopeOfCreateMapRequestView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? CreateMapRequestView.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfCreateMapRequestView {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfCreateMapRequestView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfCreateMapRequestView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: CreateMapRequestView | undefined;
}

export class CreateMapRequestView implements ICreateMapRequestView {
    isResubmitAllowed?: boolean;
    createMapRequestInput?: CreateOrUpdateMapRequestInput | undefined;
    mapRequestRoles?: { [key: string]: string; } | undefined;
    excavationMethods?: { [key: string]: string; } | undefined;
    excavationTypes?: { [key: string]: string; } | undefined;
    mapRequestTypes?: { [key: string]: string; } | undefined;
    countryCodes?: { [key: string]: string; } | undefined;
    imklPrice?: number;
    hasSubmittedShoppingCart?: boolean;
    subOrganisations?: CodeListValueOrder[] | undefined;

    constructor(data?: ICreateMapRequestView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isResubmitAllowed = _data["isResubmitAllowed"];
            this.createMapRequestInput = _data["createMapRequestInput"] ? CreateOrUpdateMapRequestInput.fromJS(_data["createMapRequestInput"]) : undefined as any;
            if (_data["mapRequestRoles"]) {
                this.mapRequestRoles = {} as any;
                for (let key in _data["mapRequestRoles"]) {
                    if (_data["mapRequestRoles"].hasOwnProperty(key))
                        (this.mapRequestRoles as any)![key] = _data["mapRequestRoles"][key];
                }
            }
            if (_data["excavationMethods"]) {
                this.excavationMethods = {} as any;
                for (let key in _data["excavationMethods"]) {
                    if (_data["excavationMethods"].hasOwnProperty(key))
                        (this.excavationMethods as any)![key] = _data["excavationMethods"][key];
                }
            }
            if (_data["excavationTypes"]) {
                this.excavationTypes = {} as any;
                for (let key in _data["excavationTypes"]) {
                    if (_data["excavationTypes"].hasOwnProperty(key))
                        (this.excavationTypes as any)![key] = _data["excavationTypes"][key];
                }
            }
            if (_data["mapRequestTypes"]) {
                this.mapRequestTypes = {} as any;
                for (let key in _data["mapRequestTypes"]) {
                    if (_data["mapRequestTypes"].hasOwnProperty(key))
                        (this.mapRequestTypes as any)![key] = _data["mapRequestTypes"][key];
                }
            }
            if (_data["countryCodes"]) {
                this.countryCodes = {} as any;
                for (let key in _data["countryCodes"]) {
                    if (_data["countryCodes"].hasOwnProperty(key))
                        (this.countryCodes as any)![key] = _data["countryCodes"][key];
                }
            }
            this.imklPrice = _data["imklPrice"];
            this.hasSubmittedShoppingCart = _data["hasSubmittedShoppingCart"];
            if (Array.isArray(_data["subOrganisations"])) {
                this.subOrganisations = [] as any;
                for (let item of _data["subOrganisations"])
                    this.subOrganisations!.push(CodeListValueOrder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateMapRequestView {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMapRequestView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isResubmitAllowed"] = this.isResubmitAllowed;
        data["createMapRequestInput"] = this.createMapRequestInput ? this.createMapRequestInput.toJSON() : undefined as any;
        if (this.mapRequestRoles) {
            data["mapRequestRoles"] = {};
            for (let key in this.mapRequestRoles) {
                if (this.mapRequestRoles.hasOwnProperty(key))
                    (data["mapRequestRoles"] as any)[key] = (this.mapRequestRoles as any)[key];
            }
        }
        if (this.excavationMethods) {
            data["excavationMethods"] = {};
            for (let key in this.excavationMethods) {
                if (this.excavationMethods.hasOwnProperty(key))
                    (data["excavationMethods"] as any)[key] = (this.excavationMethods as any)[key];
            }
        }
        if (this.excavationTypes) {
            data["excavationTypes"] = {};
            for (let key in this.excavationTypes) {
                if (this.excavationTypes.hasOwnProperty(key))
                    (data["excavationTypes"] as any)[key] = (this.excavationTypes as any)[key];
            }
        }
        if (this.mapRequestTypes) {
            data["mapRequestTypes"] = {};
            for (let key in this.mapRequestTypes) {
                if (this.mapRequestTypes.hasOwnProperty(key))
                    (data["mapRequestTypes"] as any)[key] = (this.mapRequestTypes as any)[key];
            }
        }
        if (this.countryCodes) {
            data["countryCodes"] = {};
            for (let key in this.countryCodes) {
                if (this.countryCodes.hasOwnProperty(key))
                    (data["countryCodes"] as any)[key] = (this.countryCodes as any)[key];
            }
        }
        data["imklPrice"] = this.imklPrice;
        data["hasSubmittedShoppingCart"] = this.hasSubmittedShoppingCart;
        if (Array.isArray(this.subOrganisations)) {
            data["subOrganisations"] = [];
            for (let item of this.subOrganisations)
                data["subOrganisations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateMapRequestView {
    isResubmitAllowed?: boolean;
    createMapRequestInput?: CreateOrUpdateMapRequestInput | undefined;
    mapRequestRoles?: { [key: string]: string; } | undefined;
    excavationMethods?: { [key: string]: string; } | undefined;
    excavationTypes?: { [key: string]: string; } | undefined;
    mapRequestTypes?: { [key: string]: string; } | undefined;
    countryCodes?: { [key: string]: string; } | undefined;
    imklPrice?: number;
    hasSubmittedShoppingCart?: boolean;
    subOrganisations?: CodeListValueOrder[] | undefined;
}

export class EnvelopeOfCreateMapRequestForOverlayView implements IEnvelopeOfCreateMapRequestForOverlayView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: CreateMapRequestForOverlayView | undefined;

    constructor(data?: IEnvelopeOfCreateMapRequestForOverlayView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? CreateMapRequestForOverlayView.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfCreateMapRequestForOverlayView {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfCreateMapRequestForOverlayView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfCreateMapRequestForOverlayView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: CreateMapRequestForOverlayView | undefined;
}

export class CreateMapRequestForOverlayView implements ICreateMapRequestForOverlayView {
    email?: string | undefined;

    constructor(data?: ICreateMapRequestForOverlayView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CreateMapRequestForOverlayView {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMapRequestForOverlayView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface ICreateMapRequestForOverlayView {
    email?: string | undefined;
}

export class EnvelopeOfMapRequestForOverlayView implements IEnvelopeOfMapRequestForOverlayView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestForOverlayView | undefined;

    constructor(data?: IEnvelopeOfMapRequestForOverlayView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? MapRequestForOverlayView.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfMapRequestForOverlayView {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfMapRequestForOverlayView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfMapRequestForOverlayView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestForOverlayView | undefined;
}

export class MapRequestForOverlayView implements IMapRequestForOverlayView {
    mapRequestForOverlay?: MapRequestForOverlayData | undefined;
    mapRequestForOverlayResponders?: MapRequestForOverlayResponderData[] | undefined;
    mapRequestForOverlayKlim?: MapRequestKlimData | undefined;

    constructor(data?: IMapRequestForOverlayView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestForOverlay = _data["mapRequestForOverlay"] ? MapRequestForOverlayData.fromJS(_data["mapRequestForOverlay"]) : undefined as any;
            if (Array.isArray(_data["mapRequestForOverlayResponders"])) {
                this.mapRequestForOverlayResponders = [] as any;
                for (let item of _data["mapRequestForOverlayResponders"])
                    this.mapRequestForOverlayResponders!.push(MapRequestForOverlayResponderData.fromJS(item));
            }
            this.mapRequestForOverlayKlim = _data["mapRequestForOverlayKlim"] ? MapRequestKlimData.fromJS(_data["mapRequestForOverlayKlim"]) : undefined as any;
        }
    }

    static fromJS(data: any): MapRequestForOverlayView {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestForOverlayView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestForOverlay"] = this.mapRequestForOverlay ? this.mapRequestForOverlay.toJSON() : undefined as any;
        if (Array.isArray(this.mapRequestForOverlayResponders)) {
            data["mapRequestForOverlayResponders"] = [];
            for (let item of this.mapRequestForOverlayResponders)
                data["mapRequestForOverlayResponders"].push(item ? item.toJSON() : undefined as any);
        }
        data["mapRequestForOverlayKlim"] = this.mapRequestForOverlayKlim ? this.mapRequestForOverlayKlim.toJSON() : undefined as any;
        return data;
    }
}

export interface IMapRequestForOverlayView {
    mapRequestForOverlay?: MapRequestForOverlayData | undefined;
    mapRequestForOverlayResponders?: MapRequestForOverlayResponderData[] | undefined;
    mapRequestForOverlayKlim?: MapRequestKlimData | undefined;
}

export class MapRequestForOverlayData implements IMapRequestForOverlayData {
    email?: string | undefined;
    reference?: string | undefined;
    excavationDescription?: string | undefined;
    excavationLocation?: string | undefined;
    zoneGeometry?: any | undefined;
    dateReceived?: string;
    downloadUrls?: DownloadUrl[] | undefined;

    constructor(data?: IMapRequestForOverlayData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.reference = _data["reference"];
            this.excavationDescription = _data["excavationDescription"];
            this.excavationLocation = _data["excavationLocation"];
            this.zoneGeometry = _data["zoneGeometry"];
            this.dateReceived = _data["dateReceived"];
            if (Array.isArray(_data["downloadUrls"])) {
                this.downloadUrls = [] as any;
                for (let item of _data["downloadUrls"])
                    this.downloadUrls!.push(DownloadUrl.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MapRequestForOverlayData {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestForOverlayData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["reference"] = this.reference;
        data["excavationDescription"] = this.excavationDescription;
        data["excavationLocation"] = this.excavationLocation;
        data["zoneGeometry"] = this.zoneGeometry;
        data["dateReceived"] = this.dateReceived;
        if (Array.isArray(this.downloadUrls)) {
            data["downloadUrls"] = [];
            for (let item of this.downloadUrls)
                data["downloadUrls"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMapRequestForOverlayData {
    email?: string | undefined;
    reference?: string | undefined;
    excavationDescription?: string | undefined;
    excavationLocation?: string | undefined;
    zoneGeometry?: any | undefined;
    dateReceived?: string;
    downloadUrls?: DownloadUrl[] | undefined;
}

export class MapRequestForOverlayResponderData implements IMapRequestForOverlayResponderData {
    name?: string | undefined;
    zoneName?: string | undefined;
    extraInformation?: string | undefined;
    contactName?: string | undefined;
    contactTelephone?: string | undefined;
    contactEmail?: string | undefined;
    alarmCentralTelephone?: string | undefined;
    isKlimZone?: boolean;

    constructor(data?: IMapRequestForOverlayResponderData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.zoneName = _data["zoneName"];
            this.extraInformation = _data["extraInformation"];
            this.contactName = _data["contactName"];
            this.contactTelephone = _data["contactTelephone"];
            this.contactEmail = _data["contactEmail"];
            this.alarmCentralTelephone = _data["alarmCentralTelephone"];
            this.isKlimZone = _data["isKlimZone"];
        }
    }

    static fromJS(data: any): MapRequestForOverlayResponderData {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestForOverlayResponderData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["zoneName"] = this.zoneName;
        data["extraInformation"] = this.extraInformation;
        data["contactName"] = this.contactName;
        data["contactTelephone"] = this.contactTelephone;
        data["contactEmail"] = this.contactEmail;
        data["alarmCentralTelephone"] = this.alarmCentralTelephone;
        data["isKlimZone"] = this.isKlimZone;
        return data;
    }
}

export interface IMapRequestForOverlayResponderData {
    name?: string | undefined;
    zoneName?: string | undefined;
    extraInformation?: string | undefined;
    contactName?: string | undefined;
    contactTelephone?: string | undefined;
    contactEmail?: string | undefined;
    alarmCentralTelephone?: string | undefined;
    isKlimZone?: boolean;
}

export class EnvelopeOfMapRequestViewMri implements IEnvelopeOfMapRequestViewMri {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestViewMri | undefined;

    constructor(data?: IEnvelopeOfMapRequestViewMri) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? MapRequestViewMri.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfMapRequestViewMri {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfMapRequestViewMri();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfMapRequestViewMri {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestViewMri | undefined;
}

export class MapRequestViewMri implements IMapRequestViewMri {
    mapRequest?: MapRequest | undefined;
    invoices?: InvoiceListItem[] | undefined;
    isBusinessCentralAvailable?: boolean;
    availableTags?: string[] | undefined;
    responders?: MapRequestResponderData[] | undefined;
    klimData?: MapRequestKlimData | undefined;
    assetsStatusData?: AssetsStatusMri | undefined;
    archiveUrls?: ArchiveUrls | undefined;

    constructor(data?: IMapRequestViewMri) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequest = _data["mapRequest"] ? MapRequest.fromJS(_data["mapRequest"]) : undefined as any;
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(InvoiceListItem.fromJS(item));
            }
            this.isBusinessCentralAvailable = _data["isBusinessCentralAvailable"];
            if (Array.isArray(_data["availableTags"])) {
                this.availableTags = [] as any;
                for (let item of _data["availableTags"])
                    this.availableTags!.push(item);
            }
            if (Array.isArray(_data["responders"])) {
                this.responders = [] as any;
                for (let item of _data["responders"])
                    this.responders!.push(MapRequestResponderData.fromJS(item));
            }
            this.klimData = _data["klimData"] ? MapRequestKlimData.fromJS(_data["klimData"]) : undefined as any;
            this.assetsStatusData = _data["assetsStatusData"] ? AssetsStatusMri.fromJS(_data["assetsStatusData"]) : undefined as any;
            this.archiveUrls = _data["archiveUrls"] ? ArchiveUrls.fromJS(_data["archiveUrls"]) : undefined as any;
        }
    }

    static fromJS(data: any): MapRequestViewMri {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestViewMri();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequest"] = this.mapRequest ? this.mapRequest.toJSON() : undefined as any;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item ? item.toJSON() : undefined as any);
        }
        data["isBusinessCentralAvailable"] = this.isBusinessCentralAvailable;
        if (Array.isArray(this.availableTags)) {
            data["availableTags"] = [];
            for (let item of this.availableTags)
                data["availableTags"].push(item);
        }
        if (Array.isArray(this.responders)) {
            data["responders"] = [];
            for (let item of this.responders)
                data["responders"].push(item ? item.toJSON() : undefined as any);
        }
        data["klimData"] = this.klimData ? this.klimData.toJSON() : undefined as any;
        data["assetsStatusData"] = this.assetsStatusData ? this.assetsStatusData.toJSON() : undefined as any;
        data["archiveUrls"] = this.archiveUrls ? this.archiveUrls.toJSON() : undefined as any;
        return data;
    }
}

export interface IMapRequestViewMri {
    mapRequest?: MapRequest | undefined;
    invoices?: InvoiceListItem[] | undefined;
    isBusinessCentralAvailable?: boolean;
    availableTags?: string[] | undefined;
    responders?: MapRequestResponderData[] | undefined;
    klimData?: MapRequestKlimData | undefined;
    assetsStatusData?: AssetsStatusMri | undefined;
    archiveUrls?: ArchiveUrls | undefined;
}

export class MapRequest implements IMapRequest {
    reference?: string | undefined;
    dateReceived?: string;
    startDate?: string;
    endDate?: string;
    mapRequestType?: string | undefined;
    excavationType?: string | undefined;
    excavationMethod?: string | undefined;
    excavationLocation?: string | undefined;
    excavationDescription?: string | undefined;
    excavationDepth?: number;
    zoneGeometry?: any | undefined;
    status?: MapRequestDetailStatus;
    respondersStatusMessage?: string | undefined;
    mapRequestInitiator?: MapRequestInitiatorContactData | undefined;
    isResubmitAllowed?: boolean;
    archiveDate?: string | undefined;
    deleteDate?: string | undefined;
    plans?: Plans | undefined;
    hasMapAssets?: boolean;
    tags?: string[] | undefined;
    downloadUrls?: DownloadUrl[] | undefined;
    isArchived?: boolean;
    mapRequestInitiatorDelivery?: MapRequestInitiatorDeliveryData | undefined;
    isCitizen?: boolean;

    constructor(data?: IMapRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reference = _data["reference"];
            this.dateReceived = _data["dateReceived"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.mapRequestType = _data["mapRequestType"];
            this.excavationType = _data["excavationType"];
            this.excavationMethod = _data["excavationMethod"];
            this.excavationLocation = _data["excavationLocation"];
            this.excavationDescription = _data["excavationDescription"];
            this.excavationDepth = _data["excavationDepth"];
            this.zoneGeometry = _data["zoneGeometry"];
            this.status = _data["status"];
            this.respondersStatusMessage = _data["respondersStatusMessage"];
            this.mapRequestInitiator = _data["mapRequestInitiator"] ? MapRequestInitiatorContactData.fromJS(_data["mapRequestInitiator"]) : undefined as any;
            this.isResubmitAllowed = _data["isResubmitAllowed"];
            this.archiveDate = _data["archiveDate"];
            this.deleteDate = _data["deleteDate"];
            this.plans = _data["plans"] ? Plans.fromJS(_data["plans"]) : undefined as any;
            this.hasMapAssets = _data["hasMapAssets"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["downloadUrls"])) {
                this.downloadUrls = [] as any;
                for (let item of _data["downloadUrls"])
                    this.downloadUrls!.push(DownloadUrl.fromJS(item));
            }
            this.isArchived = _data["isArchived"];
            this.mapRequestInitiatorDelivery = _data["mapRequestInitiatorDelivery"] ? MapRequestInitiatorDeliveryData.fromJS(_data["mapRequestInitiatorDelivery"]) : undefined as any;
            this.isCitizen = _data["isCitizen"];
        }
    }

    static fromJS(data: any): MapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference;
        data["dateReceived"] = this.dateReceived;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["mapRequestType"] = this.mapRequestType;
        data["excavationType"] = this.excavationType;
        data["excavationMethod"] = this.excavationMethod;
        data["excavationLocation"] = this.excavationLocation;
        data["excavationDescription"] = this.excavationDescription;
        data["excavationDepth"] = this.excavationDepth;
        data["zoneGeometry"] = this.zoneGeometry;
        data["status"] = this.status;
        data["respondersStatusMessage"] = this.respondersStatusMessage;
        data["mapRequestInitiator"] = this.mapRequestInitiator ? this.mapRequestInitiator.toJSON() : undefined as any;
        data["isResubmitAllowed"] = this.isResubmitAllowed;
        data["archiveDate"] = this.archiveDate;
        data["deleteDate"] = this.deleteDate;
        data["plans"] = this.plans ? this.plans.toJSON() : undefined as any;
        data["hasMapAssets"] = this.hasMapAssets;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.downloadUrls)) {
            data["downloadUrls"] = [];
            for (let item of this.downloadUrls)
                data["downloadUrls"].push(item ? item.toJSON() : undefined as any);
        }
        data["isArchived"] = this.isArchived;
        data["mapRequestInitiatorDelivery"] = this.mapRequestInitiatorDelivery ? this.mapRequestInitiatorDelivery.toJSON() : undefined as any;
        data["isCitizen"] = this.isCitizen;
        return data;
    }
}

export interface IMapRequest {
    reference?: string | undefined;
    dateReceived?: string;
    startDate?: string;
    endDate?: string;
    mapRequestType?: string | undefined;
    excavationType?: string | undefined;
    excavationMethod?: string | undefined;
    excavationLocation?: string | undefined;
    excavationDescription?: string | undefined;
    excavationDepth?: number;
    zoneGeometry?: any | undefined;
    status?: MapRequestDetailStatus;
    respondersStatusMessage?: string | undefined;
    mapRequestInitiator?: MapRequestInitiatorContactData | undefined;
    isResubmitAllowed?: boolean;
    archiveDate?: string | undefined;
    deleteDate?: string | undefined;
    plans?: Plans | undefined;
    hasMapAssets?: boolean;
    tags?: string[] | undefined;
    downloadUrls?: DownloadUrl[] | undefined;
    isArchived?: boolean;
    mapRequestInitiatorDelivery?: MapRequestInitiatorDeliveryData | undefined;
    isCitizen?: boolean;
}

export class MapRequestInitiatorDeliveryData implements IMapRequestInitiatorDeliveryData {
    klipOrganisationId?: string;
    company?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    klipUserId?: string;
    role?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    address?: Address | undefined;

    constructor(data?: IMapRequestInitiatorDeliveryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.klipOrganisationId = _data["klipOrganisationId"];
            this.company = _data["company"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.klipUserId = _data["klipUserId"];
            this.role = _data["role"];
            this.telephone = _data["telephone"];
            this.email = _data["email"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : undefined as any;
        }
    }

    static fromJS(data: any): MapRequestInitiatorDeliveryData {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestInitiatorDeliveryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["klipOrganisationId"] = this.klipOrganisationId;
        data["company"] = this.company;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["klipUserId"] = this.klipUserId;
        data["role"] = this.role;
        data["telephone"] = this.telephone;
        data["email"] = this.email;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        return data;
    }
}

export interface IMapRequestInitiatorDeliveryData {
    klipOrganisationId?: string;
    company?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    klipUserId?: string;
    role?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    address?: Address | undefined;
}

export class ArchiveUrls implements IArchiveUrls {
    downloadArchiveUrl?: string | undefined;

    constructor(data?: IArchiveUrls) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.downloadArchiveUrl = _data["downloadArchiveUrl"];
        }
    }

    static fromJS(data: any): ArchiveUrls {
        data = typeof data === 'object' ? data : {};
        let result = new ArchiveUrls();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["downloadArchiveUrl"] = this.downloadArchiveUrl;
        return data;
    }
}

export interface IArchiveUrls {
    downloadArchiveUrl?: string | undefined;
}

export class EnvelopeOfMriViewerViewModel implements IEnvelopeOfMriViewerViewModel {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MriViewerViewModel | undefined;

    constructor(data?: IEnvelopeOfMriViewerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? MriViewerViewModel.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfMriViewerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfMriViewerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfMriViewerViewModel {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MriViewerViewModel | undefined;
}

export class MriViewerViewModel implements IMriViewerViewModel {
    mapRequestReference?: string | undefined;
    assetsStatusData?: AssetsStatusMri | undefined;
    getPmklUrl?: string | undefined;
    getPmklStreamUrl?: string | undefined;
    getWfsUrl?: string | undefined;
    getWfsStreamUrl?: string | undefined;
    getKmHmStreamUrl?: string | undefined;
    getPrintsUrl?: string | undefined;
    downloadPmklFileUrl?: string | undefined;
    downloadImklAttachmentUrl?: string | undefined;
    mapRequestZoneDownloadUrls?: DownloadUrl[] | undefined;

    constructor(data?: IMriViewerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestReference = _data["mapRequestReference"];
            this.assetsStatusData = _data["assetsStatusData"] ? AssetsStatusMri.fromJS(_data["assetsStatusData"]) : undefined as any;
            this.getPmklUrl = _data["getPmklUrl"];
            this.getPmklStreamUrl = _data["getPmklStreamUrl"];
            this.getWfsUrl = _data["getWfsUrl"];
            this.getWfsStreamUrl = _data["getWfsStreamUrl"];
            this.getKmHmStreamUrl = _data["getKmHmStreamUrl"];
            this.getPrintsUrl = _data["getPrintsUrl"];
            this.downloadPmklFileUrl = _data["downloadPmklFileUrl"];
            this.downloadImklAttachmentUrl = _data["downloadImklAttachmentUrl"];
            if (Array.isArray(_data["mapRequestZoneDownloadUrls"])) {
                this.mapRequestZoneDownloadUrls = [] as any;
                for (let item of _data["mapRequestZoneDownloadUrls"])
                    this.mapRequestZoneDownloadUrls!.push(DownloadUrl.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MriViewerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MriViewerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestReference"] = this.mapRequestReference;
        data["assetsStatusData"] = this.assetsStatusData ? this.assetsStatusData.toJSON() : undefined as any;
        data["getPmklUrl"] = this.getPmklUrl;
        data["getPmklStreamUrl"] = this.getPmklStreamUrl;
        data["getWfsUrl"] = this.getWfsUrl;
        data["getWfsStreamUrl"] = this.getWfsStreamUrl;
        data["getKmHmStreamUrl"] = this.getKmHmStreamUrl;
        data["getPrintsUrl"] = this.getPrintsUrl;
        data["downloadPmklFileUrl"] = this.downloadPmklFileUrl;
        data["downloadImklAttachmentUrl"] = this.downloadImklAttachmentUrl;
        if (Array.isArray(this.mapRequestZoneDownloadUrls)) {
            data["mapRequestZoneDownloadUrls"] = [];
            for (let item of this.mapRequestZoneDownloadUrls)
                data["mapRequestZoneDownloadUrls"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMriViewerViewModel {
    mapRequestReference?: string | undefined;
    assetsStatusData?: AssetsStatusMri | undefined;
    getPmklUrl?: string | undefined;
    getPmklStreamUrl?: string | undefined;
    getWfsUrl?: string | undefined;
    getWfsStreamUrl?: string | undefined;
    getKmHmStreamUrl?: string | undefined;
    getPrintsUrl?: string | undefined;
    downloadPmklFileUrl?: string | undefined;
    downloadImklAttachmentUrl?: string | undefined;
    mapRequestZoneDownloadUrls?: DownloadUrl[] | undefined;
}

export class EnvelopeOfSearchOperationsMapRequestView implements IEnvelopeOfSearchOperationsMapRequestView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: SearchOperationsMapRequestView | undefined;

    constructor(data?: IEnvelopeOfSearchOperationsMapRequestView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? SearchOperationsMapRequestView.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfSearchOperationsMapRequestView {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfSearchOperationsMapRequestView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfSearchOperationsMapRequestView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: SearchOperationsMapRequestView | undefined;
}

export class SearchOperationsMapRequestView implements ISearchOperationsMapRequestView {
    mapRequestColumns?: Column[] | undefined;
    defaultSearchFilter?: GetOperationsMapRequestsInput | undefined;
    searchFields?: CodeListValueOrder[] | undefined;
    searchOptions?: CodeListValueOrder[] | undefined;
    organisations?: CodeListValueOrder[] | undefined;

    constructor(data?: ISearchOperationsMapRequestView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mapRequestColumns"])) {
                this.mapRequestColumns = [] as any;
                for (let item of _data["mapRequestColumns"])
                    this.mapRequestColumns!.push(Column.fromJS(item));
            }
            this.defaultSearchFilter = _data["defaultSearchFilter"] ? GetOperationsMapRequestsInput.fromJS(_data["defaultSearchFilter"]) : undefined as any;
            if (Array.isArray(_data["searchFields"])) {
                this.searchFields = [] as any;
                for (let item of _data["searchFields"])
                    this.searchFields!.push(CodeListValueOrder.fromJS(item));
            }
            if (Array.isArray(_data["searchOptions"])) {
                this.searchOptions = [] as any;
                for (let item of _data["searchOptions"])
                    this.searchOptions!.push(CodeListValueOrder.fromJS(item));
            }
            if (Array.isArray(_data["organisations"])) {
                this.organisations = [] as any;
                for (let item of _data["organisations"])
                    this.organisations!.push(CodeListValueOrder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchOperationsMapRequestView {
        data = typeof data === 'object' ? data : {};
        let result = new SearchOperationsMapRequestView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mapRequestColumns)) {
            data["mapRequestColumns"] = [];
            for (let item of this.mapRequestColumns)
                data["mapRequestColumns"].push(item ? item.toJSON() : undefined as any);
        }
        data["defaultSearchFilter"] = this.defaultSearchFilter ? this.defaultSearchFilter.toJSON() : undefined as any;
        if (Array.isArray(this.searchFields)) {
            data["searchFields"] = [];
            for (let item of this.searchFields)
                data["searchFields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchOptions)) {
            data["searchOptions"] = [];
            for (let item of this.searchOptions)
                data["searchOptions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.organisations)) {
            data["organisations"] = [];
            for (let item of this.organisations)
                data["organisations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISearchOperationsMapRequestView {
    mapRequestColumns?: Column[] | undefined;
    defaultSearchFilter?: GetOperationsMapRequestsInput | undefined;
    searchFields?: CodeListValueOrder[] | undefined;
    searchOptions?: CodeListValueOrder[] | undefined;
    organisations?: CodeListValueOrder[] | undefined;
}

export class GetOperationsMapRequestsInput implements IGetOperationsMapRequestsInput {
    klipContactId?: string | undefined;
    klipOrganisationId?: string | undefined;
    parentKlipOrganisationId?: string | undefined;
    utilityNetworkAuthorityZoneId?: string | undefined;
    isCitizen?: boolean;
    query?: string | undefined;
    mapRequestForOrganisationType?: SearchOperationsMapRequestForOrganisationType;
    searchField?: SearchField;
    mapRequestStatus?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    orderBy?: string | undefined;
    orderDirection?: OrderDirection;
    isArchived?: boolean;
    zoneGeometry?: string | undefined;
    offset?: number | undefined;
    limit?: number | undefined;

    constructor(data?: IGetOperationsMapRequestsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.klipContactId = _data["klipContactId"];
            this.klipOrganisationId = _data["klipOrganisationId"];
            this.parentKlipOrganisationId = _data["parentKlipOrganisationId"];
            this.utilityNetworkAuthorityZoneId = _data["utilityNetworkAuthorityZoneId"];
            this.isCitizen = _data["isCitizen"];
            this.query = _data["query"];
            this.mapRequestForOrganisationType = _data["mapRequestForOrganisationType"];
            this.searchField = _data["searchField"];
            this.mapRequestStatus = _data["mapRequestStatus"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.orderBy = _data["orderBy"];
            this.orderDirection = _data["orderDirection"];
            this.isArchived = _data["isArchived"];
            this.zoneGeometry = _data["zoneGeometry"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): GetOperationsMapRequestsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOperationsMapRequestsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["klipContactId"] = this.klipContactId;
        data["klipOrganisationId"] = this.klipOrganisationId;
        data["parentKlipOrganisationId"] = this.parentKlipOrganisationId;
        data["utilityNetworkAuthorityZoneId"] = this.utilityNetworkAuthorityZoneId;
        data["isCitizen"] = this.isCitizen;
        data["query"] = this.query;
        data["mapRequestForOrganisationType"] = this.mapRequestForOrganisationType;
        data["searchField"] = this.searchField;
        data["mapRequestStatus"] = this.mapRequestStatus;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["orderBy"] = this.orderBy;
        data["orderDirection"] = this.orderDirection;
        data["isArchived"] = this.isArchived;
        data["zoneGeometry"] = this.zoneGeometry;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IGetOperationsMapRequestsInput {
    klipContactId?: string | undefined;
    klipOrganisationId?: string | undefined;
    parentKlipOrganisationId?: string | undefined;
    utilityNetworkAuthorityZoneId?: string | undefined;
    isCitizen?: boolean;
    query?: string | undefined;
    mapRequestForOrganisationType?: SearchOperationsMapRequestForOrganisationType;
    searchField?: SearchField;
    mapRequestStatus?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    orderBy?: string | undefined;
    orderDirection?: OrderDirection;
    isArchived?: boolean;
    zoneGeometry?: string | undefined;
    offset?: number | undefined;
    limit?: number | undefined;
}

export enum SearchOperationsMapRequestForOrganisationType {
    Requested = 0,
    Received = 1,
}

export class EnvelopeOfSearchOperationsMapRequestForUserView implements IEnvelopeOfSearchOperationsMapRequestForUserView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: SearchOperationsMapRequestForUserView | undefined;

    constructor(data?: IEnvelopeOfSearchOperationsMapRequestForUserView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? SearchOperationsMapRequestForUserView.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfSearchOperationsMapRequestForUserView {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfSearchOperationsMapRequestForUserView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfSearchOperationsMapRequestForUserView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: SearchOperationsMapRequestForUserView | undefined;
}

export class SearchOperationsMapRequestForUserView implements ISearchOperationsMapRequestForUserView {
    mapRequestColumns?: Column[] | undefined;
    defaultSearchFilter?: GetOperationsMapRequestsInput | undefined;
    searchFields?: CodeListValueOrder[] | undefined;
    searchOptions?: CodeListValueOrder[] | undefined;

    constructor(data?: ISearchOperationsMapRequestForUserView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mapRequestColumns"])) {
                this.mapRequestColumns = [] as any;
                for (let item of _data["mapRequestColumns"])
                    this.mapRequestColumns!.push(Column.fromJS(item));
            }
            this.defaultSearchFilter = _data["defaultSearchFilter"] ? GetOperationsMapRequestsInput.fromJS(_data["defaultSearchFilter"]) : undefined as any;
            if (Array.isArray(_data["searchFields"])) {
                this.searchFields = [] as any;
                for (let item of _data["searchFields"])
                    this.searchFields!.push(CodeListValueOrder.fromJS(item));
            }
            if (Array.isArray(_data["searchOptions"])) {
                this.searchOptions = [] as any;
                for (let item of _data["searchOptions"])
                    this.searchOptions!.push(CodeListValueOrder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchOperationsMapRequestForUserView {
        data = typeof data === 'object' ? data : {};
        let result = new SearchOperationsMapRequestForUserView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mapRequestColumns)) {
            data["mapRequestColumns"] = [];
            for (let item of this.mapRequestColumns)
                data["mapRequestColumns"].push(item ? item.toJSON() : undefined as any);
        }
        data["defaultSearchFilter"] = this.defaultSearchFilter ? this.defaultSearchFilter.toJSON() : undefined as any;
        if (Array.isArray(this.searchFields)) {
            data["searchFields"] = [];
            for (let item of this.searchFields)
                data["searchFields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchOptions)) {
            data["searchOptions"] = [];
            for (let item of this.searchOptions)
                data["searchOptions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISearchOperationsMapRequestForUserView {
    mapRequestColumns?: Column[] | undefined;
    defaultSearchFilter?: GetOperationsMapRequestsInput | undefined;
    searchFields?: CodeListValueOrder[] | undefined;
    searchOptions?: CodeListValueOrder[] | undefined;
}

export class EnvelopeOfSearchOperationsMapRequestForOrganisationView implements IEnvelopeOfSearchOperationsMapRequestForOrganisationView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: SearchOperationsMapRequestForOrganisationView | undefined;

    constructor(data?: IEnvelopeOfSearchOperationsMapRequestForOrganisationView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? SearchOperationsMapRequestForOrganisationView.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfSearchOperationsMapRequestForOrganisationView {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfSearchOperationsMapRequestForOrganisationView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfSearchOperationsMapRequestForOrganisationView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: SearchOperationsMapRequestForOrganisationView | undefined;
}

export class SearchOperationsMapRequestForOrganisationView implements ISearchOperationsMapRequestForOrganisationView {
    mapRequestColumns?: Column[] | undefined;
    defaultSearchFilter?: GetOperationsMapRequestsInput | undefined;
    searchFields?: CodeListValueOrder[] | undefined;
    searchOptions?: CodeListValueOrder[] | undefined;
    organisations?: CodeListValueOrder[] | undefined;
    organisationZones?: CodeListValueOrder[] | undefined;

    constructor(data?: ISearchOperationsMapRequestForOrganisationView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mapRequestColumns"])) {
                this.mapRequestColumns = [] as any;
                for (let item of _data["mapRequestColumns"])
                    this.mapRequestColumns!.push(Column.fromJS(item));
            }
            this.defaultSearchFilter = _data["defaultSearchFilter"] ? GetOperationsMapRequestsInput.fromJS(_data["defaultSearchFilter"]) : undefined as any;
            if (Array.isArray(_data["searchFields"])) {
                this.searchFields = [] as any;
                for (let item of _data["searchFields"])
                    this.searchFields!.push(CodeListValueOrder.fromJS(item));
            }
            if (Array.isArray(_data["searchOptions"])) {
                this.searchOptions = [] as any;
                for (let item of _data["searchOptions"])
                    this.searchOptions!.push(CodeListValueOrder.fromJS(item));
            }
            if (Array.isArray(_data["organisations"])) {
                this.organisations = [] as any;
                for (let item of _data["organisations"])
                    this.organisations!.push(CodeListValueOrder.fromJS(item));
            }
            if (Array.isArray(_data["organisationZones"])) {
                this.organisationZones = [] as any;
                for (let item of _data["organisationZones"])
                    this.organisationZones!.push(CodeListValueOrder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchOperationsMapRequestForOrganisationView {
        data = typeof data === 'object' ? data : {};
        let result = new SearchOperationsMapRequestForOrganisationView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mapRequestColumns)) {
            data["mapRequestColumns"] = [];
            for (let item of this.mapRequestColumns)
                data["mapRequestColumns"].push(item ? item.toJSON() : undefined as any);
        }
        data["defaultSearchFilter"] = this.defaultSearchFilter ? this.defaultSearchFilter.toJSON() : undefined as any;
        if (Array.isArray(this.searchFields)) {
            data["searchFields"] = [];
            for (let item of this.searchFields)
                data["searchFields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchOptions)) {
            data["searchOptions"] = [];
            for (let item of this.searchOptions)
                data["searchOptions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.organisations)) {
            data["organisations"] = [];
            for (let item of this.organisations)
                data["organisations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.organisationZones)) {
            data["organisationZones"] = [];
            for (let item of this.organisationZones)
                data["organisationZones"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISearchOperationsMapRequestForOrganisationView {
    mapRequestColumns?: Column[] | undefined;
    defaultSearchFilter?: GetOperationsMapRequestsInput | undefined;
    searchFields?: CodeListValueOrder[] | undefined;
    searchOptions?: CodeListValueOrder[] | undefined;
    organisations?: CodeListValueOrder[] | undefined;
    organisationZones?: CodeListValueOrder[] | undefined;
}

export class EnvelopeOfICollectionOfMapRequestListItem2 implements IEnvelopeOfICollectionOfMapRequestListItem2 {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestListItem3[] | undefined;

    constructor(data?: IEnvelopeOfICollectionOfMapRequestListItem2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(MapRequestListItem3.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvelopeOfICollectionOfMapRequestListItem2 {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfICollectionOfMapRequestListItem2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnvelopeOfICollectionOfMapRequestListItem2 {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestListItem3[] | undefined;
}

export class MapRequestListItem3 implements IMapRequestListItem3 {
    id?: string;
    reference?: string | undefined;
    requester?: string | undefined;
    organisation?: string | undefined;
    zoneName?: string | undefined;
    dateReceived?: string;
    status?: string | undefined;
    isMoving?: boolean;

    constructor(data?: IMapRequestListItem3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reference = _data["reference"];
            this.requester = _data["requester"];
            this.organisation = _data["organisation"];
            this.zoneName = _data["zoneName"];
            this.dateReceived = _data["dateReceived"];
            this.status = _data["status"];
            this.isMoving = _data["isMoving"];
        }
    }

    static fromJS(data: any): MapRequestListItem3 {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestListItem3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reference"] = this.reference;
        data["requester"] = this.requester;
        data["organisation"] = this.organisation;
        data["zoneName"] = this.zoneName;
        data["dateReceived"] = this.dateReceived;
        data["status"] = this.status;
        data["isMoving"] = this.isMoving;
        return data;
    }
}

export interface IMapRequestListItem3 {
    id?: string;
    reference?: string | undefined;
    requester?: string | undefined;
    organisation?: string | undefined;
    zoneName?: string | undefined;
    dateReceived?: string;
    status?: string | undefined;
    isMoving?: boolean;
}

export class EnvelopeOfOperationsMapRequest implements IEnvelopeOfOperationsMapRequest {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: OperationsMapRequest | undefined;

    constructor(data?: IEnvelopeOfOperationsMapRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? OperationsMapRequest.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfOperationsMapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfOperationsMapRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfOperationsMapRequest {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: OperationsMapRequest | undefined;
}

export class OperationsMapRequest implements IOperationsMapRequest {
    mapRequestId?: string;
    reference?: string | undefined;
    dateReceived?: string;
    status?: string | undefined;
    mapRequestInitiator?: MapRequestInitiatorContactData | undefined;
    auditLogs?: AuditLog[] | undefined;
    responderAuditLogs?: ResponderAuditLog[] | undefined;
    invoices?: InvoiceListItem[] | undefined;
    isBusinessCentralAvailable?: boolean;
    paymentMethod?: PaymentMethod;
    organisationId?: string | undefined;

    constructor(data?: IOperationsMapRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestId = _data["mapRequestId"];
            this.reference = _data["reference"];
            this.dateReceived = _data["dateReceived"];
            this.status = _data["status"];
            this.mapRequestInitiator = _data["mapRequestInitiator"] ? MapRequestInitiatorContactData.fromJS(_data["mapRequestInitiator"]) : undefined as any;
            if (Array.isArray(_data["auditLogs"])) {
                this.auditLogs = [] as any;
                for (let item of _data["auditLogs"])
                    this.auditLogs!.push(AuditLog.fromJS(item));
            }
            if (Array.isArray(_data["responderAuditLogs"])) {
                this.responderAuditLogs = [] as any;
                for (let item of _data["responderAuditLogs"])
                    this.responderAuditLogs!.push(ResponderAuditLog.fromJS(item));
            }
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(InvoiceListItem.fromJS(item));
            }
            this.isBusinessCentralAvailable = _data["isBusinessCentralAvailable"];
            this.paymentMethod = _data["paymentMethod"];
            this.organisationId = _data["organisationId"];
        }
    }

    static fromJS(data: any): OperationsMapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OperationsMapRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestId"] = this.mapRequestId;
        data["reference"] = this.reference;
        data["dateReceived"] = this.dateReceived;
        data["status"] = this.status;
        data["mapRequestInitiator"] = this.mapRequestInitiator ? this.mapRequestInitiator.toJSON() : undefined as any;
        if (Array.isArray(this.auditLogs)) {
            data["auditLogs"] = [];
            for (let item of this.auditLogs)
                data["auditLogs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.responderAuditLogs)) {
            data["responderAuditLogs"] = [];
            for (let item of this.responderAuditLogs)
                data["responderAuditLogs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item ? item.toJSON() : undefined as any);
        }
        data["isBusinessCentralAvailable"] = this.isBusinessCentralAvailable;
        data["paymentMethod"] = this.paymentMethod;
        data["organisationId"] = this.organisationId;
        return data;
    }
}

export interface IOperationsMapRequest {
    mapRequestId?: string;
    reference?: string | undefined;
    dateReceived?: string;
    status?: string | undefined;
    mapRequestInitiator?: MapRequestInitiatorContactData | undefined;
    auditLogs?: AuditLog[] | undefined;
    responderAuditLogs?: ResponderAuditLog[] | undefined;
    invoices?: InvoiceListItem[] | undefined;
    isBusinessCentralAvailable?: boolean;
    paymentMethod?: PaymentMethod;
    organisationId?: string | undefined;
}

export enum PaymentMethod {
    None = 0,
    Invoice = 1,
    Ogone = 2,
    Credits = 3,
}

export class EnvelopeOfOperationsArchivedMapRequest implements IEnvelopeOfOperationsArchivedMapRequest {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: OperationsArchivedMapRequest | undefined;

    constructor(data?: IEnvelopeOfOperationsArchivedMapRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? OperationsArchivedMapRequest.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfOperationsArchivedMapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfOperationsArchivedMapRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfOperationsArchivedMapRequest {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: OperationsArchivedMapRequest | undefined;
}

export class OperationsArchivedMapRequest implements IOperationsArchivedMapRequest {
    mapRequestId?: string;
    reference?: string | undefined;
    dateReceived?: string;
    deleteDate?: string;
    status?: string | undefined;
    startDate?: string;
    endDate?: string;
    mapRequestType?: string | undefined;
    excavationType?: string | undefined;
    excavationMethod?: string | undefined;
    excavationDepth?: number | undefined;
    excavationLocation?: string | undefined;
    excavationDescription?: string | undefined;
    mapRequestInitiator?: MapRequestInitiatorContactData | undefined;
    downloadUrls?: DownloadUrl[] | undefined;
    mapRequestGeometry?: any | undefined;
    downloadArchiveUrl?: string | undefined;
    responders?: OperationsArchivedMapRequestResponder[] | undefined;
    isBusinessCentralAvailable?: boolean;
    invoices?: InvoiceListItem[] | undefined;

    constructor(data?: IOperationsArchivedMapRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestId = _data["mapRequestId"];
            this.reference = _data["reference"];
            this.dateReceived = _data["dateReceived"];
            this.deleteDate = _data["deleteDate"];
            this.status = _data["status"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.mapRequestType = _data["mapRequestType"];
            this.excavationType = _data["excavationType"];
            this.excavationMethod = _data["excavationMethod"];
            this.excavationDepth = _data["excavationDepth"];
            this.excavationLocation = _data["excavationLocation"];
            this.excavationDescription = _data["excavationDescription"];
            this.mapRequestInitiator = _data["mapRequestInitiator"] ? MapRequestInitiatorContactData.fromJS(_data["mapRequestInitiator"]) : undefined as any;
            if (Array.isArray(_data["downloadUrls"])) {
                this.downloadUrls = [] as any;
                for (let item of _data["downloadUrls"])
                    this.downloadUrls!.push(DownloadUrl.fromJS(item));
            }
            this.mapRequestGeometry = _data["mapRequestGeometry"];
            this.downloadArchiveUrl = _data["downloadArchiveUrl"];
            if (Array.isArray(_data["responders"])) {
                this.responders = [] as any;
                for (let item of _data["responders"])
                    this.responders!.push(OperationsArchivedMapRequestResponder.fromJS(item));
            }
            this.isBusinessCentralAvailable = _data["isBusinessCentralAvailable"];
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(InvoiceListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OperationsArchivedMapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OperationsArchivedMapRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestId"] = this.mapRequestId;
        data["reference"] = this.reference;
        data["dateReceived"] = this.dateReceived;
        data["deleteDate"] = this.deleteDate;
        data["status"] = this.status;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["mapRequestType"] = this.mapRequestType;
        data["excavationType"] = this.excavationType;
        data["excavationMethod"] = this.excavationMethod;
        data["excavationDepth"] = this.excavationDepth;
        data["excavationLocation"] = this.excavationLocation;
        data["excavationDescription"] = this.excavationDescription;
        data["mapRequestInitiator"] = this.mapRequestInitiator ? this.mapRequestInitiator.toJSON() : undefined as any;
        if (Array.isArray(this.downloadUrls)) {
            data["downloadUrls"] = [];
            for (let item of this.downloadUrls)
                data["downloadUrls"].push(item ? item.toJSON() : undefined as any);
        }
        data["mapRequestGeometry"] = this.mapRequestGeometry;
        data["downloadArchiveUrl"] = this.downloadArchiveUrl;
        if (Array.isArray(this.responders)) {
            data["responders"] = [];
            for (let item of this.responders)
                data["responders"].push(item ? item.toJSON() : undefined as any);
        }
        data["isBusinessCentralAvailable"] = this.isBusinessCentralAvailable;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOperationsArchivedMapRequest {
    mapRequestId?: string;
    reference?: string | undefined;
    dateReceived?: string;
    deleteDate?: string;
    status?: string | undefined;
    startDate?: string;
    endDate?: string;
    mapRequestType?: string | undefined;
    excavationType?: string | undefined;
    excavationMethod?: string | undefined;
    excavationDepth?: number | undefined;
    excavationLocation?: string | undefined;
    excavationDescription?: string | undefined;
    mapRequestInitiator?: MapRequestInitiatorContactData | undefined;
    downloadUrls?: DownloadUrl[] | undefined;
    mapRequestGeometry?: any | undefined;
    downloadArchiveUrl?: string | undefined;
    responders?: OperationsArchivedMapRequestResponder[] | undefined;
    isBusinessCentralAvailable?: boolean;
    invoices?: InvoiceListItem[] | undefined;
}

export class OperationsArchivedMapRequestResponder implements IOperationsArchivedMapRequestResponder {
    utilityNetworkAuthorityName?: string | undefined;
    utilityNetworkAuthorityZoneId?: string;
    utilityNetworkAuthorityZoneName?: string | undefined;
    downloadUrl?: string | undefined;
    isKlim?: boolean;

    constructor(data?: IOperationsArchivedMapRequestResponder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.utilityNetworkAuthorityName = _data["utilityNetworkAuthorityName"];
            this.utilityNetworkAuthorityZoneId = _data["utilityNetworkAuthorityZoneId"];
            this.utilityNetworkAuthorityZoneName = _data["utilityNetworkAuthorityZoneName"];
            this.downloadUrl = _data["downloadUrl"];
            this.isKlim = _data["isKlim"];
        }
    }

    static fromJS(data: any): OperationsArchivedMapRequestResponder {
        data = typeof data === 'object' ? data : {};
        let result = new OperationsArchivedMapRequestResponder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utilityNetworkAuthorityName"] = this.utilityNetworkAuthorityName;
        data["utilityNetworkAuthorityZoneId"] = this.utilityNetworkAuthorityZoneId;
        data["utilityNetworkAuthorityZoneName"] = this.utilityNetworkAuthorityZoneName;
        data["downloadUrl"] = this.downloadUrl;
        data["isKlim"] = this.isKlim;
        return data;
    }
}

export interface IOperationsArchivedMapRequestResponder {
    utilityNetworkAuthorityName?: string | undefined;
    utilityNetworkAuthorityZoneId?: string;
    utilityNetworkAuthorityZoneName?: string | undefined;
    downloadUrl?: string | undefined;
    isKlim?: boolean;
}

export class EnvelopeOfIListOfAuditLog implements IEnvelopeOfIListOfAuditLog {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: AuditLog[] | undefined;

    constructor(data?: IEnvelopeOfIListOfAuditLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(AuditLog.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvelopeOfIListOfAuditLog {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfIListOfAuditLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnvelopeOfIListOfAuditLog {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: AuditLog[] | undefined;
}

export class MoveMapRequestsInput implements IMoveMapRequestsInput {
    mapRequestIds?: string[] | undefined;
    query?: GetOperationsMapRequestsInput | undefined;
    destinationKlipOrganisationId?: string;
    isArchived?: boolean;
    reason?: string | undefined;

    constructor(data?: IMoveMapRequestsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mapRequestIds"])) {
                this.mapRequestIds = [] as any;
                for (let item of _data["mapRequestIds"])
                    this.mapRequestIds!.push(item);
            }
            this.query = _data["query"] ? GetOperationsMapRequestsInput.fromJS(_data["query"]) : undefined as any;
            this.destinationKlipOrganisationId = _data["destinationKlipOrganisationId"];
            this.isArchived = _data["isArchived"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): MoveMapRequestsInput {
        data = typeof data === 'object' ? data : {};
        let result = new MoveMapRequestsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mapRequestIds)) {
            data["mapRequestIds"] = [];
            for (let item of this.mapRequestIds)
                data["mapRequestIds"].push(item);
        }
        data["query"] = this.query ? this.query.toJSON() : undefined as any;
        data["destinationKlipOrganisationId"] = this.destinationKlipOrganisationId;
        data["isArchived"] = this.isArchived;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IMoveMapRequestsInput {
    mapRequestIds?: string[] | undefined;
    query?: GetOperationsMapRequestsInput | undefined;
    destinationKlipOrganisationId?: string;
    isArchived?: boolean;
    reason?: string | undefined;
}

export class EnvelopeOfOrganisationsPagedResult implements IEnvelopeOfOrganisationsPagedResult {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: OrganisationsPagedResult | undefined;

    constructor(data?: IEnvelopeOfOrganisationsPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? OrganisationsPagedResult.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfOrganisationsPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfOrganisationsPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfOrganisationsPagedResult {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: OrganisationsPagedResult | undefined;
}

export class OrganisationsPagedResult implements IOrganisationsPagedResult {
    totalCount?: number;
    organisations?: OrganisationListItem[] | undefined;

    constructor(data?: IOrganisationsPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["organisations"])) {
                this.organisations = [] as any;
                for (let item of _data["organisations"])
                    this.organisations!.push(OrganisationListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganisationsPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationsPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.organisations)) {
            data["organisations"] = [];
            for (let item of this.organisations)
                data["organisations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOrganisationsPagedResult {
    totalCount?: number;
    organisations?: OrganisationListItem[] | undefined;
}

export class OrganisationListItem implements IOrganisationListItem {
    organisationId?: string;
    organisationParentId?: string | undefined;
    organisationName?: string | undefined;
    organisationParentName?: string | undefined;
    utilityNetworkAuthorityName?: string | undefined;

    constructor(data?: IOrganisationListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationId = _data["organisationId"];
            this.organisationParentId = _data["organisationParentId"];
            this.organisationName = _data["organisationName"];
            this.organisationParentName = _data["organisationParentName"];
            this.utilityNetworkAuthorityName = _data["utilityNetworkAuthorityName"];
        }
    }

    static fromJS(data: any): OrganisationListItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationId"] = this.organisationId;
        data["organisationParentId"] = this.organisationParentId;
        data["organisationName"] = this.organisationName;
        data["organisationParentName"] = this.organisationParentName;
        data["utilityNetworkAuthorityName"] = this.utilityNetworkAuthorityName;
        return data;
    }
}

export interface IOrganisationListItem {
    organisationId?: string;
    organisationParentId?: string | undefined;
    organisationName?: string | undefined;
    organisationParentName?: string | undefined;
    utilityNetworkAuthorityName?: string | undefined;
}

export class GetOrganisationsInput implements IGetOrganisationsInput {
    orderField?: string | undefined;
    orderDirection?: OrderDirection;
    organisatieCodeFilter?: string | undefined;
    organisatieFilter?: string | undefined;
    utilityNetworkAuthorityZoneFilter?: string | undefined;
    offset?: number | undefined;
    limit?: number | undefined;
    onlyRootOrganisations?: boolean;

    constructor(data?: IGetOrganisationsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderField = _data["orderField"];
            this.orderDirection = _data["orderDirection"];
            this.organisatieCodeFilter = _data["organisatieCodeFilter"];
            this.organisatieFilter = _data["organisatieFilter"];
            this.utilityNetworkAuthorityZoneFilter = _data["utilityNetworkAuthorityZoneFilter"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
            this.onlyRootOrganisations = _data["onlyRootOrganisations"];
        }
    }

    static fromJS(data: any): GetOrganisationsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganisationsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderField"] = this.orderField;
        data["orderDirection"] = this.orderDirection;
        data["organisatieCodeFilter"] = this.organisatieCodeFilter;
        data["organisatieFilter"] = this.organisatieFilter;
        data["utilityNetworkAuthorityZoneFilter"] = this.utilityNetworkAuthorityZoneFilter;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        data["onlyRootOrganisations"] = this.onlyRootOrganisations;
        return data;
    }
}

export interface IGetOrganisationsInput {
    orderField?: string | undefined;
    orderDirection?: OrderDirection;
    organisatieCodeFilter?: string | undefined;
    organisatieFilter?: string | undefined;
    utilityNetworkAuthorityZoneFilter?: string | undefined;
    offset?: number | undefined;
    limit?: number | undefined;
    onlyRootOrganisations?: boolean;
}

export class EnvelopeOfOrganisationDetail implements IEnvelopeOfOrganisationDetail {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: OrganisationDetail | undefined;

    constructor(data?: IEnvelopeOfOrganisationDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? OrganisationDetail.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfOrganisationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfOrganisationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfOrganisationDetail {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: OrganisationDetail | undefined;
}

export class OrganisationDetail implements IOrganisationDetail {
    organisationId?: string;
    organisationName?: string | undefined;
    organisationsDataTable?: OrganisationDataTable[] | undefined;

    constructor(data?: IOrganisationDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationId = _data["organisationId"];
            this.organisationName = _data["organisationName"];
            if (Array.isArray(_data["organisationsDataTable"])) {
                this.organisationsDataTable = [] as any;
                for (let item of _data["organisationsDataTable"])
                    this.organisationsDataTable!.push(OrganisationDataTable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganisationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationId"] = this.organisationId;
        data["organisationName"] = this.organisationName;
        if (Array.isArray(this.organisationsDataTable)) {
            data["organisationsDataTable"] = [];
            for (let item of this.organisationsDataTable)
                data["organisationsDataTable"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOrganisationDetail {
    organisationId?: string;
    organisationName?: string | undefined;
    organisationsDataTable?: OrganisationDataTable[] | undefined;
}

export class OrganisationDataTable implements IOrganisationDataTable {
    id?: string;
    depth?: number;
    name?: string | undefined;
    utilityNetworkAuthorityName?: string | undefined;
    numberOfUtilityNetworkAuthorityZones?: number;
    hasKlimZone?: boolean;
    lockedOut?: boolean;

    constructor(data?: IOrganisationDataTable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.depth = _data["depth"];
            this.name = _data["name"];
            this.utilityNetworkAuthorityName = _data["utilityNetworkAuthorityName"];
            this.numberOfUtilityNetworkAuthorityZones = _data["numberOfUtilityNetworkAuthorityZones"];
            this.hasKlimZone = _data["hasKlimZone"];
            this.lockedOut = _data["lockedOut"];
        }
    }

    static fromJS(data: any): OrganisationDataTable {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationDataTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["depth"] = this.depth;
        data["name"] = this.name;
        data["utilityNetworkAuthorityName"] = this.utilityNetworkAuthorityName;
        data["numberOfUtilityNetworkAuthorityZones"] = this.numberOfUtilityNetworkAuthorityZones;
        data["hasKlimZone"] = this.hasKlimZone;
        data["lockedOut"] = this.lockedOut;
        return data;
    }
}

export interface IOrganisationDataTable {
    id?: string;
    depth?: number;
    name?: string | undefined;
    utilityNetworkAuthorityName?: string | undefined;
    numberOfUtilityNetworkAuthorityZones?: number;
    hasKlimZone?: boolean;
    lockedOut?: boolean;
}

export class EnvelopeOfOrganisationInvoiceSettings implements IEnvelopeOfOrganisationInvoiceSettings {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: OrganisationInvoiceSettings | undefined;

    constructor(data?: IEnvelopeOfOrganisationInvoiceSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? OrganisationInvoiceSettings.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfOrganisationInvoiceSettings {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfOrganisationInvoiceSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfOrganisationInvoiceSettings {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: OrganisationInvoiceSettings | undefined;
}

export class OrganisationInvoiceSettings implements IOrganisationInvoiceSettings {
    organisationInvoiceData?: OrganisationInvoiceData | undefined;
    invoiceSettings?: InvoiceSettingsForOrganisation | undefined;

    constructor(data?: IOrganisationInvoiceSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationInvoiceData = _data["organisationInvoiceData"] ? OrganisationInvoiceData.fromJS(_data["organisationInvoiceData"]) : undefined as any;
            this.invoiceSettings = _data["invoiceSettings"] ? InvoiceSettingsForOrganisation.fromJS(_data["invoiceSettings"]) : undefined as any;
        }
    }

    static fromJS(data: any): OrganisationInvoiceSettings {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationInvoiceSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationInvoiceData"] = this.organisationInvoiceData ? this.organisationInvoiceData.toJSON() : undefined as any;
        data["invoiceSettings"] = this.invoiceSettings ? this.invoiceSettings.toJSON() : undefined as any;
        return data;
    }
}

export interface IOrganisationInvoiceSettings {
    organisationInvoiceData?: OrganisationInvoiceData | undefined;
    invoiceSettings?: InvoiceSettingsForOrganisation | undefined;
}

export class OrganisationInvoiceData implements IOrganisationInvoiceData {
    financialServiceAvailable?: boolean;
    paysByInvoice?: boolean;
    hasUnpaidInvoices?: boolean;
    hasInvoiceData?: boolean;
    prepaidAmount?: number;
    company?: string | undefined;
    email?: string | undefined;
    attention?: string | undefined;
    reference?: string | undefined;
    vatNumber?: string | undefined;
    kboNumber?: string | undefined;
    isInGroup?: boolean;
    address?: Address | undefined;
    invoiceContactName?: string | undefined;
    invoiceContactEmail?: string | undefined;
    invoiceContactPhoneNumber?: string | undefined;
    reminderEmail?: string | undefined;
    identificators?: { [key: string]: string; } | undefined;
    athumiData?: OrganisatieAthumiData | undefined;

    constructor(data?: IOrganisationInvoiceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialServiceAvailable = _data["financialServiceAvailable"];
            this.paysByInvoice = _data["paysByInvoice"];
            this.hasUnpaidInvoices = _data["hasUnpaidInvoices"];
            this.hasInvoiceData = _data["hasInvoiceData"];
            this.prepaidAmount = _data["prepaidAmount"];
            this.company = _data["company"];
            this.email = _data["email"];
            this.attention = _data["attention"];
            this.reference = _data["reference"];
            this.vatNumber = _data["vatNumber"];
            this.kboNumber = _data["kboNumber"];
            this.isInGroup = _data["isInGroup"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : undefined as any;
            this.invoiceContactName = _data["invoiceContactName"];
            this.invoiceContactEmail = _data["invoiceContactEmail"];
            this.invoiceContactPhoneNumber = _data["invoiceContactPhoneNumber"];
            this.reminderEmail = _data["reminderEmail"];
            if (_data["identificators"]) {
                this.identificators = {} as any;
                for (let key in _data["identificators"]) {
                    if (_data["identificators"].hasOwnProperty(key))
                        (this.identificators as any)![key] = _data["identificators"][key];
                }
            }
            this.athumiData = _data["athumiData"] ? OrganisatieAthumiData.fromJS(_data["athumiData"]) : undefined as any;
        }
    }

    static fromJS(data: any): OrganisationInvoiceData {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationInvoiceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialServiceAvailable"] = this.financialServiceAvailable;
        data["paysByInvoice"] = this.paysByInvoice;
        data["hasUnpaidInvoices"] = this.hasUnpaidInvoices;
        data["hasInvoiceData"] = this.hasInvoiceData;
        data["prepaidAmount"] = this.prepaidAmount;
        data["company"] = this.company;
        data["email"] = this.email;
        data["attention"] = this.attention;
        data["reference"] = this.reference;
        data["vatNumber"] = this.vatNumber;
        data["kboNumber"] = this.kboNumber;
        data["isInGroup"] = this.isInGroup;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["invoiceContactName"] = this.invoiceContactName;
        data["invoiceContactEmail"] = this.invoiceContactEmail;
        data["invoiceContactPhoneNumber"] = this.invoiceContactPhoneNumber;
        data["reminderEmail"] = this.reminderEmail;
        if (this.identificators) {
            data["identificators"] = {};
            for (let key in this.identificators) {
                if (this.identificators.hasOwnProperty(key))
                    (data["identificators"] as any)[key] = (this.identificators as any)[key];
            }
        }
        data["athumiData"] = this.athumiData ? this.athumiData.toJSON() : undefined as any;
        return data;
    }
}

export interface IOrganisationInvoiceData {
    financialServiceAvailable?: boolean;
    paysByInvoice?: boolean;
    hasUnpaidInvoices?: boolean;
    hasInvoiceData?: boolean;
    prepaidAmount?: number;
    company?: string | undefined;
    email?: string | undefined;
    attention?: string | undefined;
    reference?: string | undefined;
    vatNumber?: string | undefined;
    kboNumber?: string | undefined;
    isInGroup?: boolean;
    address?: Address | undefined;
    invoiceContactName?: string | undefined;
    invoiceContactEmail?: string | undefined;
    invoiceContactPhoneNumber?: string | undefined;
    reminderEmail?: string | undefined;
    identificators?: { [key: string]: string; } | undefined;
    athumiData?: OrganisatieAthumiData | undefined;
}

export class OrganisatieAthumiData implements IOrganisatieAthumiData {
    hasValidAthumiId?: boolean;
    athumiId?: string | undefined;
    organisatieNaam?: string | undefined;
    identificatieNummer?: string | undefined;
    vatNumber?: string | undefined;
    straat?: string | undefined;
    nummer?: string | undefined;
    bus?: string | undefined;
    postcode?: string | undefined;
    gemeente?: string | undefined;
    peppolIdentifier?: string | undefined;
    emailAdressen?: string[] | undefined;
    countryCode?: string | undefined;

    constructor(data?: IOrganisatieAthumiData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasValidAthumiId = _data["hasValidAthumiId"];
            this.athumiId = _data["athumiId"];
            this.organisatieNaam = _data["organisatieNaam"];
            this.identificatieNummer = _data["identificatieNummer"];
            this.vatNumber = _data["vatNumber"];
            this.straat = _data["straat"];
            this.nummer = _data["nummer"];
            this.bus = _data["bus"];
            this.postcode = _data["postcode"];
            this.gemeente = _data["gemeente"];
            this.peppolIdentifier = _data["peppolIdentifier"];
            if (Array.isArray(_data["emailAdressen"])) {
                this.emailAdressen = [] as any;
                for (let item of _data["emailAdressen"])
                    this.emailAdressen!.push(item);
            }
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): OrganisatieAthumiData {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisatieAthumiData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasValidAthumiId"] = this.hasValidAthumiId;
        data["athumiId"] = this.athumiId;
        data["organisatieNaam"] = this.organisatieNaam;
        data["identificatieNummer"] = this.identificatieNummer;
        data["vatNumber"] = this.vatNumber;
        data["straat"] = this.straat;
        data["nummer"] = this.nummer;
        data["bus"] = this.bus;
        data["postcode"] = this.postcode;
        data["gemeente"] = this.gemeente;
        data["peppolIdentifier"] = this.peppolIdentifier;
        if (Array.isArray(this.emailAdressen)) {
            data["emailAdressen"] = [];
            for (let item of this.emailAdressen)
                data["emailAdressen"].push(item);
        }
        data["countryCode"] = this.countryCode;
        return data;
    }
}

export interface IOrganisatieAthumiData {
    hasValidAthumiId?: boolean;
    athumiId?: string | undefined;
    organisatieNaam?: string | undefined;
    identificatieNummer?: string | undefined;
    vatNumber?: string | undefined;
    straat?: string | undefined;
    nummer?: string | undefined;
    bus?: string | undefined;
    postcode?: string | undefined;
    gemeente?: string | undefined;
    peppolIdentifier?: string | undefined;
    emailAdressen?: string[] | undefined;
    countryCode?: string | undefined;
}

export class InvoiceSettingsForOrganisation implements IInvoiceSettingsForOrganisation {
    organisationInvoiceGroups?: OrganisationInvoiceGroup[] | undefined;
    subOrganisationInvoiceSettings?: OrganisationInvoiceSetting[] | undefined;

    constructor(data?: IInvoiceSettingsForOrganisation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organisationInvoiceGroups"])) {
                this.organisationInvoiceGroups = [] as any;
                for (let item of _data["organisationInvoiceGroups"])
                    this.organisationInvoiceGroups!.push(OrganisationInvoiceGroup.fromJS(item));
            }
            if (Array.isArray(_data["subOrganisationInvoiceSettings"])) {
                this.subOrganisationInvoiceSettings = [] as any;
                for (let item of _data["subOrganisationInvoiceSettings"])
                    this.subOrganisationInvoiceSettings!.push(OrganisationInvoiceSetting.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceSettingsForOrganisation {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceSettingsForOrganisation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organisationInvoiceGroups)) {
            data["organisationInvoiceGroups"] = [];
            for (let item of this.organisationInvoiceGroups)
                data["organisationInvoiceGroups"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.subOrganisationInvoiceSettings)) {
            data["subOrganisationInvoiceSettings"] = [];
            for (let item of this.subOrganisationInvoiceSettings)
                data["subOrganisationInvoiceSettings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInvoiceSettingsForOrganisation {
    organisationInvoiceGroups?: OrganisationInvoiceGroup[] | undefined;
    subOrganisationInvoiceSettings?: OrganisationInvoiceSetting[] | undefined;
}

export class OrganisationInvoiceGroup implements IOrganisationInvoiceGroup {
    id?: string;
    parentOrganisationId?: string;
    name?: string | undefined;
    reference?: string | undefined;
    attention?: string | undefined;
    reminderEmail?: string | undefined;
    organisations?: OrganisationInvoiceGroupMember[] | undefined;
    invoiceContactEmail?: string | undefined;
    invoiceContactName?: string | undefined;
    invoiceContactPhoneNumber?: string | undefined;

    constructor(data?: IOrganisationInvoiceGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentOrganisationId = _data["parentOrganisationId"];
            this.name = _data["name"];
            this.reference = _data["reference"];
            this.attention = _data["attention"];
            this.reminderEmail = _data["reminderEmail"];
            if (Array.isArray(_data["organisations"])) {
                this.organisations = [] as any;
                for (let item of _data["organisations"])
                    this.organisations!.push(OrganisationInvoiceGroupMember.fromJS(item));
            }
            this.invoiceContactEmail = _data["invoiceContactEmail"];
            this.invoiceContactName = _data["invoiceContactName"];
            this.invoiceContactPhoneNumber = _data["invoiceContactPhoneNumber"];
        }
    }

    static fromJS(data: any): OrganisationInvoiceGroup {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationInvoiceGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentOrganisationId"] = this.parentOrganisationId;
        data["name"] = this.name;
        data["reference"] = this.reference;
        data["attention"] = this.attention;
        data["reminderEmail"] = this.reminderEmail;
        if (Array.isArray(this.organisations)) {
            data["organisations"] = [];
            for (let item of this.organisations)
                data["organisations"].push(item ? item.toJSON() : undefined as any);
        }
        data["invoiceContactEmail"] = this.invoiceContactEmail;
        data["invoiceContactName"] = this.invoiceContactName;
        data["invoiceContactPhoneNumber"] = this.invoiceContactPhoneNumber;
        return data;
    }
}

export interface IOrganisationInvoiceGroup {
    id?: string;
    parentOrganisationId?: string;
    name?: string | undefined;
    reference?: string | undefined;
    attention?: string | undefined;
    reminderEmail?: string | undefined;
    organisations?: OrganisationInvoiceGroupMember[] | undefined;
    invoiceContactEmail?: string | undefined;
    invoiceContactName?: string | undefined;
    invoiceContactPhoneNumber?: string | undefined;
}

export class OrganisationInvoiceGroupMember implements IOrganisationInvoiceGroupMember {
    memberKlipOrganisationId?: string;
    organisationPath?: string | undefined;

    constructor(data?: IOrganisationInvoiceGroupMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberKlipOrganisationId = _data["memberKlipOrganisationId"];
            this.organisationPath = _data["organisationPath"];
        }
    }

    static fromJS(data: any): OrganisationInvoiceGroupMember {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationInvoiceGroupMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberKlipOrganisationId"] = this.memberKlipOrganisationId;
        data["organisationPath"] = this.organisationPath;
        return data;
    }
}

export interface IOrganisationInvoiceGroupMember {
    memberKlipOrganisationId?: string;
    organisationPath?: string | undefined;
}

export class OrganisationInvoiceSetting implements IOrganisationInvoiceSetting {
    klipOrganisationId?: string;
    company?: string | undefined;
    email?: string | undefined;
    attention?: string | undefined;
    reference?: string | undefined;
    vatNumber?: string | undefined;
    kboNumber?: string | undefined;
    isAthumiGatewayServiceUnavailable?: boolean;
    address?: Address | undefined;
    reminderEmail?: string | undefined;
    invoiceContactEmail?: string | undefined;
    invoiceContactName?: string | undefined;
    invoiceContactPhoneNumber?: any | undefined;

    constructor(data?: IOrganisationInvoiceSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.klipOrganisationId = _data["klipOrganisationId"];
            this.company = _data["company"];
            this.email = _data["email"];
            this.attention = _data["attention"];
            this.reference = _data["reference"];
            this.vatNumber = _data["vatNumber"];
            this.kboNumber = _data["kboNumber"];
            this.isAthumiGatewayServiceUnavailable = _data["isAthumiGatewayServiceUnavailable"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : undefined as any;
            this.reminderEmail = _data["reminderEmail"];
            this.invoiceContactEmail = _data["invoiceContactEmail"];
            this.invoiceContactName = _data["invoiceContactName"];
            this.invoiceContactPhoneNumber = _data["invoiceContactPhoneNumber"];
        }
    }

    static fromJS(data: any): OrganisationInvoiceSetting {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationInvoiceSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["klipOrganisationId"] = this.klipOrganisationId;
        data["company"] = this.company;
        data["email"] = this.email;
        data["attention"] = this.attention;
        data["reference"] = this.reference;
        data["vatNumber"] = this.vatNumber;
        data["kboNumber"] = this.kboNumber;
        data["isAthumiGatewayServiceUnavailable"] = this.isAthumiGatewayServiceUnavailable;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["reminderEmail"] = this.reminderEmail;
        data["invoiceContactEmail"] = this.invoiceContactEmail;
        data["invoiceContactName"] = this.invoiceContactName;
        data["invoiceContactPhoneNumber"] = this.invoiceContactPhoneNumber;
        return data;
    }
}

export interface IOrganisationInvoiceSetting {
    klipOrganisationId?: string;
    company?: string | undefined;
    email?: string | undefined;
    attention?: string | undefined;
    reference?: string | undefined;
    vatNumber?: string | undefined;
    kboNumber?: string | undefined;
    isAthumiGatewayServiceUnavailable?: boolean;
    address?: Address | undefined;
    reminderEmail?: string | undefined;
    invoiceContactEmail?: string | undefined;
    invoiceContactName?: string | undefined;
    invoiceContactPhoneNumber?: any | undefined;
}

export class EnvelopeOfInvoiceSettingsForOrganisation implements IEnvelopeOfInvoiceSettingsForOrganisation {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: InvoiceSettingsForOrganisation | undefined;

    constructor(data?: IEnvelopeOfInvoiceSettingsForOrganisation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? InvoiceSettingsForOrganisation.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfInvoiceSettingsForOrganisation {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfInvoiceSettingsForOrganisation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfInvoiceSettingsForOrganisation {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: InvoiceSettingsForOrganisation | undefined;
}

export class UpdateOperationInvoiceDataInput implements IUpdateOperationInvoiceDataInput {
    organisationId?: string;
    updateChildOrganisations?: boolean;
    vatNumber?: string | undefined;
    reminderEmail?: string | undefined;
    attention?: string | undefined;
    reference?: string | undefined;
    invoiceName?: string | undefined;
    invoiceEmail?: string | undefined;
    invoicePhoneNumber?: string | undefined;

    constructor(data?: IUpdateOperationInvoiceDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationId = _data["organisationId"];
            this.updateChildOrganisations = _data["updateChildOrganisations"];
            this.vatNumber = _data["vatNumber"];
            this.reminderEmail = _data["reminderEmail"];
            this.attention = _data["attention"];
            this.reference = _data["reference"];
            this.invoiceName = _data["invoiceName"];
            this.invoiceEmail = _data["invoiceEmail"];
            this.invoicePhoneNumber = _data["invoicePhoneNumber"];
        }
    }

    static fromJS(data: any): UpdateOperationInvoiceDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOperationInvoiceDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationId"] = this.organisationId;
        data["updateChildOrganisations"] = this.updateChildOrganisations;
        data["vatNumber"] = this.vatNumber;
        data["reminderEmail"] = this.reminderEmail;
        data["attention"] = this.attention;
        data["reference"] = this.reference;
        data["invoiceName"] = this.invoiceName;
        data["invoiceEmail"] = this.invoiceEmail;
        data["invoicePhoneNumber"] = this.invoicePhoneNumber;
        return data;
    }
}

export interface IUpdateOperationInvoiceDataInput {
    organisationId?: string;
    updateChildOrganisations?: boolean;
    vatNumber?: string | undefined;
    reminderEmail?: string | undefined;
    attention?: string | undefined;
    reference?: string | undefined;
    invoiceName?: string | undefined;
    invoiceEmail?: string | undefined;
    invoicePhoneNumber?: string | undefined;
}

export class UpdateOrganisationPaymentSettingsInput implements IUpdateOrganisationPaymentSettingsInput {
    organisationId?: string;
    paysByInvoice?: boolean;

    constructor(data?: IUpdateOrganisationPaymentSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationId = _data["organisationId"];
            this.paysByInvoice = _data["paysByInvoice"];
        }
    }

    static fromJS(data: any): UpdateOrganisationPaymentSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganisationPaymentSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationId"] = this.organisationId;
        data["paysByInvoice"] = this.paysByInvoice;
        return data;
    }
}

export interface IUpdateOrganisationPaymentSettingsInput {
    organisationId?: string;
    paysByInvoice?: boolean;
}

export class UpdateOrganisationActorInput implements IUpdateOrganisationActorInput {
    organisationId?: string;
    vatNumber?: string | undefined;
    name?: string | undefined;
    street?: string | undefined;
    streetNumber?: string | undefined;
    box?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    countryCode?: string | undefined;
    invoiceEmail?: string | undefined;

    constructor(data?: IUpdateOrganisationActorInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationId = _data["organisationId"];
            this.vatNumber = _data["vatNumber"];
            this.name = _data["name"];
            this.street = _data["street"];
            this.streetNumber = _data["streetNumber"];
            this.box = _data["box"];
            this.zip = _data["zip"];
            this.city = _data["city"];
            this.countryCode = _data["countryCode"];
            this.invoiceEmail = _data["invoiceEmail"];
        }
    }

    static fromJS(data: any): UpdateOrganisationActorInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganisationActorInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationId"] = this.organisationId;
        data["vatNumber"] = this.vatNumber;
        data["name"] = this.name;
        data["street"] = this.street;
        data["streetNumber"] = this.streetNumber;
        data["box"] = this.box;
        data["zip"] = this.zip;
        data["city"] = this.city;
        data["countryCode"] = this.countryCode;
        data["invoiceEmail"] = this.invoiceEmail;
        return data;
    }
}

export interface IUpdateOrganisationActorInput {
    organisationId?: string;
    vatNumber?: string | undefined;
    name?: string | undefined;
    street?: string | undefined;
    streetNumber?: string | undefined;
    box?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    countryCode?: string | undefined;
    invoiceEmail?: string | undefined;
}

export class EnvelopeOfSubOrganisationDetail implements IEnvelopeOfSubOrganisationDetail {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: SubOrganisationDetail | undefined;

    constructor(data?: IEnvelopeOfSubOrganisationDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? SubOrganisationDetail.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfSubOrganisationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfSubOrganisationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfSubOrganisationDetail {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: SubOrganisationDetail | undefined;
}

export class SubOrganisationDetail implements ISubOrganisationDetail {
    organisationId?: string;
    name?: string | undefined;
    rootOrganisationId?: string | undefined;
    rootOrganisationName?: string | undefined;
    isUna?: boolean;
    displayName?: string | undefined;
    subjectSigningCertificate?: string | undefined;
    invoiceData?: OrganisationInvoiceData | undefined;
    unaData?: OrganisationUnaData | undefined;
    invoiceGroupParentId?: number;

    constructor(data?: ISubOrganisationDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationId = _data["organisationId"];
            this.name = _data["name"];
            this.rootOrganisationId = _data["rootOrganisationId"];
            this.rootOrganisationName = _data["rootOrganisationName"];
            this.isUna = _data["isUna"];
            this.displayName = _data["displayName"];
            this.subjectSigningCertificate = _data["subjectSigningCertificate"];
            this.invoiceData = _data["invoiceData"] ? OrganisationInvoiceData.fromJS(_data["invoiceData"]) : undefined as any;
            this.unaData = _data["unaData"] ? OrganisationUnaData.fromJS(_data["unaData"]) : undefined as any;
            this.invoiceGroupParentId = _data["invoiceGroupParentId"];
        }
    }

    static fromJS(data: any): SubOrganisationDetail {
        data = typeof data === 'object' ? data : {};
        let result = new SubOrganisationDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationId"] = this.organisationId;
        data["name"] = this.name;
        data["rootOrganisationId"] = this.rootOrganisationId;
        data["rootOrganisationName"] = this.rootOrganisationName;
        data["isUna"] = this.isUna;
        data["displayName"] = this.displayName;
        data["subjectSigningCertificate"] = this.subjectSigningCertificate;
        data["invoiceData"] = this.invoiceData ? this.invoiceData.toJSON() : undefined as any;
        data["unaData"] = this.unaData ? this.unaData.toJSON() : undefined as any;
        data["invoiceGroupParentId"] = this.invoiceGroupParentId;
        return data;
    }
}

export interface ISubOrganisationDetail {
    organisationId?: string;
    name?: string | undefined;
    rootOrganisationId?: string | undefined;
    rootOrganisationName?: string | undefined;
    isUna?: boolean;
    displayName?: string | undefined;
    subjectSigningCertificate?: string | undefined;
    invoiceData?: OrganisationInvoiceData | undefined;
    unaData?: OrganisationUnaData | undefined;
    invoiceGroupParentId?: number;
}

export class OrganisationUnaData implements IOrganisationUnaData {
    unaId?: number;
    confirmation?: boolean;
    confirmationExampleUri?: string | undefined;

    constructor(data?: IOrganisationUnaData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unaId = _data["unaId"];
            this.confirmation = _data["confirmation"];
            this.confirmationExampleUri = _data["confirmationExampleUri"];
        }
    }

    static fromJS(data: any): OrganisationUnaData {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationUnaData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unaId"] = this.unaId;
        data["confirmation"] = this.confirmation;
        data["confirmationExampleUri"] = this.confirmationExampleUri;
        return data;
    }
}

export interface IOrganisationUnaData {
    unaId?: number;
    confirmation?: boolean;
    confirmationExampleUri?: string | undefined;
}

export class UpdateConfirmationInUnaZoneSettingsInput implements IUpdateConfirmationInUnaZoneSettingsInput {
    unaId?: number;
    confirmation?: boolean;

    constructor(data?: IUpdateConfirmationInUnaZoneSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unaId = _data["unaId"];
            this.confirmation = _data["confirmation"];
        }
    }

    static fromJS(data: any): UpdateConfirmationInUnaZoneSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConfirmationInUnaZoneSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unaId"] = this.unaId;
        data["confirmation"] = this.confirmation;
        return data;
    }
}

export interface IUpdateConfirmationInUnaZoneSettingsInput {
    unaId?: number;
    confirmation?: boolean;
}

export class EnvelopeOfActorDto implements IEnvelopeOfActorDto {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ActorDto | undefined;

    constructor(data?: IEnvelopeOfActorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? ActorDto.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfActorDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfActorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfActorDto {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ActorDto | undefined;
}

export class ActorDto implements IActorDto {
    id?: string;
    type?: ActorType;
    invoiceAddress?: InvoiceAddressDto | undefined;
    invoiceEmails?: string[] | undefined;
    subjectId?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    ovoCode?: string | undefined;
    kboNumber?: string | undefined;
    name?: string | undefined;
    vatNumber?: string | undefined;
    orgCode?: string | undefined;
    isConsumer?: boolean;
    peppolIdentifier?: string | undefined;

    constructor(data?: IActorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.invoiceAddress = _data["invoiceAddress"] ? InvoiceAddressDto.fromJS(_data["invoiceAddress"]) : undefined as any;
            if (Array.isArray(_data["invoiceEmails"])) {
                this.invoiceEmails = [] as any;
                for (let item of _data["invoiceEmails"])
                    this.invoiceEmails!.push(item);
            }
            this.subjectId = _data["subjectId"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.ovoCode = _data["ovoCode"];
            this.kboNumber = _data["kboNumber"];
            this.name = _data["name"];
            this.vatNumber = _data["vatNumber"];
            this.orgCode = _data["orgCode"];
            this.isConsumer = _data["isConsumer"];
            this.peppolIdentifier = _data["peppolIdentifier"];
        }
    }

    static fromJS(data: any): ActorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["invoiceAddress"] = this.invoiceAddress ? this.invoiceAddress.toJSON() : undefined as any;
        if (Array.isArray(this.invoiceEmails)) {
            data["invoiceEmails"] = [];
            for (let item of this.invoiceEmails)
                data["invoiceEmails"].push(item);
        }
        data["subjectId"] = this.subjectId;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["ovoCode"] = this.ovoCode;
        data["kboNumber"] = this.kboNumber;
        data["name"] = this.name;
        data["vatNumber"] = this.vatNumber;
        data["orgCode"] = this.orgCode;
        data["isConsumer"] = this.isConsumer;
        data["peppolIdentifier"] = this.peppolIdentifier;
        return data;
    }
}

export interface IActorDto {
    id?: string;
    type?: ActorType;
    invoiceAddress?: InvoiceAddressDto | undefined;
    invoiceEmails?: string[] | undefined;
    subjectId?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    ovoCode?: string | undefined;
    kboNumber?: string | undefined;
    name?: string | undefined;
    vatNumber?: string | undefined;
    orgCode?: string | undefined;
    isConsumer?: boolean;
    peppolIdentifier?: string | undefined;
}

export enum ActorType {
    Citizen = 0,
    ForeignOrganisation = 1,
    Organisation = 2,
    GovernmentAgency = 3,
}

export class InvoiceAddressDto implements IInvoiceAddressDto {
    street?: string | undefined;
    streetNumber?: string | undefined;
    bus?: string | undefined;
    postCode?: string | undefined;
    city?: string | undefined;
    countryCode?: string | undefined;

    constructor(data?: IInvoiceAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"];
            this.streetNumber = _data["streetNumber"];
            this.bus = _data["bus"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): InvoiceAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["streetNumber"] = this.streetNumber;
        data["bus"] = this.bus;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryCode"] = this.countryCode;
        return data;
    }
}

export interface IInvoiceAddressDto {
    street?: string | undefined;
    streetNumber?: string | undefined;
    bus?: string | undefined;
    postCode?: string | undefined;
    city?: string | undefined;
    countryCode?: string | undefined;
}

export class EnvelopeOfSubOrganisationUnaZoneDetail implements IEnvelopeOfSubOrganisationUnaZoneDetail {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: SubOrganisationUnaZoneDetail | undefined;

    constructor(data?: IEnvelopeOfSubOrganisationUnaZoneDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? SubOrganisationUnaZoneDetail.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfSubOrganisationUnaZoneDetail {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfSubOrganisationUnaZoneDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfSubOrganisationUnaZoneDetail {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: SubOrganisationUnaZoneDetail | undefined;
}

export class SubOrganisationUnaZoneDetail implements ISubOrganisationUnaZoneDetail {
    organisation?: Organisation | undefined;
    unaZone?: UnaZoneEditView | undefined;
    auditLogs?: AuditLog[] | undefined;

    constructor(data?: ISubOrganisationUnaZoneDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisation = _data["organisation"] ? Organisation.fromJS(_data["organisation"]) : undefined as any;
            this.unaZone = _data["unaZone"] ? UnaZoneEditView.fromJS(_data["unaZone"]) : undefined as any;
            if (Array.isArray(_data["auditLogs"])) {
                this.auditLogs = [] as any;
                for (let item of _data["auditLogs"])
                    this.auditLogs!.push(AuditLog.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubOrganisationUnaZoneDetail {
        data = typeof data === 'object' ? data : {};
        let result = new SubOrganisationUnaZoneDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisation"] = this.organisation ? this.organisation.toJSON() : undefined as any;
        data["unaZone"] = this.unaZone ? this.unaZone.toJSON() : undefined as any;
        if (Array.isArray(this.auditLogs)) {
            data["auditLogs"] = [];
            for (let item of this.auditLogs)
                data["auditLogs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISubOrganisationUnaZoneDetail {
    organisation?: Organisation | undefined;
    unaZone?: UnaZoneEditView | undefined;
    auditLogs?: AuditLog[] | undefined;
}

export class Organisation implements IOrganisation {
    organisationId?: string;
    name?: string | undefined;
    parentId?: string | undefined;
    rootId?: string | undefined;
    namePath?: string | undefined;

    constructor(data?: IOrganisation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationId = _data["organisationId"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
            this.rootId = _data["rootId"];
            this.namePath = _data["namePath"];
        }
    }

    static fromJS(data: any): Organisation {
        data = typeof data === 'object' ? data : {};
        let result = new Organisation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationId"] = this.organisationId;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["rootId"] = this.rootId;
        data["namePath"] = this.namePath;
        return data;
    }
}

export interface IOrganisation {
    organisationId?: string;
    name?: string | undefined;
    parentId?: string | undefined;
    rootId?: string | undefined;
    namePath?: string | undefined;
}

export class UnaZoneEditView implements IUnaZoneEditView {
    id?: string | undefined;
    zoneName?: string | undefined;
    namespace?: string | undefined;
    contactEmail?: string | undefined;
    contactEmailEmergency?: string | undefined;
    contactName?: string | undefined;
    contactTelephone?: string | undefined;
    extraInformation?: string | undefined;
    mapRequestEmail?: string | undefined;
    alarmCentralTelephone?: string | undefined;
    isArchived?: boolean;
    isKlimZone?: boolean;
    geometries?: Geometry[] | undefined;
    confirmation?: boolean;
    reminder1DayToRespond?: boolean;
    uploadImklSuccess?: boolean;
    uploadImklFailed?: boolean;
    respondedNotInvolved?: boolean;
    confirmationExampleUri?: string | undefined;
    reminder1DayToRespondExampleUri?: string | undefined;
    uploadImklSuccessExampleUri?: string | undefined;
    uploadImklFailedExampleUri?: string | undefined;
    respondedNotInvolvedExampleUri?: string | undefined;
    unaName?: string | undefined;
    unaId?: number;
    klipOrganisationId?: string;

    constructor(data?: IUnaZoneEditView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.zoneName = _data["zoneName"];
            this.namespace = _data["namespace"];
            this.contactEmail = _data["contactEmail"];
            this.contactEmailEmergency = _data["contactEmailEmergency"];
            this.contactName = _data["contactName"];
            this.contactTelephone = _data["contactTelephone"];
            this.extraInformation = _data["extraInformation"];
            this.mapRequestEmail = _data["mapRequestEmail"];
            this.alarmCentralTelephone = _data["alarmCentralTelephone"];
            this.isArchived = _data["isArchived"];
            this.isKlimZone = _data["isKlimZone"];
            if (Array.isArray(_data["geometries"])) {
                this.geometries = [] as any;
                for (let item of _data["geometries"])
                    this.geometries!.push(Geometry.fromJS(item));
            }
            this.confirmation = _data["confirmation"];
            this.reminder1DayToRespond = _data["reminder1DayToRespond"];
            this.uploadImklSuccess = _data["uploadImklSuccess"];
            this.uploadImklFailed = _data["uploadImklFailed"];
            this.respondedNotInvolved = _data["respondedNotInvolved"];
            this.confirmationExampleUri = _data["confirmationExampleUri"];
            this.reminder1DayToRespondExampleUri = _data["reminder1DayToRespondExampleUri"];
            this.uploadImklSuccessExampleUri = _data["uploadImklSuccessExampleUri"];
            this.uploadImklFailedExampleUri = _data["uploadImklFailedExampleUri"];
            this.respondedNotInvolvedExampleUri = _data["respondedNotInvolvedExampleUri"];
            this.unaName = _data["unaName"];
            this.unaId = _data["unaId"];
            this.klipOrganisationId = _data["klipOrganisationId"];
        }
    }

    static fromJS(data: any): UnaZoneEditView {
        data = typeof data === 'object' ? data : {};
        let result = new UnaZoneEditView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["zoneName"] = this.zoneName;
        data["namespace"] = this.namespace;
        data["contactEmail"] = this.contactEmail;
        data["contactEmailEmergency"] = this.contactEmailEmergency;
        data["contactName"] = this.contactName;
        data["contactTelephone"] = this.contactTelephone;
        data["extraInformation"] = this.extraInformation;
        data["mapRequestEmail"] = this.mapRequestEmail;
        data["alarmCentralTelephone"] = this.alarmCentralTelephone;
        data["isArchived"] = this.isArchived;
        data["isKlimZone"] = this.isKlimZone;
        if (Array.isArray(this.geometries)) {
            data["geometries"] = [];
            for (let item of this.geometries)
                data["geometries"].push(item ? item.toJSON() : undefined as any);
        }
        data["confirmation"] = this.confirmation;
        data["reminder1DayToRespond"] = this.reminder1DayToRespond;
        data["uploadImklSuccess"] = this.uploadImklSuccess;
        data["uploadImklFailed"] = this.uploadImklFailed;
        data["respondedNotInvolved"] = this.respondedNotInvolved;
        data["confirmationExampleUri"] = this.confirmationExampleUri;
        data["reminder1DayToRespondExampleUri"] = this.reminder1DayToRespondExampleUri;
        data["uploadImklSuccessExampleUri"] = this.uploadImklSuccessExampleUri;
        data["uploadImklFailedExampleUri"] = this.uploadImklFailedExampleUri;
        data["respondedNotInvolvedExampleUri"] = this.respondedNotInvolvedExampleUri;
        data["unaName"] = this.unaName;
        data["unaId"] = this.unaId;
        data["klipOrganisationId"] = this.klipOrganisationId;
        return data;
    }
}

export interface IUnaZoneEditView {
    id?: string | undefined;
    zoneName?: string | undefined;
    namespace?: string | undefined;
    contactEmail?: string | undefined;
    contactEmailEmergency?: string | undefined;
    contactName?: string | undefined;
    contactTelephone?: string | undefined;
    extraInformation?: string | undefined;
    mapRequestEmail?: string | undefined;
    alarmCentralTelephone?: string | undefined;
    isArchived?: boolean;
    isKlimZone?: boolean;
    geometries?: Geometry[] | undefined;
    confirmation?: boolean;
    reminder1DayToRespond?: boolean;
    uploadImklSuccess?: boolean;
    uploadImklFailed?: boolean;
    respondedNotInvolved?: boolean;
    confirmationExampleUri?: string | undefined;
    reminder1DayToRespondExampleUri?: string | undefined;
    uploadImklSuccessExampleUri?: string | undefined;
    uploadImklFailedExampleUri?: string | undefined;
    respondedNotInvolvedExampleUri?: string | undefined;
    unaName?: string | undefined;
    unaId?: number;
    klipOrganisationId?: string;
}

export class Geometry implements IGeometry {
    id?: string | undefined;
    blobName?: string | undefined;
    wkt?: string | undefined;
    activationDate?: string;
    version?: string | undefined;
    lastModificationDate?: string | undefined;
    precision?: number | undefined;
    reference?: string | undefined;
    isActive?: boolean;
    downloadUrls?: DownloadUrl[] | undefined;
    coordinateSystem?: CoordinateSystem;

    constructor(data?: IGeometry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.blobName = _data["blobName"];
            this.wkt = _data["wkt"];
            this.activationDate = _data["activationDate"];
            this.version = _data["version"];
            this.lastModificationDate = _data["lastModificationDate"];
            this.precision = _data["precision"];
            this.reference = _data["reference"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["downloadUrls"])) {
                this.downloadUrls = [] as any;
                for (let item of _data["downloadUrls"])
                    this.downloadUrls!.push(DownloadUrl.fromJS(item));
            }
            this.coordinateSystem = _data["coordinateSystem"];
        }
    }

    static fromJS(data: any): Geometry {
        data = typeof data === 'object' ? data : {};
        let result = new Geometry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["blobName"] = this.blobName;
        data["wkt"] = this.wkt;
        data["activationDate"] = this.activationDate;
        data["version"] = this.version;
        data["lastModificationDate"] = this.lastModificationDate;
        data["precision"] = this.precision;
        data["reference"] = this.reference;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.downloadUrls)) {
            data["downloadUrls"] = [];
            for (let item of this.downloadUrls)
                data["downloadUrls"].push(item ? item.toJSON() : undefined as any);
        }
        data["coordinateSystem"] = this.coordinateSystem;
        return data;
    }
}

export interface IGeometry {
    id?: string | undefined;
    blobName?: string | undefined;
    wkt?: string | undefined;
    activationDate?: string;
    version?: string | undefined;
    lastModificationDate?: string | undefined;
    precision?: number | undefined;
    reference?: string | undefined;
    isActive?: boolean;
    downloadUrls?: DownloadUrl[] | undefined;
    coordinateSystem?: CoordinateSystem;
}

export class EnvelopeOfIListOfZoneListItem implements IEnvelopeOfIListOfZoneListItem {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ZoneListItem[] | undefined;

    constructor(data?: IEnvelopeOfIListOfZoneListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(ZoneListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvelopeOfIListOfZoneListItem {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfIListOfZoneListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnvelopeOfIListOfZoneListItem {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ZoneListItem[] | undefined;
}

export class ZoneListItem implements IZoneListItem {
    id?: string;
    name?: string | undefined;
    wkt?: string | undefined;

    constructor(data?: IZoneListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.wkt = _data["wkt"];
        }
    }

    static fromJS(data: any): ZoneListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["wkt"] = this.wkt;
        return data;
    }
}

export interface IZoneListItem {
    id?: string;
    name?: string | undefined;
    wkt?: string | undefined;
}

export class EnvelopeOfICollectionOfVersionDto implements IEnvelopeOfICollectionOfVersionDto {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: VersionDto[] | undefined;

    constructor(data?: IEnvelopeOfICollectionOfVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(VersionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvelopeOfICollectionOfVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfICollectionOfVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnvelopeOfICollectionOfVersionDto {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: VersionDto[] | undefined;
}

export class VersionDto implements IVersionDto {
    id?: number;
    activationDate?: string | undefined;
    packageVersion?: string | undefined;
    pmklVersion?: string | undefined;
    wfsVersion?: string | undefined;
    minimumViewerVersion?: string | undefined;
    viewerVersion?: string | undefined;
    minimumPackageVersion?: string | undefined;
    releaseNotes?: string | undefined;
    order?: number;

    constructor(data?: IVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activationDate = _data["activationDate"];
            this.packageVersion = _data["packageVersion"];
            this.pmklVersion = _data["pmklVersion"];
            this.wfsVersion = _data["wfsVersion"];
            this.minimumViewerVersion = _data["minimumViewerVersion"];
            this.viewerVersion = _data["viewerVersion"];
            this.minimumPackageVersion = _data["minimumPackageVersion"];
            this.releaseNotes = _data["releaseNotes"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): VersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new VersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activationDate"] = this.activationDate;
        data["packageVersion"] = this.packageVersion;
        data["pmklVersion"] = this.pmklVersion;
        data["wfsVersion"] = this.wfsVersion;
        data["minimumViewerVersion"] = this.minimumViewerVersion;
        data["viewerVersion"] = this.viewerVersion;
        data["minimumPackageVersion"] = this.minimumPackageVersion;
        data["releaseNotes"] = this.releaseNotes;
        data["order"] = this.order;
        return data;
    }
}

export interface IVersionDto {
    id?: number;
    activationDate?: string | undefined;
    packageVersion?: string | undefined;
    pmklVersion?: string | undefined;
    wfsVersion?: string | undefined;
    minimumViewerVersion?: string | undefined;
    viewerVersion?: string | undefined;
    minimumPackageVersion?: string | undefined;
    releaseNotes?: string | undefined;
    order?: number;
}

export class AddVersionRequest implements IAddVersionRequest {
    activationDate?: string | undefined;
    packageVersion?: string | undefined;
    pmklVersion?: string | undefined;
    wfsVersion?: string | undefined;
    minimumViewerVersion?: string | undefined;
    viewerVersion?: string | undefined;
    minimumPackageVersion?: string | undefined;
    releaseNotes?: string | undefined;

    constructor(data?: IAddVersionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activationDate = _data["activationDate"];
            this.packageVersion = _data["packageVersion"];
            this.pmklVersion = _data["pmklVersion"];
            this.wfsVersion = _data["wfsVersion"];
            this.minimumViewerVersion = _data["minimumViewerVersion"];
            this.viewerVersion = _data["viewerVersion"];
            this.minimumPackageVersion = _data["minimumPackageVersion"];
            this.releaseNotes = _data["releaseNotes"];
        }
    }

    static fromJS(data: any): AddVersionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddVersionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activationDate"] = this.activationDate;
        data["packageVersion"] = this.packageVersion;
        data["pmklVersion"] = this.pmklVersion;
        data["wfsVersion"] = this.wfsVersion;
        data["minimumViewerVersion"] = this.minimumViewerVersion;
        data["viewerVersion"] = this.viewerVersion;
        data["minimumPackageVersion"] = this.minimumPackageVersion;
        data["releaseNotes"] = this.releaseNotes;
        return data;
    }
}

export interface IAddVersionRequest {
    activationDate?: string | undefined;
    packageVersion?: string | undefined;
    pmklVersion?: string | undefined;
    wfsVersion?: string | undefined;
    minimumViewerVersion?: string | undefined;
    viewerVersion?: string | undefined;
    minimumPackageVersion?: string | undefined;
    releaseNotes?: string | undefined;
}

export class EnvelopeOfIListOfPriceDto implements IEnvelopeOfIListOfPriceDto {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: PriceDto[] | undefined;

    constructor(data?: IEnvelopeOfIListOfPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(PriceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvelopeOfIListOfPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfIListOfPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnvelopeOfIListOfPriceDto {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: PriceDto[] | undefined;
}

export class EnvelopeOfIDictionaryOfIntegerAndListOfDateTime implements IEnvelopeOfIDictionaryOfIntegerAndListOfDateTime {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: { [key: string]: string[]; } | undefined;

    constructor(data?: IEnvelopeOfIDictionaryOfIntegerAndListOfDateTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (_data["result"]) {
                this.result = {} as any;
                for (let key in _data["result"]) {
                    if (_data["result"].hasOwnProperty(key))
                        (this.result as any)![key] = _data["result"][key] !== undefined ? _data["result"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): EnvelopeOfIDictionaryOfIntegerAndListOfDateTime {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfIDictionaryOfIntegerAndListOfDateTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (this.result) {
            data["result"] = {};
            for (let key in this.result) {
                if (this.result.hasOwnProperty(key))
                    (data["result"] as any)[key] = (this.result as any)[key];
            }
        }
        return data;
    }
}

export interface IEnvelopeOfIDictionaryOfIntegerAndListOfDateTime {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: { [key: string]: string[]; } | undefined;
}

export class EnvelopeOfIListOfMessageDto implements IEnvelopeOfIListOfMessageDto {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MessageDto[] | undefined;

    constructor(data?: IEnvelopeOfIListOfMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(MessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvelopeOfIListOfMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfIListOfMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnvelopeOfIListOfMessageDto {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MessageDto[] | undefined;
}

export class MessageDto implements IMessageDto {
    messageId?: number;
    type?: MessageType;
    title?: string | undefined;
    text?: string | undefined;
    startTimestamp?: string;
    endTimestamp?: string | undefined;

    constructor(data?: IMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["messageId"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.text = _data["text"];
            this.startTimestamp = _data["startTimestamp"];
            this.endTimestamp = _data["endTimestamp"];
        }
    }

    static fromJS(data: any): MessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId;
        data["type"] = this.type;
        data["title"] = this.title;
        data["text"] = this.text;
        data["startTimestamp"] = this.startTimestamp;
        data["endTimestamp"] = this.endTimestamp;
        return data;
    }
}

export interface IMessageDto {
    messageId?: number;
    type?: MessageType;
    title?: string | undefined;
    text?: string | undefined;
    startTimestamp?: string;
    endTimestamp?: string | undefined;
}

export enum MessageType {
    Announcement = 0,
    Warning = 1,
    WhatsNew = 2,
}

export class UpdateMessageRequest implements IUpdateMessageRequest {
    messageId?: number | undefined;
    type?: MessageType;
    title?: string | undefined;
    text?: string | undefined;
    startTimestamp?: string;
    endTimestamp?: string | undefined;

    constructor(data?: IUpdateMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["messageId"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.text = _data["text"];
            this.startTimestamp = _data["startTimestamp"];
            this.endTimestamp = _data["endTimestamp"];
        }
    }

    static fromJS(data: any): UpdateMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId;
        data["type"] = this.type;
        data["title"] = this.title;
        data["text"] = this.text;
        data["startTimestamp"] = this.startTimestamp;
        data["endTimestamp"] = this.endTimestamp;
        return data;
    }
}

export interface IUpdateMessageRequest {
    messageId?: number | undefined;
    type?: MessageType;
    title?: string | undefined;
    text?: string | undefined;
    startTimestamp?: string;
    endTimestamp?: string | undefined;
}

export class OrganisationSettingsInput implements IOrganisationSettingsInput {
    organisation?: Organisation | undefined;
    organisationInvoiceData?: UpdateOrganisationInvoiceDataInput | undefined;

    constructor(data?: IOrganisationSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisation = _data["organisation"] ? Organisation.fromJS(_data["organisation"]) : undefined as any;
            this.organisationInvoiceData = _data["organisationInvoiceData"] ? UpdateOrganisationInvoiceDataInput.fromJS(_data["organisationInvoiceData"]) : undefined as any;
        }
    }

    static fromJS(data: any): OrganisationSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisation"] = this.organisation ? this.organisation.toJSON() : undefined as any;
        data["organisationInvoiceData"] = this.organisationInvoiceData ? this.organisationInvoiceData.toJSON() : undefined as any;
        return data;
    }
}

export interface IOrganisationSettingsInput {
    organisation?: Organisation | undefined;
    organisationInvoiceData?: UpdateOrganisationInvoiceDataInput | undefined;
}

export class UpdateOrganisationInvoiceDataInput implements IUpdateOrganisationInvoiceDataInput {
    vatNumber?: string | undefined;
    reminderEmail?: string | undefined;
    attention?: string | undefined;
    reference?: string | undefined;

    constructor(data?: IUpdateOrganisationInvoiceDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vatNumber = _data["vatNumber"];
            this.reminderEmail = _data["reminderEmail"];
            this.attention = _data["attention"];
            this.reference = _data["reference"];
        }
    }

    static fromJS(data: any): UpdateOrganisationInvoiceDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganisationInvoiceDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vatNumber"] = this.vatNumber;
        data["reminderEmail"] = this.reminderEmail;
        data["attention"] = this.attention;
        data["reference"] = this.reference;
        return data;
    }
}

export interface IUpdateOrganisationInvoiceDataInput {
    vatNumber?: string | undefined;
    reminderEmail?: string | undefined;
    attention?: string | undefined;
    reference?: string | undefined;
}

export class OrganisationUnaSettingsInput implements IOrganisationUnaSettingsInput {
    organisationId?: string;
    displayName?: string | undefined;
    subjectSigningCertificate?: string | undefined;

    constructor(data?: IOrganisationUnaSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationId = _data["organisationId"];
            this.displayName = _data["displayName"];
            this.subjectSigningCertificate = _data["subjectSigningCertificate"];
        }
    }

    static fromJS(data: any): OrganisationUnaSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationUnaSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationId"] = this.organisationId;
        data["displayName"] = this.displayName;
        data["subjectSigningCertificate"] = this.subjectSigningCertificate;
        return data;
    }
}

export interface IOrganisationUnaSettingsInput {
    organisationId?: string;
    displayName?: string | undefined;
    subjectSigningCertificate?: string | undefined;
}

export class EnvelopeOfSettingsForOrganisationView implements IEnvelopeOfSettingsForOrganisationView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: SettingsForOrganisationView | undefined;

    constructor(data?: IEnvelopeOfSettingsForOrganisationView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? SettingsForOrganisationView.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfSettingsForOrganisationView {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfSettingsForOrganisationView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfSettingsForOrganisationView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: SettingsForOrganisationView | undefined;
}

export class SettingsForOrganisationView implements ISettingsForOrganisationView {
    organisationSetting?: OrganisationSetting | undefined;
    organisationsOverviewTable?: OrganisationDataTable[] | undefined;

    constructor(data?: ISettingsForOrganisationView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationSetting = _data["organisationSetting"] ? OrganisationSetting.fromJS(_data["organisationSetting"]) : undefined as any;
            if (Array.isArray(_data["organisationsOverviewTable"])) {
                this.organisationsOverviewTable = [] as any;
                for (let item of _data["organisationsOverviewTable"])
                    this.organisationsOverviewTable!.push(OrganisationDataTable.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SettingsForOrganisationView {
        data = typeof data === 'object' ? data : {};
        let result = new SettingsForOrganisationView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationSetting"] = this.organisationSetting ? this.organisationSetting.toJSON() : undefined as any;
        if (Array.isArray(this.organisationsOverviewTable)) {
            data["organisationsOverviewTable"] = [];
            for (let item of this.organisationsOverviewTable)
                data["organisationsOverviewTable"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISettingsForOrganisationView {
    organisationSetting?: OrganisationSetting | undefined;
    organisationsOverviewTable?: OrganisationDataTable[] | undefined;
}

export class OrganisationSetting implements IOrganisationSetting {
    organisationId?: string | undefined;
    parentOrganisationId?: string | undefined;
    name?: string | undefined;
    utilityNetworkAuthorityName?: string | undefined;
    identificators?: { [key: string]: string; } | undefined;

    constructor(data?: IOrganisationSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationId = _data["organisationId"];
            this.parentOrganisationId = _data["parentOrganisationId"];
            this.name = _data["name"];
            this.utilityNetworkAuthorityName = _data["utilityNetworkAuthorityName"];
            if (_data["identificators"]) {
                this.identificators = {} as any;
                for (let key in _data["identificators"]) {
                    if (_data["identificators"].hasOwnProperty(key))
                        (this.identificators as any)![key] = _data["identificators"][key];
                }
            }
        }
    }

    static fromJS(data: any): OrganisationSetting {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationId"] = this.organisationId;
        data["parentOrganisationId"] = this.parentOrganisationId;
        data["name"] = this.name;
        data["utilityNetworkAuthorityName"] = this.utilityNetworkAuthorityName;
        if (this.identificators) {
            data["identificators"] = {};
            for (let key in this.identificators) {
                if (this.identificators.hasOwnProperty(key))
                    (data["identificators"] as any)[key] = (this.identificators as any)[key];
            }
        }
        return data;
    }
}

export interface IOrganisationSetting {
    organisationId?: string | undefined;
    parentOrganisationId?: string | undefined;
    name?: string | undefined;
    utilityNetworkAuthorityName?: string | undefined;
    identificators?: { [key: string]: string; } | undefined;
}

export class EnvelopeOfCreateOrganisationView implements IEnvelopeOfCreateOrganisationView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: CreateOrganisationView | undefined;

    constructor(data?: IEnvelopeOfCreateOrganisationView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? CreateOrganisationView.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfCreateOrganisationView {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfCreateOrganisationView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfCreateOrganisationView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: CreateOrganisationView | undefined;
}

export class CreateOrganisationView implements ICreateOrganisationView {
    paysByInvoice?: boolean;
    subOrganisations?: SubOrganisation2[] | undefined;
    invoiceData?: OrganisationInvoiceData2 | undefined;

    constructor(data?: ICreateOrganisationView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paysByInvoice = _data["paysByInvoice"];
            if (Array.isArray(_data["subOrganisations"])) {
                this.subOrganisations = [] as any;
                for (let item of _data["subOrganisations"])
                    this.subOrganisations!.push(SubOrganisation2.fromJS(item));
            }
            this.invoiceData = _data["invoiceData"] ? OrganisationInvoiceData2.fromJS(_data["invoiceData"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateOrganisationView {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganisationView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paysByInvoice"] = this.paysByInvoice;
        if (Array.isArray(this.subOrganisations)) {
            data["subOrganisations"] = [];
            for (let item of this.subOrganisations)
                data["subOrganisations"].push(item ? item.toJSON() : undefined as any);
        }
        data["invoiceData"] = this.invoiceData ? this.invoiceData.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateOrganisationView {
    paysByInvoice?: boolean;
    subOrganisations?: SubOrganisation2[] | undefined;
    invoiceData?: OrganisationInvoiceData2 | undefined;
}

export class SubOrganisation2 implements ISubOrganisation2 {
    id?: string;
    parentId?: string;
    name?: string | undefined;
    displayName?: string | undefined;
    isUna?: boolean;
    depth?: number;
    lockedOut?: boolean;
    identificators?: { [key: string]: string; } | undefined;

    constructor(data?: ISubOrganisation2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isUna = _data["isUna"];
            this.depth = _data["depth"];
            this.lockedOut = _data["lockedOut"];
            if (_data["identificators"]) {
                this.identificators = {} as any;
                for (let key in _data["identificators"]) {
                    if (_data["identificators"].hasOwnProperty(key))
                        (this.identificators as any)![key] = _data["identificators"][key];
                }
            }
        }
    }

    static fromJS(data: any): SubOrganisation2 {
        data = typeof data === 'object' ? data : {};
        let result = new SubOrganisation2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isUna"] = this.isUna;
        data["depth"] = this.depth;
        data["lockedOut"] = this.lockedOut;
        if (this.identificators) {
            data["identificators"] = {};
            for (let key in this.identificators) {
                if (this.identificators.hasOwnProperty(key))
                    (data["identificators"] as any)[key] = (this.identificators as any)[key];
            }
        }
        return data;
    }
}

export interface ISubOrganisation2 {
    id?: string;
    parentId?: string;
    name?: string | undefined;
    displayName?: string | undefined;
    isUna?: boolean;
    depth?: number;
    lockedOut?: boolean;
    identificators?: { [key: string]: string; } | undefined;
}

export class OrganisationInvoiceData2 implements IOrganisationInvoiceData2 {
    company?: string | undefined;
    email?: string | undefined;
    reminderEmail?: string | undefined;
    attention?: string | undefined;
    reference?: string | undefined;
    vatNumber?: string | undefined;
    kboNumber?: string | undefined;
    isAthumiGatewayServiceUnavailable?: boolean;
    address?: Address | undefined;

    constructor(data?: IOrganisationInvoiceData2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"];
            this.email = _data["email"];
            this.reminderEmail = _data["reminderEmail"];
            this.attention = _data["attention"];
            this.reference = _data["reference"];
            this.vatNumber = _data["vatNumber"];
            this.kboNumber = _data["kboNumber"];
            this.isAthumiGatewayServiceUnavailable = _data["isAthumiGatewayServiceUnavailable"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : undefined as any;
        }
    }

    static fromJS(data: any): OrganisationInvoiceData2 {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationInvoiceData2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company;
        data["email"] = this.email;
        data["reminderEmail"] = this.reminderEmail;
        data["attention"] = this.attention;
        data["reference"] = this.reference;
        data["vatNumber"] = this.vatNumber;
        data["kboNumber"] = this.kboNumber;
        data["isAthumiGatewayServiceUnavailable"] = this.isAthumiGatewayServiceUnavailable;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        return data;
    }
}

export interface IOrganisationInvoiceData2 {
    company?: string | undefined;
    email?: string | undefined;
    reminderEmail?: string | undefined;
    attention?: string | undefined;
    reference?: string | undefined;
    vatNumber?: string | undefined;
    kboNumber?: string | undefined;
    isAthumiGatewayServiceUnavailable?: boolean;
    address?: Address | undefined;
}

export class EnvelopeOfEditOrganisationView implements IEnvelopeOfEditOrganisationView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: EditOrganisationView | undefined;

    constructor(data?: IEnvelopeOfEditOrganisationView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? EditOrganisationView.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfEditOrganisationView {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfEditOrganisationView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfEditOrganisationView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: EditOrganisationView | undefined;
}

export class EditOrganisationView implements IEditOrganisationView {
    organisation?: Organisation | undefined;
    unaSettings?: OrganisationUnaSettings | undefined;

    constructor(data?: IEditOrganisationView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisation = _data["organisation"] ? Organisation.fromJS(_data["organisation"]) : undefined as any;
            this.unaSettings = _data["unaSettings"] ? OrganisationUnaSettings.fromJS(_data["unaSettings"]) : undefined as any;
        }
    }

    static fromJS(data: any): EditOrganisationView {
        data = typeof data === 'object' ? data : {};
        let result = new EditOrganisationView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisation"] = this.organisation ? this.organisation.toJSON() : undefined as any;
        data["unaSettings"] = this.unaSettings ? this.unaSettings.toJSON() : undefined as any;
        return data;
    }
}

export interface IEditOrganisationView {
    organisation?: Organisation | undefined;
    unaSettings?: OrganisationUnaSettings | undefined;
}

export class OrganisationUnaSettings implements IOrganisationUnaSettings {
    organisationId?: string;
    displayName?: string | undefined;
    subjectSigningCertificate?: string | undefined;
    isUna?: boolean;

    constructor(data?: IOrganisationUnaSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationId = _data["organisationId"];
            this.displayName = _data["displayName"];
            this.subjectSigningCertificate = _data["subjectSigningCertificate"];
            this.isUna = _data["isUna"];
        }
    }

    static fromJS(data: any): OrganisationUnaSettings {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationUnaSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationId"] = this.organisationId;
        data["displayName"] = this.displayName;
        data["subjectSigningCertificate"] = this.subjectSigningCertificate;
        data["isUna"] = this.isUna;
        return data;
    }
}

export interface IOrganisationUnaSettings {
    organisationId?: string;
    displayName?: string | undefined;
    subjectSigningCertificate?: string | undefined;
    isUna?: boolean;
}

export class EnvelopeOfOrganisation implements IEnvelopeOfOrganisation {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: Organisation | undefined;

    constructor(data?: IEnvelopeOfOrganisation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? Organisation.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfOrganisation {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfOrganisation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfOrganisation {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: Organisation | undefined;
}

export class EnvelopeOfICollectionOfZoneNamespace implements IEnvelopeOfICollectionOfZoneNamespace {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ZoneNamespace[] | undefined;

    constructor(data?: IEnvelopeOfICollectionOfZoneNamespace) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(ZoneNamespace.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvelopeOfICollectionOfZoneNamespace {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfICollectionOfZoneNamespace();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnvelopeOfICollectionOfZoneNamespace {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ZoneNamespace[] | undefined;
}

export class ZoneNamespace implements IZoneNamespace {
    zoneId!: string;
    zoneGeometryActivationDate?: string | undefined;
    zoneGeometry?: string | undefined;
    zoneName?: string | undefined;
    namespace?: string | undefined;
    isKlimZone?: boolean;
    unaId?: number;
    isArchived?: boolean;

    constructor(data?: IZoneNamespace) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zoneId = _data["zoneId"];
            this.zoneGeometryActivationDate = _data["zoneGeometryActivationDate"];
            this.zoneGeometry = _data["zoneGeometry"];
            this.zoneName = _data["zoneName"];
            this.namespace = _data["namespace"];
            this.isKlimZone = _data["isKlimZone"];
            this.unaId = _data["unaId"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): ZoneNamespace {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneNamespace();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoneId"] = this.zoneId;
        data["zoneGeometryActivationDate"] = this.zoneGeometryActivationDate;
        data["zoneGeometry"] = this.zoneGeometry;
        data["zoneName"] = this.zoneName;
        data["namespace"] = this.namespace;
        data["isKlimZone"] = this.isKlimZone;
        data["unaId"] = this.unaId;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface IZoneNamespace {
    zoneId: string;
    zoneGeometryActivationDate?: string | undefined;
    zoneGeometry?: string | undefined;
    zoneName?: string | undefined;
    namespace?: string | undefined;
    isKlimZone?: boolean;
    unaId?: number;
    isArchived?: boolean;
}

export class EnvelopeOfICollectionOfOrganisation implements IEnvelopeOfICollectionOfOrganisation {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: Organisation[] | undefined;

    constructor(data?: IEnvelopeOfICollectionOfOrganisation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(Organisation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvelopeOfICollectionOfOrganisation {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfICollectionOfOrganisation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnvelopeOfICollectionOfOrganisation {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: Organisation[] | undefined;
}

export class EnvelopeOfICollectionOfOrganisationHierarchyFlatListItem implements IEnvelopeOfICollectionOfOrganisationHierarchyFlatListItem {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: OrganisationHierarchyFlatListItem[] | undefined;

    constructor(data?: IEnvelopeOfICollectionOfOrganisationHierarchyFlatListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(OrganisationHierarchyFlatListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvelopeOfICollectionOfOrganisationHierarchyFlatListItem {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfICollectionOfOrganisationHierarchyFlatListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnvelopeOfICollectionOfOrganisationHierarchyFlatListItem {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: OrganisationHierarchyFlatListItem[] | undefined;
}

export class OrganisationHierarchyFlatListItem implements IOrganisationHierarchyFlatListItem {
    organisationId!: string;
    parentId?: string | undefined;
    rootId!: string;
    name?: string | undefined;
    organisationPath?: OrganisationPath | undefined;

    constructor(data?: IOrganisationHierarchyFlatListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationId = _data["organisationId"];
            this.parentId = _data["parentId"];
            this.rootId = _data["rootId"];
            this.name = _data["name"];
            this.organisationPath = _data["organisationPath"] ? OrganisationPath.fromJS(_data["organisationPath"]) : undefined as any;
        }
    }

    static fromJS(data: any): OrganisationHierarchyFlatListItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationHierarchyFlatListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationId"] = this.organisationId;
        data["parentId"] = this.parentId;
        data["rootId"] = this.rootId;
        data["name"] = this.name;
        data["organisationPath"] = this.organisationPath ? this.organisationPath.toJSON() : undefined as any;
        return data;
    }
}

export interface IOrganisationHierarchyFlatListItem {
    organisationId: string;
    parentId?: string | undefined;
    rootId: string;
    name?: string | undefined;
    organisationPath?: OrganisationPath | undefined;
}

export class OrganisationPath implements IOrganisationPath {
    names?: string | undefined;
    ids?: string | undefined;

    constructor(data?: IOrganisationPath) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.names = _data["names"];
            this.ids = _data["ids"];
        }
    }

    static fromJS(data: any): OrganisationPath {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationPath();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["names"] = this.names;
        data["ids"] = this.ids;
        return data;
    }
}

export interface IOrganisationPath {
    names?: string | undefined;
    ids?: string | undefined;
}

export class EnvelopeOfShoppingCartStatus implements IEnvelopeOfShoppingCartStatus {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ShoppingCartStatus | undefined;

    constructor(data?: IEnvelopeOfShoppingCartStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? ShoppingCartStatus.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfShoppingCartStatus {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfShoppingCartStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfShoppingCartStatus {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ShoppingCartStatus | undefined;
}

export class ShoppingCartStatus implements IShoppingCartStatus {
    status?: string | undefined;
    paymentLink?: string | undefined;

    constructor(data?: IShoppingCartStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.paymentLink = _data["paymentLink"];
        }
    }

    static fromJS(data: any): ShoppingCartStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingCartStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["paymentLink"] = this.paymentLink;
        return data;
    }
}

export interface IShoppingCartStatus {
    status?: string | undefined;
    paymentLink?: string | undefined;
}

export class EnvelopeOfPrepaidAmount implements IEnvelopeOfPrepaidAmount {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: PrepaidAmount | undefined;

    constructor(data?: IEnvelopeOfPrepaidAmount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? PrepaidAmount.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfPrepaidAmount {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfPrepaidAmount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfPrepaidAmount {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: PrepaidAmount | undefined;
}

export class PrepaidAmount implements IPrepaidAmount {
    amount?: number | undefined;
    financialServiceAvailable?: boolean;

    constructor(data?: IPrepaidAmount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.financialServiceAvailable = _data["financialServiceAvailable"];
        }
    }

    static fromJS(data: any): PrepaidAmount {
        data = typeof data === 'object' ? data : {};
        let result = new PrepaidAmount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["financialServiceAvailable"] = this.financialServiceAvailable;
        return data;
    }
}

export interface IPrepaidAmount {
    amount?: number | undefined;
    financialServiceAvailable?: boolean;
}

export class EnvelopeOfGetCurrentShoppingCartResult implements IEnvelopeOfGetCurrentShoppingCartResult {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: GetCurrentShoppingCartResult | undefined;

    constructor(data?: IEnvelopeOfGetCurrentShoppingCartResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? GetCurrentShoppingCartResult.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfGetCurrentShoppingCartResult {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfGetCurrentShoppingCartResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfGetCurrentShoppingCartResult {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: GetCurrentShoppingCartResult | undefined;
}

export class GetCurrentShoppingCartResult implements IGetCurrentShoppingCartResult {
    mapRequests?: MapRequest2[] | undefined;
    mapRequestExtras?: MapRequestExtra[] | undefined;

    constructor(data?: IGetCurrentShoppingCartResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["MapRequests"])) {
                this.mapRequests = [] as any;
                for (let item of _data["MapRequests"])
                    this.mapRequests!.push(MapRequest2.fromJS(item));
            }
            if (Array.isArray(_data["MapRequestExtras"])) {
                this.mapRequestExtras = [] as any;
                for (let item of _data["MapRequestExtras"])
                    this.mapRequestExtras!.push(MapRequestExtra.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCurrentShoppingCartResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentShoppingCartResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mapRequests)) {
            data["MapRequests"] = [];
            for (let item of this.mapRequests)
                data["MapRequests"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.mapRequestExtras)) {
            data["MapRequestExtras"] = [];
            for (let item of this.mapRequestExtras)
                data["MapRequestExtras"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetCurrentShoppingCartResult {
    mapRequests?: MapRequest2[] | undefined;
    mapRequestExtras?: MapRequestExtra[] | undefined;
}

export class MapRequest2 implements IMapRequest2 {
    id?: string;
    reference?: string | undefined;
    price?: number;
    expired?: boolean;
    dateReceived?: string;

    constructor(data?: IMapRequest2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.reference = _data["Reference"];
            this.price = _data["Price"];
            this.expired = _data["Expired"];
            this.dateReceived = _data["DateReceived"];
        }
    }

    static fromJS(data: any): MapRequest2 {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequest2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Reference"] = this.reference;
        data["Price"] = this.price;
        data["Expired"] = this.expired;
        data["DateReceived"] = this.dateReceived;
        return data;
    }
}

export interface IMapRequest2 {
    id?: string;
    reference?: string | undefined;
    price?: number;
    expired?: boolean;
    dateReceived?: string;
}

export class MapRequestExtra implements IMapRequestExtra {
    mapRequestId?: string;
    reference?: string | undefined;
    price?: number;
    dateReceived?: string;
    alreadyPaid?: boolean;

    constructor(data?: IMapRequestExtra) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestId = _data["MapRequestId"];
            this.reference = _data["Reference"];
            this.price = _data["Price"];
            this.dateReceived = _data["DateReceived"];
            this.alreadyPaid = _data["AlreadyPaid"];
        }
    }

    static fromJS(data: any): MapRequestExtra {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestExtra();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MapRequestId"] = this.mapRequestId;
        data["Reference"] = this.reference;
        data["Price"] = this.price;
        data["DateReceived"] = this.dateReceived;
        data["AlreadyPaid"] = this.alreadyPaid;
        return data;
    }
}

export interface IMapRequestExtra {
    mapRequestId?: string;
    reference?: string | undefined;
    price?: number;
    dateReceived?: string;
    alreadyPaid?: boolean;
}

export class EnvelopeOfDictionaryOfStringAndString implements IEnvelopeOfDictionaryOfStringAndString {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: { [key: string]: string; } | undefined;

    constructor(data?: IEnvelopeOfDictionaryOfStringAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (_data["result"]) {
                this.result = {} as any;
                for (let key in _data["result"]) {
                    if (_data["result"].hasOwnProperty(key))
                        (this.result as any)![key] = _data["result"][key];
                }
            }
        }
    }

    static fromJS(data: any): EnvelopeOfDictionaryOfStringAndString {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfDictionaryOfStringAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (this.result) {
            data["result"] = {};
            for (let key in this.result) {
                if (this.result.hasOwnProperty(key))
                    (data["result"] as any)[key] = (this.result as any)[key];
            }
        }
        return data;
    }
}

export interface IEnvelopeOfDictionaryOfStringAndString {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: { [key: string]: string; } | undefined;
}

export class CheckoutInput implements ICheckoutInput {
    invoiceData?: AddressInput | undefined;
    companyInvoiceData?: CompanyInvoiceData | undefined;
    primaryEmail?: string | undefined;
    secondaryEmail?: string | undefined;
    ownReference?: string | undefined;
    sendCopyToEmail?: boolean;
    checkoutType?: CheckoutType;
    paymentMethod?: CheckoutPaymentMethod;
    prepaidAmount?: number | undefined;
    callbackUrl?: string | undefined;

    constructor(data?: ICheckoutInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceData = _data["invoiceData"] ? AddressInput.fromJS(_data["invoiceData"]) : undefined as any;
            this.companyInvoiceData = _data["companyInvoiceData"] ? CompanyInvoiceData.fromJS(_data["companyInvoiceData"]) : undefined as any;
            this.primaryEmail = _data["primaryEmail"];
            this.secondaryEmail = _data["secondaryEmail"];
            this.ownReference = _data["ownReference"];
            this.sendCopyToEmail = _data["sendCopyToEmail"];
            this.checkoutType = _data["checkoutType"];
            this.paymentMethod = _data["paymentMethod"];
            this.prepaidAmount = _data["prepaidAmount"];
            this.callbackUrl = _data["callbackUrl"];
        }
    }

    static fromJS(data: any): CheckoutInput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceData"] = this.invoiceData ? this.invoiceData.toJSON() : undefined as any;
        data["companyInvoiceData"] = this.companyInvoiceData ? this.companyInvoiceData.toJSON() : undefined as any;
        data["primaryEmail"] = this.primaryEmail;
        data["secondaryEmail"] = this.secondaryEmail;
        data["ownReference"] = this.ownReference;
        data["sendCopyToEmail"] = this.sendCopyToEmail;
        data["checkoutType"] = this.checkoutType;
        data["paymentMethod"] = this.paymentMethod;
        data["prepaidAmount"] = this.prepaidAmount;
        data["callbackUrl"] = this.callbackUrl;
        return data;
    }
}

export interface ICheckoutInput {
    invoiceData?: AddressInput | undefined;
    companyInvoiceData?: CompanyInvoiceData | undefined;
    primaryEmail?: string | undefined;
    secondaryEmail?: string | undefined;
    ownReference?: string | undefined;
    sendCopyToEmail?: boolean;
    checkoutType?: CheckoutType;
    paymentMethod?: CheckoutPaymentMethod;
    prepaidAmount?: number | undefined;
    callbackUrl?: string | undefined;
}

export class CompanyInvoiceData implements ICompanyInvoiceData {
    organisation?: string | undefined;
    vatNumber?: string | undefined;
    attention?: string | undefined;

    constructor(data?: ICompanyInvoiceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisation = _data["organisation"];
            this.vatNumber = _data["vatNumber"];
            this.attention = _data["attention"];
        }
    }

    static fromJS(data: any): CompanyInvoiceData {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyInvoiceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisation"] = this.organisation;
        data["vatNumber"] = this.vatNumber;
        data["attention"] = this.attention;
        return data;
    }
}

export interface ICompanyInvoiceData {
    organisation?: string | undefined;
    vatNumber?: string | undefined;
    attention?: string | undefined;
}

export enum CheckoutType {
    ShoppingCart = 0,
    TopUpPrepaid = 1,
}

export enum CheckoutPaymentMethod {
    PayByCard = 0,
    PayByPrepaid = 1,
}

export class EnvelopeOfShoppingCartViewModel implements IEnvelopeOfShoppingCartViewModel {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ShoppingCartViewModel | undefined;

    constructor(data?: IEnvelopeOfShoppingCartViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? ShoppingCartViewModel.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfShoppingCartViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfShoppingCartViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfShoppingCartViewModel {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ShoppingCartViewModel | undefined;
}

export class ShoppingCartViewModel implements IShoppingCartViewModel {
    mapRequests?: ShoppingCartMapRequest[] | undefined;
    mapRequestExtras?: ShoppingCartMapRequestExtra[] | undefined;
    totalPriceExclVat?: number;
    vatPercentage?: number | undefined;
    totalVat?: number | undefined;
    totalPriceInclVat?: number | undefined;
    totalPriceExclVatFormatted?: string | undefined;
    totalVatFormatted?: string | undefined;
    totalPriceInclVatFormatted?: string | undefined;
    paysByInvoice?: boolean;

    constructor(data?: IShoppingCartViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mapRequests"])) {
                this.mapRequests = [] as any;
                for (let item of _data["mapRequests"])
                    this.mapRequests!.push(ShoppingCartMapRequest.fromJS(item));
            }
            if (Array.isArray(_data["mapRequestExtras"])) {
                this.mapRequestExtras = [] as any;
                for (let item of _data["mapRequestExtras"])
                    this.mapRequestExtras!.push(ShoppingCartMapRequestExtra.fromJS(item));
            }
            this.totalPriceExclVat = _data["totalPriceExclVat"];
            this.vatPercentage = _data["vatPercentage"];
            this.totalVat = _data["totalVat"];
            this.totalPriceInclVat = _data["totalPriceInclVat"];
            this.totalPriceExclVatFormatted = _data["totalPriceExclVatFormatted"];
            this.totalVatFormatted = _data["totalVatFormatted"];
            this.totalPriceInclVatFormatted = _data["totalPriceInclVatFormatted"];
            this.paysByInvoice = _data["paysByInvoice"];
        }
    }

    static fromJS(data: any): ShoppingCartViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingCartViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mapRequests)) {
            data["mapRequests"] = [];
            for (let item of this.mapRequests)
                data["mapRequests"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.mapRequestExtras)) {
            data["mapRequestExtras"] = [];
            for (let item of this.mapRequestExtras)
                data["mapRequestExtras"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalPriceExclVat"] = this.totalPriceExclVat;
        data["vatPercentage"] = this.vatPercentage;
        data["totalVat"] = this.totalVat;
        data["totalPriceInclVat"] = this.totalPriceInclVat;
        data["totalPriceExclVatFormatted"] = this.totalPriceExclVatFormatted;
        data["totalVatFormatted"] = this.totalVatFormatted;
        data["totalPriceInclVatFormatted"] = this.totalPriceInclVatFormatted;
        data["paysByInvoice"] = this.paysByInvoice;
        return data;
    }
}

export interface IShoppingCartViewModel {
    mapRequests?: ShoppingCartMapRequest[] | undefined;
    mapRequestExtras?: ShoppingCartMapRequestExtra[] | undefined;
    totalPriceExclVat?: number;
    vatPercentage?: number | undefined;
    totalVat?: number | undefined;
    totalPriceInclVat?: number | undefined;
    totalPriceExclVatFormatted?: string | undefined;
    totalVatFormatted?: string | undefined;
    totalPriceInclVatFormatted?: string | undefined;
    paysByInvoice?: boolean;
}

export class ShoppingCartMapRequest implements IShoppingCartMapRequest {
    id?: string;
    reference?: string | undefined;
    price?: number;
    priceFormatted?: string | undefined;
    isExpired?: boolean;
    dateReceived?: string;
    organisation?: string | undefined;

    constructor(data?: IShoppingCartMapRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reference = _data["reference"];
            this.price = _data["price"];
            this.priceFormatted = _data["priceFormatted"];
            this.isExpired = _data["isExpired"];
            this.dateReceived = _data["dateReceived"];
            this.organisation = _data["organisation"];
        }
    }

    static fromJS(data: any): ShoppingCartMapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingCartMapRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reference"] = this.reference;
        data["price"] = this.price;
        data["priceFormatted"] = this.priceFormatted;
        data["isExpired"] = this.isExpired;
        data["dateReceived"] = this.dateReceived;
        data["organisation"] = this.organisation;
        return data;
    }
}

export interface IShoppingCartMapRequest {
    id?: string;
    reference?: string | undefined;
    price?: number;
    priceFormatted?: string | undefined;
    isExpired?: boolean;
    dateReceived?: string;
    organisation?: string | undefined;
}

export class ShoppingCartMapRequestExtra implements IShoppingCartMapRequestExtra {
    id?: number;
    mapRequestId?: string;
    reference?: string | undefined;
    price?: number;
    priceFormatted?: string | undefined;
    dateReceived?: string;
    isAlreadyPaid?: boolean;
    organisation?: string | undefined;

    constructor(data?: IShoppingCartMapRequestExtra) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mapRequestId = _data["mapRequestId"];
            this.reference = _data["reference"];
            this.price = _data["price"];
            this.priceFormatted = _data["priceFormatted"];
            this.dateReceived = _data["dateReceived"];
            this.isAlreadyPaid = _data["isAlreadyPaid"];
            this.organisation = _data["organisation"];
        }
    }

    static fromJS(data: any): ShoppingCartMapRequestExtra {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingCartMapRequestExtra();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mapRequestId"] = this.mapRequestId;
        data["reference"] = this.reference;
        data["price"] = this.price;
        data["priceFormatted"] = this.priceFormatted;
        data["dateReceived"] = this.dateReceived;
        data["isAlreadyPaid"] = this.isAlreadyPaid;
        data["organisation"] = this.organisation;
        return data;
    }
}

export interface IShoppingCartMapRequestExtra {
    id?: number;
    mapRequestId?: string;
    reference?: string | undefined;
    price?: number;
    priceFormatted?: string | undefined;
    dateReceived?: string;
    isAlreadyPaid?: boolean;
    organisation?: string | undefined;
}

export class EnvelopeOfShoppingCartCheckoutViewModel implements IEnvelopeOfShoppingCartCheckoutViewModel {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ShoppingCartCheckoutViewModel | undefined;

    constructor(data?: IEnvelopeOfShoppingCartCheckoutViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? ShoppingCartCheckoutViewModel.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfShoppingCartCheckoutViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfShoppingCartCheckoutViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfShoppingCartCheckoutViewModel {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ShoppingCartCheckoutViewModel | undefined;
}

export class ShoppingCartCheckoutViewModel implements IShoppingCartCheckoutViewModel {
    totalPrice?: number;
    prepaidData?: PrepaidData | undefined;
    isAllowedToCheckout?: boolean;
    actor?: Actor | undefined;
    actorServiceAvailable?: boolean;
    financialServiceAvailable?: boolean;

    constructor(data?: IShoppingCartCheckoutViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPrice = _data["totalPrice"];
            this.prepaidData = _data["prepaidData"] ? PrepaidData.fromJS(_data["prepaidData"]) : undefined as any;
            this.isAllowedToCheckout = _data["isAllowedToCheckout"];
            this.actor = _data["actor"] ? Actor.fromJS(_data["actor"]) : undefined as any;
            this.actorServiceAvailable = _data["actorServiceAvailable"];
            this.financialServiceAvailable = _data["financialServiceAvailable"];
        }
    }

    static fromJS(data: any): ShoppingCartCheckoutViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingCartCheckoutViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPrice"] = this.totalPrice;
        data["prepaidData"] = this.prepaidData ? this.prepaidData.toJSON() : undefined as any;
        data["isAllowedToCheckout"] = this.isAllowedToCheckout;
        data["actor"] = this.actor ? this.actor.toJSON() : undefined as any;
        data["actorServiceAvailable"] = this.actorServiceAvailable;
        data["financialServiceAvailable"] = this.financialServiceAvailable;
        return data;
    }
}

export interface IShoppingCartCheckoutViewModel {
    totalPrice?: number;
    prepaidData?: PrepaidData | undefined;
    isAllowedToCheckout?: boolean;
    actor?: Actor | undefined;
    actorServiceAvailable?: boolean;
    financialServiceAvailable?: boolean;
}

export class PrepaidData implements IPrepaidData {
    amount?: number;
    isPrepaidUploaded?: boolean;

    constructor(data?: IPrepaidData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.isPrepaidUploaded = _data["isPrepaidUploaded"];
        }
    }

    static fromJS(data: any): PrepaidData {
        data = typeof data === 'object' ? data : {};
        let result = new PrepaidData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["isPrepaidUploaded"] = this.isPrepaidUploaded;
        return data;
    }
}

export interface IPrepaidData {
    amount?: number;
    isPrepaidUploaded?: boolean;
}

export class Actor implements IActor {
    id?: string;
    invoiceEmail?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    name?: string | undefined;
    vatNumber?: string | undefined;
    countryCode?: string | undefined;
    country?: string | undefined;
    street?: string | undefined;
    streetNumber?: string | undefined;
    box?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    failedLoadingActor?: boolean;

    constructor(data?: IActor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceEmail = _data["invoiceEmail"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.name = _data["name"];
            this.vatNumber = _data["vatNumber"];
            this.countryCode = _data["countryCode"];
            this.country = _data["country"];
            this.street = _data["street"];
            this.streetNumber = _data["streetNumber"];
            this.box = _data["box"];
            this.zip = _data["zip"];
            this.city = _data["city"];
            this.failedLoadingActor = _data["failedLoadingActor"];
        }
    }

    static fromJS(data: any): Actor {
        data = typeof data === 'object' ? data : {};
        let result = new Actor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceEmail"] = this.invoiceEmail;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["name"] = this.name;
        data["vatNumber"] = this.vatNumber;
        data["countryCode"] = this.countryCode;
        data["country"] = this.country;
        data["street"] = this.street;
        data["streetNumber"] = this.streetNumber;
        data["box"] = this.box;
        data["zip"] = this.zip;
        data["city"] = this.city;
        data["failedLoadingActor"] = this.failedLoadingActor;
        return data;
    }
}

export interface IActor {
    id?: string;
    invoiceEmail?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    name?: string | undefined;
    vatNumber?: string | undefined;
    countryCode?: string | undefined;
    country?: string | undefined;
    street?: string | undefined;
    streetNumber?: string | undefined;
    box?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    failedLoadingActor?: boolean;
}

export class EnvelopeOfPrepaidCheckoutViewModel implements IEnvelopeOfPrepaidCheckoutViewModel {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: PrepaidCheckoutViewModel | undefined;

    constructor(data?: IEnvelopeOfPrepaidCheckoutViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? PrepaidCheckoutViewModel.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfPrepaidCheckoutViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfPrepaidCheckoutViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfPrepaidCheckoutViewModel {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: PrepaidCheckoutViewModel | undefined;
}

export class PrepaidCheckoutViewModel implements IPrepaidCheckoutViewModel {
    actor?: Actor | undefined;
    actorServiceAvailable?: boolean;

    constructor(data?: IPrepaidCheckoutViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actor = _data["actor"] ? Actor.fromJS(_data["actor"]) : undefined as any;
            this.actorServiceAvailable = _data["actorServiceAvailable"];
        }
    }

    static fromJS(data: any): PrepaidCheckoutViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PrepaidCheckoutViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actor"] = this.actor ? this.actor.toJSON() : undefined as any;
        data["actorServiceAvailable"] = this.actorServiceAvailable;
        return data;
    }
}

export interface IPrepaidCheckoutViewModel {
    actor?: Actor | undefined;
    actorServiceAvailable?: boolean;
}

export class EnvelopeOfPrepaidViewModel implements IEnvelopeOfPrepaidViewModel {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: PrepaidViewModel | undefined;

    constructor(data?: IEnvelopeOfPrepaidViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? PrepaidViewModel.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfPrepaidViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfPrepaidViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfPrepaidViewModel {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: PrepaidViewModel | undefined;
}

export class PrepaidViewModel implements IPrepaidViewModel {
    isUnavailable?: boolean;
    amount?: number;
    isPrepaidUploaded?: boolean;
    hasFailedPayment?: boolean;

    constructor(data?: IPrepaidViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isUnavailable = _data["isUnavailable"];
            this.amount = _data["amount"];
            this.isPrepaidUploaded = _data["isPrepaidUploaded"];
            this.hasFailedPayment = _data["hasFailedPayment"];
        }
    }

    static fromJS(data: any): PrepaidViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PrepaidViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isUnavailable"] = this.isUnavailable;
        data["amount"] = this.amount;
        data["isPrepaidUploaded"] = this.isPrepaidUploaded;
        data["hasFailedPayment"] = this.hasFailedPayment;
        return data;
    }
}

export interface IPrepaidViewModel {
    isUnavailable?: boolean;
    amount?: number;
    isPrepaidUploaded?: boolean;
    hasFailedPayment?: boolean;
}

export class EnvelopeOfPriceDto implements IEnvelopeOfPriceDto {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: PriceDto | undefined;

    constructor(data?: IEnvelopeOfPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? PriceDto.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfPriceDto {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: PriceDto | undefined;
}

export class EnvelopeOfShoppingCartPaymentStatusResult implements IEnvelopeOfShoppingCartPaymentStatusResult {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ShoppingCartPaymentStatusResult | undefined;

    constructor(data?: IEnvelopeOfShoppingCartPaymentStatusResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? ShoppingCartPaymentStatusResult.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfShoppingCartPaymentStatusResult {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfShoppingCartPaymentStatusResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfShoppingCartPaymentStatusResult {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ShoppingCartPaymentStatusResult | undefined;
}

export class ShoppingCartPaymentStatusResult implements IShoppingCartPaymentStatusResult {
    id?: string;
    status?: ShoppingCartPaymentStatus;
    numberOfMapRequests?: number;
    numberOfIndividualMapRequestExtras?: number;
    mapRequestsWithImklDataIncluded?: boolean;

    constructor(data?: IShoppingCartPaymentStatusResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.numberOfMapRequests = _data["numberOfMapRequests"];
            this.numberOfIndividualMapRequestExtras = _data["numberOfIndividualMapRequestExtras"];
            this.mapRequestsWithImklDataIncluded = _data["mapRequestsWithImklDataIncluded"];
        }
    }

    static fromJS(data: any): ShoppingCartPaymentStatusResult {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingCartPaymentStatusResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["numberOfMapRequests"] = this.numberOfMapRequests;
        data["numberOfIndividualMapRequestExtras"] = this.numberOfIndividualMapRequestExtras;
        data["mapRequestsWithImklDataIncluded"] = this.mapRequestsWithImklDataIncluded;
        return data;
    }
}

export interface IShoppingCartPaymentStatusResult {
    id?: string;
    status?: ShoppingCartPaymentStatus;
    numberOfMapRequests?: number;
    numberOfIndividualMapRequestExtras?: number;
    mapRequestsWithImklDataIncluded?: boolean;
}

export enum ShoppingCartPaymentStatus {
    Pending = 0,
    Paid = 1,
    Error = 2,
}

export class EnvelopeOfZoneDetails implements IEnvelopeOfZoneDetails {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ZoneDetails | undefined;

    constructor(data?: IEnvelopeOfZoneDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? ZoneDetails.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfZoneDetails {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfZoneDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfZoneDetails {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ZoneDetails | undefined;
}

export class ZoneDetails implements IZoneDetails {
    id?: string | undefined;
    organisationId?: string;
    organisation?: string | undefined;
    name?: string | undefined;
    wkt?: string | undefined;
    downloadUrls?: DownloadUrl[] | undefined;

    constructor(data?: IZoneDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organisationId = _data["organisationId"];
            this.organisation = _data["organisation"];
            this.name = _data["name"];
            this.wkt = _data["wkt"];
            if (Array.isArray(_data["downloadUrls"])) {
                this.downloadUrls = [] as any;
                for (let item of _data["downloadUrls"])
                    this.downloadUrls!.push(DownloadUrl.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ZoneDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organisationId"] = this.organisationId;
        data["organisation"] = this.organisation;
        data["name"] = this.name;
        data["wkt"] = this.wkt;
        if (Array.isArray(this.downloadUrls)) {
            data["downloadUrls"] = [];
            for (let item of this.downloadUrls)
                data["downloadUrls"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IZoneDetails {
    id?: string | undefined;
    organisationId?: string;
    organisation?: string | undefined;
    name?: string | undefined;
    wkt?: string | undefined;
    downloadUrls?: DownloadUrl[] | undefined;
}

export class NewZone implements INewZone {
    name?: string | undefined;
    wkt?: string | undefined;

    constructor(data?: INewZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.wkt = _data["wkt"];
        }
    }

    static fromJS(data: any): NewZone {
        data = typeof data === 'object' ? data : {};
        let result = new NewZone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["wkt"] = this.wkt;
        return data;
    }
}

export interface INewZone {
    name?: string | undefined;
    wkt?: string | undefined;
}

export class UpdateZone implements IUpdateZone {
    id?: string;
    name?: string | undefined;
    wkt?: string | undefined;

    constructor(data?: IUpdateZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.wkt = _data["wkt"];
        }
    }

    static fromJS(data: any): UpdateZone {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateZone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["wkt"] = this.wkt;
        return data;
    }
}

export interface IUpdateZone {
    id?: string;
    name?: string | undefined;
    wkt?: string | undefined;
}

export class EnvelopeOfIListOfUnaZoneListItem implements IEnvelopeOfIListOfUnaZoneListItem {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: UnaZoneListItem[] | undefined;

    constructor(data?: IEnvelopeOfIListOfUnaZoneListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(UnaZoneListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvelopeOfIListOfUnaZoneListItem {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfIListOfUnaZoneListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnvelopeOfIListOfUnaZoneListItem {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: UnaZoneListItem[] | undefined;
}

export class UnaZoneListItem implements IUnaZoneListItem {
    name?: string | undefined;
    zoneName?: string | undefined;
    extraInformation?: string | undefined;
    contactName?: string | undefined;
    contactTelephone?: string | undefined;
    contactEmail?: string | undefined;
    alarmCentralTelephone?: string | undefined;
    isKlimZone?: boolean;
    zoneId?: string;

    constructor(data?: IUnaZoneListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.zoneName = _data["zoneName"];
            this.extraInformation = _data["extraInformation"];
            this.contactName = _data["contactName"];
            this.contactTelephone = _data["contactTelephone"];
            this.contactEmail = _data["contactEmail"];
            this.alarmCentralTelephone = _data["alarmCentralTelephone"];
            this.isKlimZone = _data["isKlimZone"];
            this.zoneId = _data["zoneId"];
        }
    }

    static fromJS(data: any): UnaZoneListItem {
        data = typeof data === 'object' ? data : {};
        let result = new UnaZoneListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["zoneName"] = this.zoneName;
        data["extraInformation"] = this.extraInformation;
        data["contactName"] = this.contactName;
        data["contactTelephone"] = this.contactTelephone;
        data["contactEmail"] = this.contactEmail;
        data["alarmCentralTelephone"] = this.alarmCentralTelephone;
        data["isKlimZone"] = this.isKlimZone;
        data["zoneId"] = this.zoneId;
        return data;
    }
}

export interface IUnaZoneListItem {
    name?: string | undefined;
    zoneName?: string | undefined;
    extraInformation?: string | undefined;
    contactName?: string | undefined;
    contactTelephone?: string | undefined;
    contactEmail?: string | undefined;
    alarmCentralTelephone?: string | undefined;
    isKlimZone?: boolean;
    zoneId?: string;
}

export class EnvelopeOfIListOfMapRequestListItem implements IEnvelopeOfIListOfMapRequestListItem {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestListItem4[] | undefined;

    constructor(data?: IEnvelopeOfIListOfMapRequestListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(MapRequestListItem4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvelopeOfIListOfMapRequestListItem {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfIListOfMapRequestListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnvelopeOfIListOfMapRequestListItem {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestListItem4[] | undefined;
}

export class MapRequestListItem4 implements IMapRequestListItem4 {
    mapRequestId?: string;
    pdaZoneId?: string;
    zoneName?: string | undefined;
    reference?: string | undefined;
    dateReceived?: string;
    requestor?: string | undefined;

    constructor(data?: IMapRequestListItem4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestId = _data["mapRequestId"];
            this.pdaZoneId = _data["pdaZoneId"];
            this.zoneName = _data["zoneName"];
            this.reference = _data["reference"];
            this.dateReceived = _data["dateReceived"];
            this.requestor = _data["requestor"];
        }
    }

    static fromJS(data: any): MapRequestListItem4 {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestListItem4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestId"] = this.mapRequestId;
        data["pdaZoneId"] = this.pdaZoneId;
        data["zoneName"] = this.zoneName;
        data["reference"] = this.reference;
        data["dateReceived"] = this.dateReceived;
        data["requestor"] = this.requestor;
        return data;
    }
}

export interface IMapRequestListItem4 {
    mapRequestId?: string;
    pdaZoneId?: string;
    zoneName?: string | undefined;
    reference?: string | undefined;
    dateReceived?: string;
    requestor?: string | undefined;
}

export class GetPdaMapRequestsInput implements IGetPdaMapRequestsInput {
    query?: string | undefined;
    searchField?: SearchField;
    zoneId?: string;
    parentOrganisationId?: string;
    startDate?: string | undefined;
    endDate?: string | undefined;
    dateType?: string | undefined;
    zoneGeometry?: string | undefined;
    zoneWkt?: string | undefined;
    orderDirection?: OrderDirection;
    orderField?: OrderField2;
    offset?: number | undefined;
    limit?: number | undefined;

    constructor(data?: IGetPdaMapRequestsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"];
            this.searchField = _data["searchField"];
            this.zoneId = _data["zoneId"];
            this.parentOrganisationId = _data["parentOrganisationId"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.dateType = _data["dateType"];
            this.zoneGeometry = _data["zoneGeometry"];
            this.zoneWkt = _data["zoneWkt"];
            this.orderDirection = _data["orderDirection"];
            this.orderField = _data["orderField"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): GetPdaMapRequestsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPdaMapRequestsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        data["searchField"] = this.searchField;
        data["zoneId"] = this.zoneId;
        data["parentOrganisationId"] = this.parentOrganisationId;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["dateType"] = this.dateType;
        data["zoneGeometry"] = this.zoneGeometry;
        data["zoneWkt"] = this.zoneWkt;
        data["orderDirection"] = this.orderDirection;
        data["orderField"] = this.orderField;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IGetPdaMapRequestsInput {
    query?: string | undefined;
    searchField?: SearchField;
    zoneId?: string;
    parentOrganisationId?: string;
    startDate?: string | undefined;
    endDate?: string | undefined;
    dateType?: string | undefined;
    zoneGeometry?: string | undefined;
    zoneWkt?: string | undefined;
    orderDirection?: OrderDirection;
    orderField?: OrderField2;
    offset?: number | undefined;
    limit?: number | undefined;
}

export enum OrderField2 {
    ZoneName = 0,
    Requestor = 1,
    DateReceived = 2,
    Reference = 3,
}

export class EnvelopeOfZoneDetailView implements IEnvelopeOfZoneDetailView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ZoneDetailView | undefined;

    constructor(data?: IEnvelopeOfZoneDetailView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? ZoneDetailView.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfZoneDetailView {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfZoneDetailView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfZoneDetailView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ZoneDetailView | undefined;
}

export class ZoneDetailView implements IZoneDetailView {
    zoneDetails?: ZoneDetails | undefined;
    getPdaMapRequestsInput?: GetPdaMapRequestsInput | undefined;
    searchFields?: CodeListValueOrder[] | undefined;
    mapRequestColumns?: Column[] | undefined;

    constructor(data?: IZoneDetailView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zoneDetails = _data["zoneDetails"] ? ZoneDetails.fromJS(_data["zoneDetails"]) : undefined as any;
            this.getPdaMapRequestsInput = _data["getPdaMapRequestsInput"] ? GetPdaMapRequestsInput.fromJS(_data["getPdaMapRequestsInput"]) : undefined as any;
            if (Array.isArray(_data["searchFields"])) {
                this.searchFields = [] as any;
                for (let item of _data["searchFields"])
                    this.searchFields!.push(CodeListValueOrder.fromJS(item));
            }
            if (Array.isArray(_data["mapRequestColumns"])) {
                this.mapRequestColumns = [] as any;
                for (let item of _data["mapRequestColumns"])
                    this.mapRequestColumns!.push(Column.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ZoneDetailView {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDetailView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoneDetails"] = this.zoneDetails ? this.zoneDetails.toJSON() : undefined as any;
        data["getPdaMapRequestsInput"] = this.getPdaMapRequestsInput ? this.getPdaMapRequestsInput.toJSON() : undefined as any;
        if (Array.isArray(this.searchFields)) {
            data["searchFields"] = [];
            for (let item of this.searchFields)
                data["searchFields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.mapRequestColumns)) {
            data["mapRequestColumns"] = [];
            for (let item of this.mapRequestColumns)
                data["mapRequestColumns"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IZoneDetailView {
    zoneDetails?: ZoneDetails | undefined;
    getPdaMapRequestsInput?: GetPdaMapRequestsInput | undefined;
    searchFields?: CodeListValueOrder[] | undefined;
    mapRequestColumns?: Column[] | undefined;
}

export class EnvelopeOfMapRequestViewPda implements IEnvelopeOfMapRequestViewPda {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestViewPda | undefined;

    constructor(data?: IEnvelopeOfMapRequestViewPda) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? MapRequestViewPda.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfMapRequestViewPda {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfMapRequestViewPda();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfMapRequestViewPda {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestViewPda | undefined;
}

export class MapRequestViewPda implements IMapRequestViewPda {
    mapRequest?: MapRequest3 | undefined;
    responders?: UnaContactCardData[] | undefined;

    constructor(data?: IMapRequestViewPda) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequest = _data["mapRequest"] ? MapRequest3.fromJS(_data["mapRequest"]) : undefined as any;
            if (Array.isArray(_data["responders"])) {
                this.responders = [] as any;
                for (let item of _data["responders"])
                    this.responders!.push(UnaContactCardData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MapRequestViewPda {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestViewPda();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequest"] = this.mapRequest ? this.mapRequest.toJSON() : undefined as any;
        if (Array.isArray(this.responders)) {
            data["responders"] = [];
            for (let item of this.responders)
                data["responders"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMapRequestViewPda {
    mapRequest?: MapRequest3 | undefined;
    responders?: UnaContactCardData[] | undefined;
}

export class MapRequest3 implements IMapRequest3 {
    reference?: string | undefined;
    dateReceived?: string;
    startDate?: string;
    endDate?: string;
    mapRequestType?: string | undefined;
    excavationType?: string | undefined;
    excavationMethod?: string | undefined;
    excavationLocation?: string | undefined;
    excavationDescription?: string | undefined;
    excavationDepth?: number;
    zoneGeometry?: any | undefined;
    status?: MapRequestDetailStatus;
    respondersStatusMessage?: string | undefined;
    mapRequestInitiator?: MapRequestInitiatorContactData | undefined;
    isProfessional?: boolean;

    constructor(data?: IMapRequest3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reference = _data["reference"];
            this.dateReceived = _data["dateReceived"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.mapRequestType = _data["mapRequestType"];
            this.excavationType = _data["excavationType"];
            this.excavationMethod = _data["excavationMethod"];
            this.excavationLocation = _data["excavationLocation"];
            this.excavationDescription = _data["excavationDescription"];
            this.excavationDepth = _data["excavationDepth"];
            this.zoneGeometry = _data["zoneGeometry"];
            this.status = _data["status"];
            this.respondersStatusMessage = _data["respondersStatusMessage"];
            this.mapRequestInitiator = _data["mapRequestInitiator"] ? MapRequestInitiatorContactData.fromJS(_data["mapRequestInitiator"]) : undefined as any;
            this.isProfessional = _data["isProfessional"];
        }
    }

    static fromJS(data: any): MapRequest3 {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequest3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference;
        data["dateReceived"] = this.dateReceived;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["mapRequestType"] = this.mapRequestType;
        data["excavationType"] = this.excavationType;
        data["excavationMethod"] = this.excavationMethod;
        data["excavationLocation"] = this.excavationLocation;
        data["excavationDescription"] = this.excavationDescription;
        data["excavationDepth"] = this.excavationDepth;
        data["zoneGeometry"] = this.zoneGeometry;
        data["status"] = this.status;
        data["respondersStatusMessage"] = this.respondersStatusMessage;
        data["mapRequestInitiator"] = this.mapRequestInitiator ? this.mapRequestInitiator.toJSON() : undefined as any;
        data["isProfessional"] = this.isProfessional;
        return data;
    }
}

export interface IMapRequest3 {
    reference?: string | undefined;
    dateReceived?: string;
    startDate?: string;
    endDate?: string;
    mapRequestType?: string | undefined;
    excavationType?: string | undefined;
    excavationMethod?: string | undefined;
    excavationLocation?: string | undefined;
    excavationDescription?: string | undefined;
    excavationDepth?: number;
    zoneGeometry?: any | undefined;
    status?: MapRequestDetailStatus;
    respondersStatusMessage?: string | undefined;
    mapRequestInitiator?: MapRequestInitiatorContactData | undefined;
    isProfessional?: boolean;
}

export class UnaContactCardData implements IUnaContactCardData {
    name?: string | undefined;
    zoneName?: string | undefined;
    extraInformation?: string | undefined;
    contactName?: string | undefined;
    contactTelephone?: string | undefined;
    contactEmail?: string | undefined;
    alarmCentralTelephone?: string | undefined;
    isKlimZone?: boolean;

    constructor(data?: IUnaContactCardData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.zoneName = _data["zoneName"];
            this.extraInformation = _data["extraInformation"];
            this.contactName = _data["contactName"];
            this.contactTelephone = _data["contactTelephone"];
            this.contactEmail = _data["contactEmail"];
            this.alarmCentralTelephone = _data["alarmCentralTelephone"];
            this.isKlimZone = _data["isKlimZone"];
        }
    }

    static fromJS(data: any): UnaContactCardData {
        data = typeof data === 'object' ? data : {};
        let result = new UnaContactCardData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["zoneName"] = this.zoneName;
        data["extraInformation"] = this.extraInformation;
        data["contactName"] = this.contactName;
        data["contactTelephone"] = this.contactTelephone;
        data["contactEmail"] = this.contactEmail;
        data["alarmCentralTelephone"] = this.alarmCentralTelephone;
        data["isKlimZone"] = this.isKlimZone;
        return data;
    }
}

export interface IUnaContactCardData {
    name?: string | undefined;
    zoneName?: string | undefined;
    extraInformation?: string | undefined;
    contactName?: string | undefined;
    contactTelephone?: string | undefined;
    contactEmail?: string | undefined;
    alarmCentralTelephone?: string | undefined;
    isKlimZone?: boolean;
}

export class UpdateMailSettingsInput implements IUpdateMailSettingsInput {
    updateMriMailSettingsInput?: UpdateMriMailSettingsInputData | undefined;

    constructor(data?: IUpdateMailSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updateMriMailSettingsInput = _data["updateMriMailSettingsInput"] ? UpdateMriMailSettingsInputData.fromJS(_data["updateMriMailSettingsInput"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateMailSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMailSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateMriMailSettingsInput"] = this.updateMriMailSettingsInput ? this.updateMriMailSettingsInput.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateMailSettingsInput {
    updateMriMailSettingsInput?: UpdateMriMailSettingsInputData | undefined;
}

export class UpdateMriMailSettingsInputData implements IUpdateMriMailSettingsInputData {
    confirmation?: boolean;
    incompletePackageAvailable?: boolean;
    soonToBeArchived?: boolean;

    constructor(data?: IUpdateMriMailSettingsInputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.confirmation = _data["confirmation"];
            this.incompletePackageAvailable = _data["incompletePackageAvailable"];
            this.soonToBeArchived = _data["soonToBeArchived"];
        }
    }

    static fromJS(data: any): UpdateMriMailSettingsInputData {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMriMailSettingsInputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confirmation"] = this.confirmation;
        data["incompletePackageAvailable"] = this.incompletePackageAvailable;
        data["soonToBeArchived"] = this.soonToBeArchived;
        return data;
    }
}

export interface IUpdateMriMailSettingsInputData {
    confirmation?: boolean;
    incompletePackageAvailable?: boolean;
    soonToBeArchived?: boolean;
}

export class EnvelopeOfSettingsView implements IEnvelopeOfSettingsView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: SettingsView | undefined;

    constructor(data?: IEnvelopeOfSettingsView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? SettingsView.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfSettingsView {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfSettingsView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfSettingsView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: SettingsView | undefined;
}

export class SettingsView implements ISettingsView {
    mriSettings?: MriSettingsData | undefined;

    constructor(data?: ISettingsView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mriSettings = _data["mriSettings"] ? MriSettingsData.fromJS(_data["mriSettings"]) : undefined as any;
        }
    }

    static fromJS(data: any): SettingsView {
        data = typeof data === 'object' ? data : {};
        let result = new SettingsView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mriSettings"] = this.mriSettings ? this.mriSettings.toJSON() : undefined as any;
        return data;
    }
}

export interface ISettingsView {
    mriSettings?: MriSettingsData | undefined;
}

export class MriSettingsData implements IMriSettingsData {
    mailConfirmation?: boolean;
    mailConfirmationExampleUri?: string | undefined;
    mailIncompletePackageAvailable?: boolean;
    mailIncompletePackageAvailableExampleUri?: string | undefined;
    mailSoonToBeArchived?: boolean;
    mailSoonToBeArchivedExampleUri?: string | undefined;

    constructor(data?: IMriSettingsData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailConfirmation = _data["mailConfirmation"];
            this.mailConfirmationExampleUri = _data["mailConfirmationExampleUri"];
            this.mailIncompletePackageAvailable = _data["mailIncompletePackageAvailable"];
            this.mailIncompletePackageAvailableExampleUri = _data["mailIncompletePackageAvailableExampleUri"];
            this.mailSoonToBeArchived = _data["mailSoonToBeArchived"];
            this.mailSoonToBeArchivedExampleUri = _data["mailSoonToBeArchivedExampleUri"];
        }
    }

    static fromJS(data: any): MriSettingsData {
        data = typeof data === 'object' ? data : {};
        let result = new MriSettingsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailConfirmation"] = this.mailConfirmation;
        data["mailConfirmationExampleUri"] = this.mailConfirmationExampleUri;
        data["mailIncompletePackageAvailable"] = this.mailIncompletePackageAvailable;
        data["mailIncompletePackageAvailableExampleUri"] = this.mailIncompletePackageAvailableExampleUri;
        data["mailSoonToBeArchived"] = this.mailSoonToBeArchived;
        data["mailSoonToBeArchivedExampleUri"] = this.mailSoonToBeArchivedExampleUri;
        return data;
    }
}

export interface IMriSettingsData {
    mailConfirmation?: boolean;
    mailConfirmationExampleUri?: string | undefined;
    mailIncompletePackageAvailable?: boolean;
    mailIncompletePackageAvailableExampleUri?: string | undefined;
    mailSoonToBeArchived?: boolean;
    mailSoonToBeArchivedExampleUri?: string | undefined;
}

export class EnvelopeOfInvoiceSettingsView implements IEnvelopeOfInvoiceSettingsView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: InvoiceSettingsView | undefined;

    constructor(data?: IEnvelopeOfInvoiceSettingsView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? InvoiceSettingsView.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfInvoiceSettingsView {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfInvoiceSettingsView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfInvoiceSettingsView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: InvoiceSettingsView | undefined;
}

export class InvoiceSettingsView implements IInvoiceSettingsView {
    organisationInvoiceData?: OrganisationInvoiceData2 | undefined;

    constructor(data?: IInvoiceSettingsView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationInvoiceData = _data["organisationInvoiceData"] ? OrganisationInvoiceData2.fromJS(_data["organisationInvoiceData"]) : undefined as any;
        }
    }

    static fromJS(data: any): InvoiceSettingsView {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceSettingsView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationInvoiceData"] = this.organisationInvoiceData ? this.organisationInvoiceData.toJSON() : undefined as any;
        return data;
    }
}

export interface IInvoiceSettingsView {
    organisationInvoiceData?: OrganisationInvoiceData2 | undefined;
}

export class EnvelopeOfOrganisationInvoiceSettingsView implements IEnvelopeOfOrganisationInvoiceSettingsView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: OrganisationInvoiceSettingsView | undefined;

    constructor(data?: IEnvelopeOfOrganisationInvoiceSettingsView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? OrganisationInvoiceSettingsView.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfOrganisationInvoiceSettingsView {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfOrganisationInvoiceSettingsView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfOrganisationInvoiceSettingsView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: OrganisationInvoiceSettingsView | undefined;
}

export class OrganisationInvoiceSettingsView implements IOrganisationInvoiceSettingsView {
    organisationInvoiceSetting?: OrganisationInvoiceSetting | undefined;
    subOrganisationsInvoiceSetting?: OrganisationInvoiceSetting[] | undefined;
    organisationInvoiceGroups?: OrganisationInvoiceGroup[] | undefined;

    constructor(data?: IOrganisationInvoiceSettingsView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationInvoiceSetting = _data["organisationInvoiceSetting"] ? OrganisationInvoiceSetting.fromJS(_data["organisationInvoiceSetting"]) : undefined as any;
            if (Array.isArray(_data["subOrganisationsInvoiceSetting"])) {
                this.subOrganisationsInvoiceSetting = [] as any;
                for (let item of _data["subOrganisationsInvoiceSetting"])
                    this.subOrganisationsInvoiceSetting!.push(OrganisationInvoiceSetting.fromJS(item));
            }
            if (Array.isArray(_data["organisationInvoiceGroups"])) {
                this.organisationInvoiceGroups = [] as any;
                for (let item of _data["organisationInvoiceGroups"])
                    this.organisationInvoiceGroups!.push(OrganisationInvoiceGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganisationInvoiceSettingsView {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationInvoiceSettingsView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationInvoiceSetting"] = this.organisationInvoiceSetting ? this.organisationInvoiceSetting.toJSON() : undefined as any;
        if (Array.isArray(this.subOrganisationsInvoiceSetting)) {
            data["subOrganisationsInvoiceSetting"] = [];
            for (let item of this.subOrganisationsInvoiceSetting)
                data["subOrganisationsInvoiceSetting"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.organisationInvoiceGroups)) {
            data["organisationInvoiceGroups"] = [];
            for (let item of this.organisationInvoiceGroups)
                data["organisationInvoiceGroups"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOrganisationInvoiceSettingsView {
    organisationInvoiceSetting?: OrganisationInvoiceSetting | undefined;
    subOrganisationsInvoiceSetting?: OrganisationInvoiceSetting[] | undefined;
    organisationInvoiceGroups?: OrganisationInvoiceGroup[] | undefined;
}

export class EnvelopeOfOrganisationInvoiceGroup implements IEnvelopeOfOrganisationInvoiceGroup {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: OrganisationInvoiceGroup | undefined;

    constructor(data?: IEnvelopeOfOrganisationInvoiceGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? OrganisationInvoiceGroup.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfOrganisationInvoiceGroup {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfOrganisationInvoiceGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfOrganisationInvoiceGroup {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: OrganisationInvoiceGroup | undefined;
}

export class MapRequestNotInvolvedInput implements IMapRequestNotInvolvedInput {
    mapRequestId?: string;
    zoneId?: string;

    constructor(data?: IMapRequestNotInvolvedInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestId = _data["mapRequestId"];
            this.zoneId = _data["zoneId"];
        }
    }

    static fromJS(data: any): MapRequestNotInvolvedInput {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestNotInvolvedInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestId"] = this.mapRequestId;
        data["zoneId"] = this.zoneId;
        return data;
    }
}

export interface IMapRequestNotInvolvedInput {
    mapRequestId?: string;
    zoneId?: string;
}

export class EnvelopeOfImklDataValidationReport implements IEnvelopeOfImklDataValidationReport {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ImklDataValidationReport | undefined;

    constructor(data?: IEnvelopeOfImklDataValidationReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? ImklDataValidationReport.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfImklDataValidationReport {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfImklDataValidationReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfImklDataValidationReport {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ImklDataValidationReport | undefined;
}

export class ImklDataValidationReport implements IImklDataValidationReport {
    mapRequestId?: string;
    zoneId?: string;
    status?: ImklDataValidationStatus;
    statusMessage?: string | undefined;
    signature?: ImklSignature | undefined;
    validationSteps?: ValidationStep[] | undefined;

    constructor(data?: IImklDataValidationReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestId = _data["mapRequestId"];
            this.zoneId = _data["zoneId"];
            this.status = _data["status"];
            this.statusMessage = _data["statusMessage"];
            this.signature = _data["signature"] ? ImklSignature.fromJS(_data["signature"]) : undefined as any;
            if (Array.isArray(_data["validationSteps"])) {
                this.validationSteps = [] as any;
                for (let item of _data["validationSteps"])
                    this.validationSteps!.push(ValidationStep.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImklDataValidationReport {
        data = typeof data === 'object' ? data : {};
        let result = new ImklDataValidationReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestId"] = this.mapRequestId;
        data["zoneId"] = this.zoneId;
        data["status"] = this.status;
        data["statusMessage"] = this.statusMessage;
        data["signature"] = this.signature ? this.signature.toJSON() : undefined as any;
        if (Array.isArray(this.validationSteps)) {
            data["validationSteps"] = [];
            for (let item of this.validationSteps)
                data["validationSteps"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImklDataValidationReport {
    mapRequestId?: string;
    zoneId?: string;
    status?: ImklDataValidationStatus;
    statusMessage?: string | undefined;
    signature?: ImklSignature | undefined;
    validationSteps?: ValidationStep[] | undefined;
}

export enum ImklDataValidationStatus {
    Uploaded = 1,
    Invalid = 2,
    Valid = 3,
}

export class ImklSignature implements IImklSignature {
    signedInfo?: ImklSignedInfo | undefined;
    signatureValue?: string | undefined;
    keyInfo?: ImklKeyInfo | undefined;

    constructor(data?: IImklSignature) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signedInfo = _data["signedInfo"] ? ImklSignedInfo.fromJS(_data["signedInfo"]) : undefined as any;
            this.signatureValue = _data["signatureValue"];
            this.keyInfo = _data["keyInfo"] ? ImklKeyInfo.fromJS(_data["keyInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImklSignature {
        data = typeof data === 'object' ? data : {};
        let result = new ImklSignature();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signedInfo"] = this.signedInfo ? this.signedInfo.toJSON() : undefined as any;
        data["signatureValue"] = this.signatureValue;
        data["keyInfo"] = this.keyInfo ? this.keyInfo.toJSON() : undefined as any;
        return data;
    }
}

export interface IImklSignature {
    signedInfo?: ImklSignedInfo | undefined;
    signatureValue?: string | undefined;
    keyInfo?: ImklKeyInfo | undefined;
}

export class ImklSignedInfo implements IImklSignedInfo {
    canonicalizationMethod?: CanonicalizationMethod | undefined;
    signatureMethod?: SignatureMethod | undefined;
    reference?: ImklReference | undefined;

    constructor(data?: IImklSignedInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canonicalizationMethod = _data["canonicalizationMethod"] ? CanonicalizationMethod.fromJS(_data["canonicalizationMethod"]) : undefined as any;
            this.signatureMethod = _data["signatureMethod"] ? SignatureMethod.fromJS(_data["signatureMethod"]) : undefined as any;
            this.reference = _data["reference"] ? ImklReference.fromJS(_data["reference"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImklSignedInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ImklSignedInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canonicalizationMethod"] = this.canonicalizationMethod ? this.canonicalizationMethod.toJSON() : undefined as any;
        data["signatureMethod"] = this.signatureMethod ? this.signatureMethod.toJSON() : undefined as any;
        data["reference"] = this.reference ? this.reference.toJSON() : undefined as any;
        return data;
    }
}

export interface IImklSignedInfo {
    canonicalizationMethod?: CanonicalizationMethod | undefined;
    signatureMethod?: SignatureMethod | undefined;
    reference?: ImklReference | undefined;
}

export class CanonicalizationMethod implements ICanonicalizationMethod {
    algorithm?: string | undefined;

    constructor(data?: ICanonicalizationMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.algorithm = _data["algorithm"];
        }
    }

    static fromJS(data: any): CanonicalizationMethod {
        data = typeof data === 'object' ? data : {};
        let result = new CanonicalizationMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["algorithm"] = this.algorithm;
        return data;
    }
}

export interface ICanonicalizationMethod {
    algorithm?: string | undefined;
}

export class SignatureMethod implements ISignatureMethod {
    algorithm?: string | undefined;

    constructor(data?: ISignatureMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.algorithm = _data["algorithm"];
        }
    }

    static fromJS(data: any): SignatureMethod {
        data = typeof data === 'object' ? data : {};
        let result = new SignatureMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["algorithm"] = this.algorithm;
        return data;
    }
}

export interface ISignatureMethod {
    algorithm?: string | undefined;
}

export class ImklReference implements IImklReference {
    uri?: string | undefined;
    transforms?: Transforms | undefined;
    digestMethod?: DigestMethod | undefined;
    digestValue?: string | undefined;

    constructor(data?: IImklReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uri = _data["uri"];
            this.transforms = _data["transforms"] ? Transforms.fromJS(_data["transforms"]) : undefined as any;
            this.digestMethod = _data["digestMethod"] ? DigestMethod.fromJS(_data["digestMethod"]) : undefined as any;
            this.digestValue = _data["digestValue"];
        }
    }

    static fromJS(data: any): ImklReference {
        data = typeof data === 'object' ? data : {};
        let result = new ImklReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uri"] = this.uri;
        data["transforms"] = this.transforms ? this.transforms.toJSON() : undefined as any;
        data["digestMethod"] = this.digestMethod ? this.digestMethod.toJSON() : undefined as any;
        data["digestValue"] = this.digestValue;
        return data;
    }
}

export interface IImklReference {
    uri?: string | undefined;
    transforms?: Transforms | undefined;
    digestMethod?: DigestMethod | undefined;
    digestValue?: string | undefined;
}

export class Transforms implements ITransforms {
    transform?: ImklTransform | undefined;

    constructor(data?: ITransforms) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transform = _data["transform"] ? ImklTransform.fromJS(_data["transform"]) : undefined as any;
        }
    }

    static fromJS(data: any): Transforms {
        data = typeof data === 'object' ? data : {};
        let result = new Transforms();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transform"] = this.transform ? this.transform.toJSON() : undefined as any;
        return data;
    }
}

export interface ITransforms {
    transform?: ImklTransform | undefined;
}

export class ImklTransform implements IImklTransform {
    algorithm?: string | undefined;

    constructor(data?: IImklTransform) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.algorithm = _data["algorithm"];
        }
    }

    static fromJS(data: any): ImklTransform {
        data = typeof data === 'object' ? data : {};
        let result = new ImklTransform();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["algorithm"] = this.algorithm;
        return data;
    }
}

export interface IImklTransform {
    algorithm?: string | undefined;
}

export class DigestMethod implements IDigestMethod {
    algorithm?: string | undefined;

    constructor(data?: IDigestMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.algorithm = _data["algorithm"];
        }
    }

    static fromJS(data: any): DigestMethod {
        data = typeof data === 'object' ? data : {};
        let result = new DigestMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["algorithm"] = this.algorithm;
        return data;
    }
}

export interface IDigestMethod {
    algorithm?: string | undefined;
}

export class ImklKeyInfo implements IImklKeyInfo {
    x509Data?: X509Data | undefined;

    constructor(data?: IImklKeyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x509Data = _data["x509Data"] ? X509Data.fromJS(_data["x509Data"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImklKeyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ImklKeyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x509Data"] = this.x509Data ? this.x509Data.toJSON() : undefined as any;
        return data;
    }
}

export interface IImklKeyInfo {
    x509Data?: X509Data | undefined;
}

export class X509Data implements IX509Data {
    x509Certificate?: string | undefined;

    constructor(data?: IX509Data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x509Certificate = _data["x509Certificate"];
        }
    }

    static fromJS(data: any): X509Data {
        data = typeof data === 'object' ? data : {};
        let result = new X509Data();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x509Certificate"] = this.x509Certificate;
        return data;
    }
}

export interface IX509Data {
    x509Certificate?: string | undefined;
}

export class EnvelopeOfPmklMapAssetsStatusUna implements IEnvelopeOfPmklMapAssetsStatusUna {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: PmklMapAssetsStatusUna | undefined;

    constructor(data?: IEnvelopeOfPmklMapAssetsStatusUna) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? PmklMapAssetsStatusUna.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfPmklMapAssetsStatusUna {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfPmklMapAssetsStatusUna();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfPmklMapAssetsStatusUna {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: PmklMapAssetsStatusUna | undefined;
}

export class PmklMapAssetsStatusUna implements IPmklMapAssetsStatusUna {
    pmklPackageStatus?: MapRequestPmklMapAssetsStatus;
    mapAssetsStatus?: MapRequestPmklMapAssetsStatus;
    pmklPackageSizeInBytes?: number;

    constructor(data?: IPmklMapAssetsStatusUna) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pmklPackageStatus = _data["pmklPackageStatus"];
            this.mapAssetsStatus = _data["mapAssetsStatus"];
            this.pmklPackageSizeInBytes = _data["pmklPackageSizeInBytes"];
        }
    }

    static fromJS(data: any): PmklMapAssetsStatusUna {
        data = typeof data === 'object' ? data : {};
        let result = new PmklMapAssetsStatusUna();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pmklPackageStatus"] = this.pmklPackageStatus;
        data["mapAssetsStatus"] = this.mapAssetsStatus;
        data["pmklPackageSizeInBytes"] = this.pmklPackageSizeInBytes;
        return data;
    }
}

export interface IPmklMapAssetsStatusUna {
    pmklPackageStatus?: MapRequestPmklMapAssetsStatus;
    mapAssetsStatus?: MapRequestPmklMapAssetsStatus;
    pmklPackageSizeInBytes?: number;
}

export class EnvelopeOfMapRequestsToConfirmList implements IEnvelopeOfMapRequestsToConfirmList {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestsToConfirmList | undefined;

    constructor(data?: IEnvelopeOfMapRequestsToConfirmList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? MapRequestsToConfirmList.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfMapRequestsToConfirmList {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfMapRequestsToConfirmList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfMapRequestsToConfirmList {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestsToConfirmList | undefined;
}

export class MapRequestsToConfirmList implements IMapRequestsToConfirmList {
    mapRequests?: MapRequestToConfirmListItem[] | undefined;

    constructor(data?: IMapRequestsToConfirmList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mapRequests"])) {
                this.mapRequests = [] as any;
                for (let item of _data["mapRequests"])
                    this.mapRequests!.push(MapRequestToConfirmListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MapRequestsToConfirmList {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestsToConfirmList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mapRequests)) {
            data["mapRequests"] = [];
            for (let item of this.mapRequests)
                data["mapRequests"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMapRequestsToConfirmList {
    mapRequests?: MapRequestToConfirmListItem[] | undefined;
}

export class MapRequestToConfirmListItem implements IMapRequestToConfirmListItem {
    mapRequestId?: string;
    unaZoneId?: string;
    dateReceived?: string;
    zoneName?: string | undefined;
    reference?: string | undefined;
    confirmationDate?: string | undefined;
    isOverdue?: boolean;
    startDate?: string;
    mapRequestType?: string | undefined;
    organisation?: string | undefined;

    constructor(data?: IMapRequestToConfirmListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestId = _data["mapRequestId"];
            this.unaZoneId = _data["unaZoneId"];
            this.dateReceived = _data["dateReceived"];
            this.zoneName = _data["zoneName"];
            this.reference = _data["reference"];
            this.confirmationDate = _data["confirmationDate"];
            this.isOverdue = _data["isOverdue"];
            this.startDate = _data["startDate"];
            this.mapRequestType = _data["mapRequestType"];
            this.organisation = _data["organisation"];
        }
    }

    static fromJS(data: any): MapRequestToConfirmListItem {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestToConfirmListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestId"] = this.mapRequestId;
        data["unaZoneId"] = this.unaZoneId;
        data["dateReceived"] = this.dateReceived;
        data["zoneName"] = this.zoneName;
        data["reference"] = this.reference;
        data["confirmationDate"] = this.confirmationDate;
        data["isOverdue"] = this.isOverdue;
        data["startDate"] = this.startDate;
        data["mapRequestType"] = this.mapRequestType;
        data["organisation"] = this.organisation;
        return data;
    }
}

export interface IMapRequestToConfirmListItem {
    mapRequestId?: string;
    unaZoneId?: string;
    dateReceived?: string;
    zoneName?: string | undefined;
    reference?: string | undefined;
    confirmationDate?: string | undefined;
    isOverdue?: boolean;
    startDate?: string;
    mapRequestType?: string | undefined;
    organisation?: string | undefined;
}

export class GetMapRequestsToConfirmInput implements IGetMapRequestsToConfirmInput {
    orderDirection?: OrderDirection;
    offset?: number;
    limit?: number;
    searchOption?: SearchOption;
    organisationId?: string | undefined;
    utilityNetworkAuthorityZoneId?: string | undefined;
    searchField?: SearchField;
    query?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    orderField?: MapRequestsToConfirmOrderField;

    constructor(data?: IGetMapRequestsToConfirmInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderDirection = _data["orderDirection"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
            this.searchOption = _data["searchOption"];
            this.organisationId = _data["organisationId"];
            this.utilityNetworkAuthorityZoneId = _data["utilityNetworkAuthorityZoneId"];
            this.searchField = _data["searchField"];
            this.query = _data["query"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.orderField = _data["orderField"];
        }
    }

    static fromJS(data: any): GetMapRequestsToConfirmInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMapRequestsToConfirmInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderDirection"] = this.orderDirection;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        data["searchOption"] = this.searchOption;
        data["organisationId"] = this.organisationId;
        data["utilityNetworkAuthorityZoneId"] = this.utilityNetworkAuthorityZoneId;
        data["searchField"] = this.searchField;
        data["query"] = this.query;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["orderField"] = this.orderField;
        return data;
    }
}

export interface IGetMapRequestsToConfirmInput {
    orderDirection?: OrderDirection;
    offset?: number;
    limit?: number;
    searchOption?: SearchOption;
    organisationId?: string | undefined;
    utilityNetworkAuthorityZoneId?: string | undefined;
    searchField?: SearchField;
    query?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    orderField?: MapRequestsToConfirmOrderField;
}

export class ConfirmMapRequestsInput implements IConfirmMapRequestsInput {
    mapRequestId?: string;
    zoneId?: string;

    constructor(data?: IConfirmMapRequestsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestId = _data["mapRequestId"];
            this.zoneId = _data["zoneId"];
        }
    }

    static fromJS(data: any): ConfirmMapRequestsInput {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmMapRequestsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestId"] = this.mapRequestId;
        data["zoneId"] = this.zoneId;
        return data;
    }
}

export interface IConfirmMapRequestsInput {
    mapRequestId?: string;
    zoneId?: string;
}

export class EnvelopeOfMapRequestsToReplyList implements IEnvelopeOfMapRequestsToReplyList {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestsToReplyList | undefined;

    constructor(data?: IEnvelopeOfMapRequestsToReplyList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? MapRequestsToReplyList.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfMapRequestsToReplyList {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfMapRequestsToReplyList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfMapRequestsToReplyList {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestsToReplyList | undefined;
}

export class MapRequestsToReplyList implements IMapRequestsToReplyList {
    mapRequests?: MapRequestToReplyListItem[] | undefined;

    constructor(data?: IMapRequestsToReplyList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mapRequests"])) {
                this.mapRequests = [] as any;
                for (let item of _data["mapRequests"])
                    this.mapRequests!.push(MapRequestToReplyListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MapRequestsToReplyList {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestsToReplyList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mapRequests)) {
            data["mapRequests"] = [];
            for (let item of this.mapRequests)
                data["mapRequests"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMapRequestsToReplyList {
    mapRequests?: MapRequestToReplyListItem[] | undefined;
}

export class MapRequestToReplyListItem implements IMapRequestToReplyListItem {
    mapRequestId?: string;
    unaZoneId?: string;
    dateReceived?: string;
    zoneName?: string | undefined;
    reference?: string | undefined;
    startDate?: string;
    mapRequestType?: string | undefined;
    organisation?: string | undefined;

    constructor(data?: IMapRequestToReplyListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestId = _data["mapRequestId"];
            this.unaZoneId = _data["unaZoneId"];
            this.dateReceived = _data["dateReceived"];
            this.zoneName = _data["zoneName"];
            this.reference = _data["reference"];
            this.startDate = _data["startDate"];
            this.mapRequestType = _data["mapRequestType"];
            this.organisation = _data["organisation"];
        }
    }

    static fromJS(data: any): MapRequestToReplyListItem {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestToReplyListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestId"] = this.mapRequestId;
        data["unaZoneId"] = this.unaZoneId;
        data["dateReceived"] = this.dateReceived;
        data["zoneName"] = this.zoneName;
        data["reference"] = this.reference;
        data["startDate"] = this.startDate;
        data["mapRequestType"] = this.mapRequestType;
        data["organisation"] = this.organisation;
        return data;
    }
}

export interface IMapRequestToReplyListItem {
    mapRequestId?: string;
    unaZoneId?: string;
    dateReceived?: string;
    zoneName?: string | undefined;
    reference?: string | undefined;
    startDate?: string;
    mapRequestType?: string | undefined;
    organisation?: string | undefined;
}

export class GetMapRequestsToReplyInput implements IGetMapRequestsToReplyInput {
    orderField?: MapRequestsToReplyOrderField;
    orderDirection?: OrderDirection;
    offset?: number;
    limit?: number;
    searchOption?: SearchOption;
    organisationId?: string | undefined;
    utilityNetworkAuthorityZoneId?: string | undefined;
    searchField?: SearchField;
    query?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;

    constructor(data?: IGetMapRequestsToReplyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderField = _data["orderField"];
            this.orderDirection = _data["orderDirection"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
            this.searchOption = _data["searchOption"];
            this.organisationId = _data["organisationId"];
            this.utilityNetworkAuthorityZoneId = _data["utilityNetworkAuthorityZoneId"];
            this.searchField = _data["searchField"];
            this.query = _data["query"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
        }
    }

    static fromJS(data: any): GetMapRequestsToReplyInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMapRequestsToReplyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderField"] = this.orderField;
        data["orderDirection"] = this.orderDirection;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        data["searchOption"] = this.searchOption;
        data["organisationId"] = this.organisationId;
        data["utilityNetworkAuthorityZoneId"] = this.utilityNetworkAuthorityZoneId;
        data["searchField"] = this.searchField;
        data["query"] = this.query;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        return data;
    }
}

export interface IGetMapRequestsToReplyInput {
    orderField?: MapRequestsToReplyOrderField;
    orderDirection?: OrderDirection;
    offset?: number;
    limit?: number;
    searchOption?: SearchOption;
    organisationId?: string | undefined;
    utilityNetworkAuthorityZoneId?: string | undefined;
    searchField?: SearchField;
    query?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
}

export class EnvelopeOfMapRequestsRepliedList implements IEnvelopeOfMapRequestsRepliedList {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestsRepliedList | undefined;

    constructor(data?: IEnvelopeOfMapRequestsRepliedList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? MapRequestsRepliedList.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfMapRequestsRepliedList {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfMapRequestsRepliedList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfMapRequestsRepliedList {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestsRepliedList | undefined;
}

export class MapRequestsRepliedList implements IMapRequestsRepliedList {
    mapRequests?: MapRequestRepliedListItem[] | undefined;

    constructor(data?: IMapRequestsRepliedList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mapRequests"])) {
                this.mapRequests = [] as any;
                for (let item of _data["mapRequests"])
                    this.mapRequests!.push(MapRequestRepliedListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MapRequestsRepliedList {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestsRepliedList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mapRequests)) {
            data["mapRequests"] = [];
            for (let item of this.mapRequests)
                data["mapRequests"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMapRequestsRepliedList {
    mapRequests?: MapRequestRepliedListItem[] | undefined;
}

export class MapRequestRepliedListItem implements IMapRequestRepliedListItem {
    mapRequestId?: string;
    unaZoneId?: string;
    dateReceived?: string;
    zoneName?: string | undefined;
    reference?: string | undefined;
    requestor?: string | undefined;
    organisation?: string | undefined;
    isArchived?: boolean;

    constructor(data?: IMapRequestRepliedListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestId = _data["mapRequestId"];
            this.unaZoneId = _data["unaZoneId"];
            this.dateReceived = _data["dateReceived"];
            this.zoneName = _data["zoneName"];
            this.reference = _data["reference"];
            this.requestor = _data["requestor"];
            this.organisation = _data["organisation"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): MapRequestRepliedListItem {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestRepliedListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestId"] = this.mapRequestId;
        data["unaZoneId"] = this.unaZoneId;
        data["dateReceived"] = this.dateReceived;
        data["zoneName"] = this.zoneName;
        data["reference"] = this.reference;
        data["requestor"] = this.requestor;
        data["organisation"] = this.organisation;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface IMapRequestRepliedListItem {
    mapRequestId?: string;
    unaZoneId?: string;
    dateReceived?: string;
    zoneName?: string | undefined;
    reference?: string | undefined;
    requestor?: string | undefined;
    organisation?: string | undefined;
    isArchived?: boolean;
}

export class EnvelopeOfMapRequestCount implements IEnvelopeOfMapRequestCount {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestCount | undefined;

    constructor(data?: IEnvelopeOfMapRequestCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? MapRequestCount.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfMapRequestCount {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfMapRequestCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfMapRequestCount {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestCount | undefined;
}

export class MapRequestCount implements IMapRequestCount {
    mapRequestToConfirmCount?: number;
    mapRequestToReplyCount?: number;
    mapRequestRepliedCount?: number;

    constructor(data?: IMapRequestCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestToConfirmCount = _data["mapRequestToConfirmCount"];
            this.mapRequestToReplyCount = _data["mapRequestToReplyCount"];
            this.mapRequestRepliedCount = _data["mapRequestRepliedCount"];
        }
    }

    static fromJS(data: any): MapRequestCount {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestToConfirmCount"] = this.mapRequestToConfirmCount;
        data["mapRequestToReplyCount"] = this.mapRequestToReplyCount;
        data["mapRequestRepliedCount"] = this.mapRequestRepliedCount;
        return data;
    }
}

export interface IMapRequestCount {
    mapRequestToConfirmCount?: number;
    mapRequestToReplyCount?: number;
    mapRequestRepliedCount?: number;
}

export class GetAllMapRequestCountInput implements IGetAllMapRequestCountInput {
    mapRequestsToConfirmInput?: GetMapRequestsToConfirmInput | undefined;
    mapRequestsToReplyInput?: GetMapRequestsToReplyInput | undefined;
    mapRequestsRepliedInput?: GetMapRequestsRepliedInput | undefined;

    constructor(data?: IGetAllMapRequestCountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestsToConfirmInput = _data["mapRequestsToConfirmInput"] ? GetMapRequestsToConfirmInput.fromJS(_data["mapRequestsToConfirmInput"]) : undefined as any;
            this.mapRequestsToReplyInput = _data["mapRequestsToReplyInput"] ? GetMapRequestsToReplyInput.fromJS(_data["mapRequestsToReplyInput"]) : undefined as any;
            this.mapRequestsRepliedInput = _data["mapRequestsRepliedInput"] ? GetMapRequestsRepliedInput.fromJS(_data["mapRequestsRepliedInput"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetAllMapRequestCountInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllMapRequestCountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestsToConfirmInput"] = this.mapRequestsToConfirmInput ? this.mapRequestsToConfirmInput.toJSON() : undefined as any;
        data["mapRequestsToReplyInput"] = this.mapRequestsToReplyInput ? this.mapRequestsToReplyInput.toJSON() : undefined as any;
        data["mapRequestsRepliedInput"] = this.mapRequestsRepliedInput ? this.mapRequestsRepliedInput.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetAllMapRequestCountInput {
    mapRequestsToConfirmInput?: GetMapRequestsToConfirmInput | undefined;
    mapRequestsToReplyInput?: GetMapRequestsToReplyInput | undefined;
    mapRequestsRepliedInput?: GetMapRequestsRepliedInput | undefined;
}

export class EnvelopeOfMapRequestListViewUna implements IEnvelopeOfMapRequestListViewUna {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestListViewUna | undefined;

    constructor(data?: IEnvelopeOfMapRequestListViewUna) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? MapRequestListViewUna.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfMapRequestListViewUna {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfMapRequestListViewUna();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfMapRequestListViewUna {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestListViewUna | undefined;
}

export class MapRequestListViewUna implements IMapRequestListViewUna {
    mapRequestsToConfirmData?: MapRequestsToConfirmData | undefined;
    mapRequestsToReplyData?: MapRequestsToReplyData | undefined;
    mapRequestsRepliedData?: MapRequestsRepliedData | undefined;
    unaZonesCount?: number;

    constructor(data?: IMapRequestListViewUna) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestsToConfirmData = _data["mapRequestsToConfirmData"] ? MapRequestsToConfirmData.fromJS(_data["mapRequestsToConfirmData"]) : undefined as any;
            this.mapRequestsToReplyData = _data["mapRequestsToReplyData"] ? MapRequestsToReplyData.fromJS(_data["mapRequestsToReplyData"]) : undefined as any;
            this.mapRequestsRepliedData = _data["mapRequestsRepliedData"] ? MapRequestsRepliedData.fromJS(_data["mapRequestsRepliedData"]) : undefined as any;
            this.unaZonesCount = _data["unaZonesCount"];
        }
    }

    static fromJS(data: any): MapRequestListViewUna {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestListViewUna();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestsToConfirmData"] = this.mapRequestsToConfirmData ? this.mapRequestsToConfirmData.toJSON() : undefined as any;
        data["mapRequestsToReplyData"] = this.mapRequestsToReplyData ? this.mapRequestsToReplyData.toJSON() : undefined as any;
        data["mapRequestsRepliedData"] = this.mapRequestsRepliedData ? this.mapRequestsRepliedData.toJSON() : undefined as any;
        data["unaZonesCount"] = this.unaZonesCount;
        return data;
    }
}

export interface IMapRequestListViewUna {
    mapRequestsToConfirmData?: MapRequestsToConfirmData | undefined;
    mapRequestsToReplyData?: MapRequestsToReplyData | undefined;
    mapRequestsRepliedData?: MapRequestsRepliedData | undefined;
    unaZonesCount?: number;
}

export class MapRequestsToConfirmData implements IMapRequestsToConfirmData {
    mapRequestColumns?: Column[] | undefined;
    getMapRequestsInput?: GetMapRequestsToConfirmInput | undefined;
    searchFields?: CodeListValueOrder[] | undefined;
    searchOptions?: CodeListValueOrder[] | undefined;
    zones?: CodeListValueOrder[] | undefined;
    groupedSearchOptions?: GroupedCodeListValueOrder[] | undefined;

    constructor(data?: IMapRequestsToConfirmData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mapRequestColumns"])) {
                this.mapRequestColumns = [] as any;
                for (let item of _data["mapRequestColumns"])
                    this.mapRequestColumns!.push(Column.fromJS(item));
            }
            this.getMapRequestsInput = _data["getMapRequestsInput"] ? GetMapRequestsToConfirmInput.fromJS(_data["getMapRequestsInput"]) : undefined as any;
            if (Array.isArray(_data["searchFields"])) {
                this.searchFields = [] as any;
                for (let item of _data["searchFields"])
                    this.searchFields!.push(CodeListValueOrder.fromJS(item));
            }
            if (Array.isArray(_data["searchOptions"])) {
                this.searchOptions = [] as any;
                for (let item of _data["searchOptions"])
                    this.searchOptions!.push(CodeListValueOrder.fromJS(item));
            }
            if (Array.isArray(_data["zones"])) {
                this.zones = [] as any;
                for (let item of _data["zones"])
                    this.zones!.push(CodeListValueOrder.fromJS(item));
            }
            if (Array.isArray(_data["groupedSearchOptions"])) {
                this.groupedSearchOptions = [] as any;
                for (let item of _data["groupedSearchOptions"])
                    this.groupedSearchOptions!.push(GroupedCodeListValueOrder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MapRequestsToConfirmData {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestsToConfirmData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mapRequestColumns)) {
            data["mapRequestColumns"] = [];
            for (let item of this.mapRequestColumns)
                data["mapRequestColumns"].push(item ? item.toJSON() : undefined as any);
        }
        data["getMapRequestsInput"] = this.getMapRequestsInput ? this.getMapRequestsInput.toJSON() : undefined as any;
        if (Array.isArray(this.searchFields)) {
            data["searchFields"] = [];
            for (let item of this.searchFields)
                data["searchFields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchOptions)) {
            data["searchOptions"] = [];
            for (let item of this.searchOptions)
                data["searchOptions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.zones)) {
            data["zones"] = [];
            for (let item of this.zones)
                data["zones"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.groupedSearchOptions)) {
            data["groupedSearchOptions"] = [];
            for (let item of this.groupedSearchOptions)
                data["groupedSearchOptions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMapRequestsToConfirmData {
    mapRequestColumns?: Column[] | undefined;
    getMapRequestsInput?: GetMapRequestsToConfirmInput | undefined;
    searchFields?: CodeListValueOrder[] | undefined;
    searchOptions?: CodeListValueOrder[] | undefined;
    zones?: CodeListValueOrder[] | undefined;
    groupedSearchOptions?: GroupedCodeListValueOrder[] | undefined;
}

export class MapRequestsToReplyData implements IMapRequestsToReplyData {
    mapRequestColumns?: Column[] | undefined;
    getMapRequestsInput?: GetMapRequestsToReplyInput | undefined;
    searchOptions?: CodeListValueOrder[] | undefined;
    searchFields?: CodeListValueOrder[] | undefined;
    zones?: CodeListValueOrder[] | undefined;
    groupedSearchOptions?: GroupedCodeListValueOrder[] | undefined;

    constructor(data?: IMapRequestsToReplyData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mapRequestColumns"])) {
                this.mapRequestColumns = [] as any;
                for (let item of _data["mapRequestColumns"])
                    this.mapRequestColumns!.push(Column.fromJS(item));
            }
            this.getMapRequestsInput = _data["getMapRequestsInput"] ? GetMapRequestsToReplyInput.fromJS(_data["getMapRequestsInput"]) : undefined as any;
            if (Array.isArray(_data["searchOptions"])) {
                this.searchOptions = [] as any;
                for (let item of _data["searchOptions"])
                    this.searchOptions!.push(CodeListValueOrder.fromJS(item));
            }
            if (Array.isArray(_data["searchFields"])) {
                this.searchFields = [] as any;
                for (let item of _data["searchFields"])
                    this.searchFields!.push(CodeListValueOrder.fromJS(item));
            }
            if (Array.isArray(_data["zones"])) {
                this.zones = [] as any;
                for (let item of _data["zones"])
                    this.zones!.push(CodeListValueOrder.fromJS(item));
            }
            if (Array.isArray(_data["groupedSearchOptions"])) {
                this.groupedSearchOptions = [] as any;
                for (let item of _data["groupedSearchOptions"])
                    this.groupedSearchOptions!.push(GroupedCodeListValueOrder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MapRequestsToReplyData {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestsToReplyData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mapRequestColumns)) {
            data["mapRequestColumns"] = [];
            for (let item of this.mapRequestColumns)
                data["mapRequestColumns"].push(item ? item.toJSON() : undefined as any);
        }
        data["getMapRequestsInput"] = this.getMapRequestsInput ? this.getMapRequestsInput.toJSON() : undefined as any;
        if (Array.isArray(this.searchOptions)) {
            data["searchOptions"] = [];
            for (let item of this.searchOptions)
                data["searchOptions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchFields)) {
            data["searchFields"] = [];
            for (let item of this.searchFields)
                data["searchFields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.zones)) {
            data["zones"] = [];
            for (let item of this.zones)
                data["zones"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.groupedSearchOptions)) {
            data["groupedSearchOptions"] = [];
            for (let item of this.groupedSearchOptions)
                data["groupedSearchOptions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMapRequestsToReplyData {
    mapRequestColumns?: Column[] | undefined;
    getMapRequestsInput?: GetMapRequestsToReplyInput | undefined;
    searchOptions?: CodeListValueOrder[] | undefined;
    searchFields?: CodeListValueOrder[] | undefined;
    zones?: CodeListValueOrder[] | undefined;
    groupedSearchOptions?: GroupedCodeListValueOrder[] | undefined;
}

export class MapRequestsRepliedData implements IMapRequestsRepliedData {
    mapRequestColumns?: Column[] | undefined;
    getMapRequestsInput?: GetMapRequestsRepliedInput | undefined;
    searchFields?: CodeListValueOrder[] | undefined;
    searchOptions?: CodeListValueOrder[] | undefined;
    zones?: CodeListValueOrder[] | undefined;
    groupedSearchOptions?: GroupedCodeListValueOrder[] | undefined;

    constructor(data?: IMapRequestsRepliedData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mapRequestColumns"])) {
                this.mapRequestColumns = [] as any;
                for (let item of _data["mapRequestColumns"])
                    this.mapRequestColumns!.push(Column.fromJS(item));
            }
            this.getMapRequestsInput = _data["getMapRequestsInput"] ? GetMapRequestsRepliedInput.fromJS(_data["getMapRequestsInput"]) : undefined as any;
            if (Array.isArray(_data["searchFields"])) {
                this.searchFields = [] as any;
                for (let item of _data["searchFields"])
                    this.searchFields!.push(CodeListValueOrder.fromJS(item));
            }
            if (Array.isArray(_data["searchOptions"])) {
                this.searchOptions = [] as any;
                for (let item of _data["searchOptions"])
                    this.searchOptions!.push(CodeListValueOrder.fromJS(item));
            }
            if (Array.isArray(_data["zones"])) {
                this.zones = [] as any;
                for (let item of _data["zones"])
                    this.zones!.push(CodeListValueOrder.fromJS(item));
            }
            if (Array.isArray(_data["groupedSearchOptions"])) {
                this.groupedSearchOptions = [] as any;
                for (let item of _data["groupedSearchOptions"])
                    this.groupedSearchOptions!.push(GroupedCodeListValueOrder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MapRequestsRepliedData {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestsRepliedData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mapRequestColumns)) {
            data["mapRequestColumns"] = [];
            for (let item of this.mapRequestColumns)
                data["mapRequestColumns"].push(item ? item.toJSON() : undefined as any);
        }
        data["getMapRequestsInput"] = this.getMapRequestsInput ? this.getMapRequestsInput.toJSON() : undefined as any;
        if (Array.isArray(this.searchFields)) {
            data["searchFields"] = [];
            for (let item of this.searchFields)
                data["searchFields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.searchOptions)) {
            data["searchOptions"] = [];
            for (let item of this.searchOptions)
                data["searchOptions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.zones)) {
            data["zones"] = [];
            for (let item of this.zones)
                data["zones"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.groupedSearchOptions)) {
            data["groupedSearchOptions"] = [];
            for (let item of this.groupedSearchOptions)
                data["groupedSearchOptions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMapRequestsRepliedData {
    mapRequestColumns?: Column[] | undefined;
    getMapRequestsInput?: GetMapRequestsRepliedInput | undefined;
    searchFields?: CodeListValueOrder[] | undefined;
    searchOptions?: CodeListValueOrder[] | undefined;
    zones?: CodeListValueOrder[] | undefined;
    groupedSearchOptions?: GroupedCodeListValueOrder[] | undefined;
}

export class EnvelopeOfMapRequestViewUna implements IEnvelopeOfMapRequestViewUna {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestViewUna | undefined;

    constructor(data?: IEnvelopeOfMapRequestViewUna) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? MapRequestViewUna.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfMapRequestViewUna {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfMapRequestViewUna();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfMapRequestViewUna {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestViewUna | undefined;
}

export class MapRequestViewUna implements IMapRequestViewUna {
    id?: string;
    reference?: string | undefined;
    zoneName?: string | undefined;
    utilityNetworkAuthorityName?: string | undefined;
    dateReceived?: string;
    deleteDate?: string | undefined;
    startDate?: string;
    endDate?: string;
    mapRequestType?: string | undefined;
    excavationType?: string | undefined;
    excavationMethod?: string | undefined;
    excavationLocation?: string | undefined;
    excavationDepth?: number | undefined;
    excavationDescription?: string | undefined;
    status?: MapRequestDetailUnaStatus;
    statusMessage?: string | undefined;
    lastStatusChange?: string | undefined;
    isProfessionalMapRequest?: boolean;
    fromSubOrganisation?: boolean;
    isClosed?: boolean;
    zoneGeometry?: any | undefined;
    downloadUrls?: DownloadUrl[] | undefined;
    downloadImklUrl?: string | undefined;
    downloadKlipPackageUrl?: string | undefined;
    mapRequestInitiator?: MapRequestInitiatorContactData | undefined;
    mapRequestInitiatorDelivery?: MapRequestInitiatorDeliveryData | undefined;
    archiveUrls?: ArchiveUrls2 | undefined;

    constructor(data?: IMapRequestViewUna) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reference = _data["reference"];
            this.zoneName = _data["zoneName"];
            this.utilityNetworkAuthorityName = _data["utilityNetworkAuthorityName"];
            this.dateReceived = _data["dateReceived"];
            this.deleteDate = _data["deleteDate"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.mapRequestType = _data["mapRequestType"];
            this.excavationType = _data["excavationType"];
            this.excavationMethod = _data["excavationMethod"];
            this.excavationLocation = _data["excavationLocation"];
            this.excavationDepth = _data["excavationDepth"];
            this.excavationDescription = _data["excavationDescription"];
            this.status = _data["status"];
            this.statusMessage = _data["statusMessage"];
            this.lastStatusChange = _data["lastStatusChange"];
            this.isProfessionalMapRequest = _data["isProfessionalMapRequest"];
            this.fromSubOrganisation = _data["fromSubOrganisation"];
            this.isClosed = _data["isClosed"];
            this.zoneGeometry = _data["zoneGeometry"];
            if (Array.isArray(_data["downloadUrls"])) {
                this.downloadUrls = [] as any;
                for (let item of _data["downloadUrls"])
                    this.downloadUrls!.push(DownloadUrl.fromJS(item));
            }
            this.downloadImklUrl = _data["downloadImklUrl"];
            this.downloadKlipPackageUrl = _data["downloadKlipPackageUrl"];
            this.mapRequestInitiator = _data["mapRequestInitiator"] ? MapRequestInitiatorContactData.fromJS(_data["mapRequestInitiator"]) : undefined as any;
            this.mapRequestInitiatorDelivery = _data["mapRequestInitiatorDelivery"] ? MapRequestInitiatorDeliveryData.fromJS(_data["mapRequestInitiatorDelivery"]) : undefined as any;
            this.archiveUrls = _data["archiveUrls"] ? ArchiveUrls2.fromJS(_data["archiveUrls"]) : undefined as any;
        }
    }

    static fromJS(data: any): MapRequestViewUna {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestViewUna();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reference"] = this.reference;
        data["zoneName"] = this.zoneName;
        data["utilityNetworkAuthorityName"] = this.utilityNetworkAuthorityName;
        data["dateReceived"] = this.dateReceived;
        data["deleteDate"] = this.deleteDate;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["mapRequestType"] = this.mapRequestType;
        data["excavationType"] = this.excavationType;
        data["excavationMethod"] = this.excavationMethod;
        data["excavationLocation"] = this.excavationLocation;
        data["excavationDepth"] = this.excavationDepth;
        data["excavationDescription"] = this.excavationDescription;
        data["status"] = this.status;
        data["statusMessage"] = this.statusMessage;
        data["lastStatusChange"] = this.lastStatusChange;
        data["isProfessionalMapRequest"] = this.isProfessionalMapRequest;
        data["fromSubOrganisation"] = this.fromSubOrganisation;
        data["isClosed"] = this.isClosed;
        data["zoneGeometry"] = this.zoneGeometry;
        if (Array.isArray(this.downloadUrls)) {
            data["downloadUrls"] = [];
            for (let item of this.downloadUrls)
                data["downloadUrls"].push(item ? item.toJSON() : undefined as any);
        }
        data["downloadImklUrl"] = this.downloadImklUrl;
        data["downloadKlipPackageUrl"] = this.downloadKlipPackageUrl;
        data["mapRequestInitiator"] = this.mapRequestInitiator ? this.mapRequestInitiator.toJSON() : undefined as any;
        data["mapRequestInitiatorDelivery"] = this.mapRequestInitiatorDelivery ? this.mapRequestInitiatorDelivery.toJSON() : undefined as any;
        data["archiveUrls"] = this.archiveUrls ? this.archiveUrls.toJSON() : undefined as any;
        return data;
    }
}

export interface IMapRequestViewUna {
    id?: string;
    reference?: string | undefined;
    zoneName?: string | undefined;
    utilityNetworkAuthorityName?: string | undefined;
    dateReceived?: string;
    deleteDate?: string | undefined;
    startDate?: string;
    endDate?: string;
    mapRequestType?: string | undefined;
    excavationType?: string | undefined;
    excavationMethod?: string | undefined;
    excavationLocation?: string | undefined;
    excavationDepth?: number | undefined;
    excavationDescription?: string | undefined;
    status?: MapRequestDetailUnaStatus;
    statusMessage?: string | undefined;
    lastStatusChange?: string | undefined;
    isProfessionalMapRequest?: boolean;
    fromSubOrganisation?: boolean;
    isClosed?: boolean;
    zoneGeometry?: any | undefined;
    downloadUrls?: DownloadUrl[] | undefined;
    downloadImklUrl?: string | undefined;
    downloadKlipPackageUrl?: string | undefined;
    mapRequestInitiator?: MapRequestInitiatorContactData | undefined;
    mapRequestInitiatorDelivery?: MapRequestInitiatorDeliveryData | undefined;
    archiveUrls?: ArchiveUrls2 | undefined;
}

export enum MapRequestDetailUnaStatus {
    Assigned = 1,
    Confirmed = 2,
    ConfirmedUploadedImkl = 3,
    ConfirmedInvalidImkl = 4,
    Responded = 5,
    NotInvolved = 6,
    NotAnswered = 7,
    ShouldRespondToMri = 8,
}

export class ArchiveUrls2 implements IArchiveUrls2 {
    downloadArchiveUrl?: string | undefined;

    constructor(data?: IArchiveUrls2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.downloadArchiveUrl = _data["downloadArchiveUrl"];
        }
    }

    static fromJS(data: any): ArchiveUrls2 {
        data = typeof data === 'object' ? data : {};
        let result = new ArchiveUrls2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["downloadArchiveUrl"] = this.downloadArchiveUrl;
        return data;
    }
}

export interface IArchiveUrls2 {
    downloadArchiveUrl?: string | undefined;
}

export class EnvelopeOfUnaViewerViewModel implements IEnvelopeOfUnaViewerViewModel {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: UnaViewerViewModel | undefined;

    constructor(data?: IEnvelopeOfUnaViewerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? UnaViewerViewModel.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfUnaViewerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfUnaViewerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfUnaViewerViewModel {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: UnaViewerViewModel | undefined;
}

export class UnaViewerViewModel implements IUnaViewerViewModel {
    mapRequestReference?: string | undefined;
    getPmklUrl?: string | undefined;
    getPmklStreamUrl?: string | undefined;
    getWfsUrl?: string | undefined;
    getWfsStreamUrl?: string | undefined;
    getKmHmStreamUrl?: string | undefined;
    downloadImklAttachmentUrl?: string | undefined;
    downloadPmklFileUrl?: string | undefined;
    mapRequestZoneDownloadUrls?: DownloadUrl[] | undefined;

    constructor(data?: IUnaViewerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestReference = _data["mapRequestReference"];
            this.getPmklUrl = _data["getPmklUrl"];
            this.getPmklStreamUrl = _data["getPmklStreamUrl"];
            this.getWfsUrl = _data["getWfsUrl"];
            this.getWfsStreamUrl = _data["getWfsStreamUrl"];
            this.getKmHmStreamUrl = _data["getKmHmStreamUrl"];
            this.downloadImklAttachmentUrl = _data["downloadImklAttachmentUrl"];
            this.downloadPmklFileUrl = _data["downloadPmklFileUrl"];
            if (Array.isArray(_data["mapRequestZoneDownloadUrls"])) {
                this.mapRequestZoneDownloadUrls = [] as any;
                for (let item of _data["mapRequestZoneDownloadUrls"])
                    this.mapRequestZoneDownloadUrls!.push(DownloadUrl.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UnaViewerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UnaViewerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestReference"] = this.mapRequestReference;
        data["getPmklUrl"] = this.getPmklUrl;
        data["getPmklStreamUrl"] = this.getPmklStreamUrl;
        data["getWfsUrl"] = this.getWfsUrl;
        data["getWfsStreamUrl"] = this.getWfsStreamUrl;
        data["getKmHmStreamUrl"] = this.getKmHmStreamUrl;
        data["downloadImklAttachmentUrl"] = this.downloadImklAttachmentUrl;
        data["downloadPmklFileUrl"] = this.downloadPmklFileUrl;
        if (Array.isArray(this.mapRequestZoneDownloadUrls)) {
            data["mapRequestZoneDownloadUrls"] = [];
            for (let item of this.mapRequestZoneDownloadUrls)
                data["mapRequestZoneDownloadUrls"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUnaViewerViewModel {
    mapRequestReference?: string | undefined;
    getPmklUrl?: string | undefined;
    getPmklStreamUrl?: string | undefined;
    getWfsUrl?: string | undefined;
    getWfsStreamUrl?: string | undefined;
    getKmHmStreamUrl?: string | undefined;
    downloadImklAttachmentUrl?: string | undefined;
    downloadPmklFileUrl?: string | undefined;
    mapRequestZoneDownloadUrls?: DownloadUrl[] | undefined;
}

export class EnvelopeOfUnaZoneCreateView implements IEnvelopeOfUnaZoneCreateView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: UnaZoneCreateView | undefined;

    constructor(data?: IEnvelopeOfUnaZoneCreateView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? UnaZoneCreateView.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfUnaZoneCreateView {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfUnaZoneCreateView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfUnaZoneCreateView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: UnaZoneCreateView | undefined;
}

export class UnaZoneCreateView implements IUnaZoneCreateView {
    confirmationExampleUri?: string | undefined;
    reminder1DayToRespondExampleUri?: string | undefined;
    uploadImklSuccessExampleUri?: string | undefined;
    uploadImklFailedExampleUri?: string | undefined;
    respondedNotInvolvedExampleUri?: string | undefined;

    constructor(data?: IUnaZoneCreateView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.confirmationExampleUri = _data["confirmationExampleUri"];
            this.reminder1DayToRespondExampleUri = _data["reminder1DayToRespondExampleUri"];
            this.uploadImklSuccessExampleUri = _data["uploadImklSuccessExampleUri"];
            this.uploadImklFailedExampleUri = _data["uploadImklFailedExampleUri"];
            this.respondedNotInvolvedExampleUri = _data["respondedNotInvolvedExampleUri"];
        }
    }

    static fromJS(data: any): UnaZoneCreateView {
        data = typeof data === 'object' ? data : {};
        let result = new UnaZoneCreateView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confirmationExampleUri"] = this.confirmationExampleUri;
        data["reminder1DayToRespondExampleUri"] = this.reminder1DayToRespondExampleUri;
        data["uploadImklSuccessExampleUri"] = this.uploadImklSuccessExampleUri;
        data["uploadImklFailedExampleUri"] = this.uploadImklFailedExampleUri;
        data["respondedNotInvolvedExampleUri"] = this.respondedNotInvolvedExampleUri;
        return data;
    }
}

export interface IUnaZoneCreateView {
    confirmationExampleUri?: string | undefined;
    reminder1DayToRespondExampleUri?: string | undefined;
    uploadImklSuccessExampleUri?: string | undefined;
    uploadImklFailedExampleUri?: string | undefined;
    respondedNotInvolvedExampleUri?: string | undefined;
}

export class EnvelopeOfUnaZoneEditView implements IEnvelopeOfUnaZoneEditView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: UnaZoneEditView | undefined;

    constructor(data?: IEnvelopeOfUnaZoneEditView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? UnaZoneEditView.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfUnaZoneEditView {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfUnaZoneEditView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfUnaZoneEditView {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: UnaZoneEditView | undefined;
}

export class EnvelopeOfKlipZoneCreated implements IEnvelopeOfKlipZoneCreated {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: KlipZoneCreated | undefined;

    constructor(data?: IEnvelopeOfKlipZoneCreated) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? KlipZoneCreated.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfKlipZoneCreated {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfKlipZoneCreated();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfKlipZoneCreated {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: KlipZoneCreated | undefined;
}

export class KlipZoneCreated implements IKlipZoneCreated {
    id?: string;

    constructor(data?: IKlipZoneCreated) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): KlipZoneCreated {
        data = typeof data === 'object' ? data : {};
        let result = new KlipZoneCreated();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IKlipZoneCreated {
    id?: string;
}

export class CreateKlipZoneInput implements ICreateKlipZoneInput {
    name?: string | undefined;
    organisationId?: string;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    contactTelephone?: string | undefined;
    extraInformation?: string | undefined;
    mapRequestEmail?: string | undefined;
    alarmCentralTelephone?: string | undefined;
    geometryReference?: string | undefined;
    geometryWkt?: string | undefined;
    geometryVersion?: string | undefined;
    geometryLastModificationDate?: string | undefined;
    geometryPrecision?: number | undefined;
    geometryActivationDate?: string;
    namespace?: string | undefined;
    confirmation?: boolean;
    reminder1DayToRespond?: boolean;
    uploadImklSuccess?: boolean;
    uploadImklFailed?: boolean;
    respondedNotInvolved?: boolean;

    constructor(data?: ICreateKlipZoneInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.organisationId = _data["organisationId"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.contactTelephone = _data["contactTelephone"];
            this.extraInformation = _data["extraInformation"];
            this.mapRequestEmail = _data["mapRequestEmail"];
            this.alarmCentralTelephone = _data["alarmCentralTelephone"];
            this.geometryReference = _data["geometryReference"];
            this.geometryWkt = _data["geometryWkt"];
            this.geometryVersion = _data["geometryVersion"];
            this.geometryLastModificationDate = _data["geometryLastModificationDate"];
            this.geometryPrecision = _data["geometryPrecision"];
            this.geometryActivationDate = _data["geometryActivationDate"];
            this.namespace = _data["namespace"];
            this.confirmation = _data["confirmation"];
            this.reminder1DayToRespond = _data["reminder1DayToRespond"];
            this.uploadImklSuccess = _data["uploadImklSuccess"];
            this.uploadImklFailed = _data["uploadImklFailed"];
            this.respondedNotInvolved = _data["respondedNotInvolved"];
        }
    }

    static fromJS(data: any): CreateKlipZoneInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateKlipZoneInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["organisationId"] = this.organisationId;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["contactTelephone"] = this.contactTelephone;
        data["extraInformation"] = this.extraInformation;
        data["mapRequestEmail"] = this.mapRequestEmail;
        data["alarmCentralTelephone"] = this.alarmCentralTelephone;
        data["geometryReference"] = this.geometryReference;
        data["geometryWkt"] = this.geometryWkt;
        data["geometryVersion"] = this.geometryVersion;
        data["geometryLastModificationDate"] = this.geometryLastModificationDate;
        data["geometryPrecision"] = this.geometryPrecision;
        data["geometryActivationDate"] = this.geometryActivationDate;
        data["namespace"] = this.namespace;
        data["confirmation"] = this.confirmation;
        data["reminder1DayToRespond"] = this.reminder1DayToRespond;
        data["uploadImklSuccess"] = this.uploadImklSuccess;
        data["uploadImklFailed"] = this.uploadImklFailed;
        data["respondedNotInvolved"] = this.respondedNotInvolved;
        return data;
    }
}

export interface ICreateKlipZoneInput {
    name?: string | undefined;
    organisationId?: string;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    contactTelephone?: string | undefined;
    extraInformation?: string | undefined;
    mapRequestEmail?: string | undefined;
    alarmCentralTelephone?: string | undefined;
    geometryReference?: string | undefined;
    geometryWkt?: string | undefined;
    geometryVersion?: string | undefined;
    geometryLastModificationDate?: string | undefined;
    geometryPrecision?: number | undefined;
    geometryActivationDate?: string;
    namespace?: string | undefined;
    confirmation?: boolean;
    reminder1DayToRespond?: boolean;
    uploadImklSuccess?: boolean;
    uploadImklFailed?: boolean;
    respondedNotInvolved?: boolean;
}

export class UpdateKlipZoneInput implements IUpdateKlipZoneInput {
    id?: string;
    organisationId?: string;
    name?: string | undefined;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    contactTelephone?: string | undefined;
    extraInformation?: string | undefined;
    mapRequestEmail?: string | undefined;
    alarmCentralTelephone?: string | undefined;
    namespace?: string | undefined;
    geometries?: GeometryInput[] | undefined;
    confirmation?: boolean;
    reminder1DayToRespond?: boolean;
    uploadImklSuccess?: boolean;
    uploadImklFailed?: boolean;
    respondedNotInvolved?: boolean;

    constructor(data?: IUpdateKlipZoneInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organisationId = _data["organisationId"];
            this.name = _data["name"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.contactTelephone = _data["contactTelephone"];
            this.extraInformation = _data["extraInformation"];
            this.mapRequestEmail = _data["mapRequestEmail"];
            this.alarmCentralTelephone = _data["alarmCentralTelephone"];
            this.namespace = _data["namespace"];
            if (Array.isArray(_data["geometries"])) {
                this.geometries = [] as any;
                for (let item of _data["geometries"])
                    this.geometries!.push(GeometryInput.fromJS(item));
            }
            this.confirmation = _data["confirmation"];
            this.reminder1DayToRespond = _data["reminder1DayToRespond"];
            this.uploadImklSuccess = _data["uploadImklSuccess"];
            this.uploadImklFailed = _data["uploadImklFailed"];
            this.respondedNotInvolved = _data["respondedNotInvolved"];
        }
    }

    static fromJS(data: any): UpdateKlipZoneInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateKlipZoneInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organisationId"] = this.organisationId;
        data["name"] = this.name;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["contactTelephone"] = this.contactTelephone;
        data["extraInformation"] = this.extraInformation;
        data["mapRequestEmail"] = this.mapRequestEmail;
        data["alarmCentralTelephone"] = this.alarmCentralTelephone;
        data["namespace"] = this.namespace;
        if (Array.isArray(this.geometries)) {
            data["geometries"] = [];
            for (let item of this.geometries)
                data["geometries"].push(item ? item.toJSON() : undefined as any);
        }
        data["confirmation"] = this.confirmation;
        data["reminder1DayToRespond"] = this.reminder1DayToRespond;
        data["uploadImklSuccess"] = this.uploadImklSuccess;
        data["uploadImklFailed"] = this.uploadImklFailed;
        data["respondedNotInvolved"] = this.respondedNotInvolved;
        return data;
    }
}

export interface IUpdateKlipZoneInput {
    id?: string;
    organisationId?: string;
    name?: string | undefined;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    contactTelephone?: string | undefined;
    extraInformation?: string | undefined;
    mapRequestEmail?: string | undefined;
    alarmCentralTelephone?: string | undefined;
    namespace?: string | undefined;
    geometries?: GeometryInput[] | undefined;
    confirmation?: boolean;
    reminder1DayToRespond?: boolean;
    uploadImklSuccess?: boolean;
    uploadImklFailed?: boolean;
    respondedNotInvolved?: boolean;
}

export class GeometryInput implements IGeometryInput {
    id?: string | undefined;
    reference?: string | undefined;
    wkt?: string | undefined;
    version?: string | undefined;
    lastModificationDate?: string | undefined;
    precision?: number | undefined;
    activationDate?: string;
    isActive?: boolean;

    constructor(data?: IGeometryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reference = _data["reference"];
            this.wkt = _data["wkt"];
            this.version = _data["version"];
            this.lastModificationDate = _data["lastModificationDate"];
            this.precision = _data["precision"];
            this.activationDate = _data["activationDate"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): GeometryInput {
        data = typeof data === 'object' ? data : {};
        let result = new GeometryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reference"] = this.reference;
        data["wkt"] = this.wkt;
        data["version"] = this.version;
        data["lastModificationDate"] = this.lastModificationDate;
        data["precision"] = this.precision;
        data["activationDate"] = this.activationDate;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IGeometryInput {
    id?: string | undefined;
    reference?: string | undefined;
    wkt?: string | undefined;
    version?: string | undefined;
    lastModificationDate?: string | undefined;
    precision?: number | undefined;
    activationDate?: string;
    isActive?: boolean;
}

export class EnvelopeOfKlimZoneCreated implements IEnvelopeOfKlimZoneCreated {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: KlimZoneCreated | undefined;

    constructor(data?: IEnvelopeOfKlimZoneCreated) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? KlimZoneCreated.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfKlimZoneCreated {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfKlimZoneCreated();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfKlimZoneCreated {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: KlimZoneCreated | undefined;
}

export class KlimZoneCreated implements IKlimZoneCreated {
    id?: string;

    constructor(data?: IKlimZoneCreated) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): KlimZoneCreated {
        data = typeof data === 'object' ? data : {};
        let result = new KlimZoneCreated();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IKlimZoneCreated {
    id?: string;
}

export class CreateKlimZoneInput implements ICreateKlimZoneInput {
    name?: string | undefined;
    organisationId?: string;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    contactEmailEmergency?: string | undefined;
    contactTelephone?: string | undefined;
    extraInformation?: string | undefined;
    mapRequestEmail?: string | undefined;
    alarmCentralTelephone?: string | undefined;
    namespace?: string | undefined;
    sendConfirmation?: boolean;
    sendReminder1DayToRespond?: boolean;
    sendUploadImklSuccess?: boolean;
    sendUploadImklFailed?: boolean;
    sendRespondedNotInvolved?: boolean;

    constructor(data?: ICreateKlimZoneInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.organisationId = _data["organisationId"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.contactEmailEmergency = _data["contactEmailEmergency"];
            this.contactTelephone = _data["contactTelephone"];
            this.extraInformation = _data["extraInformation"];
            this.mapRequestEmail = _data["mapRequestEmail"];
            this.alarmCentralTelephone = _data["alarmCentralTelephone"];
            this.namespace = _data["namespace"];
            this.sendConfirmation = _data["sendConfirmation"];
            this.sendReminder1DayToRespond = _data["sendReminder1DayToRespond"];
            this.sendUploadImklSuccess = _data["sendUploadImklSuccess"];
            this.sendUploadImklFailed = _data["sendUploadImklFailed"];
            this.sendRespondedNotInvolved = _data["sendRespondedNotInvolved"];
        }
    }

    static fromJS(data: any): CreateKlimZoneInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateKlimZoneInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["organisationId"] = this.organisationId;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["contactEmailEmergency"] = this.contactEmailEmergency;
        data["contactTelephone"] = this.contactTelephone;
        data["extraInformation"] = this.extraInformation;
        data["mapRequestEmail"] = this.mapRequestEmail;
        data["alarmCentralTelephone"] = this.alarmCentralTelephone;
        data["namespace"] = this.namespace;
        data["sendConfirmation"] = this.sendConfirmation;
        data["sendReminder1DayToRespond"] = this.sendReminder1DayToRespond;
        data["sendUploadImklSuccess"] = this.sendUploadImklSuccess;
        data["sendUploadImklFailed"] = this.sendUploadImklFailed;
        data["sendRespondedNotInvolved"] = this.sendRespondedNotInvolved;
        return data;
    }
}

export interface ICreateKlimZoneInput {
    name?: string | undefined;
    organisationId?: string;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    contactEmailEmergency?: string | undefined;
    contactTelephone?: string | undefined;
    extraInformation?: string | undefined;
    mapRequestEmail?: string | undefined;
    alarmCentralTelephone?: string | undefined;
    namespace?: string | undefined;
    sendConfirmation?: boolean;
    sendReminder1DayToRespond?: boolean;
    sendUploadImklSuccess?: boolean;
    sendUploadImklFailed?: boolean;
    sendRespondedNotInvolved?: boolean;
}

export class UpdateKlimZoneInput implements IUpdateKlimZoneInput {
    id?: string;
    organisationId?: string;
    name?: string | undefined;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    contactEmailEmergency?: string | undefined;
    contactTelephone?: string | undefined;
    extraInformation?: string | undefined;
    mapRequestEmail?: string | undefined;
    alarmCentralTelephone?: string | undefined;
    namespace?: string | undefined;
    sendConfirmation?: boolean;
    sendReminder1DayToRespond?: boolean;
    sendUploadImklSuccess?: boolean;
    sendUploadImklFailed?: boolean;
    sendRespondedNotInvolved?: boolean;

    constructor(data?: IUpdateKlimZoneInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organisationId = _data["organisationId"];
            this.name = _data["name"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.contactEmailEmergency = _data["contactEmailEmergency"];
            this.contactTelephone = _data["contactTelephone"];
            this.extraInformation = _data["extraInformation"];
            this.mapRequestEmail = _data["mapRequestEmail"];
            this.alarmCentralTelephone = _data["alarmCentralTelephone"];
            this.namespace = _data["namespace"];
            this.sendConfirmation = _data["sendConfirmation"];
            this.sendReminder1DayToRespond = _data["sendReminder1DayToRespond"];
            this.sendUploadImklSuccess = _data["sendUploadImklSuccess"];
            this.sendUploadImklFailed = _data["sendUploadImklFailed"];
            this.sendRespondedNotInvolved = _data["sendRespondedNotInvolved"];
        }
    }

    static fromJS(data: any): UpdateKlimZoneInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateKlimZoneInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organisationId"] = this.organisationId;
        data["name"] = this.name;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["contactEmailEmergency"] = this.contactEmailEmergency;
        data["contactTelephone"] = this.contactTelephone;
        data["extraInformation"] = this.extraInformation;
        data["mapRequestEmail"] = this.mapRequestEmail;
        data["alarmCentralTelephone"] = this.alarmCentralTelephone;
        data["namespace"] = this.namespace;
        data["sendConfirmation"] = this.sendConfirmation;
        data["sendReminder1DayToRespond"] = this.sendReminder1DayToRespond;
        data["sendUploadImklSuccess"] = this.sendUploadImklSuccess;
        data["sendUploadImklFailed"] = this.sendUploadImklFailed;
        data["sendRespondedNotInvolved"] = this.sendRespondedNotInvolved;
        return data;
    }
}

export interface IUpdateKlimZoneInput {
    id?: string;
    organisationId?: string;
    name?: string | undefined;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    contactEmailEmergency?: string | undefined;
    contactTelephone?: string | undefined;
    extraInformation?: string | undefined;
    mapRequestEmail?: string | undefined;
    alarmCentralTelephone?: string | undefined;
    namespace?: string | undefined;
    sendConfirmation?: boolean;
    sendReminder1DayToRespond?: boolean;
    sendUploadImklSuccess?: boolean;
    sendUploadImklFailed?: boolean;
    sendRespondedNotInvolved?: boolean;
}

export class EnvelopeOfIListOfString implements IEnvelopeOfIListOfString {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: string[] | undefined;

    constructor(data?: IEnvelopeOfIListOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(item);
            }
        }
    }

    static fromJS(data: any): EnvelopeOfIListOfString {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfIListOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item);
        }
        return data;
    }
}

export interface IEnvelopeOfIListOfString {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: string[] | undefined;
}

export class GetUnaManagerEmailAddressesQuery implements IGetUnaManagerEmailAddressesQuery {
    klipOrganisationIds?: string[] | undefined;

    constructor(data?: IGetUnaManagerEmailAddressesQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["klipOrganisationIds"])) {
                this.klipOrganisationIds = [] as any;
                for (let item of _data["klipOrganisationIds"])
                    this.klipOrganisationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUnaManagerEmailAddressesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetUnaManagerEmailAddressesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.klipOrganisationIds)) {
            data["klipOrganisationIds"] = [];
            for (let item of this.klipOrganisationIds)
                data["klipOrganisationIds"].push(item);
        }
        return data;
    }
}

export interface IGetUnaManagerEmailAddressesQuery {
    klipOrganisationIds?: string[] | undefined;
}

export class MoveZoneInput implements IMoveZoneInput {
    zoneId?: string;
    targetKlipOrganisationId?: string;
    reason?: string | undefined;
    mailTo?: string[] | undefined;

    constructor(data?: IMoveZoneInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zoneId = _data["zoneId"];
            this.targetKlipOrganisationId = _data["targetKlipOrganisationId"];
            this.reason = _data["reason"];
            if (Array.isArray(_data["mailTo"])) {
                this.mailTo = [] as any;
                for (let item of _data["mailTo"])
                    this.mailTo!.push(item);
            }
        }
    }

    static fromJS(data: any): MoveZoneInput {
        data = typeof data === 'object' ? data : {};
        let result = new MoveZoneInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoneId"] = this.zoneId;
        data["targetKlipOrganisationId"] = this.targetKlipOrganisationId;
        data["reason"] = this.reason;
        if (Array.isArray(this.mailTo)) {
            data["mailTo"] = [];
            for (let item of this.mailTo)
                data["mailTo"].push(item);
        }
        return data;
    }
}

export interface IMoveZoneInput {
    zoneId?: string;
    targetKlipOrganisationId?: string;
    reason?: string | undefined;
    mailTo?: string[] | undefined;
}

export class IsGeometryWithinBufferedFlandersInput implements IIsGeometryWithinBufferedFlandersInput {
    geometry?: string | undefined;

    constructor(data?: IIsGeometryWithinBufferedFlandersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.geometry = _data["geometry"];
        }
    }

    static fromJS(data: any): IsGeometryWithinBufferedFlandersInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsGeometryWithinBufferedFlandersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geometry"] = this.geometry;
        return data;
    }
}

export interface IIsGeometryWithinBufferedFlandersInput {
    geometry?: string | undefined;
}

export class IsGeometryIntersectingFlandersInput implements IIsGeometryIntersectingFlandersInput {
    geometry?: string | undefined;

    constructor(data?: IIsGeometryIntersectingFlandersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.geometry = _data["geometry"];
        }
    }

    static fromJS(data: any): IsGeometryIntersectingFlandersInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsGeometryIntersectingFlandersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geometry"] = this.geometry;
        return data;
    }
}

export interface IIsGeometryIntersectingFlandersInput {
    geometry?: string | undefined;
}

export class EnvelopeOfIEnumerableOfEventDto implements IEnvelopeOfIEnumerableOfEventDto {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: EventDto[] | undefined;

    constructor(data?: IEnvelopeOfIEnumerableOfEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(EventDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvelopeOfIEnumerableOfEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfIEnumerableOfEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnvelopeOfIEnumerableOfEventDto {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: EventDto[] | undefined;
}

export class EventDto implements IEventDto {
    id?: string | undefined;
    eventStoreType?: EventStoreType;
    version?: number;
    appliedOn?: string;
    name?: string | undefined;
    metadata?: { [key: string]: string; } | undefined;
    payload?: any | undefined;
    fullTextSearch?: string | undefined;

    constructor(data?: IEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eventStoreType = _data["eventStoreType"];
            this.version = _data["version"];
            this.appliedOn = _data["appliedOn"];
            this.name = _data["name"];
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (this.metadata as any)![key] = _data["metadata"][key];
                }
            }
            this.payload = _data["payload"];
            this.fullTextSearch = _data["fullTextSearch"];
        }
    }

    static fromJS(data: any): EventDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eventStoreType"] = this.eventStoreType;
        data["version"] = this.version;
        data["appliedOn"] = this.appliedOn;
        data["name"] = this.name;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (data["metadata"] as any)[key] = (this.metadata as any)[key];
            }
        }
        data["payload"] = this.payload;
        data["fullTextSearch"] = this.fullTextSearch;
        return data;
    }
}

export interface IEventDto {
    id?: string | undefined;
    eventStoreType?: EventStoreType;
    version?: number;
    appliedOn?: string;
    name?: string | undefined;
    metadata?: { [key: string]: string; } | undefined;
    payload?: any | undefined;
    fullTextSearch?: string | undefined;
}

export enum EventStoreType {
    MapRequest = 0,
    Una = 10,
}

export class GetEventsRequest implements IGetEventsRequest {
    eventStoreType?: EventStoreType;
    mapRequestId?: string | undefined;
    unaId?: number | undefined;

    constructor(data?: IGetEventsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventStoreType = _data["eventStoreType"];
            this.mapRequestId = _data["mapRequestId"];
            this.unaId = _data["unaId"];
        }
    }

    static fromJS(data: any): GetEventsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetEventsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventStoreType"] = this.eventStoreType;
        data["mapRequestId"] = this.mapRequestId;
        data["unaId"] = this.unaId;
        return data;
    }
}

export interface IGetEventsRequest {
    eventStoreType?: EventStoreType;
    mapRequestId?: string | undefined;
    unaId?: number | undefined;
}

export class ReplayEventsRequest implements IReplayEventsRequest {
    mapRequestId?: string | undefined;
    unaId?: number | undefined;
    eventStore?: EventStoreType;
    versions?: number[] | undefined;

    constructor(data?: IReplayEventsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestId = _data["mapRequestId"];
            this.unaId = _data["unaId"];
            this.eventStore = _data["eventStore"];
            if (Array.isArray(_data["versions"])) {
                this.versions = [] as any;
                for (let item of _data["versions"])
                    this.versions!.push(item);
            }
        }
    }

    static fromJS(data: any): ReplayEventsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReplayEventsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestId"] = this.mapRequestId;
        data["unaId"] = this.unaId;
        data["eventStore"] = this.eventStore;
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item);
        }
        return data;
    }
}

export interface IReplayEventsRequest {
    mapRequestId?: string | undefined;
    unaId?: number | undefined;
    eventStore?: EventStoreType;
    versions?: number[] | undefined;
}

export class EnvelopeOfStartInvoiceRoundResponse implements IEnvelopeOfStartInvoiceRoundResponse {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: StartInvoiceRoundResponse | undefined;

    constructor(data?: IEnvelopeOfStartInvoiceRoundResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? StartInvoiceRoundResponse.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfStartInvoiceRoundResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfStartInvoiceRoundResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfStartInvoiceRoundResponse {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: StartInvoiceRoundResponse | undefined;
}

export class StartInvoiceRoundResponse implements IStartInvoiceRoundResponse {
    success?: boolean;
    invoiceRoundId?: string | undefined;
    failure?: FailureResult | undefined;

    constructor(data?: IStartInvoiceRoundResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.invoiceRoundId = _data["invoiceRoundId"];
            this.failure = _data["failure"] ? FailureResult.fromJS(_data["failure"]) : undefined as any;
        }
    }

    static fromJS(data: any): StartInvoiceRoundResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StartInvoiceRoundResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["invoiceRoundId"] = this.invoiceRoundId;
        data["failure"] = this.failure ? this.failure.toJSON() : undefined as any;
        return data;
    }
}

export interface IStartInvoiceRoundResponse {
    success?: boolean;
    invoiceRoundId?: string | undefined;
    failure?: FailureResult | undefined;
}

export class StartInvoicingRoundRequest implements IStartInvoicingRoundRequest {
    startDate?: string;
    startMethod?: InvoicingRoundStartMethod;
    organisations?: string[] | undefined;

    constructor(data?: IStartInvoicingRoundRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"];
            this.startMethod = _data["startMethod"];
            if (Array.isArray(_data["organisations"])) {
                this.organisations = [] as any;
                for (let item of _data["organisations"])
                    this.organisations!.push(item);
            }
        }
    }

    static fromJS(data: any): StartInvoicingRoundRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StartInvoicingRoundRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate;
        data["startMethod"] = this.startMethod;
        if (Array.isArray(this.organisations)) {
            data["organisations"] = [];
            for (let item of this.organisations)
                data["organisations"].push(item);
        }
        return data;
    }
}

export interface IStartInvoicingRoundRequest {
    startDate?: string;
    startMethod?: InvoicingRoundStartMethod;
    organisations?: string[] | undefined;
}

export enum InvoicingRoundStartMethod {
    Default = 0,
    DryRunOnly = 1,
    DryRunOverruleAndStart = 2,
}

export class EnvelopeOfCurrentInvoiceRound implements IEnvelopeOfCurrentInvoiceRound {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: CurrentInvoiceRound | undefined;

    constructor(data?: IEnvelopeOfCurrentInvoiceRound) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? CurrentInvoiceRound.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfCurrentInvoiceRound {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfCurrentInvoiceRound();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfCurrentInvoiceRound {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: CurrentInvoiceRound | undefined;
}

export class CurrentInvoiceRound implements ICurrentInvoiceRound {
    state?: InvoiceStates;
    invoicedRunId?: string | undefined;
    invoicedDryRunId?: string | undefined;
    startTime?: string;
    endTime?: string | undefined;
    log?: InvoicingLogMessage[] | undefined;
    incorrectVatNumbers?: InvoicingIncorrectVatNumberLog[] | undefined;

    constructor(data?: ICurrentInvoiceRound) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.invoicedRunId = _data["invoicedRunId"];
            this.invoicedDryRunId = _data["invoicedDryRunId"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            if (Array.isArray(_data["log"])) {
                this.log = [] as any;
                for (let item of _data["log"])
                    this.log!.push(InvoicingLogMessage.fromJS(item));
            }
            if (Array.isArray(_data["incorrectVatNumbers"])) {
                this.incorrectVatNumbers = [] as any;
                for (let item of _data["incorrectVatNumbers"])
                    this.incorrectVatNumbers!.push(InvoicingIncorrectVatNumberLog.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CurrentInvoiceRound {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentInvoiceRound();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["invoicedRunId"] = this.invoicedRunId;
        data["invoicedDryRunId"] = this.invoicedDryRunId;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        if (Array.isArray(this.log)) {
            data["log"] = [];
            for (let item of this.log)
                data["log"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.incorrectVatNumbers)) {
            data["incorrectVatNumbers"] = [];
            for (let item of this.incorrectVatNumbers)
                data["incorrectVatNumbers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICurrentInvoiceRound {
    state?: InvoiceStates;
    invoicedRunId?: string | undefined;
    invoicedDryRunId?: string | undefined;
    startTime?: string;
    endTime?: string | undefined;
    log?: InvoicingLogMessage[] | undefined;
    incorrectVatNumbers?: InvoicingIncorrectVatNumberLog[] | undefined;
}

export enum InvoiceStates {
    Created = 0,
    OrganisationsSelected = 1,
    NoOrganisations = 2,
    ValidatingVatNumbers = 3,
    VatNumbersValidated = 4,
    VatNumbersValidatedWithIssues = 5,
    GeneratingInvoices = 6,
    InvoicesGenerated = 7,
    GeneratingOrafinFile = 8,
    OrafinFileGenerated = 9,
    SavingInvoices = 10,
    InvoicesSaved = 11,
    SendingInvoices = 12,
    InvoicesSent = 13,
    NoInvoicesToGenerate = 14,
    CopyingOrafinAndCsvsFiles = 15,
    CopyOrafinAndCsvsFilesFailed = 16,
    CopyOrafinAndCsvsFilesSucceeded = 17,
    ValidateOrafinFeedbackFile = 18,
    ValidateOrafinFeedbackFileSucceeded = 19,
    ValidateOrafinFeedbackFileFailed = 20,
    VerifyOrafinFeedbackFile = 21,
    VerifyOrafinFeedbackFileSucceeded = 22,
    Canceling = 23,
    Canceled = 24,
    Completed = 25,
    NotStarted = 26,
}

export class InvoicingLogMessage implements IInvoicingLogMessage {
    message?: string | undefined;
    timestamp?: string;
    logTypes?: LogTypes;

    constructor(data?: IInvoicingLogMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.timestamp = _data["timestamp"];
            this.logTypes = _data["logTypes"];
        }
    }

    static fromJS(data: any): InvoicingLogMessage {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicingLogMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["timestamp"] = this.timestamp;
        data["logTypes"] = this.logTypes;
        return data;
    }
}

export interface IInvoicingLogMessage {
    message?: string | undefined;
    timestamp?: string;
    logTypes?: LogTypes;
}

export enum LogTypes {
    Info = 0,
    Warning = 1,
    Error = 2,
}

export class InvoicingIncorrectVatNumberLog implements IInvoicingIncorrectVatNumberLog {
    organisationStates?: OrganisationStates;
    vatNumber?: string | undefined;

    constructor(data?: IInvoicingIncorrectVatNumberLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationStates = _data["organisationStates"];
            this.vatNumber = _data["vatNumber"];
        }
    }

    static fromJS(data: any): InvoicingIncorrectVatNumberLog {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicingIncorrectVatNumberLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationStates"] = this.organisationStates;
        data["vatNumber"] = this.vatNumber;
        return data;
    }
}

export interface IInvoicingIncorrectVatNumberLog {
    organisationStates?: OrganisationStates;
    vatNumber?: string | undefined;
}

export enum OrganisationStates {
    Selected = 0,
    InvalidVatNumber = 1,
    ValidKboState = 2,
    InactiveOrAbnormalKboState = 3,
    VatNumberNotFound = 4,
    MagdaConnectionError = 5,
    Invoiced = 6,
}

export class EnvelopeOfIListOfMapRequestWithFinancialAnomalies implements IEnvelopeOfIListOfMapRequestWithFinancialAnomalies {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestWithFinancialAnomalies[] | undefined;

    constructor(data?: IEnvelopeOfIListOfMapRequestWithFinancialAnomalies) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(MapRequestWithFinancialAnomalies.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvelopeOfIListOfMapRequestWithFinancialAnomalies {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfIListOfMapRequestWithFinancialAnomalies();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnvelopeOfIListOfMapRequestWithFinancialAnomalies {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestWithFinancialAnomalies[] | undefined;
}

export class MapRequestWithFinancialAnomalies implements IMapRequestWithFinancialAnomalies {
    mapRequestId!: string;
    dateReceived!: string;
    invoiceNumber?: string | undefined;

    constructor(data?: IMapRequestWithFinancialAnomalies) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestId = _data["mapRequestId"];
            this.dateReceived = _data["dateReceived"];
            this.invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): MapRequestWithFinancialAnomalies {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestWithFinancialAnomalies();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestId"] = this.mapRequestId;
        data["dateReceived"] = this.dateReceived;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }
}

export interface IMapRequestWithFinancialAnomalies {
    mapRequestId: string;
    dateReceived: string;
    invoiceNumber?: string | undefined;
}

export class EnvelopeOfPerformanceData implements IEnvelopeOfPerformanceData {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: PerformanceData | undefined;

    constructor(data?: IEnvelopeOfPerformanceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? PerformanceData.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfPerformanceData {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfPerformanceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfPerformanceData {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: PerformanceData | undefined;
}

export class PerformanceData implements IPerformanceData {
    queues?: ServiceInfo[] | undefined;

    constructor(data?: IPerformanceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["queues"])) {
                this.queues = [] as any;
                for (let item of _data["queues"])
                    this.queues!.push(ServiceInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PerformanceData {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.queues)) {
            data["queues"] = [];
            for (let item of this.queues)
                data["queues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPerformanceData {
    queues?: ServiceInfo[] | undefined;
}

export class ServiceInfo implements IServiceInfo {
    name?: string | undefined;
    activeMessageCount?: number;
    deadLetterMessageCount?: number;

    constructor(data?: IServiceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.activeMessageCount = _data["activeMessageCount"];
            this.deadLetterMessageCount = _data["deadLetterMessageCount"];
        }
    }

    static fromJS(data: any): ServiceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["activeMessageCount"] = this.activeMessageCount;
        data["deadLetterMessageCount"] = this.deadLetterMessageCount;
        return data;
    }
}

export interface IServiceInfo {
    name?: string | undefined;
    activeMessageCount?: number;
    deadLetterMessageCount?: number;
}

export class EnvelopeOfPerformanceDataDetail implements IEnvelopeOfPerformanceDataDetail {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: PerformanceDataDetail | undefined;

    constructor(data?: IEnvelopeOfPerformanceDataDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? PerformanceDataDetail.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfPerformanceDataDetail {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfPerformanceDataDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfPerformanceDataDetail {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: PerformanceDataDetail | undefined;
}

export class PerformanceDataDetail implements IPerformanceDataDetail {
    queue?: string | undefined;
    totalDeadLettersCount?: number;
    totalActiveMessagesCount?: number;
    deadLetters?: DeadLetterInfo[] | undefined;

    constructor(data?: IPerformanceDataDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.queue = _data["queue"];
            this.totalDeadLettersCount = _data["totalDeadLettersCount"];
            this.totalActiveMessagesCount = _data["totalActiveMessagesCount"];
            if (Array.isArray(_data["deadLetters"])) {
                this.deadLetters = [] as any;
                for (let item of _data["deadLetters"])
                    this.deadLetters!.push(DeadLetterInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PerformanceDataDetail {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceDataDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queue"] = this.queue;
        data["totalDeadLettersCount"] = this.totalDeadLettersCount;
        data["totalActiveMessagesCount"] = this.totalActiveMessagesCount;
        if (Array.isArray(this.deadLetters)) {
            data["deadLetters"] = [];
            for (let item of this.deadLetters)
                data["deadLetters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPerformanceDataDetail {
    queue?: string | undefined;
    totalDeadLettersCount?: number;
    totalActiveMessagesCount?: number;
    deadLetters?: DeadLetterInfo[] | undefined;
}

export class DeadLetterInfo implements IDeadLetterInfo {
    messageType?: string | undefined;
    reason?: string | undefined;
    sequenceNumber?: number;
    exceptionType?: string | undefined;
    faultMessage?: string | undefined;
    stackTrace?: string | undefined;
    messageId?: string | undefined;
    correlationId?: string | undefined;
    enqueuedTime?: string | undefined;
    messageBody?: string | undefined;

    constructor(data?: IDeadLetterInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageType = _data["messageType"];
            this.reason = _data["reason"];
            this.sequenceNumber = _data["sequenceNumber"];
            this.exceptionType = _data["exceptionType"];
            this.faultMessage = _data["faultMessage"];
            this.stackTrace = _data["stackTrace"];
            this.messageId = _data["messageId"];
            this.correlationId = _data["correlationId"];
            this.enqueuedTime = _data["enqueuedTime"];
            this.messageBody = _data["messageBody"];
        }
    }

    static fromJS(data: any): DeadLetterInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DeadLetterInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageType"] = this.messageType;
        data["reason"] = this.reason;
        data["sequenceNumber"] = this.sequenceNumber;
        data["exceptionType"] = this.exceptionType;
        data["faultMessage"] = this.faultMessage;
        data["stackTrace"] = this.stackTrace;
        data["messageId"] = this.messageId;
        data["correlationId"] = this.correlationId;
        data["enqueuedTime"] = this.enqueuedTime;
        data["messageBody"] = this.messageBody;
        return data;
    }
}

export interface IDeadLetterInfo {
    messageType?: string | undefined;
    reason?: string | undefined;
    sequenceNumber?: number;
    exceptionType?: string | undefined;
    faultMessage?: string | undefined;
    stackTrace?: string | undefined;
    messageId?: string | undefined;
    correlationId?: string | undefined;
    enqueuedTime?: string | undefined;
    messageBody?: string | undefined;
}

export class EnvelopeOfPollPerformanceDataDetail implements IEnvelopeOfPollPerformanceDataDetail {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: PollPerformanceDataDetail | undefined;

    constructor(data?: IEnvelopeOfPollPerformanceDataDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? PollPerformanceDataDetail.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfPollPerformanceDataDetail {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfPollPerformanceDataDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfPollPerformanceDataDetail {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: PollPerformanceDataDetail | undefined;
}

export class PollPerformanceDataDetail implements IPollPerformanceDataDetail {
    totalDeadLettersCount?: number;
    totalActiveMessagesCount?: number;

    constructor(data?: IPollPerformanceDataDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalDeadLettersCount = _data["totalDeadLettersCount"];
            this.totalActiveMessagesCount = _data["totalActiveMessagesCount"];
        }
    }

    static fromJS(data: any): PollPerformanceDataDetail {
        data = typeof data === 'object' ? data : {};
        let result = new PollPerformanceDataDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalDeadLettersCount"] = this.totalDeadLettersCount;
        data["totalActiveMessagesCount"] = this.totalActiveMessagesCount;
        return data;
    }
}

export interface IPollPerformanceDataDetail {
    totalDeadLettersCount?: number;
    totalActiveMessagesCount?: number;
}

export class DeadLetterRequest implements IDeadLetterRequest {
    queueName?: string | undefined;
    deadLetters?: DeadLetter[] | undefined;

    constructor(data?: IDeadLetterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.queueName = _data["queueName"];
            if (Array.isArray(_data["deadLetters"])) {
                this.deadLetters = [] as any;
                for (let item of _data["deadLetters"])
                    this.deadLetters!.push(DeadLetter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeadLetterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeadLetterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queueName"] = this.queueName;
        if (Array.isArray(this.deadLetters)) {
            data["deadLetters"] = [];
            for (let item of this.deadLetters)
                data["deadLetters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDeadLetterRequest {
    queueName?: string | undefined;
    deadLetters?: DeadLetter[] | undefined;
}

export class DeadLetter implements IDeadLetter {
    messageId?: string | undefined;
    sequenceNumber?: number;

    constructor(data?: IDeadLetter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["messageId"];
            this.sequenceNumber = _data["sequenceNumber"];
        }
    }

    static fromJS(data: any): DeadLetter {
        data = typeof data === 'object' ? data : {};
        let result = new DeadLetter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId;
        data["sequenceNumber"] = this.sequenceNumber;
        return data;
    }
}

export interface IDeadLetter {
    messageId?: string | undefined;
    sequenceNumber?: number;
}

export enum ProcessCounter {
    FailedPmklPackages = 0,
    HangingImklValidations = 1,
    FailedAndMissingKlimResponses = 2,
    PendingRequests = 3,
    PendingPmkl2Assets = 4,
    UnprocessedMapRequests = 5,
    HangingMapRequests = 6,
    OverdueMapRequests = 7,
    MapRequestRespondersInInvalidState = 8,
    MapRequestWithFinancialAnomalies = 9,
}

export class EnvelopeOfIListOfFailedPmklPackage implements IEnvelopeOfIListOfFailedPmklPackage {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: FailedPmklPackage[] | undefined;

    constructor(data?: IEnvelopeOfIListOfFailedPmklPackage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(FailedPmklPackage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvelopeOfIListOfFailedPmklPackage {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfIListOfFailedPmklPackage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnvelopeOfIListOfFailedPmklPackage {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: FailedPmklPackage[] | undefined;
}

export class FailedPmklPackage implements IFailedPmklPackage {
    mapRequestId!: string;
    zoneId!: string;
    blobName?: string | undefined;
    dateReceived!: string;

    constructor(data?: IFailedPmklPackage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestId = _data["mapRequestId"];
            this.zoneId = _data["zoneId"];
            this.blobName = _data["blobName"];
            this.dateReceived = _data["dateReceived"];
        }
    }

    static fromJS(data: any): FailedPmklPackage {
        data = typeof data === 'object' ? data : {};
        let result = new FailedPmklPackage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestId"] = this.mapRequestId;
        data["zoneId"] = this.zoneId;
        data["blobName"] = this.blobName;
        data["dateReceived"] = this.dateReceived;
        return data;
    }
}

export interface IFailedPmklPackage {
    mapRequestId: string;
    zoneId: string;
    blobName?: string | undefined;
    dateReceived: string;
}

export class EnvelopeOfAdditionalProcesses implements IEnvelopeOfAdditionalProcesses {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: AdditionalProcesses | undefined;

    constructor(data?: IEnvelopeOfAdditionalProcesses) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? AdditionalProcesses.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfAdditionalProcesses {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfAdditionalProcesses();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfAdditionalProcesses {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: AdditionalProcesses | undefined;
}

export class AdditionalProcesses implements IAdditionalProcesses {
    kmHmPuntenOutdated?: boolean;
    unregisteredKlimKlbs?: string[] | undefined;
    missingUnaResponsesAfterDeadline?: MissingUnaResponsesAfterDeadline[] | undefined;
    holidaysNeedsNewData?: boolean;

    constructor(data?: IAdditionalProcesses) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kmHmPuntenOutdated = _data["kmHmPuntenOutdated"];
            if (Array.isArray(_data["unregisteredKlimKlbs"])) {
                this.unregisteredKlimKlbs = [] as any;
                for (let item of _data["unregisteredKlimKlbs"])
                    this.unregisteredKlimKlbs!.push(item);
            }
            if (Array.isArray(_data["missingUnaResponsesAfterDeadline"])) {
                this.missingUnaResponsesAfterDeadline = [] as any;
                for (let item of _data["missingUnaResponsesAfterDeadline"])
                    this.missingUnaResponsesAfterDeadline!.push(MissingUnaResponsesAfterDeadline.fromJS(item));
            }
            this.holidaysNeedsNewData = _data["holidaysNeedsNewData"];
        }
    }

    static fromJS(data: any): AdditionalProcesses {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalProcesses();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kmHmPuntenOutdated"] = this.kmHmPuntenOutdated;
        if (Array.isArray(this.unregisteredKlimKlbs)) {
            data["unregisteredKlimKlbs"] = [];
            for (let item of this.unregisteredKlimKlbs)
                data["unregisteredKlimKlbs"].push(item);
        }
        if (Array.isArray(this.missingUnaResponsesAfterDeadline)) {
            data["missingUnaResponsesAfterDeadline"] = [];
            for (let item of this.missingUnaResponsesAfterDeadline)
                data["missingUnaResponsesAfterDeadline"].push(item ? item.toJSON() : undefined as any);
        }
        data["holidaysNeedsNewData"] = this.holidaysNeedsNewData;
        return data;
    }
}

export interface IAdditionalProcesses {
    kmHmPuntenOutdated?: boolean;
    unregisteredKlimKlbs?: string[] | undefined;
    missingUnaResponsesAfterDeadline?: MissingUnaResponsesAfterDeadline[] | undefined;
    holidaysNeedsNewData?: boolean;
}

export class MissingUnaResponsesAfterDeadline implements IMissingUnaResponsesAfterDeadline {
    unaName?: string | undefined;
    klipOrganisationId?: string;
    numberOfMapRequests?: number;

    constructor(data?: IMissingUnaResponsesAfterDeadline) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unaName = _data["unaName"];
            this.klipOrganisationId = _data["klipOrganisationId"];
            this.numberOfMapRequests = _data["numberOfMapRequests"];
        }
    }

    static fromJS(data: any): MissingUnaResponsesAfterDeadline {
        data = typeof data === 'object' ? data : {};
        let result = new MissingUnaResponsesAfterDeadline();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unaName"] = this.unaName;
        data["klipOrganisationId"] = this.klipOrganisationId;
        data["numberOfMapRequests"] = this.numberOfMapRequests;
        return data;
    }
}

export interface IMissingUnaResponsesAfterDeadline {
    unaName?: string | undefined;
    klipOrganisationId?: string;
    numberOfMapRequests?: number;
}

export class EnvelopeOfIListOfHangingImklValidation implements IEnvelopeOfIListOfHangingImklValidation {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: HangingImklValidation[] | undefined;

    constructor(data?: IEnvelopeOfIListOfHangingImklValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(HangingImklValidation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvelopeOfIListOfHangingImklValidation {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfIListOfHangingImklValidation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnvelopeOfIListOfHangingImklValidation {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: HangingImklValidation[] | undefined;
}

export class HangingImklValidation implements IHangingImklValidation {
    mapRequestId!: string;
    zoneId!: string;
    blobName?: string | undefined;
    dateReceived!: string;

    constructor(data?: IHangingImklValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestId = _data["mapRequestId"];
            this.zoneId = _data["zoneId"];
            this.blobName = _data["blobName"];
            this.dateReceived = _data["dateReceived"];
        }
    }

    static fromJS(data: any): HangingImklValidation {
        data = typeof data === 'object' ? data : {};
        let result = new HangingImklValidation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestId"] = this.mapRequestId;
        data["zoneId"] = this.zoneId;
        data["blobName"] = this.blobName;
        data["dateReceived"] = this.dateReceived;
        return data;
    }
}

export interface IHangingImklValidation {
    mapRequestId: string;
    zoneId: string;
    blobName?: string | undefined;
    dateReceived: string;
}

export class EnvelopeOfFailedAndMissingKlimResponse implements IEnvelopeOfFailedAndMissingKlimResponse {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: FailedAndMissingKlimResponse | undefined;

    constructor(data?: IEnvelopeOfFailedAndMissingKlimResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? FailedAndMissingKlimResponse.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfFailedAndMissingKlimResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfFailedAndMissingKlimResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfFailedAndMissingKlimResponse {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: FailedAndMissingKlimResponse | undefined;
}

export class FailedAndMissingKlimResponse implements IFailedAndMissingKlimResponse {
    failedKlimResponses?: FailedKlimResponse[] | undefined;
    missingKlimResponses?: MissingKlimResponse[] | undefined;

    constructor(data?: IFailedAndMissingKlimResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["failedKlimResponses"])) {
                this.failedKlimResponses = [] as any;
                for (let item of _data["failedKlimResponses"])
                    this.failedKlimResponses!.push(FailedKlimResponse.fromJS(item));
            }
            if (Array.isArray(_data["missingKlimResponses"])) {
                this.missingKlimResponses = [] as any;
                for (let item of _data["missingKlimResponses"])
                    this.missingKlimResponses!.push(MissingKlimResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FailedAndMissingKlimResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FailedAndMissingKlimResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.failedKlimResponses)) {
            data["failedKlimResponses"] = [];
            for (let item of this.failedKlimResponses)
                data["failedKlimResponses"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.missingKlimResponses)) {
            data["missingKlimResponses"] = [];
            for (let item of this.missingKlimResponses)
                data["missingKlimResponses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFailedAndMissingKlimResponse {
    failedKlimResponses?: FailedKlimResponse[] | undefined;
    missingKlimResponses?: MissingKlimResponse[] | undefined;
}

export class FailedKlimResponse implements IFailedKlimResponse {
    mapRequestId!: string;
    timestamp!: string;

    constructor(data?: IFailedKlimResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestId = _data["mapRequestId"];
            this.timestamp = _data["timestamp"];
        }
    }

    static fromJS(data: any): FailedKlimResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FailedKlimResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestId"] = this.mapRequestId;
        data["timestamp"] = this.timestamp;
        return data;
    }
}

export interface IFailedKlimResponse {
    mapRequestId: string;
    timestamp: string;
}

export class MissingKlimResponse implements IMissingKlimResponse {
    mapRequestId!: string;
    timestamp!: string;

    constructor(data?: IMissingKlimResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestId = _data["mapRequestId"];
            this.timestamp = _data["timestamp"];
        }
    }

    static fromJS(data: any): MissingKlimResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MissingKlimResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestId"] = this.mapRequestId;
        data["timestamp"] = this.timestamp;
        return data;
    }
}

export interface IMissingKlimResponse {
    mapRequestId: string;
    timestamp: string;
}

export class EnvelopeOfIEnumerableOfPendingRequest implements IEnvelopeOfIEnumerableOfPendingRequest {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: PendingRequest[] | undefined;

    constructor(data?: IEnvelopeOfIEnumerableOfPendingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(PendingRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvelopeOfIEnumerableOfPendingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfIEnumerableOfPendingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnvelopeOfIEnumerableOfPendingRequest {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: PendingRequest[] | undefined;
}

export class PendingRequest implements IPendingRequest {
    id?: string | undefined;
    messageType?: string | undefined;
    message?: string | undefined;
    extension!: Extension;
    timestamp?: string | undefined;

    constructor(data?: IPendingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.messageType = _data["messageType"];
            this.message = _data["message"];
            this.extension = _data["extension"];
            this.timestamp = _data["timestamp"];
        }
    }

    static fromJS(data: any): PendingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PendingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["messageType"] = this.messageType;
        data["message"] = this.message;
        data["extension"] = this.extension;
        data["timestamp"] = this.timestamp;
        return data;
    }
}

export interface IPendingRequest {
    id?: string | undefined;
    messageType?: string | undefined;
    message?: string | undefined;
    extension: Extension;
    timestamp?: string | undefined;
}

export enum Extension {
    Json = "Json",
    Xml = "Xml",
    Unknown = "Unknown",
}

export class EnvelopeOfIEnumerableOfPendingPmkl2Asset implements IEnvelopeOfIEnumerableOfPendingPmkl2Asset {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: PendingPmkl2Asset[] | undefined;

    constructor(data?: IEnvelopeOfIEnumerableOfPendingPmkl2Asset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(PendingPmkl2Asset.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvelopeOfIEnumerableOfPendingPmkl2Asset {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfIEnumerableOfPendingPmkl2Asset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnvelopeOfIEnumerableOfPendingPmkl2Asset {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: PendingPmkl2Asset[] | undefined;
}

export class PendingPmkl2Asset implements IPendingPmkl2Asset {
    mapRequestId!: string;
    timestamp!: string;
    type!: Pmkl2AssetType;

    constructor(data?: IPendingPmkl2Asset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestId = _data["mapRequestId"];
            this.timestamp = _data["timestamp"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): PendingPmkl2Asset {
        data = typeof data === 'object' ? data : {};
        let result = new PendingPmkl2Asset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestId"] = this.mapRequestId;
        data["timestamp"] = this.timestamp;
        data["type"] = this.type;
        return data;
    }
}

export interface IPendingPmkl2Asset {
    mapRequestId: string;
    timestamp: string;
    type: Pmkl2AssetType;
}

export enum Pmkl2AssetType {
    Pmkl2 = "Pmkl2",
    Wfs = "Wfs",
    Pmkl2Package = "Pmkl2Package",
    Pmkl2MriPackage = "Pmkl2MriPackage",
    Pmkl2UnaPackage = "Pmkl2UnaPackage",
}

export class EnvelopeOfIEnumerableOfUnprocessedPaidShoppingCartMapRequest implements IEnvelopeOfIEnumerableOfUnprocessedPaidShoppingCartMapRequest {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: UnprocessedPaidShoppingCartMapRequest[] | undefined;

    constructor(data?: IEnvelopeOfIEnumerableOfUnprocessedPaidShoppingCartMapRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(UnprocessedPaidShoppingCartMapRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvelopeOfIEnumerableOfUnprocessedPaidShoppingCartMapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfIEnumerableOfUnprocessedPaidShoppingCartMapRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnvelopeOfIEnumerableOfUnprocessedPaidShoppingCartMapRequest {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: UnprocessedPaidShoppingCartMapRequest[] | undefined;
}

export class UnprocessedPaidShoppingCartMapRequest implements IUnprocessedPaidShoppingCartMapRequest {
    shoppingCartId!: string;
    mapRequestId!: string;
    dateReceived!: string;

    constructor(data?: IUnprocessedPaidShoppingCartMapRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shoppingCartId = _data["shoppingCartId"];
            this.mapRequestId = _data["mapRequestId"];
            this.dateReceived = _data["dateReceived"];
        }
    }

    static fromJS(data: any): UnprocessedPaidShoppingCartMapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UnprocessedPaidShoppingCartMapRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shoppingCartId"] = this.shoppingCartId;
        data["mapRequestId"] = this.mapRequestId;
        data["dateReceived"] = this.dateReceived;
        return data;
    }
}

export interface IUnprocessedPaidShoppingCartMapRequest {
    shoppingCartId: string;
    mapRequestId: string;
    dateReceived: string;
}

export class EnvelopeOfIEnumerableOfHangingMapRequest implements IEnvelopeOfIEnumerableOfHangingMapRequest {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: HangingMapRequest[] | undefined;

    constructor(data?: IEnvelopeOfIEnumerableOfHangingMapRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(HangingMapRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvelopeOfIEnumerableOfHangingMapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfIEnumerableOfHangingMapRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnvelopeOfIEnumerableOfHangingMapRequest {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: HangingMapRequest[] | undefined;
}

export class HangingMapRequest implements IHangingMapRequest {
    mapRequestId?: string;
    mapRequestStatus?: string | undefined;
    dateReceived?: string;
    hangingMapRequestType?: HangingMapRequestType;

    constructor(data?: IHangingMapRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestId = _data["mapRequestId"];
            this.mapRequestStatus = _data["mapRequestStatus"];
            this.dateReceived = _data["dateReceived"];
            this.hangingMapRequestType = _data["hangingMapRequestType"];
        }
    }

    static fromJS(data: any): HangingMapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HangingMapRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestId"] = this.mapRequestId;
        data["mapRequestStatus"] = this.mapRequestStatus;
        data["dateReceived"] = this.dateReceived;
        data["hangingMapRequestType"] = this.hangingMapRequestType;
        return data;
    }
}

export interface IHangingMapRequest {
    mapRequestId?: string;
    mapRequestStatus?: string | undefined;
    dateReceived?: string;
    hangingMapRequestType?: HangingMapRequestType;
}

export enum HangingMapRequestType {
    CreatedAndOlderThanOneDay = 0,
    InProgressWithKlim = 1,
    InProgressWithKlip = 2,
    InProgressWithIncorrectStatus = 3,
    InProgressWithKlipAndKlim = 4,
}

export class EnvelopeOfIEnumerableOfOverdueMapRequest implements IEnvelopeOfIEnumerableOfOverdueMapRequest {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: OverdueMapRequest[] | undefined;

    constructor(data?: IEnvelopeOfIEnumerableOfOverdueMapRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(OverdueMapRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvelopeOfIEnumerableOfOverdueMapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfIEnumerableOfOverdueMapRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnvelopeOfIEnumerableOfOverdueMapRequest {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: OverdueMapRequest[] | undefined;
}

export class OverdueMapRequest implements IOverdueMapRequest {
    mapRequestId!: string;
    dateReceived!: string;

    constructor(data?: IOverdueMapRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestId = _data["mapRequestId"];
            this.dateReceived = _data["dateReceived"];
        }
    }

    static fromJS(data: any): OverdueMapRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OverdueMapRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestId"] = this.mapRequestId;
        data["dateReceived"] = this.dateReceived;
        return data;
    }
}

export interface IOverdueMapRequest {
    mapRequestId: string;
    dateReceived: string;
}

export class EnvelopeOfIEnumerableOfMapRequestRespondersInIncorrectStatus implements IEnvelopeOfIEnumerableOfMapRequestRespondersInIncorrectStatus {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestRespondersInIncorrectStatus[] | undefined;

    constructor(data?: IEnvelopeOfIEnumerableOfMapRequestRespondersInIncorrectStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(MapRequestRespondersInIncorrectStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvelopeOfIEnumerableOfMapRequestRespondersInIncorrectStatus {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfIEnumerableOfMapRequestRespondersInIncorrectStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnvelopeOfIEnumerableOfMapRequestRespondersInIncorrectStatus {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestRespondersInIncorrectStatus[] | undefined;
}

export class MapRequestRespondersInIncorrectStatus implements IMapRequestRespondersInIncorrectStatus {
    mapRequestId!: string;
    utilityNetworkAuthorityZoneId!: string;
    mriMapRequestRespondersStatus?: string | undefined;
    unaMapRequestsForQueryStatus?: string | undefined;
    unaMapRequestStatusesStatus?: string | undefined;

    constructor(data?: IMapRequestRespondersInIncorrectStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestId = _data["mapRequestId"];
            this.utilityNetworkAuthorityZoneId = _data["utilityNetworkAuthorityZoneId"];
            this.mriMapRequestRespondersStatus = _data["mriMapRequestRespondersStatus"];
            this.unaMapRequestsForQueryStatus = _data["unaMapRequestsForQueryStatus"];
            this.unaMapRequestStatusesStatus = _data["unaMapRequestStatusesStatus"];
        }
    }

    static fromJS(data: any): MapRequestRespondersInIncorrectStatus {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestRespondersInIncorrectStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestId"] = this.mapRequestId;
        data["utilityNetworkAuthorityZoneId"] = this.utilityNetworkAuthorityZoneId;
        data["mriMapRequestRespondersStatus"] = this.mriMapRequestRespondersStatus;
        data["unaMapRequestsForQueryStatus"] = this.unaMapRequestsForQueryStatus;
        data["unaMapRequestStatusesStatus"] = this.unaMapRequestStatusesStatus;
        return data;
    }
}

export interface IMapRequestRespondersInIncorrectStatus {
    mapRequestId: string;
    utilityNetworkAuthorityZoneId: string;
    mriMapRequestRespondersStatus?: string | undefined;
    unaMapRequestsForQueryStatus?: string | undefined;
    unaMapRequestStatusesStatus?: string | undefined;
}

export class EnvelopeOfMapRequestsWithFinancialAnomaly implements IEnvelopeOfMapRequestsWithFinancialAnomaly {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestsWithFinancialAnomaly | undefined;

    constructor(data?: IEnvelopeOfMapRequestsWithFinancialAnomaly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? MapRequestsWithFinancialAnomaly.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfMapRequestsWithFinancialAnomaly {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfMapRequestsWithFinancialAnomaly();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfMapRequestsWithFinancialAnomaly {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: MapRequestsWithFinancialAnomaly | undefined;
}

export class MapRequestsWithFinancialAnomaly implements IMapRequestsWithFinancialAnomaly {
    notRegisteredInFinancialTransaction?: FinancialAnomaly[] | undefined;
    postpaidWithoutInvoiceNumber?: FinancialAnomaly[] | undefined;
    withoutInvoiceNumberOlderThanAMonth?: FinancialAnomaly[] | undefined;
    withoutSettlement?: FinancialAnomaly[] | undefined;
    withMissingPdf?: FinancialAnomaly[] | undefined;
    lastInvoiceRound?: string | undefined;
    lastInvoiceError?: boolean;

    constructor(data?: IMapRequestsWithFinancialAnomaly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notRegisteredInFinancialTransaction"])) {
                this.notRegisteredInFinancialTransaction = [] as any;
                for (let item of _data["notRegisteredInFinancialTransaction"])
                    this.notRegisteredInFinancialTransaction!.push(FinancialAnomaly.fromJS(item));
            }
            if (Array.isArray(_data["postpaidWithoutInvoiceNumber"])) {
                this.postpaidWithoutInvoiceNumber = [] as any;
                for (let item of _data["postpaidWithoutInvoiceNumber"])
                    this.postpaidWithoutInvoiceNumber!.push(FinancialAnomaly.fromJS(item));
            }
            if (Array.isArray(_data["withoutInvoiceNumberOlderThanAMonth"])) {
                this.withoutInvoiceNumberOlderThanAMonth = [] as any;
                for (let item of _data["withoutInvoiceNumberOlderThanAMonth"])
                    this.withoutInvoiceNumberOlderThanAMonth!.push(FinancialAnomaly.fromJS(item));
            }
            if (Array.isArray(_data["withoutSettlement"])) {
                this.withoutSettlement = [] as any;
                for (let item of _data["withoutSettlement"])
                    this.withoutSettlement!.push(FinancialAnomaly.fromJS(item));
            }
            if (Array.isArray(_data["withMissingPdf"])) {
                this.withMissingPdf = [] as any;
                for (let item of _data["withMissingPdf"])
                    this.withMissingPdf!.push(FinancialAnomaly.fromJS(item));
            }
            this.lastInvoiceRound = _data["lastInvoiceRound"];
            this.lastInvoiceError = _data["lastInvoiceError"];
        }
    }

    static fromJS(data: any): MapRequestsWithFinancialAnomaly {
        data = typeof data === 'object' ? data : {};
        let result = new MapRequestsWithFinancialAnomaly();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notRegisteredInFinancialTransaction)) {
            data["notRegisteredInFinancialTransaction"] = [];
            for (let item of this.notRegisteredInFinancialTransaction)
                data["notRegisteredInFinancialTransaction"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.postpaidWithoutInvoiceNumber)) {
            data["postpaidWithoutInvoiceNumber"] = [];
            for (let item of this.postpaidWithoutInvoiceNumber)
                data["postpaidWithoutInvoiceNumber"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.withoutInvoiceNumberOlderThanAMonth)) {
            data["withoutInvoiceNumberOlderThanAMonth"] = [];
            for (let item of this.withoutInvoiceNumberOlderThanAMonth)
                data["withoutInvoiceNumberOlderThanAMonth"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.withoutSettlement)) {
            data["withoutSettlement"] = [];
            for (let item of this.withoutSettlement)
                data["withoutSettlement"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.withMissingPdf)) {
            data["withMissingPdf"] = [];
            for (let item of this.withMissingPdf)
                data["withMissingPdf"].push(item ? item.toJSON() : undefined as any);
        }
        data["lastInvoiceRound"] = this.lastInvoiceRound;
        data["lastInvoiceError"] = this.lastInvoiceError;
        return data;
    }
}

export interface IMapRequestsWithFinancialAnomaly {
    notRegisteredInFinancialTransaction?: FinancialAnomaly[] | undefined;
    postpaidWithoutInvoiceNumber?: FinancialAnomaly[] | undefined;
    withoutInvoiceNumberOlderThanAMonth?: FinancialAnomaly[] | undefined;
    withoutSettlement?: FinancialAnomaly[] | undefined;
    withMissingPdf?: FinancialAnomaly[] | undefined;
    lastInvoiceRound?: string | undefined;
    lastInvoiceError?: boolean;
}

export class FinancialAnomaly implements IFinancialAnomaly {
    mapRequestId?: string;
    dateReceived?: string;
    invoiceNumber?: string | undefined;

    constructor(data?: IFinancialAnomaly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapRequestId = _data["mapRequestId"];
            this.dateReceived = _data["dateReceived"];
            this.invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): FinancialAnomaly {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialAnomaly();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapRequestId"] = this.mapRequestId;
        data["dateReceived"] = this.dateReceived;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }
}

export interface IFinancialAnomaly {
    mapRequestId?: string;
    dateReceived?: string;
    invoiceNumber?: string | undefined;
}

export class EnvelopeOfSagaDto implements IEnvelopeOfSagaDto {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: SagaDto | undefined;

    constructor(data?: IEnvelopeOfSagaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? SagaDto.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfSagaDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfSagaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfSagaDto {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: SagaDto | undefined;
}

export class SagaDto implements ISagaDto {
    id?: string | undefined;
    type?: SagaType;
    currentState?: string | undefined;
    content?: string | undefined;

    constructor(data?: ISagaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.currentState = _data["currentState"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): SagaDto {
        data = typeof data === 'object' ? data : {};
        let result = new SagaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["currentState"] = this.currentState;
        data["content"] = this.content;
        return data;
    }
}

export interface ISagaDto {
    id?: string | undefined;
    type?: SagaType;
    currentState?: string | undefined;
    content?: string | undefined;
}

export enum SagaType {
    Archive = 0,
    GeneratePmkl2Package = 1,
}

export class EnvelopeOfICollectionOfUserListItem implements IEnvelopeOfICollectionOfUserListItem {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: UserListItem[] | undefined;

    constructor(data?: IEnvelopeOfICollectionOfUserListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(UserListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnvelopeOfICollectionOfUserListItem {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfICollectionOfUserListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEnvelopeOfICollectionOfUserListItem {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: UserListItem[] | undefined;
}

export class UserListItem implements IUserListItem {
    userId?: string;
    lastName?: string | undefined;
    firstName?: string | undefined;
    organisation?: string | undefined;
    organisationId?: string | undefined;
    types?: string | undefined;
    lastActiveAt?: string | undefined;
    source?: string | undefined;

    constructor(data?: IUserListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.organisation = _data["organisation"];
            this.organisationId = _data["organisationId"];
            this.types = _data["types"];
            this.lastActiveAt = _data["lastActiveAt"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): UserListItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["organisation"] = this.organisation;
        data["organisationId"] = this.organisationId;
        data["types"] = this.types;
        data["lastActiveAt"] = this.lastActiveAt;
        data["source"] = this.source;
        return data;
    }
}

export interface IUserListItem {
    userId?: string;
    lastName?: string | undefined;
    firstName?: string | undefined;
    organisation?: string | undefined;
    organisationId?: string | undefined;
    types?: string | undefined;
    lastActiveAt?: string | undefined;
    source?: string | undefined;
}

export class EnvelopeOfUserDetail implements IEnvelopeOfUserDetail {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: UserDetail | undefined;

    constructor(data?: IEnvelopeOfUserDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? UserDetail.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfUserDetail {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfUserDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfUserDetail {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: UserDetail | undefined;
}

export class UserDetail implements IUserDetail {
    isCitizen?: boolean;
    incompletePackageAvailableMail?: boolean;
    incompletePackageAvailableMailExampleUri?: string | undefined;
    soonToBeArchivedMail?: boolean;
    soonToBeArchivedMailExampleUri?: string | undefined;
    confirmationMail?: boolean;
    confirmationMailExampleUri?: string | undefined;
    userId?: string;
    lastName?: string | undefined;
    firstName?: string | undefined;
    email?: string | undefined;
    organisationId?: string | undefined;
    organisationName?: string | undefined;
    rolesInOrganisation?: string[] | undefined;
    lastActiveAt?: string | undefined;
    source?: string | undefined;

    constructor(data?: IUserDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isCitizen = _data["isCitizen"];
            this.incompletePackageAvailableMail = _data["incompletePackageAvailableMail"];
            this.incompletePackageAvailableMailExampleUri = _data["incompletePackageAvailableMailExampleUri"];
            this.soonToBeArchivedMail = _data["soonToBeArchivedMail"];
            this.soonToBeArchivedMailExampleUri = _data["soonToBeArchivedMailExampleUri"];
            this.confirmationMail = _data["confirmationMail"];
            this.confirmationMailExampleUri = _data["confirmationMailExampleUri"];
            this.userId = _data["userId"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.email = _data["email"];
            this.organisationId = _data["organisationId"];
            this.organisationName = _data["organisationName"];
            if (Array.isArray(_data["rolesInOrganisation"])) {
                this.rolesInOrganisation = [] as any;
                for (let item of _data["rolesInOrganisation"])
                    this.rolesInOrganisation!.push(item);
            }
            this.lastActiveAt = _data["lastActiveAt"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): UserDetail {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCitizen"] = this.isCitizen;
        data["incompletePackageAvailableMail"] = this.incompletePackageAvailableMail;
        data["incompletePackageAvailableMailExampleUri"] = this.incompletePackageAvailableMailExampleUri;
        data["soonToBeArchivedMail"] = this.soonToBeArchivedMail;
        data["soonToBeArchivedMailExampleUri"] = this.soonToBeArchivedMailExampleUri;
        data["confirmationMail"] = this.confirmationMail;
        data["confirmationMailExampleUri"] = this.confirmationMailExampleUri;
        data["userId"] = this.userId;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["email"] = this.email;
        data["organisationId"] = this.organisationId;
        data["organisationName"] = this.organisationName;
        if (Array.isArray(this.rolesInOrganisation)) {
            data["rolesInOrganisation"] = [];
            for (let item of this.rolesInOrganisation)
                data["rolesInOrganisation"].push(item);
        }
        data["lastActiveAt"] = this.lastActiveAt;
        data["source"] = this.source;
        return data;
    }
}

export interface IUserDetail {
    isCitizen?: boolean;
    incompletePackageAvailableMail?: boolean;
    incompletePackageAvailableMailExampleUri?: string | undefined;
    soonToBeArchivedMail?: boolean;
    soonToBeArchivedMailExampleUri?: string | undefined;
    confirmationMail?: boolean;
    confirmationMailExampleUri?: string | undefined;
    userId?: string;
    lastName?: string | undefined;
    firstName?: string | undefined;
    email?: string | undefined;
    organisationId?: string | undefined;
    organisationName?: string | undefined;
    rolesInOrganisation?: string[] | undefined;
    lastActiveAt?: string | undefined;
    source?: string | undefined;
}

export class AskImpersonationConsentRequest implements IAskImpersonationConsentRequest {
    userId!: string;
    impersonatorUserId!: string;
    klipOrganisationId?: string | undefined;
    crmCaseNumber!: string;

    constructor(data?: IAskImpersonationConsentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.impersonatorUserId = _data["impersonatorUserId"];
            this.klipOrganisationId = _data["klipOrganisationId"];
            this.crmCaseNumber = _data["crmCaseNumber"];
        }
    }

    static fromJS(data: any): AskImpersonationConsentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AskImpersonationConsentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["klipOrganisationId"] = this.klipOrganisationId;
        data["crmCaseNumber"] = this.crmCaseNumber;
        return data;
    }
}

export interface IAskImpersonationConsentRequest {
    userId: string;
    impersonatorUserId: string;
    klipOrganisationId?: string | undefined;
    crmCaseNumber: string;
}

export class EnvelopeOfImpersonationSessionForUser implements IEnvelopeOfImpersonationSessionForUser {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ImpersonationSessionForUser | undefined;

    constructor(data?: IEnvelopeOfImpersonationSessionForUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? ImpersonationSessionForUser.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfImpersonationSessionForUser {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfImpersonationSessionForUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfImpersonationSessionForUser {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: ImpersonationSessionForUser | undefined;
}

export class ImpersonationSessionForUser implements IImpersonationSessionForUser {
    activeImpersonationSession?: UserImpersonationDto | undefined;
    history?: UserImpersonationDto[] | undefined;

    constructor(data?: IImpersonationSessionForUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeImpersonationSession = _data["activeImpersonationSession"] ? UserImpersonationDto.fromJS(_data["activeImpersonationSession"]) : undefined as any;
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(UserImpersonationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImpersonationSessionForUser {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonationSessionForUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeImpersonationSession"] = this.activeImpersonationSession ? this.activeImpersonationSession.toJSON() : undefined as any;
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImpersonationSessionForUser {
    activeImpersonationSession?: UserImpersonationDto | undefined;
    history?: UserImpersonationDto[] | undefined;
}

export class EnvelopeOfUnit implements IEnvelopeOfUnit {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: Unit;

    constructor(data?: IEnvelopeOfUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.status = _data["status"];
            this.statusCode = _data["statusCode"];
            this.isSuccessStatusCode = _data["isSuccessStatusCode"];
            this.result = _data["result"] ? Unit.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): EnvelopeOfUnit {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeOfUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        data["statusCode"] = this.statusCode;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }
}

export interface IEnvelopeOfUnit {
    messages?: string[] | undefined;
    status?: string | undefined;
    statusCode?: number;
    isSuccessStatusCode?: boolean;
    result?: Unit;
}

export class Unit implements IUnit {

    constructor(data?: IUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Unit {
        data = typeof data === 'object' ? data : {};
        let result = new Unit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IUnit {
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}